import * as br from "react";
import Je, { useContext as yi, createElement as cp, useRef as _t, useLayoutEffect as dp, useState as Se, useEffect as Pr, useCallback as li, forwardRef as fp, useMemo as si } from "react";
import * as pp from "react-dom";
import Br, { createPortal as mp } from "react-dom";
function gi(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var Bo = { exports: {} }, qe = {};
/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Nl;
function vp() {
  if (Nl) return qe;
  Nl = 1;
  var e = Symbol.for("react.element"), r = Symbol.for("react.portal"), t = Symbol.for("react.fragment"), n = Symbol.for("react.strict_mode"), a = Symbol.for("react.profiler"), o = Symbol.for("react.provider"), l = Symbol.for("react.context"), f = Symbol.for("react.server_context"), i = Symbol.for("react.forward_ref"), s = Symbol.for("react.suspense"), c = Symbol.for("react.suspense_list"), d = Symbol.for("react.memo"), u = Symbol.for("react.lazy"), m = Symbol.for("react.offscreen"), v;
  v = Symbol.for("react.module.reference");
  function h(g) {
    if (typeof g == "object" && g !== null) {
      var p = g.$$typeof;
      switch (p) {
        case e:
          switch (g = g.type, g) {
            case t:
            case a:
            case n:
            case s:
            case c:
              return g;
            default:
              switch (g = g && g.$$typeof, g) {
                case f:
                case l:
                case i:
                case u:
                case d:
                case o:
                  return g;
                default:
                  return p;
              }
          }
        case r:
          return p;
      }
    }
  }
  return qe.ContextConsumer = l, qe.ContextProvider = o, qe.Element = e, qe.ForwardRef = i, qe.Fragment = t, qe.Lazy = u, qe.Memo = d, qe.Portal = r, qe.Profiler = a, qe.StrictMode = n, qe.Suspense = s, qe.SuspenseList = c, qe.isAsyncMode = function() {
    return !1;
  }, qe.isConcurrentMode = function() {
    return !1;
  }, qe.isContextConsumer = function(g) {
    return h(g) === l;
  }, qe.isContextProvider = function(g) {
    return h(g) === o;
  }, qe.isElement = function(g) {
    return typeof g == "object" && g !== null && g.$$typeof === e;
  }, qe.isForwardRef = function(g) {
    return h(g) === i;
  }, qe.isFragment = function(g) {
    return h(g) === t;
  }, qe.isLazy = function(g) {
    return h(g) === u;
  }, qe.isMemo = function(g) {
    return h(g) === d;
  }, qe.isPortal = function(g) {
    return h(g) === r;
  }, qe.isProfiler = function(g) {
    return h(g) === a;
  }, qe.isStrictMode = function(g) {
    return h(g) === n;
  }, qe.isSuspense = function(g) {
    return h(g) === s;
  }, qe.isSuspenseList = function(g) {
    return h(g) === c;
  }, qe.isValidElementType = function(g) {
    return typeof g == "string" || typeof g == "function" || g === t || g === a || g === n || g === s || g === c || g === m || typeof g == "object" && g !== null && (g.$$typeof === u || g.$$typeof === d || g.$$typeof === o || g.$$typeof === l || g.$$typeof === i || g.$$typeof === v || g.getModuleId !== void 0);
  }, qe.typeOf = h, qe;
}
var Oe = {};
/**
 * @license React
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Ll;
function hp() {
  return Ll || (Ll = 1, process.env.NODE_ENV !== "production" && function() {
    var e = Symbol.for("react.element"), r = Symbol.for("react.portal"), t = Symbol.for("react.fragment"), n = Symbol.for("react.strict_mode"), a = Symbol.for("react.profiler"), o = Symbol.for("react.provider"), l = Symbol.for("react.context"), f = Symbol.for("react.server_context"), i = Symbol.for("react.forward_ref"), s = Symbol.for("react.suspense"), c = Symbol.for("react.suspense_list"), d = Symbol.for("react.memo"), u = Symbol.for("react.lazy"), m = Symbol.for("react.offscreen"), v = !1, h = !1, g = !1, p = !1, x = !1, w;
    w = Symbol.for("react.module.reference");
    function C(Z) {
      return !!(typeof Z == "string" || typeof Z == "function" || Z === t || Z === a || x || Z === n || Z === s || Z === c || p || Z === m || v || h || g || typeof Z == "object" && Z !== null && (Z.$$typeof === u || Z.$$typeof === d || Z.$$typeof === o || Z.$$typeof === l || Z.$$typeof === i || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      Z.$$typeof === w || Z.getModuleId !== void 0));
    }
    function y(Z) {
      if (typeof Z == "object" && Z !== null) {
        var se = Z.$$typeof;
        switch (se) {
          case e:
            var pe = Z.type;
            switch (pe) {
              case t:
              case a:
              case n:
              case s:
              case c:
                return pe;
              default:
                var de = pe && pe.$$typeof;
                switch (de) {
                  case f:
                  case l:
                  case i:
                  case u:
                  case d:
                  case o:
                    return de;
                  default:
                    return se;
                }
            }
          case r:
            return se;
        }
      }
    }
    var b = l, R = o, E = e, M = i, I = t, $ = u, G = d, D = r, k = a, F = n, B = s, H = c, U = !1, ae = !1;
    function oe(Z) {
      return U || (U = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function ce(Z) {
      return ae || (ae = !0, console.warn("The ReactIs.isConcurrentMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function J(Z) {
      return y(Z) === l;
    }
    function O(Z) {
      return y(Z) === o;
    }
    function N(Z) {
      return typeof Z == "object" && Z !== null && Z.$$typeof === e;
    }
    function V(Z) {
      return y(Z) === i;
    }
    function A(Z) {
      return y(Z) === t;
    }
    function le(Z) {
      return y(Z) === u;
    }
    function X(Z) {
      return y(Z) === d;
    }
    function q(Z) {
      return y(Z) === r;
    }
    function W(Z) {
      return y(Z) === a;
    }
    function L(Z) {
      return y(Z) === n;
    }
    function j(Z) {
      return y(Z) === s;
    }
    function ie(Z) {
      return y(Z) === c;
    }
    Oe.ContextConsumer = b, Oe.ContextProvider = R, Oe.Element = E, Oe.ForwardRef = M, Oe.Fragment = I, Oe.Lazy = $, Oe.Memo = G, Oe.Portal = D, Oe.Profiler = k, Oe.StrictMode = F, Oe.Suspense = B, Oe.SuspenseList = H, Oe.isAsyncMode = oe, Oe.isConcurrentMode = ce, Oe.isContextConsumer = J, Oe.isContextProvider = O, Oe.isElement = N, Oe.isForwardRef = V, Oe.isFragment = A, Oe.isLazy = le, Oe.isMemo = X, Oe.isPortal = q, Oe.isProfiler = W, Oe.isStrictMode = L, Oe.isSuspense = j, Oe.isSuspenseList = ie, Oe.isValidElementType = C, Oe.typeOf = y;
  }()), Oe;
}
var $l;
function bp() {
  return $l || ($l = 1, process.env.NODE_ENV === "production" ? Bo.exports = vp() : Bo.exports = hp()), Bo.exports;
}
var ul = bp();
function yp(e) {
  function r(J, O, N, V, A) {
    for (var le = 0, X = 0, q = 0, W = 0, L, j, ie = 0, Z = 0, se, pe = se = L = 0, de = 0, Re = 0, Ue = 0, xe = 0, Ke = N.length, Ge = Ke - 1, Le, fe = "", _e = "", Ze = "", er = "", $e; de < Ke; ) {
      if (j = N.charCodeAt(de), de === Ge && X + W + q + le !== 0 && (X !== 0 && (j = X === 47 ? 10 : 47), W = q = le = 0, Ke++, Ge++), X + W + q + le === 0) {
        if (de === Ge && (0 < Re && (fe = fe.replace(u, "")), 0 < fe.trim().length)) {
          switch (j) {
            case 32:
            case 9:
            case 59:
            case 13:
            case 10:
              break;
            default:
              fe += N.charAt(de);
          }
          j = 59;
        }
        switch (j) {
          case 123:
            for (fe = fe.trim(), L = fe.charCodeAt(0), se = 1, xe = ++de; de < Ke; ) {
              switch (j = N.charCodeAt(de)) {
                case 123:
                  se++;
                  break;
                case 125:
                  se--;
                  break;
                case 47:
                  switch (j = N.charCodeAt(de + 1)) {
                    case 42:
                    case 47:
                      e: {
                        for (pe = de + 1; pe < Ge; ++pe)
                          switch (N.charCodeAt(pe)) {
                            case 47:
                              if (j === 42 && N.charCodeAt(pe - 1) === 42 && de + 2 !== pe) {
                                de = pe + 1;
                                break e;
                              }
                              break;
                            case 10:
                              if (j === 47) {
                                de = pe + 1;
                                break e;
                              }
                          }
                        de = pe;
                      }
                  }
                  break;
                case 91:
                  j++;
                case 40:
                  j++;
                case 34:
                case 39:
                  for (; de++ < Ge && N.charCodeAt(de) !== j; )
                    ;
              }
              if (se === 0) break;
              de++;
            }
            switch (se = N.substring(xe, de), L === 0 && (L = (fe = fe.replace(d, "").trim()).charCodeAt(0)), L) {
              case 64:
                switch (0 < Re && (fe = fe.replace(u, "")), j = fe.charCodeAt(1), j) {
                  case 100:
                  case 109:
                  case 115:
                  case 45:
                    Re = O;
                    break;
                  default:
                    Re = B;
                }
                if (se = r(O, Re, se, j, A + 1), xe = se.length, 0 < U && (Re = t(B, fe, Ue), $e = f(3, se, Re, O, D, G, xe, j, A, V), fe = Re.join(""), $e !== void 0 && (xe = (se = $e.trim()).length) === 0 && (j = 0, se = "")), 0 < xe) switch (j) {
                  case 115:
                    fe = fe.replace(b, l);
                  case 100:
                  case 109:
                  case 45:
                    se = fe + "{" + se + "}";
                    break;
                  case 107:
                    fe = fe.replace(x, "$1 $2"), se = fe + "{" + se + "}", se = F === 1 || F === 2 && o("@" + se, 3) ? "@-webkit-" + se + "@" + se : "@" + se;
                    break;
                  default:
                    se = fe + se, V === 112 && (se = (_e += se, ""));
                }
                else se = "";
                break;
              default:
                se = r(O, t(O, fe, Ue), se, V, A + 1);
            }
            Ze += se, se = Ue = Re = pe = L = 0, fe = "", j = N.charCodeAt(++de);
            break;
          case 125:
          case 59:
            if (fe = (0 < Re ? fe.replace(u, "") : fe).trim(), 1 < (xe = fe.length)) switch (pe === 0 && (L = fe.charCodeAt(0), L === 45 || 96 < L && 123 > L) && (xe = (fe = fe.replace(" ", ":")).length), 0 < U && ($e = f(1, fe, O, J, D, G, _e.length, V, A, V)) !== void 0 && (xe = (fe = $e.trim()).length) === 0 && (fe = "\0\0"), L = fe.charCodeAt(0), j = fe.charCodeAt(1), L) {
              case 0:
                break;
              case 64:
                if (j === 105 || j === 99) {
                  er += fe + N.charAt(de);
                  break;
                }
              default:
                fe.charCodeAt(xe - 1) !== 58 && (_e += a(fe, L, j, fe.charCodeAt(2)));
            }
            Ue = Re = pe = L = 0, fe = "", j = N.charCodeAt(++de);
        }
      }
      switch (j) {
        case 13:
        case 10:
          X === 47 ? X = 0 : 1 + L === 0 && V !== 107 && 0 < fe.length && (Re = 1, fe += "\0"), 0 < U * oe && f(0, fe, O, J, D, G, _e.length, V, A, V), G = 1, D++;
          break;
        case 59:
        case 125:
          if (X + W + q + le === 0) {
            G++;
            break;
          }
        default:
          switch (G++, Le = N.charAt(de), j) {
            case 9:
            case 32:
              if (W + le + X === 0) switch (ie) {
                case 44:
                case 58:
                case 9:
                case 32:
                  Le = "";
                  break;
                default:
                  j !== 32 && (Le = " ");
              }
              break;
            case 0:
              Le = "\\0";
              break;
            case 12:
              Le = "\\f";
              break;
            case 11:
              Le = "\\v";
              break;
            case 38:
              W + X + le === 0 && (Re = Ue = 1, Le = "\f" + Le);
              break;
            case 108:
              if (W + X + le + k === 0 && 0 < pe) switch (de - pe) {
                case 2:
                  ie === 112 && N.charCodeAt(de - 3) === 58 && (k = ie);
                case 8:
                  Z === 111 && (k = Z);
              }
              break;
            case 58:
              W + X + le === 0 && (pe = de);
              break;
            case 44:
              X + q + W + le === 0 && (Re = 1, Le += "\r");
              break;
            case 34:
            case 39:
              X === 0 && (W = W === j ? 0 : W === 0 ? j : W);
              break;
            case 91:
              W + X + q === 0 && le++;
              break;
            case 93:
              W + X + q === 0 && le--;
              break;
            case 41:
              W + X + le === 0 && q--;
              break;
            case 40:
              if (W + X + le === 0) {
                if (L === 0) switch (2 * ie + 3 * Z) {
                  case 533:
                    break;
                  default:
                    L = 1;
                }
                q++;
              }
              break;
            case 64:
              X + q + W + le + pe + se === 0 && (se = 1);
              break;
            case 42:
            case 47:
              if (!(0 < W + le + q)) switch (X) {
                case 0:
                  switch (2 * j + 3 * N.charCodeAt(de + 1)) {
                    case 235:
                      X = 47;
                      break;
                    case 220:
                      xe = de, X = 42;
                  }
                  break;
                case 42:
                  j === 47 && ie === 42 && xe + 2 !== de && (N.charCodeAt(xe + 2) === 33 && (_e += N.substring(xe, de + 1)), Le = "", X = 0);
              }
          }
          X === 0 && (fe += Le);
      }
      Z = ie, ie = j, de++;
    }
    if (xe = _e.length, 0 < xe) {
      if (Re = O, 0 < U && ($e = f(2, _e, Re, J, D, G, xe, V, A, V), $e !== void 0 && (_e = $e).length === 0)) return er + _e + Ze;
      if (_e = Re.join(",") + "{" + _e + "}", F * k !== 0) {
        switch (F !== 2 || o(_e, 2) || (k = 0), k) {
          case 111:
            _e = _e.replace(C, ":-moz-$1") + _e;
            break;
          case 112:
            _e = _e.replace(w, "::-webkit-input-$1") + _e.replace(w, "::-moz-$1") + _e.replace(w, ":-ms-input-$1") + _e;
        }
        k = 0;
      }
    }
    return er + _e + Ze;
  }
  function t(J, O, N) {
    var V = O.trim().split(g);
    O = V;
    var A = V.length, le = J.length;
    switch (le) {
      case 0:
      case 1:
        var X = 0;
        for (J = le === 0 ? "" : J[0] + " "; X < A; ++X)
          O[X] = n(J, O[X], N).trim();
        break;
      default:
        var q = X = 0;
        for (O = []; X < A; ++X)
          for (var W = 0; W < le; ++W)
            O[q++] = n(J[W] + " ", V[X], N).trim();
    }
    return O;
  }
  function n(J, O, N) {
    var V = O.charCodeAt(0);
    switch (33 > V && (V = (O = O.trim()).charCodeAt(0)), V) {
      case 38:
        return O.replace(p, "$1" + J.trim());
      case 58:
        return J.trim() + O.replace(p, "$1" + J.trim());
      default:
        if (0 < 1 * N && 0 < O.indexOf("\f")) return O.replace(p, (J.charCodeAt(0) === 58 ? "" : "$1") + J.trim());
    }
    return J + O;
  }
  function a(J, O, N, V) {
    var A = J + ";", le = 2 * O + 3 * N + 4 * V;
    if (le === 944) {
      J = A.indexOf(":", 9) + 1;
      var X = A.substring(J, A.length - 1).trim();
      return X = A.substring(0, J).trim() + X + ";", F === 1 || F === 2 && o(X, 1) ? "-webkit-" + X + X : X;
    }
    if (F === 0 || F === 2 && !o(A, 1)) return A;
    switch (le) {
      case 1015:
        return A.charCodeAt(10) === 97 ? "-webkit-" + A + A : A;
      case 951:
        return A.charCodeAt(3) === 116 ? "-webkit-" + A + A : A;
      case 963:
        return A.charCodeAt(5) === 110 ? "-webkit-" + A + A : A;
      case 1009:
        if (A.charCodeAt(4) !== 100) break;
      case 969:
      case 942:
        return "-webkit-" + A + A;
      case 978:
        return "-webkit-" + A + "-moz-" + A + A;
      case 1019:
      case 983:
        return "-webkit-" + A + "-moz-" + A + "-ms-" + A + A;
      case 883:
        if (A.charCodeAt(8) === 45) return "-webkit-" + A + A;
        if (0 < A.indexOf("image-set(", 11)) return A.replace($, "$1-webkit-$2") + A;
        break;
      case 932:
        if (A.charCodeAt(4) === 45) switch (A.charCodeAt(5)) {
          case 103:
            return "-webkit-box-" + A.replace("-grow", "") + "-webkit-" + A + "-ms-" + A.replace("grow", "positive") + A;
          case 115:
            return "-webkit-" + A + "-ms-" + A.replace("shrink", "negative") + A;
          case 98:
            return "-webkit-" + A + "-ms-" + A.replace("basis", "preferred-size") + A;
        }
        return "-webkit-" + A + "-ms-" + A + A;
      case 964:
        return "-webkit-" + A + "-ms-flex-" + A + A;
      case 1023:
        if (A.charCodeAt(8) !== 99) break;
        return X = A.substring(A.indexOf(":", 15)).replace("flex-", "").replace("space-between", "justify"), "-webkit-box-pack" + X + "-webkit-" + A + "-ms-flex-pack" + X + A;
      case 1005:
        return v.test(A) ? A.replace(m, ":-webkit-") + A.replace(m, ":-moz-") + A : A;
      case 1e3:
        switch (X = A.substring(13).trim(), O = X.indexOf("-") + 1, X.charCodeAt(0) + X.charCodeAt(O)) {
          case 226:
            X = A.replace(y, "tb");
            break;
          case 232:
            X = A.replace(y, "tb-rl");
            break;
          case 220:
            X = A.replace(y, "lr");
            break;
          default:
            return A;
        }
        return "-webkit-" + A + "-ms-" + X + A;
      case 1017:
        if (A.indexOf("sticky", 9) === -1) break;
      case 975:
        switch (O = (A = J).length - 10, X = (A.charCodeAt(O) === 33 ? A.substring(0, O) : A).substring(J.indexOf(":", 7) + 1).trim(), le = X.charCodeAt(0) + (X.charCodeAt(7) | 0)) {
          case 203:
            if (111 > X.charCodeAt(8)) break;
          case 115:
            A = A.replace(X, "-webkit-" + X) + ";" + A;
            break;
          case 207:
          case 102:
            A = A.replace(X, "-webkit-" + (102 < le ? "inline-" : "") + "box") + ";" + A.replace(X, "-webkit-" + X) + ";" + A.replace(X, "-ms-" + X + "box") + ";" + A;
        }
        return A + ";";
      case 938:
        if (A.charCodeAt(5) === 45) switch (A.charCodeAt(6)) {
          case 105:
            return X = A.replace("-items", ""), "-webkit-" + A + "-webkit-box-" + X + "-ms-flex-" + X + A;
          case 115:
            return "-webkit-" + A + "-ms-flex-item-" + A.replace(E, "") + A;
          default:
            return "-webkit-" + A + "-ms-flex-line-pack" + A.replace("align-content", "").replace(E, "") + A;
        }
        break;
      case 973:
      case 989:
        if (A.charCodeAt(3) !== 45 || A.charCodeAt(4) === 122) break;
      case 931:
      case 953:
        if (I.test(J) === !0) return (X = J.substring(J.indexOf(":") + 1)).charCodeAt(0) === 115 ? a(J.replace("stretch", "fill-available"), O, N, V).replace(":fill-available", ":stretch") : A.replace(X, "-webkit-" + X) + A.replace(X, "-moz-" + X.replace("fill-", "")) + A;
        break;
      case 962:
        if (A = "-webkit-" + A + (A.charCodeAt(5) === 102 ? "-ms-" + A : "") + A, N + V === 211 && A.charCodeAt(13) === 105 && 0 < A.indexOf("transform", 10)) return A.substring(0, A.indexOf(";", 27) + 1).replace(h, "$1-webkit-$2") + A;
    }
    return A;
  }
  function o(J, O) {
    var N = J.indexOf(O === 1 ? ":" : "{"), V = J.substring(0, O !== 3 ? N : 10);
    return N = J.substring(N + 1, J.length - 1), ae(O !== 2 ? V : V.replace(M, "$1"), N, O);
  }
  function l(J, O) {
    var N = a(O, O.charCodeAt(0), O.charCodeAt(1), O.charCodeAt(2));
    return N !== O + ";" ? N.replace(R, " or ($1)").substring(4) : "(" + O + ")";
  }
  function f(J, O, N, V, A, le, X, q, W, L) {
    for (var j = 0, ie = O, Z; j < U; ++j)
      switch (Z = H[j].call(c, J, ie, N, V, A, le, X, q, W, L)) {
        case void 0:
        case !1:
        case !0:
        case null:
          break;
        default:
          ie = Z;
      }
    if (ie !== O) return ie;
  }
  function i(J) {
    switch (J) {
      case void 0:
      case null:
        U = H.length = 0;
        break;
      default:
        if (typeof J == "function") H[U++] = J;
        else if (typeof J == "object") for (var O = 0, N = J.length; O < N; ++O)
          i(J[O]);
        else oe = !!J | 0;
    }
    return i;
  }
  function s(J) {
    return J = J.prefix, J !== void 0 && (ae = null, J ? typeof J != "function" ? F = 1 : (F = 2, ae = J) : F = 0), s;
  }
  function c(J, O) {
    var N = J;
    if (33 > N.charCodeAt(0) && (N = N.trim()), ce = N, N = [ce], 0 < U) {
      var V = f(-1, O, N, N, D, G, 0, 0, 0, 0);
      V !== void 0 && typeof V == "string" && (O = V);
    }
    var A = r(B, N, O, 0, 0);
    return 0 < U && (V = f(-2, A, N, N, D, G, A.length, 0, 0, 0), V !== void 0 && (A = V)), ce = "", k = 0, G = D = 1, A;
  }
  var d = /^\0+/g, u = /[\0\r\f]/g, m = /: */g, v = /zoo|gra/, h = /([,: ])(transform)/g, g = /,\r+?/g, p = /([\t\r\n ])*\f?&/g, x = /@(k\w+)\s*(\S*)\s*/, w = /::(place)/g, C = /:(read-only)/g, y = /[svh]\w+-[tblr]{2}/, b = /\(\s*(.*)\s*\)/g, R = /([\s\S]*?);/g, E = /-self|flex-/g, M = /[^]*?(:[rp][el]a[\w-]+)[^]*/, I = /stretch|:\s*\w+\-(?:conte|avail)/, $ = /([^-])(image-set\()/, G = 1, D = 1, k = 0, F = 1, B = [], H = [], U = 0, ae = null, oe = 0, ce = "";
  return c.use = i, c.set = s, e !== void 0 && s(e), c;
}
var gp = {
  animationIterationCount: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
};
function Rp(e) {
  var r = /* @__PURE__ */ Object.create(null);
  return function(t) {
    return r[t] === void 0 && (r[t] = e(t)), r[t];
  };
}
var xp = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|disableRemotePlayback|download|draggable|encType|enterKeyHint|fetchpriority|fetchPriority|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/, Fl = /* @__PURE__ */ Rp(
  function(e) {
    return xp.test(e) || e.charCodeAt(0) === 111 && e.charCodeAt(1) === 110 && e.charCodeAt(2) < 91;
  }
  /* Z+1 */
), Ho = { exports: {} }, Ae = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Bl;
function wp() {
  if (Bl) return Ae;
  Bl = 1;
  var e = typeof Symbol == "function" && Symbol.for, r = e ? Symbol.for("react.element") : 60103, t = e ? Symbol.for("react.portal") : 60106, n = e ? Symbol.for("react.fragment") : 60107, a = e ? Symbol.for("react.strict_mode") : 60108, o = e ? Symbol.for("react.profiler") : 60114, l = e ? Symbol.for("react.provider") : 60109, f = e ? Symbol.for("react.context") : 60110, i = e ? Symbol.for("react.async_mode") : 60111, s = e ? Symbol.for("react.concurrent_mode") : 60111, c = e ? Symbol.for("react.forward_ref") : 60112, d = e ? Symbol.for("react.suspense") : 60113, u = e ? Symbol.for("react.suspense_list") : 60120, m = e ? Symbol.for("react.memo") : 60115, v = e ? Symbol.for("react.lazy") : 60116, h = e ? Symbol.for("react.block") : 60121, g = e ? Symbol.for("react.fundamental") : 60117, p = e ? Symbol.for("react.responder") : 60118, x = e ? Symbol.for("react.scope") : 60119;
  function w(y) {
    if (typeof y == "object" && y !== null) {
      var b = y.$$typeof;
      switch (b) {
        case r:
          switch (y = y.type, y) {
            case i:
            case s:
            case n:
            case o:
            case a:
            case d:
              return y;
            default:
              switch (y = y && y.$$typeof, y) {
                case f:
                case c:
                case v:
                case m:
                case l:
                  return y;
                default:
                  return b;
              }
          }
        case t:
          return b;
      }
    }
  }
  function C(y) {
    return w(y) === s;
  }
  return Ae.AsyncMode = i, Ae.ConcurrentMode = s, Ae.ContextConsumer = f, Ae.ContextProvider = l, Ae.Element = r, Ae.ForwardRef = c, Ae.Fragment = n, Ae.Lazy = v, Ae.Memo = m, Ae.Portal = t, Ae.Profiler = o, Ae.StrictMode = a, Ae.Suspense = d, Ae.isAsyncMode = function(y) {
    return C(y) || w(y) === i;
  }, Ae.isConcurrentMode = C, Ae.isContextConsumer = function(y) {
    return w(y) === f;
  }, Ae.isContextProvider = function(y) {
    return w(y) === l;
  }, Ae.isElement = function(y) {
    return typeof y == "object" && y !== null && y.$$typeof === r;
  }, Ae.isForwardRef = function(y) {
    return w(y) === c;
  }, Ae.isFragment = function(y) {
    return w(y) === n;
  }, Ae.isLazy = function(y) {
    return w(y) === v;
  }, Ae.isMemo = function(y) {
    return w(y) === m;
  }, Ae.isPortal = function(y) {
    return w(y) === t;
  }, Ae.isProfiler = function(y) {
    return w(y) === o;
  }, Ae.isStrictMode = function(y) {
    return w(y) === a;
  }, Ae.isSuspense = function(y) {
    return w(y) === d;
  }, Ae.isValidElementType = function(y) {
    return typeof y == "string" || typeof y == "function" || y === n || y === s || y === o || y === a || y === d || y === u || typeof y == "object" && y !== null && (y.$$typeof === v || y.$$typeof === m || y.$$typeof === l || y.$$typeof === f || y.$$typeof === c || y.$$typeof === g || y.$$typeof === p || y.$$typeof === x || y.$$typeof === h);
  }, Ae.typeOf = w, Ae;
}
var Me = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Hl;
function Ep() {
  return Hl || (Hl = 1, process.env.NODE_ENV !== "production" && function() {
    var e = typeof Symbol == "function" && Symbol.for, r = e ? Symbol.for("react.element") : 60103, t = e ? Symbol.for("react.portal") : 60106, n = e ? Symbol.for("react.fragment") : 60107, a = e ? Symbol.for("react.strict_mode") : 60108, o = e ? Symbol.for("react.profiler") : 60114, l = e ? Symbol.for("react.provider") : 60109, f = e ? Symbol.for("react.context") : 60110, i = e ? Symbol.for("react.async_mode") : 60111, s = e ? Symbol.for("react.concurrent_mode") : 60111, c = e ? Symbol.for("react.forward_ref") : 60112, d = e ? Symbol.for("react.suspense") : 60113, u = e ? Symbol.for("react.suspense_list") : 60120, m = e ? Symbol.for("react.memo") : 60115, v = e ? Symbol.for("react.lazy") : 60116, h = e ? Symbol.for("react.block") : 60121, g = e ? Symbol.for("react.fundamental") : 60117, p = e ? Symbol.for("react.responder") : 60118, x = e ? Symbol.for("react.scope") : 60119;
    function w(j) {
      return typeof j == "string" || typeof j == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      j === n || j === s || j === o || j === a || j === d || j === u || typeof j == "object" && j !== null && (j.$$typeof === v || j.$$typeof === m || j.$$typeof === l || j.$$typeof === f || j.$$typeof === c || j.$$typeof === g || j.$$typeof === p || j.$$typeof === x || j.$$typeof === h);
    }
    function C(j) {
      if (typeof j == "object" && j !== null) {
        var ie = j.$$typeof;
        switch (ie) {
          case r:
            var Z = j.type;
            switch (Z) {
              case i:
              case s:
              case n:
              case o:
              case a:
              case d:
                return Z;
              default:
                var se = Z && Z.$$typeof;
                switch (se) {
                  case f:
                  case c:
                  case v:
                  case m:
                  case l:
                    return se;
                  default:
                    return ie;
                }
            }
          case t:
            return ie;
        }
      }
    }
    var y = i, b = s, R = f, E = l, M = r, I = c, $ = n, G = v, D = m, k = t, F = o, B = a, H = d, U = !1;
    function ae(j) {
      return U || (U = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), oe(j) || C(j) === i;
    }
    function oe(j) {
      return C(j) === s;
    }
    function ce(j) {
      return C(j) === f;
    }
    function J(j) {
      return C(j) === l;
    }
    function O(j) {
      return typeof j == "object" && j !== null && j.$$typeof === r;
    }
    function N(j) {
      return C(j) === c;
    }
    function V(j) {
      return C(j) === n;
    }
    function A(j) {
      return C(j) === v;
    }
    function le(j) {
      return C(j) === m;
    }
    function X(j) {
      return C(j) === t;
    }
    function q(j) {
      return C(j) === o;
    }
    function W(j) {
      return C(j) === a;
    }
    function L(j) {
      return C(j) === d;
    }
    Me.AsyncMode = y, Me.ConcurrentMode = b, Me.ContextConsumer = R, Me.ContextProvider = E, Me.Element = M, Me.ForwardRef = I, Me.Fragment = $, Me.Lazy = G, Me.Memo = D, Me.Portal = k, Me.Profiler = F, Me.StrictMode = B, Me.Suspense = H, Me.isAsyncMode = ae, Me.isConcurrentMode = oe, Me.isContextConsumer = ce, Me.isContextProvider = J, Me.isElement = O, Me.isForwardRef = N, Me.isFragment = V, Me.isLazy = A, Me.isMemo = le, Me.isPortal = X, Me.isProfiler = q, Me.isStrictMode = W, Me.isSuspense = L, Me.isValidElementType = w, Me.typeOf = C;
  }()), Me;
}
var Ul;
function Cp() {
  return Ul || (Ul = 1, process.env.NODE_ENV === "production" ? Ho.exports = wp() : Ho.exports = Ep()), Ho.exports;
}
var Oi, Wl;
function _p() {
  if (Wl) return Oi;
  Wl = 1;
  var e = Cp(), r = {
    childContextTypes: !0,
    contextType: !0,
    contextTypes: !0,
    defaultProps: !0,
    displayName: !0,
    getDefaultProps: !0,
    getDerivedStateFromError: !0,
    getDerivedStateFromProps: !0,
    mixins: !0,
    propTypes: !0,
    type: !0
  }, t = {
    name: !0,
    length: !0,
    prototype: !0,
    caller: !0,
    callee: !0,
    arguments: !0,
    arity: !0
  }, n = {
    $$typeof: !0,
    render: !0,
    defaultProps: !0,
    displayName: !0,
    propTypes: !0
  }, a = {
    $$typeof: !0,
    compare: !0,
    defaultProps: !0,
    displayName: !0,
    propTypes: !0,
    type: !0
  }, o = {};
  o[e.ForwardRef] = n, o[e.Memo] = a;
  function l(v) {
    return e.isMemo(v) ? a : o[v.$$typeof] || r;
  }
  var f = Object.defineProperty, i = Object.getOwnPropertyNames, s = Object.getOwnPropertySymbols, c = Object.getOwnPropertyDescriptor, d = Object.getPrototypeOf, u = Object.prototype;
  function m(v, h, g) {
    if (typeof h != "string") {
      if (u) {
        var p = d(h);
        p && p !== u && m(v, p, g);
      }
      var x = i(h);
      s && (x = x.concat(s(h)));
      for (var w = l(v), C = l(h), y = 0; y < x.length; ++y) {
        var b = x[y];
        if (!t[b] && !(g && g[b]) && !(C && C[b]) && !(w && w[b])) {
          var R = c(h, b);
          try {
            f(v, b, R);
          } catch {
          }
        }
      }
    }
    return v;
  }
  return Oi = m, Oi;
}
var Pp = _p();
const Tp = /* @__PURE__ */ gi(Pp);
function Cr() {
  return (Cr = Object.assign || function(e) {
    for (var r = 1; r < arguments.length; r++) {
      var t = arguments[r];
      for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
    }
    return e;
  }).apply(this, arguments);
}
var zl = function(e, r) {
  for (var t = [e[0]], n = 0, a = r.length; n < a; n += 1) t.push(r[n], e[n + 1]);
  return t;
}, Hi = function(e) {
  return e !== null && typeof e == "object" && (e.toString ? e.toString() : Object.prototype.toString.call(e)) === "[object Object]" && !ul.typeOf(e);
}, ui = Object.freeze([]), Jr = Object.freeze({});
function Po(e) {
  return typeof e == "function";
}
function Ui(e) {
  return process.env.NODE_ENV !== "production" && typeof e == "string" && e || e.displayName || e.name || "Component";
}
function cl(e) {
  return e && typeof e.styledComponentId == "string";
}
var bt = typeof process < "u" && process.env !== void 0 && (process.env.REACT_APP_SC_ATTR || process.env.SC_ATTR) || "data-styled", dl = typeof window < "u" && "HTMLElement" in window, Sp = !!(typeof SC_DISABLE_SPEEDY == "boolean" ? SC_DISABLE_SPEEDY : typeof process < "u" && process.env !== void 0 && (process.env.REACT_APP_SC_DISABLE_SPEEDY !== void 0 && process.env.REACT_APP_SC_DISABLE_SPEEDY !== "" ? process.env.REACT_APP_SC_DISABLE_SPEEDY !== "false" && process.env.REACT_APP_SC_DISABLE_SPEEDY : process.env.SC_DISABLE_SPEEDY !== void 0 && process.env.SC_DISABLE_SPEEDY !== "" ? process.env.SC_DISABLE_SPEEDY !== "false" && process.env.SC_DISABLE_SPEEDY : process.env.NODE_ENV !== "production")), qp = {}, Op = process.env.NODE_ENV !== "production" ? { 1: `Cannot create styled-component for component: %s.

`, 2: `Can't collect styles once you've consumed a \`ServerStyleSheet\`'s styles! \`ServerStyleSheet\` is a one off instance for each server-side render cycle.

- Are you trying to reuse it across renders?
- Are you accidentally calling collectStyles twice?

`, 3: `Streaming SSR is only supported in a Node.js environment; Please do not try to call this method in the browser.

`, 4: `The \`StyleSheetManager\` expects a valid target or sheet prop!

- Does this error occur on the client and is your target falsy?
- Does this error occur on the server and is the sheet falsy?

`, 5: `The clone method cannot be used on the client!

- Are you running in a client-like environment on the server?
- Are you trying to run SSR on the client?

`, 6: `Trying to insert a new style tag, but the given Node is unmounted!

- Are you using a custom target that isn't mounted?
- Does your document not have a valid head element?
- Have you accidentally removed a style tag manually?

`, 7: 'ThemeProvider: Please return an object from your "theme" prop function, e.g.\n\n```js\ntheme={() => ({})}\n```\n\n', 8: `ThemeProvider: Please make your "theme" prop an object.

`, 9: "Missing document `<head>`\n\n", 10: `Cannot find a StyleSheet instance. Usually this happens if there are multiple copies of styled-components loaded at once. Check out this issue for how to troubleshoot and fix the common cases where this situation can happen: https://github.com/styled-components/styled-components/issues/1941#issuecomment-417862021

`, 11: `_This error was replaced with a dev-time warning, it will be deleted for v4 final._ [createGlobalStyle] received children which will not be rendered. Please use the component without passing children elements.

`, 12: "It seems you are interpolating a keyframe declaration (%s) into an untagged string. This was supported in styled-components v3, but is not longer supported in v4 as keyframes are now injected on-demand. Please wrap your string in the css\\`\\` helper which ensures the styles are injected correctly. See https://www.styled-components.com/docs/api#css\n\n", 13: `%s is not a styled component and cannot be referred to via component selector. See https://www.styled-components.com/docs/advanced#referring-to-other-components for more details.

`, 14: `ThemeProvider: "theme" prop is required.

`, 15: "A stylis plugin has been supplied that is not named. We need a name for each plugin to be able to prevent styling collisions between different stylis configurations within the same app. Before you pass your plugin to `<StyleSheetManager stylisPlugins={[]}>`, please make sure each plugin is uniquely-named, e.g.\n\n```js\nObject.defineProperty(importedPlugin, 'name', { value: 'some-unique-name' });\n```\n\n", 16: `Reached the limit of how many styled components may be created at group %s.
You may only create up to 1,073,741,824 components. If you're creating components dynamically,
as for instance in your render method then you may be running into this limitation.

`, 17: `CSSStyleSheet could not be found on HTMLStyleElement.
Has styled-components' style tag been unmounted or altered by another script?
` } : {};
function Ap() {
  for (var e = arguments.length <= 0 ? void 0 : arguments[0], r = [], t = 1, n = arguments.length; t < n; t += 1) r.push(t < 0 || arguments.length <= t ? void 0 : arguments[t]);
  return r.forEach(function(a) {
    e = e.replace(/%[a-z]/, a);
  }), e;
}
function Pt(e) {
  for (var r = arguments.length, t = new Array(r > 1 ? r - 1 : 0), n = 1; n < r; n++) t[n - 1] = arguments[n];
  throw process.env.NODE_ENV === "production" ? new Error("An error occurred. See https://git.io/JUIaE#" + e + " for more information." + (t.length > 0 ? " Args: " + t.join(", ") : "")) : new Error(Ap.apply(void 0, [Op[e]].concat(t)).trim());
}
var Mp = function() {
  function e(t) {
    this.groupSizes = new Uint32Array(512), this.length = 512, this.tag = t;
  }
  var r = e.prototype;
  return r.indexOfGroup = function(t) {
    for (var n = 0, a = 0; a < t; a++) n += this.groupSizes[a];
    return n;
  }, r.insertRules = function(t, n) {
    if (t >= this.groupSizes.length) {
      for (var a = this.groupSizes, o = a.length, l = o; t >= l; ) (l <<= 1) < 0 && Pt(16, "" + t);
      this.groupSizes = new Uint32Array(l), this.groupSizes.set(a), this.length = l;
      for (var f = o; f < l; f++) this.groupSizes[f] = 0;
    }
    for (var i = this.indexOfGroup(t + 1), s = 0, c = n.length; s < c; s++) this.tag.insertRule(i, n[s]) && (this.groupSizes[t]++, i++);
  }, r.clearGroup = function(t) {
    if (t < this.length) {
      var n = this.groupSizes[t], a = this.indexOfGroup(t), o = a + n;
      this.groupSizes[t] = 0;
      for (var l = a; l < o; l++) this.tag.deleteRule(a);
    }
  }, r.getGroup = function(t) {
    var n = "";
    if (t >= this.length || this.groupSizes[t] === 0) return n;
    for (var a = this.groupSizes[t], o = this.indexOfGroup(t), l = o + a, f = o; f < l; f++) n += this.tag.getRule(f) + `/*!sc*/
`;
    return n;
  }, e;
}(), ri = /* @__PURE__ */ new Map(), ci = /* @__PURE__ */ new Map(), wo = 1, Uo = function(e) {
  if (ri.has(e)) return ri.get(e);
  for (; ci.has(wo); ) wo++;
  var r = wo++;
  return process.env.NODE_ENV !== "production" && ((0 | r) < 0 || r > 1 << 30) && Pt(16, "" + r), ri.set(e, r), ci.set(r, e), r;
}, kp = function(e) {
  return ci.get(e);
}, Dp = function(e, r) {
  r >= wo && (wo = r + 1), ri.set(e, r), ci.set(r, e);
}, jp = "style[" + bt + '][data-styled-version="5.3.11"]', Ip = new RegExp("^" + bt + '\\.g(\\d+)\\[id="([\\w\\d-]+)"\\].*?"([^"]*)'), Np = function(e, r, t) {
  for (var n, a = t.split(","), o = 0, l = a.length; o < l; o++) (n = a[o]) && e.registerName(r, n);
}, Lp = function(e, r) {
  for (var t = (r.textContent || "").split(`/*!sc*/
`), n = [], a = 0, o = t.length; a < o; a++) {
    var l = t[a].trim();
    if (l) {
      var f = l.match(Ip);
      if (f) {
        var i = 0 | parseInt(f[1], 10), s = f[2];
        i !== 0 && (Dp(s, i), Np(e, s, f[3]), e.getTag().insertRules(i, n)), n.length = 0;
      } else n.push(l);
    }
  }
}, $p = function() {
  return typeof __webpack_nonce__ < "u" ? __webpack_nonce__ : null;
}, Vd = function(e) {
  var r = document.head, t = e || r, n = document.createElement("style"), a = function(f) {
    for (var i = f.childNodes, s = i.length; s >= 0; s--) {
      var c = i[s];
      if (c && c.nodeType === 1 && c.hasAttribute(bt)) return c;
    }
  }(t), o = a !== void 0 ? a.nextSibling : null;
  n.setAttribute(bt, "active"), n.setAttribute("data-styled-version", "5.3.11");
  var l = $p();
  return l && n.setAttribute("nonce", l), t.insertBefore(n, o), n;
}, Fp = function() {
  function e(t) {
    var n = this.element = Vd(t);
    n.appendChild(document.createTextNode("")), this.sheet = function(a) {
      if (a.sheet) return a.sheet;
      for (var o = document.styleSheets, l = 0, f = o.length; l < f; l++) {
        var i = o[l];
        if (i.ownerNode === a) return i;
      }
      Pt(17);
    }(n), this.length = 0;
  }
  var r = e.prototype;
  return r.insertRule = function(t, n) {
    try {
      return this.sheet.insertRule(n, t), this.length++, !0;
    } catch {
      return !1;
    }
  }, r.deleteRule = function(t) {
    this.sheet.deleteRule(t), this.length--;
  }, r.getRule = function(t) {
    var n = this.sheet.cssRules[t];
    return n !== void 0 && typeof n.cssText == "string" ? n.cssText : "";
  }, e;
}(), Bp = function() {
  function e(t) {
    var n = this.element = Vd(t);
    this.nodes = n.childNodes, this.length = 0;
  }
  var r = e.prototype;
  return r.insertRule = function(t, n) {
    if (t <= this.length && t >= 0) {
      var a = document.createTextNode(n), o = this.nodes[t];
      return this.element.insertBefore(a, o || null), this.length++, !0;
    }
    return !1;
  }, r.deleteRule = function(t) {
    this.element.removeChild(this.nodes[t]), this.length--;
  }, r.getRule = function(t) {
    return t < this.length ? this.nodes[t].textContent : "";
  }, e;
}(), Hp = function() {
  function e(t) {
    this.rules = [], this.length = 0;
  }
  var r = e.prototype;
  return r.insertRule = function(t, n) {
    return t <= this.length && (this.rules.splice(t, 0, n), this.length++, !0);
  }, r.deleteRule = function(t) {
    this.rules.splice(t, 1), this.length--;
  }, r.getRule = function(t) {
    return t < this.length ? this.rules[t] : "";
  }, e;
}(), Yl = dl, Up = { isServer: !dl, useCSSOMInjection: !Sp }, di = function() {
  function e(t, n, a) {
    t === void 0 && (t = Jr), n === void 0 && (n = {}), this.options = Cr({}, Up, {}, t), this.gs = n, this.names = new Map(a), this.server = !!t.isServer, !this.server && dl && Yl && (Yl = !1, function(o) {
      for (var l = document.querySelectorAll(jp), f = 0, i = l.length; f < i; f++) {
        var s = l[f];
        s && s.getAttribute(bt) !== "active" && (Lp(o, s), s.parentNode && s.parentNode.removeChild(s));
      }
    }(this));
  }
  e.registerId = function(t) {
    return Uo(t);
  };
  var r = e.prototype;
  return r.reconstructWithOptions = function(t, n) {
    return n === void 0 && (n = !0), new e(Cr({}, this.options, {}, t), this.gs, n && this.names || void 0);
  }, r.allocateGSInstance = function(t) {
    return this.gs[t] = (this.gs[t] || 0) + 1;
  }, r.getTag = function() {
    return this.tag || (this.tag = (a = (n = this.options).isServer, o = n.useCSSOMInjection, l = n.target, t = a ? new Hp(l) : o ? new Fp(l) : new Bp(l), new Mp(t)));
    var t, n, a, o, l;
  }, r.hasNameForId = function(t, n) {
    return this.names.has(t) && this.names.get(t).has(n);
  }, r.registerName = function(t, n) {
    if (Uo(t), this.names.has(t)) this.names.get(t).add(n);
    else {
      var a = /* @__PURE__ */ new Set();
      a.add(n), this.names.set(t, a);
    }
  }, r.insertRules = function(t, n, a) {
    this.registerName(t, n), this.getTag().insertRules(Uo(t), a);
  }, r.clearNames = function(t) {
    this.names.has(t) && this.names.get(t).clear();
  }, r.clearRules = function(t) {
    this.getTag().clearGroup(Uo(t)), this.clearNames(t);
  }, r.clearTag = function() {
    this.tag = void 0;
  }, r.toString = function() {
    return function(t) {
      for (var n = t.getTag(), a = n.length, o = "", l = 0; l < a; l++) {
        var f = kp(l);
        if (f !== void 0) {
          var i = t.names.get(f), s = n.getGroup(l);
          if (i && s && i.size) {
            var c = bt + ".g" + l + '[id="' + f + '"]', d = "";
            i !== void 0 && i.forEach(function(u) {
              u.length > 0 && (d += u + ",");
            }), o += "" + s + c + '{content:"' + d + `"}/*!sc*/
`;
          }
        }
      }
      return o;
    }(this);
  }, e;
}(), Wp = /(a)(d)/gi, Vl = function(e) {
  return String.fromCharCode(e + (e > 25 ? 39 : 97));
};
function Wi(e) {
  var r, t = "";
  for (r = Math.abs(e); r > 52; r = r / 52 | 0) t = Vl(r % 52) + t;
  return (Vl(r % 52) + t).replace(Wp, "$1-$2");
}
var at = function(e, r) {
  for (var t = r.length; t; ) e = 33 * e ^ r.charCodeAt(--t);
  return e;
}, Gd = function(e) {
  return at(5381, e);
};
function Xd(e) {
  for (var r = 0; r < e.length; r += 1) {
    var t = e[r];
    if (Po(t) && !cl(t)) return !1;
  }
  return !0;
}
var zp = Gd("5.3.11"), Yp = function() {
  function e(r, t, n) {
    this.rules = r, this.staticRulesId = "", this.isStatic = process.env.NODE_ENV === "production" && (n === void 0 || n.isStatic) && Xd(r), this.componentId = t, this.baseHash = at(zp, t), this.baseStyle = n, di.registerId(t);
  }
  return e.prototype.generateAndInjectStyles = function(r, t, n) {
    var a = this.componentId, o = [];
    if (this.baseStyle && o.push(this.baseStyle.generateAndInjectStyles(r, t, n)), this.isStatic && !n.hash) if (this.staticRulesId && t.hasNameForId(a, this.staticRulesId)) o.push(this.staticRulesId);
    else {
      var l = st(this.rules, r, t, n).join(""), f = Wi(at(this.baseHash, l) >>> 0);
      if (!t.hasNameForId(a, f)) {
        var i = n(l, "." + f, void 0, a);
        t.insertRules(a, f, i);
      }
      o.push(f), this.staticRulesId = f;
    }
    else {
      for (var s = this.rules.length, c = at(this.baseHash, n.hash), d = "", u = 0; u < s; u++) {
        var m = this.rules[u];
        if (typeof m == "string") d += m, process.env.NODE_ENV !== "production" && (c = at(c, m + u));
        else if (m) {
          var v = st(m, r, t, n), h = Array.isArray(v) ? v.join("") : v;
          c = at(c, h + u), d += h;
        }
      }
      if (d) {
        var g = Wi(c >>> 0);
        if (!t.hasNameForId(a, g)) {
          var p = n(d, "." + g, void 0, a);
          t.insertRules(a, g, p);
        }
        o.push(g);
      }
    }
    return o.join(" ");
  }, e;
}(), Vp = /^\s*\/\/.*$/gm, Gp = [":", "[", ".", "#"];
function Xp(e) {
  var r, t, n, a, o = Jr, l = o.options, f = l === void 0 ? Jr : l, i = o.plugins, s = i === void 0 ? ui : i, c = new yp(f), d = [], u = /* @__PURE__ */ function(h) {
    function g(p) {
      if (p) try {
        h(p + "}");
      } catch {
      }
    }
    return function(p, x, w, C, y, b, R, E, M, I) {
      switch (p) {
        case 1:
          if (M === 0 && x.charCodeAt(0) === 64) return h(x + ";"), "";
          break;
        case 2:
          if (E === 0) return x + "/*|*/";
          break;
        case 3:
          switch (E) {
            case 102:
            case 112:
              return h(w[0] + x), "";
            default:
              return x + (I === 0 ? "/*|*/" : "");
          }
        case -2:
          x.split("/*|*/}").forEach(g);
      }
    };
  }(function(h) {
    d.push(h);
  }), m = function(h, g, p) {
    return g === 0 && Gp.indexOf(p[t.length]) !== -1 || p.match(a) ? h : "." + r;
  };
  function v(h, g, p, x) {
    x === void 0 && (x = "&");
    var w = h.replace(Vp, ""), C = g && p ? p + " " + g + " { " + w + " }" : w;
    return r = x, t = g, n = new RegExp("\\" + t + "\\b", "g"), a = new RegExp("(\\" + t + "\\b){2,}"), c(p || !g ? "" : g, C);
  }
  return c.use([].concat(s, [function(h, g, p) {
    h === 2 && p.length && p[0].lastIndexOf(t) > 0 && (p[0] = p[0].replace(n, m));
  }, u, function(h) {
    if (h === -2) {
      var g = d;
      return d = [], g;
    }
  }])), v.hash = s.length ? s.reduce(function(h, g) {
    return g.name || Pt(15), at(h, g.name);
  }, 5381).toString() : "", v;
}
var Kd = Je.createContext();
Kd.Consumer;
var Jd = Je.createContext(), Kp = (Jd.Consumer, new di()), zi = Xp();
function Zd() {
  return yi(Kd) || Kp;
}
function Qd() {
  return yi(Jd) || zi;
}
var Jp = function() {
  function e(r, t) {
    var n = this;
    this.inject = function(a, o) {
      o === void 0 && (o = zi);
      var l = n.name + o.hash;
      a.hasNameForId(n.id, l) || a.insertRules(n.id, l, o(n.rules, l, "@keyframes"));
    }, this.toString = function() {
      return Pt(12, String(n.name));
    }, this.name = r, this.id = "sc-keyframes-" + r, this.rules = t;
  }
  return e.prototype.getName = function(r) {
    return r === void 0 && (r = zi), this.name + r.hash;
  }, e;
}(), Zp = /([A-Z])/, Qp = /([A-Z])/g, em = /^ms-/, rm = function(e) {
  return "-" + e.toLowerCase();
};
function Gl(e) {
  return Zp.test(e) ? e.replace(Qp, rm).replace(em, "-ms-") : e;
}
var Xl = function(e) {
  return e == null || e === !1 || e === "";
};
function st(e, r, t, n) {
  if (Array.isArray(e)) {
    for (var a, o = [], l = 0, f = e.length; l < f; l += 1) (a = st(e[l], r, t, n)) !== "" && (Array.isArray(a) ? o.push.apply(o, a) : o.push(a));
    return o;
  }
  if (Xl(e)) return "";
  if (cl(e)) return "." + e.styledComponentId;
  if (Po(e)) {
    if (typeof (s = e) != "function" || s.prototype && s.prototype.isReactComponent || !r) return e;
    var i = e(r);
    return process.env.NODE_ENV !== "production" && ul.isElement(i) && console.warn(Ui(e) + " is not a styled component and cannot be referred to via component selector. See https://www.styled-components.com/docs/advanced#referring-to-other-components for more details."), st(i, r, t, n);
  }
  var s;
  return e instanceof Jp ? t ? (e.inject(t, n), e.getName(n)) : e : Hi(e) ? function c(d, u) {
    var m, v, h = [];
    for (var g in d) d.hasOwnProperty(g) && !Xl(d[g]) && (Array.isArray(d[g]) && d[g].isCss || Po(d[g]) ? h.push(Gl(g) + ":", d[g], ";") : Hi(d[g]) ? h.push.apply(h, c(d[g], g)) : h.push(Gl(g) + ": " + (m = g, (v = d[g]) == null || typeof v == "boolean" || v === "" ? "" : typeof v != "number" || v === 0 || m in gp || m.startsWith("--") ? String(v).trim() : v + "px") + ";"));
    return u ? [u + " {"].concat(h, ["}"]) : h;
  }(e) : e.toString();
}
var Kl = function(e) {
  return Array.isArray(e) && (e.isCss = !0), e;
};
function ef(e) {
  for (var r = arguments.length, t = new Array(r > 1 ? r - 1 : 0), n = 1; n < r; n++) t[n - 1] = arguments[n];
  return Po(e) || Hi(e) ? Kl(st(zl(ui, [e].concat(t)))) : t.length === 0 && e.length === 1 && typeof e[0] == "string" ? e : Kl(st(zl(e, t)));
}
var Jl = /invalid hook call/i, Wo = /* @__PURE__ */ new Set(), rf = function(e, r) {
  if (process.env.NODE_ENV !== "production") {
    var t = "The component " + e + (r ? ' with the id of "' + r + '"' : "") + ` has been created dynamically.
You may see this warning because you've called styled inside another component.
To resolve this only create new StyledComponents outside of any render method and function component.`, n = console.error;
    try {
      var a = !0;
      console.error = function(o) {
        if (Jl.test(o)) a = !1, Wo.delete(t);
        else {
          for (var l = arguments.length, f = new Array(l > 1 ? l - 1 : 0), i = 1; i < l; i++) f[i - 1] = arguments[i];
          n.apply(void 0, [o].concat(f));
        }
      }, _t(), a && !Wo.has(t) && (console.warn(t), Wo.add(t));
    } catch (o) {
      Jl.test(o.message) && Wo.delete(t);
    } finally {
      console.error = n;
    }
  }
}, tf = function(e, r, t) {
  return t === void 0 && (t = Jr), e.theme !== t.theme && e.theme || r || t.theme;
}, tm = /[!"#$%&'()*+,./:;<=>?@[\\\]^`{|}~-]+/g, nm = /(^-|-$)/g;
function Ai(e) {
  return e.replace(tm, "-").replace(nm, "");
}
var nf = function(e) {
  return Wi(Gd(e) >>> 0);
};
function zo(e) {
  return typeof e == "string" && (process.env.NODE_ENV === "production" || e.charAt(0) === e.charAt(0).toLowerCase());
}
var Yi = function(e) {
  return typeof e == "function" || typeof e == "object" && e !== null && !Array.isArray(e);
}, am = function(e) {
  return e !== "__proto__" && e !== "constructor" && e !== "prototype";
};
function om(e, r, t) {
  var n = e[t];
  Yi(r) && Yi(n) ? af(n, r) : e[t] = r;
}
function af(e) {
  for (var r = arguments.length, t = new Array(r > 1 ? r - 1 : 0), n = 1; n < r; n++) t[n - 1] = arguments[n];
  for (var a = 0, o = t; a < o.length; a++) {
    var l = o[a];
    if (Yi(l)) for (var f in l) am(f) && om(e, l[f], f);
  }
  return e;
}
var fl = Je.createContext();
fl.Consumer;
var Mi = {};
function of(e, r, t) {
  var n = cl(e), a = !zo(e), o = r.attrs, l = o === void 0 ? ui : o, f = r.componentId, i = f === void 0 ? function(x, w) {
    var C = typeof x != "string" ? "sc" : Ai(x);
    Mi[C] = (Mi[C] || 0) + 1;
    var y = C + "-" + nf("5.3.11" + C + Mi[C]);
    return w ? w + "-" + y : y;
  }(r.displayName, r.parentComponentId) : f, s = r.displayName, c = s === void 0 ? function(x) {
    return zo(x) ? "styled." + x : "Styled(" + Ui(x) + ")";
  }(e) : s, d = r.displayName && r.componentId ? Ai(r.displayName) + "-" + r.componentId : r.componentId || i, u = n && e.attrs ? Array.prototype.concat(e.attrs, l).filter(Boolean) : l, m = r.shouldForwardProp;
  n && e.shouldForwardProp && (m = r.shouldForwardProp ? function(x, w, C) {
    return e.shouldForwardProp(x, w, C) && r.shouldForwardProp(x, w, C);
  } : e.shouldForwardProp);
  var v, h = new Yp(t, d, n ? e.componentStyle : void 0), g = h.isStatic && l.length === 0, p = function(x, w) {
    return function(C, y, b, R) {
      var E = C.attrs, M = C.componentStyle, I = C.defaultProps, $ = C.foldedComponentIds, G = C.shouldForwardProp, D = C.styledComponentId, k = C.target, F = function(V, A, le) {
        V === void 0 && (V = Jr);
        var X = Cr({}, A, { theme: V }), q = {};
        return le.forEach(function(W) {
          var L, j, ie, Z = W;
          for (L in Po(Z) && (Z = Z(X)), Z) X[L] = q[L] = L === "className" ? (j = q[L], ie = Z[L], j && ie ? j + " " + ie : j || ie) : Z[L];
        }), [X, q];
      }(tf(y, yi(fl), I) || Jr, y, E), B = F[0], H = F[1], U = function(V, A, le, X) {
        var q = Zd(), W = Qd(), L = A ? V.generateAndInjectStyles(Jr, q, W) : V.generateAndInjectStyles(le, q, W);
        return process.env.NODE_ENV !== "production" && !A && X && X(L), L;
      }(M, R, B, process.env.NODE_ENV !== "production" ? C.warnTooManyClasses : void 0), ae = b, oe = H.$as || y.$as || H.as || y.as || k, ce = zo(oe), J = H !== y ? Cr({}, y, {}, H) : y, O = {};
      for (var N in J) N[0] !== "$" && N !== "as" && (N === "forwardedAs" ? O.as = J[N] : (G ? G(N, Fl, oe) : !ce || Fl(N)) && (O[N] = J[N]));
      return y.style && H.style !== y.style && (O.style = Cr({}, y.style, {}, H.style)), O.className = Array.prototype.concat($, D, U !== D ? U : null, y.className, H.className).filter(Boolean).join(" "), O.ref = ae, cp(oe, O);
    }(v, x, w, g);
  };
  return p.displayName = c, (v = Je.forwardRef(p)).attrs = u, v.componentStyle = h, v.displayName = c, v.shouldForwardProp = m, v.foldedComponentIds = n ? Array.prototype.concat(e.foldedComponentIds, e.styledComponentId) : ui, v.styledComponentId = d, v.target = n ? e.target : e, v.withComponent = function(x) {
    var w = r.componentId, C = function(b, R) {
      if (b == null) return {};
      var E, M, I = {}, $ = Object.keys(b);
      for (M = 0; M < $.length; M++) E = $[M], R.indexOf(E) >= 0 || (I[E] = b[E]);
      return I;
    }(r, ["componentId"]), y = w && w + "-" + (zo(x) ? x : Ai(Ui(x)));
    return of(x, Cr({}, C, { attrs: u, componentId: y }), t);
  }, Object.defineProperty(v, "defaultProps", { get: function() {
    return this._foldedDefaultProps;
  }, set: function(x) {
    this._foldedDefaultProps = n ? af({}, e.defaultProps, x) : x;
  } }), process.env.NODE_ENV !== "production" && (rf(c, d), v.warnTooManyClasses = /* @__PURE__ */ function(x, w) {
    var C = {}, y = !1;
    return function(b) {
      if (!y && (C[b] = !0, Object.keys(C).length >= 200)) {
        var R = w ? ' with the id of "' + w + '"' : "";
        console.warn("Over 200 classes were generated for component " + x + R + `.
Consider using the attrs method, together with a style object for frequently changed styles.
Example:
  const Component = styled.div.attrs(props => ({
    style: {
      background: props.background,
    },
  }))\`width: 100%;\`

  <Component />`), y = !0, C = {};
      }
    };
  }(c, d)), Object.defineProperty(v, "toString", { value: function() {
    return "." + v.styledComponentId;
  } }), a && Tp(v, e, { attrs: !0, componentStyle: !0, displayName: !0, foldedComponentIds: !0, shouldForwardProp: !0, styledComponentId: !0, target: !0, withComponent: !0 }), v;
}
var Q = function(e) {
  return function r(t, n, a) {
    if (a === void 0 && (a = Jr), !ul.isValidElementType(n)) return Pt(1, String(n));
    var o = function() {
      return t(n, a, ef.apply(void 0, arguments));
    };
    return o.withConfig = function(l) {
      return r(t, n, Cr({}, a, {}, l));
    }, o.attrs = function(l) {
      return r(t, n, Cr({}, a, { attrs: Array.prototype.concat(a.attrs, l).filter(Boolean) }));
    }, o;
  }(of, e);
};
["a", "abbr", "address", "area", "article", "aside", "audio", "b", "base", "bdi", "bdo", "big", "blockquote", "body", "br", "button", "canvas", "caption", "cite", "code", "col", "colgroup", "data", "datalist", "dd", "del", "details", "dfn", "dialog", "div", "dl", "dt", "em", "embed", "fieldset", "figcaption", "figure", "footer", "form", "h1", "h2", "h3", "h4", "h5", "h6", "head", "header", "hgroup", "hr", "html", "i", "iframe", "img", "input", "ins", "kbd", "keygen", "label", "legend", "li", "link", "main", "map", "mark", "marquee", "menu", "menuitem", "meta", "meter", "nav", "noscript", "object", "ol", "optgroup", "option", "output", "p", "param", "picture", "pre", "progress", "q", "rp", "rt", "ruby", "s", "samp", "script", "section", "select", "small", "source", "span", "strong", "style", "sub", "summary", "sup", "table", "tbody", "td", "textarea", "tfoot", "th", "thead", "time", "title", "tr", "track", "u", "ul", "var", "video", "wbr", "circle", "clipPath", "defs", "ellipse", "foreignObject", "g", "image", "line", "linearGradient", "marker", "mask", "path", "pattern", "polygon", "polyline", "radialGradient", "rect", "stop", "svg", "text", "textPath", "tspan"].forEach(function(e) {
  Q[e] = Q(e);
});
var im = function() {
  function e(t, n) {
    this.rules = t, this.componentId = n, this.isStatic = Xd(t), di.registerId(this.componentId + 1);
  }
  var r = e.prototype;
  return r.createStyles = function(t, n, a, o) {
    var l = o(st(this.rules, n, a, o).join(""), ""), f = this.componentId + t;
    a.insertRules(f, f, l);
  }, r.removeStyles = function(t, n) {
    n.clearRules(this.componentId + t);
  }, r.renderStyles = function(t, n, a, o) {
    t > 2 && di.registerId(this.componentId + t), this.removeStyles(t, a), this.createStyles(t, n, a, o);
  }, e;
}();
function lm(e) {
  for (var r = arguments.length, t = new Array(r > 1 ? r - 1 : 0), n = 1; n < r; n++) t[n - 1] = arguments[n];
  var a = ef.apply(void 0, [e].concat(t)), o = "sc-global-" + nf(JSON.stringify(a)), l = new im(a, o);
  function f(s) {
    var c = Zd(), d = Qd(), u = yi(fl), m = _t(c.allocateGSInstance(o)).current;
    return process.env.NODE_ENV !== "production" && Je.Children.count(s.children) && console.warn("The global style component " + o + " was given child JSX. createGlobalStyle does not render children."), process.env.NODE_ENV !== "production" && a.some(function(v) {
      return typeof v == "string" && v.indexOf("@import") !== -1;
    }) && console.warn("Please do not use @import CSS syntax in createGlobalStyle at this time, as the CSSOM APIs we use in production do not handle it well. Instead, we recommend using a library such as react-helmet to inject a typical <link> meta tag to the stylesheet, or simply embedding it manually in your index.html <head> section for a simpler app."), c.server && i(m, s, c, u, d), dp(function() {
      if (!c.server) return i(m, s, c, u, d), function() {
        return l.removeStyles(m, c);
      };
    }, [m, s, c, u, d]), null;
  }
  function i(s, c, d, u, m) {
    if (l.isStatic) l.renderStyles(s, qp, d, m);
    else {
      var v = Cr({}, c, { theme: tf(c, u, f.defaultProps) });
      l.renderStyles(s, v, d, m);
    }
  }
  return process.env.NODE_ENV !== "production" && rf(o), Je.memo(f);
}
process.env.NODE_ENV !== "production" && typeof navigator < "u" && navigator.product === "ReactNative" && console.warn(`It looks like you've imported 'styled-components' on React Native.
Perhaps you're looking to import 'styled-components/native'?
Read more about this at https://www.styled-components.com/docs/basics#react-native`), process.env.NODE_ENV !== "production" && process.env.NODE_ENV !== "test" && typeof window < "u" && (window["__styled-components-init__"] = window["__styled-components-init__"] || 0, window["__styled-components-init__"] === 1 && console.warn(`It looks like there are several instances of 'styled-components' initialized in this application. This may cause dynamic styles to not render properly, errors during the rehydration process, a missing theme prop, and makes your application bigger without good reason.

See https://s-c.sh/2BAXzed for more info.`), window["__styled-components-init__"] += 1);
const sm = Q.div`
    position: absolute;
    top: 0;
    width: fit-content;
    display: flex;
    flex-direction: column;
    padding: 10px;
    gap: 10px;
`;
var Yo = { exports: {} }, Mt = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Zl;
function um() {
  if (Zl) return Mt;
  Zl = 1;
  var e = Je, r = Symbol.for("react.element"), t = Symbol.for("react.fragment"), n = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function l(f, i, s) {
    var c, d = {}, u = null, m = null;
    s !== void 0 && (u = "" + s), i.key !== void 0 && (u = "" + i.key), i.ref !== void 0 && (m = i.ref);
    for (c in i) n.call(i, c) && !o.hasOwnProperty(c) && (d[c] = i[c]);
    if (f && f.defaultProps) for (c in i = f.defaultProps, i) d[c] === void 0 && (d[c] = i[c]);
    return { $$typeof: r, type: f, key: u, ref: m, props: d, _owner: a.current };
  }
  return Mt.Fragment = t, Mt.jsx = l, Mt.jsxs = l, Mt;
}
var kt = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Ql;
function cm() {
  return Ql || (Ql = 1, process.env.NODE_ENV !== "production" && function() {
    var e = Je, r = Symbol.for("react.element"), t = Symbol.for("react.portal"), n = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), l = Symbol.for("react.provider"), f = Symbol.for("react.context"), i = Symbol.for("react.forward_ref"), s = Symbol.for("react.suspense"), c = Symbol.for("react.suspense_list"), d = Symbol.for("react.memo"), u = Symbol.for("react.lazy"), m = Symbol.for("react.offscreen"), v = Symbol.iterator, h = "@@iterator";
    function g(S) {
      if (S === null || typeof S != "object")
        return null;
      var te = v && S[v] || S[h];
      return typeof te == "function" ? te : null;
    }
    var p = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function x(S) {
      {
        for (var te = arguments.length, ue = new Array(te > 1 ? te - 1 : 0), ve = 1; ve < te; ve++)
          ue[ve - 1] = arguments[ve];
        w("error", S, ue);
      }
    }
    function w(S, te, ue) {
      {
        var ve = p.ReactDebugCurrentFrame, Te = ve.getStackAddendum();
        Te !== "" && (te += "%s", ue = ue.concat([Te]));
        var ke = ue.map(function(ge) {
          return String(ge);
        });
        ke.unshift("Warning: " + te), Function.prototype.apply.call(console[S], console, ke);
      }
    }
    var C = !1, y = !1, b = !1, R = !1, E = !1, M;
    M = Symbol.for("react.module.reference");
    function I(S) {
      return !!(typeof S == "string" || typeof S == "function" || S === n || S === o || E || S === a || S === s || S === c || R || S === m || C || y || b || typeof S == "object" && S !== null && (S.$$typeof === u || S.$$typeof === d || S.$$typeof === l || S.$$typeof === f || S.$$typeof === i || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      S.$$typeof === M || S.getModuleId !== void 0));
    }
    function $(S, te, ue) {
      var ve = S.displayName;
      if (ve)
        return ve;
      var Te = te.displayName || te.name || "";
      return Te !== "" ? ue + "(" + Te + ")" : ue;
    }
    function G(S) {
      return S.displayName || "Context";
    }
    function D(S) {
      if (S == null)
        return null;
      if (typeof S.tag == "number" && x("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof S == "function")
        return S.displayName || S.name || null;
      if (typeof S == "string")
        return S;
      switch (S) {
        case n:
          return "Fragment";
        case t:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case s:
          return "Suspense";
        case c:
          return "SuspenseList";
      }
      if (typeof S == "object")
        switch (S.$$typeof) {
          case f:
            var te = S;
            return G(te) + ".Consumer";
          case l:
            var ue = S;
            return G(ue._context) + ".Provider";
          case i:
            return $(S, S.render, "ForwardRef");
          case d:
            var ve = S.displayName || null;
            return ve !== null ? ve : D(S.type) || "Memo";
          case u: {
            var Te = S, ke = Te._payload, ge = Te._init;
            try {
              return D(ge(ke));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var k = Object.assign, F = 0, B, H, U, ae, oe, ce, J;
    function O() {
    }
    O.__reactDisabledLog = !0;
    function N() {
      {
        if (F === 0) {
          B = console.log, H = console.info, U = console.warn, ae = console.error, oe = console.group, ce = console.groupCollapsed, J = console.groupEnd;
          var S = {
            configurable: !0,
            enumerable: !0,
            value: O,
            writable: !0
          };
          Object.defineProperties(console, {
            info: S,
            log: S,
            warn: S,
            error: S,
            group: S,
            groupCollapsed: S,
            groupEnd: S
          });
        }
        F++;
      }
    }
    function V() {
      {
        if (F--, F === 0) {
          var S = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: k({}, S, {
              value: B
            }),
            info: k({}, S, {
              value: H
            }),
            warn: k({}, S, {
              value: U
            }),
            error: k({}, S, {
              value: ae
            }),
            group: k({}, S, {
              value: oe
            }),
            groupCollapsed: k({}, S, {
              value: ce
            }),
            groupEnd: k({}, S, {
              value: J
            })
          });
        }
        F < 0 && x("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var A = p.ReactCurrentDispatcher, le;
    function X(S, te, ue) {
      {
        if (le === void 0)
          try {
            throw Error();
          } catch (Te) {
            var ve = Te.stack.trim().match(/\n( *(at )?)/);
            le = ve && ve[1] || "";
          }
        return `
` + le + S;
      }
    }
    var q = !1, W;
    {
      var L = typeof WeakMap == "function" ? WeakMap : Map;
      W = new L();
    }
    function j(S, te) {
      if (!S || q)
        return "";
      {
        var ue = W.get(S);
        if (ue !== void 0)
          return ue;
      }
      var ve;
      q = !0;
      var Te = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var ke;
      ke = A.current, A.current = null, N();
      try {
        if (te) {
          var ge = function() {
            throw Error();
          };
          if (Object.defineProperty(ge.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(ge, []);
            } catch (tr) {
              ve = tr;
            }
            Reflect.construct(S, [], ge);
          } else {
            try {
              ge.call();
            } catch (tr) {
              ve = tr;
            }
            S.call(ge.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (tr) {
            ve = tr;
          }
          S();
        }
      } catch (tr) {
        if (tr && ve && typeof tr.stack == "string") {
          for (var ye = tr.stack.split(`
`), Qe = ve.stack.split(`
`), Fe = ye.length - 1, Be = Qe.length - 1; Fe >= 1 && Be >= 0 && ye[Fe] !== Qe[Be]; )
            Be--;
          for (; Fe >= 1 && Be >= 0; Fe--, Be--)
            if (ye[Fe] !== Qe[Be]) {
              if (Fe !== 1 || Be !== 1)
                do
                  if (Fe--, Be--, Be < 0 || ye[Fe] !== Qe[Be]) {
                    var ir = `
` + ye[Fe].replace(" at new ", " at ");
                    return S.displayName && ir.includes("<anonymous>") && (ir = ir.replace("<anonymous>", S.displayName)), typeof S == "function" && W.set(S, ir), ir;
                  }
                while (Fe >= 1 && Be >= 0);
              break;
            }
        }
      } finally {
        q = !1, A.current = ke, V(), Error.prepareStackTrace = Te;
      }
      var Or = S ? S.displayName || S.name : "", Ar = Or ? X(Or) : "";
      return typeof S == "function" && W.set(S, Ar), Ar;
    }
    function ie(S, te, ue) {
      return j(S, !1);
    }
    function Z(S) {
      var te = S.prototype;
      return !!(te && te.isReactComponent);
    }
    function se(S, te, ue) {
      if (S == null)
        return "";
      if (typeof S == "function")
        return j(S, Z(S));
      if (typeof S == "string")
        return X(S);
      switch (S) {
        case s:
          return X("Suspense");
        case c:
          return X("SuspenseList");
      }
      if (typeof S == "object")
        switch (S.$$typeof) {
          case i:
            return ie(S.render);
          case d:
            return se(S.type, te, ue);
          case u: {
            var ve = S, Te = ve._payload, ke = ve._init;
            try {
              return se(ke(Te), te, ue);
            } catch {
            }
          }
        }
      return "";
    }
    var pe = Object.prototype.hasOwnProperty, de = {}, Re = p.ReactDebugCurrentFrame;
    function Ue(S) {
      if (S) {
        var te = S._owner, ue = se(S.type, S._source, te ? te.type : null);
        Re.setExtraStackFrame(ue);
      } else
        Re.setExtraStackFrame(null);
    }
    function xe(S, te, ue, ve, Te) {
      {
        var ke = Function.call.bind(pe);
        for (var ge in S)
          if (ke(S, ge)) {
            var ye = void 0;
            try {
              if (typeof S[ge] != "function") {
                var Qe = Error((ve || "React class") + ": " + ue + " type `" + ge + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof S[ge] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw Qe.name = "Invariant Violation", Qe;
              }
              ye = S[ge](te, ge, ve, ue, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (Fe) {
              ye = Fe;
            }
            ye && !(ye instanceof Error) && (Ue(Te), x("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", ve || "React class", ue, ge, typeof ye), Ue(null)), ye instanceof Error && !(ye.message in de) && (de[ye.message] = !0, Ue(Te), x("Failed %s type: %s", ue, ye.message), Ue(null));
          }
      }
    }
    var Ke = Array.isArray;
    function Ge(S) {
      return Ke(S);
    }
    function Le(S) {
      {
        var te = typeof Symbol == "function" && Symbol.toStringTag, ue = te && S[Symbol.toStringTag] || S.constructor.name || "Object";
        return ue;
      }
    }
    function fe(S) {
      try {
        return _e(S), !1;
      } catch {
        return !0;
      }
    }
    function _e(S) {
      return "" + S;
    }
    function Ze(S) {
      if (fe(S))
        return x("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", Le(S)), _e(S);
    }
    var er = p.ReactCurrentOwner, $e = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, zr, _;
    function ee(S) {
      if (pe.call(S, "ref")) {
        var te = Object.getOwnPropertyDescriptor(S, "ref").get;
        if (te && te.isReactWarning)
          return !1;
      }
      return S.ref !== void 0;
    }
    function K(S) {
      if (pe.call(S, "key")) {
        var te = Object.getOwnPropertyDescriptor(S, "key").get;
        if (te && te.isReactWarning)
          return !1;
      }
      return S.key !== void 0;
    }
    function me(S, te) {
      typeof S.ref == "string" && er.current;
    }
    function we(S, te) {
      {
        var ue = function() {
          zr || (zr = !0, x("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", te));
        };
        ue.isReactWarning = !0, Object.defineProperty(S, "key", {
          get: ue,
          configurable: !0
        });
      }
    }
    function Ee(S, te) {
      {
        var ue = function() {
          _ || (_ = !0, x("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", te));
        };
        ue.isReactWarning = !0, Object.defineProperty(S, "ref", {
          get: ue,
          configurable: !0
        });
      }
    }
    var be = function(S, te, ue, ve, Te, ke, ge) {
      var ye = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: r,
        // Built-in properties that belong on the element
        type: S,
        key: te,
        ref: ue,
        props: ge,
        // Record the component responsible for creating this element.
        _owner: ke
      };
      return ye._store = {}, Object.defineProperty(ye._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(ye, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: ve
      }), Object.defineProperty(ye, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: Te
      }), Object.freeze && (Object.freeze(ye.props), Object.freeze(ye)), ye;
    };
    function Pe(S, te, ue, ve, Te) {
      {
        var ke, ge = {}, ye = null, Qe = null;
        ue !== void 0 && (Ze(ue), ye = "" + ue), K(te) && (Ze(te.key), ye = "" + te.key), ee(te) && (Qe = te.ref, me(te, Te));
        for (ke in te)
          pe.call(te, ke) && !$e.hasOwnProperty(ke) && (ge[ke] = te[ke]);
        if (S && S.defaultProps) {
          var Fe = S.defaultProps;
          for (ke in Fe)
            ge[ke] === void 0 && (ge[ke] = Fe[ke]);
        }
        if (ye || Qe) {
          var Be = typeof S == "function" ? S.displayName || S.name || "Unknown" : S;
          ye && we(ge, Be), Qe && Ee(ge, Be);
        }
        return be(S, ye, Qe, Te, ve, er.current, ge);
      }
    }
    var Xe = p.ReactCurrentOwner, rr = p.ReactDebugCurrentFrame;
    function pr(S) {
      if (S) {
        var te = S._owner, ue = se(S.type, S._source, te ? te.type : null);
        rr.setExtraStackFrame(ue);
      } else
        rr.setExtraStackFrame(null);
    }
    var Qr;
    Qr = !1;
    function et(S) {
      return typeof S == "object" && S !== null && S.$$typeof === r;
    }
    function Sr() {
      {
        if (Xe.current) {
          var S = D(Xe.current.type);
          if (S)
            return `

Check the render method of \`` + S + "`.";
        }
        return "";
      }
    }
    function St(S) {
      return "";
    }
    var Yr = {};
    function pt(S) {
      {
        var te = Sr();
        if (!te) {
          var ue = typeof S == "string" ? S : S.displayName || S.name;
          ue && (te = `

Check the top-level render call using <` + ue + ">.");
        }
        return te;
      }
    }
    function ne(S, te) {
      {
        if (!S._store || S._store.validated || S.key != null)
          return;
        S._store.validated = !0;
        var ue = pt(te);
        if (Yr[ue])
          return;
        Yr[ue] = !0;
        var ve = "";
        S && S._owner && S._owner !== Xe.current && (ve = " It was passed a child from " + D(S._owner.type) + "."), pr(S), x('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', ue, ve), pr(null);
      }
    }
    function rt(S, te) {
      {
        if (typeof S != "object")
          return;
        if (Ge(S))
          for (var ue = 0; ue < S.length; ue++) {
            var ve = S[ue];
            et(ve) && ne(ve, te);
          }
        else if (et(S))
          S._store && (S._store.validated = !0);
        else if (S) {
          var Te = g(S);
          if (typeof Te == "function" && Te !== S.entries)
            for (var ke = Te.call(S), ge; !(ge = ke.next()).done; )
              et(ge.value) && ne(ge.value, te);
        }
      }
    }
    function qt(S) {
      {
        var te = S.type;
        if (te == null || typeof te == "string")
          return;
        var ue;
        if (typeof te == "function")
          ue = te.propTypes;
        else if (typeof te == "object" && (te.$$typeof === i || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        te.$$typeof === d))
          ue = te.propTypes;
        else
          return;
        if (ue) {
          var ve = D(te);
          xe(ue, S.props, "prop", ve, S);
        } else if (te.PropTypes !== void 0 && !Qr) {
          Qr = !0;
          var Te = D(te);
          x("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", Te || "Unknown");
        }
        typeof te.getDefaultProps == "function" && !te.getDefaultProps.isReactClassApproved && x("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function qr(S) {
      {
        for (var te = Object.keys(S.props), ue = 0; ue < te.length; ue++) {
          var ve = te[ue];
          if (ve !== "children" && ve !== "key") {
            pr(S), x("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", ve), pr(null);
            break;
          }
        }
        S.ref !== null && (pr(S), x("Invalid attribute `ref` supplied to `React.Fragment`."), pr(null));
      }
    }
    var No = {};
    function Ot(S, te, ue, ve, Te, ke) {
      {
        var ge = I(S);
        if (!ge) {
          var ye = "";
          (S === void 0 || typeof S == "object" && S !== null && Object.keys(S).length === 0) && (ye += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var Qe = St();
          Qe ? ye += Qe : ye += Sr();
          var Fe;
          S === null ? Fe = "null" : Ge(S) ? Fe = "array" : S !== void 0 && S.$$typeof === r ? (Fe = "<" + (D(S.type) || "Unknown") + " />", ye = " Did you accidentally export a JSX literal instead of a component?") : Fe = typeof S, x("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", Fe, ye);
        }
        var Be = Pe(S, te, ue, Te, ke);
        if (Be == null)
          return Be;
        if (ge) {
          var ir = te.children;
          if (ir !== void 0)
            if (ve)
              if (Ge(ir)) {
                for (var Or = 0; Or < ir.length; Or++)
                  rt(ir[Or], S);
                Object.freeze && Object.freeze(ir);
              } else
                x("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              rt(ir, S);
        }
        if (pe.call(te, "key")) {
          var Ar = D(S), tr = Object.keys(te).filter(function($o) {
            return $o !== "key";
          }), At = tr.length > 0 ? "{key: someKey, " + tr.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!No[Ar + At]) {
            var Ti = tr.length > 0 ? "{" + tr.join(": ..., ") + ": ...}" : "{}";
            x(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, At, Ar, Ti, Ar), No[Ar + At] = !0;
          }
        }
        return S === n ? qr(Be) : qt(Be), Be;
      }
    }
    function Ci(S, te, ue) {
      return Ot(S, te, ue, !0);
    }
    function _i(S, te, ue) {
      return Ot(S, te, ue, !1);
    }
    var Pi = _i, Lo = Ci;
    kt.Fragment = n, kt.jsx = Pi, kt.jsxs = Lo;
  }()), kt;
}
var es;
function dm() {
  return es || (es = 1, process.env.NODE_ENV === "production" ? Yo.exports = um() : Yo.exports = cm()), Yo.exports;
}
var T = dm();
const fm = (e, r) => e && new Intl.NumberFormat("pl-PL", {
  minimumFractionDigits: r ?? 0,
  useGrouping: !0
}).format(e);
var ti = { exports: {} }, pm = ti.exports, rs;
function lf() {
  return rs || (rs = 1, function(e, r) {
    (function(t, n) {
      e.exports = n();
    })(pm, function() {
      var t = 1e3, n = 6e4, a = 36e5, o = "millisecond", l = "second", f = "minute", i = "hour", s = "day", c = "week", d = "month", u = "quarter", m = "year", v = "date", h = "Invalid Date", g = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/, p = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, x = { name: "en", weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"), ordinal: function(k) {
        var F = ["th", "st", "nd", "rd"], B = k % 100;
        return "[" + k + (F[(B - 20) % 10] || F[B] || F[0]) + "]";
      } }, w = function(k, F, B) {
        var H = String(k);
        return !H || H.length >= F ? k : "" + Array(F + 1 - H.length).join(B) + k;
      }, C = { s: w, z: function(k) {
        var F = -k.utcOffset(), B = Math.abs(F), H = Math.floor(B / 60), U = B % 60;
        return (F <= 0 ? "+" : "-") + w(H, 2, "0") + ":" + w(U, 2, "0");
      }, m: function k(F, B) {
        if (F.date() < B.date()) return -k(B, F);
        var H = 12 * (B.year() - F.year()) + (B.month() - F.month()), U = F.clone().add(H, d), ae = B - U < 0, oe = F.clone().add(H + (ae ? -1 : 1), d);
        return +(-(H + (B - U) / (ae ? U - oe : oe - U)) || 0);
      }, a: function(k) {
        return k < 0 ? Math.ceil(k) || 0 : Math.floor(k);
      }, p: function(k) {
        return { M: d, y: m, w: c, d: s, D: v, h: i, m: f, s: l, ms: o, Q: u }[k] || String(k || "").toLowerCase().replace(/s$/, "");
      }, u: function(k) {
        return k === void 0;
      } }, y = "en", b = {};
      b[y] = x;
      var R = "$isDayjsObject", E = function(k) {
        return k instanceof G || !(!k || !k[R]);
      }, M = function k(F, B, H) {
        var U;
        if (!F) return y;
        if (typeof F == "string") {
          var ae = F.toLowerCase();
          b[ae] && (U = ae), B && (b[ae] = B, U = ae);
          var oe = F.split("-");
          if (!U && oe.length > 1) return k(oe[0]);
        } else {
          var ce = F.name;
          b[ce] = F, U = ce;
        }
        return !H && U && (y = U), U || !H && y;
      }, I = function(k, F) {
        if (E(k)) return k.clone();
        var B = typeof F == "object" ? F : {};
        return B.date = k, B.args = arguments, new G(B);
      }, $ = C;
      $.l = M, $.i = E, $.w = function(k, F) {
        return I(k, { locale: F.$L, utc: F.$u, x: F.$x, $offset: F.$offset });
      };
      var G = function() {
        function k(B) {
          this.$L = M(B.locale, null, !0), this.parse(B), this.$x = this.$x || B.x || {}, this[R] = !0;
        }
        var F = k.prototype;
        return F.parse = function(B) {
          this.$d = function(H) {
            var U = H.date, ae = H.utc;
            if (U === null) return /* @__PURE__ */ new Date(NaN);
            if ($.u(U)) return /* @__PURE__ */ new Date();
            if (U instanceof Date) return new Date(U);
            if (typeof U == "string" && !/Z$/i.test(U)) {
              var oe = U.match(g);
              if (oe) {
                var ce = oe[2] - 1 || 0, J = (oe[7] || "0").substring(0, 3);
                return ae ? new Date(Date.UTC(oe[1], ce, oe[3] || 1, oe[4] || 0, oe[5] || 0, oe[6] || 0, J)) : new Date(oe[1], ce, oe[3] || 1, oe[4] || 0, oe[5] || 0, oe[6] || 0, J);
              }
            }
            return new Date(U);
          }(B), this.init();
        }, F.init = function() {
          var B = this.$d;
          this.$y = B.getFullYear(), this.$M = B.getMonth(), this.$D = B.getDate(), this.$W = B.getDay(), this.$H = B.getHours(), this.$m = B.getMinutes(), this.$s = B.getSeconds(), this.$ms = B.getMilliseconds();
        }, F.$utils = function() {
          return $;
        }, F.isValid = function() {
          return this.$d.toString() !== h;
        }, F.isSame = function(B, H) {
          var U = I(B);
          return this.startOf(H) <= U && U <= this.endOf(H);
        }, F.isAfter = function(B, H) {
          return I(B) < this.startOf(H);
        }, F.isBefore = function(B, H) {
          return this.endOf(H) < I(B);
        }, F.$g = function(B, H, U) {
          return $.u(B) ? this[H] : this.set(U, B);
        }, F.unix = function() {
          return Math.floor(this.valueOf() / 1e3);
        }, F.valueOf = function() {
          return this.$d.getTime();
        }, F.startOf = function(B, H) {
          var U = this, ae = !!$.u(H) || H, oe = $.p(B), ce = function(q, W) {
            var L = $.w(U.$u ? Date.UTC(U.$y, W, q) : new Date(U.$y, W, q), U);
            return ae ? L : L.endOf(s);
          }, J = function(q, W) {
            return $.w(U.toDate()[q].apply(U.toDate("s"), (ae ? [0, 0, 0, 0] : [23, 59, 59, 999]).slice(W)), U);
          }, O = this.$W, N = this.$M, V = this.$D, A = "set" + (this.$u ? "UTC" : "");
          switch (oe) {
            case m:
              return ae ? ce(1, 0) : ce(31, 11);
            case d:
              return ae ? ce(1, N) : ce(0, N + 1);
            case c:
              var le = this.$locale().weekStart || 0, X = (O < le ? O + 7 : O) - le;
              return ce(ae ? V - X : V + (6 - X), N);
            case s:
            case v:
              return J(A + "Hours", 0);
            case i:
              return J(A + "Minutes", 1);
            case f:
              return J(A + "Seconds", 2);
            case l:
              return J(A + "Milliseconds", 3);
            default:
              return this.clone();
          }
        }, F.endOf = function(B) {
          return this.startOf(B, !1);
        }, F.$set = function(B, H) {
          var U, ae = $.p(B), oe = "set" + (this.$u ? "UTC" : ""), ce = (U = {}, U[s] = oe + "Date", U[v] = oe + "Date", U[d] = oe + "Month", U[m] = oe + "FullYear", U[i] = oe + "Hours", U[f] = oe + "Minutes", U[l] = oe + "Seconds", U[o] = oe + "Milliseconds", U)[ae], J = ae === s ? this.$D + (H - this.$W) : H;
          if (ae === d || ae === m) {
            var O = this.clone().set(v, 1);
            O.$d[ce](J), O.init(), this.$d = O.set(v, Math.min(this.$D, O.daysInMonth())).$d;
          } else ce && this.$d[ce](J);
          return this.init(), this;
        }, F.set = function(B, H) {
          return this.clone().$set(B, H);
        }, F.get = function(B) {
          return this[$.p(B)]();
        }, F.add = function(B, H) {
          var U, ae = this;
          B = Number(B);
          var oe = $.p(H), ce = function(N) {
            var V = I(ae);
            return $.w(V.date(V.date() + Math.round(N * B)), ae);
          };
          if (oe === d) return this.set(d, this.$M + B);
          if (oe === m) return this.set(m, this.$y + B);
          if (oe === s) return ce(1);
          if (oe === c) return ce(7);
          var J = (U = {}, U[f] = n, U[i] = a, U[l] = t, U)[oe] || 1, O = this.$d.getTime() + B * J;
          return $.w(O, this);
        }, F.subtract = function(B, H) {
          return this.add(-1 * B, H);
        }, F.format = function(B) {
          var H = this, U = this.$locale();
          if (!this.isValid()) return U.invalidDate || h;
          var ae = B || "YYYY-MM-DDTHH:mm:ssZ", oe = $.z(this), ce = this.$H, J = this.$m, O = this.$M, N = U.weekdays, V = U.months, A = U.meridiem, le = function(W, L, j, ie) {
            return W && (W[L] || W(H, ae)) || j[L].slice(0, ie);
          }, X = function(W) {
            return $.s(ce % 12 || 12, W, "0");
          }, q = A || function(W, L, j) {
            var ie = W < 12 ? "AM" : "PM";
            return j ? ie.toLowerCase() : ie;
          };
          return ae.replace(p, function(W, L) {
            return L || function(j) {
              switch (j) {
                case "YY":
                  return String(H.$y).slice(-2);
                case "YYYY":
                  return $.s(H.$y, 4, "0");
                case "M":
                  return O + 1;
                case "MM":
                  return $.s(O + 1, 2, "0");
                case "MMM":
                  return le(U.monthsShort, O, V, 3);
                case "MMMM":
                  return le(V, O);
                case "D":
                  return H.$D;
                case "DD":
                  return $.s(H.$D, 2, "0");
                case "d":
                  return String(H.$W);
                case "dd":
                  return le(U.weekdaysMin, H.$W, N, 2);
                case "ddd":
                  return le(U.weekdaysShort, H.$W, N, 3);
                case "dddd":
                  return N[H.$W];
                case "H":
                  return String(ce);
                case "HH":
                  return $.s(ce, 2, "0");
                case "h":
                  return X(1);
                case "hh":
                  return X(2);
                case "a":
                  return q(ce, J, !0);
                case "A":
                  return q(ce, J, !1);
                case "m":
                  return String(J);
                case "mm":
                  return $.s(J, 2, "0");
                case "s":
                  return String(H.$s);
                case "ss":
                  return $.s(H.$s, 2, "0");
                case "SSS":
                  return $.s(H.$ms, 3, "0");
                case "Z":
                  return oe;
              }
              return null;
            }(W) || oe.replace(":", "");
          });
        }, F.utcOffset = function() {
          return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
        }, F.diff = function(B, H, U) {
          var ae, oe = this, ce = $.p(H), J = I(B), O = (J.utcOffset() - this.utcOffset()) * n, N = this - J, V = function() {
            return $.m(oe, J);
          };
          switch (ce) {
            case m:
              ae = V() / 12;
              break;
            case d:
              ae = V();
              break;
            case u:
              ae = V() / 3;
              break;
            case c:
              ae = (N - O) / 6048e5;
              break;
            case s:
              ae = (N - O) / 864e5;
              break;
            case i:
              ae = N / a;
              break;
            case f:
              ae = N / n;
              break;
            case l:
              ae = N / t;
              break;
            default:
              ae = N;
          }
          return U ? ae : $.a(ae);
        }, F.daysInMonth = function() {
          return this.endOf(d).$D;
        }, F.$locale = function() {
          return b[this.$L];
        }, F.locale = function(B, H) {
          if (!B) return this.$L;
          var U = this.clone(), ae = M(B, H, !0);
          return ae && (U.$L = ae), U;
        }, F.clone = function() {
          return $.w(this.$d, this);
        }, F.toDate = function() {
          return new Date(this.valueOf());
        }, F.toJSON = function() {
          return this.isValid() ? this.toISOString() : null;
        }, F.toISOString = function() {
          return this.$d.toISOString();
        }, F.toString = function() {
          return this.$d.toUTCString();
        }, k;
      }(), D = G.prototype;
      return I.prototype = D, [["$ms", o], ["$s", l], ["$m", f], ["$H", i], ["$W", s], ["$M", d], ["$y", m], ["$D", v]].forEach(function(k) {
        D[k[1]] = function(F) {
          return this.$g(F, k[0], k[1]);
        };
      }), I.extend = function(k, F) {
        return k.$i || (k(F, G, I), k.$i = !0), I;
      }, I.locale = M, I.isDayjs = E, I.unix = function(k) {
        return I(1e3 * k);
      }, I.en = b[y], I.Ls = b, I.p = {}, I;
    });
  }(ti)), ti.exports;
}
var mm = lf();
const yt = /* @__PURE__ */ gi(mm), vm = (e) => e.match(/^\d{2}\.\d{2}\.\d{4}/) ? e : yt(e).isValid() ? yt(e).format("DD.MM.YYYY, HH:mm") : e, sf = (e, r = 0) => {
  if (!e) return e;
  const t = e.toString().replace(/\s/g, "").replace(",", ".");
  return new Intl.NumberFormat("pl-PL", {
    minimumFractionDigits: r,
    useGrouping: !0
  }).format(Number(t)).replace(" ", " ");
}, $w = (e) => e === "true" || e === "false" ? e === "true" : !!(e && e.length > 0), uf = () => {
  const [e, r] = Se(window.innerWidth);
  return Pr(() => {
    const t = () => {
      r(window.innerWidth);
    };
    return window.addEventListener("resize", t), () => window.removeEventListener("resize", t);
  }, []), e;
}, hm = Q.div`
    background-color: var(--color-white);
    border-radius: var(--box-border-radius);
    position: relative;
    margin-bottom: 15px;
    height: 350px;
    width: 100%;
    background: var(--color-background);

    h1 {
        padding: 10px 15px;
    }
`, bm = Q(sm)`
    position: unset;
    padding: 0;
`, ym = Q.div`
    position: absolute;
    top: 0;
    padding: 15px 65px 0 25px;
    width: 100%;
    left: 0;
    display: grid;
    grid-template-columns: 30% 70%;

    .user-offer-details-modal {
        position: absolute;
        top: 15px;
        right: 65px;
    }

    .icons-modal {
        align-self: flex-start;
    }
`, gm = Q.img`
    height: 350px;
    width: 100%;
    object-fit: cover;
    border-radius: 6px;
`, Rm = ({
  preferredTab: e,
  onToggleContainerDetails: r,
  modificationDate: t,
  dateIcon: n,
  date: a,
  additionalInfoBadge: o,
  predictedAdditionalInfoBadge: l,
  isNotInteractive: f,
  notInteractiveElements: i,
  interactiveElements: s,
  userDetails: c,
  thumbnailPath: d,
  tabsContent: u,
  isMyOffersPage: m,
  isUsersOffersPage: v,
  isDarkMode: h
}) => {
  const g = uf(), [p, x] = Se(t || a), [w, C] = Se(!t), [y, b] = Se(nt.DETAILS), R = ((s == null ? void 0 : s.length) || 0) + ((i == null ? void 0 : i.length) || 0), E = ($) => {
    t && g <= 1200 && ($.stopPropagation(), x((G) => G === t ? a : t), C((G) => !G));
  }, M = li(() => {
    t && g > 991 && setTimeout(() => {
      x(t), C(!1);
    }, 150);
  }, [g, t]), I = li(() => {
    t && g > 991 && setTimeout(() => {
      x(a), C(!0);
    }, 150);
  }, [t, g]);
  return Pr(() => {
    switch (e) {
      case nt.NOTES:
        b(nt.NOTES);
        break;
      case nt.OPINIONS:
        b(nt.OPINIONS);
        break;
      default:
        b(nt.DETAILS);
    }
  }, [e]), /* @__PURE__ */ T.jsxs(T.Fragment, { children: [
    /* @__PURE__ */ T.jsxs(hm, { children: [
      /* @__PURE__ */ T.jsx(gm, { src: d }),
      /* @__PURE__ */ T.jsxs(ym, { children: [
        /* @__PURE__ */ T.jsxs(bm, { children: [
          p ? /* @__PURE__ */ T.jsx(
            gs,
            {
              onClick: g <= 1200 ? E : void 0,
              onMouseLeave: M,
              onMouseEnter: I,
              isSuccess: w,
              isWarning: !w,
              icon: n,
              children: vm(p)
            }
          ) : null,
          (o || l) && /* @__PURE__ */ T.jsx(gs, { isWhite: !0, predictedValue: l, children: o })
        ] }),
        g >= 991 || R < 2 ? /* @__PURE__ */ T.jsx(
          np,
          {
            isDarkMode: h,
            className: "icons-modal",
            isModalOpen: !0,
            interactiveElements: s,
            notInteractiveElements: i,
            isNotInteractive: f,
            userDetails: c,
            isMyOffersPage: m,
            isUsersOffersPage: v
          }
        ) : null
      ] })
    ] }),
    /* @__PURE__ */ T.jsx(Aw, { ...u, toggleContainerDetails: r, tabIndex: y })
  ] });
};
var ts = function(r) {
  return r.reduce(function(t, n) {
    var a = n[0], o = n[1];
    return t[a] = o, t;
  }, {});
}, ns = typeof window < "u" && window.document && window.document.createElement ? br.useLayoutEffect : br.useEffect, lr = "top", gr = "bottom", Rr = "right", sr = "left", pl = "auto", ko = [lr, gr, Rr, sr], gt = "start", To = "end", xm = "clippingParents", cf = "viewport", Dt = "popper", wm = "reference", as = /* @__PURE__ */ ko.reduce(function(e, r) {
  return e.concat([r + "-" + gt, r + "-" + To]);
}, []), df = /* @__PURE__ */ [].concat(ko, [pl]).reduce(function(e, r) {
  return e.concat([r, r + "-" + gt, r + "-" + To]);
}, []), Em = "beforeRead", Cm = "read", _m = "afterRead", Pm = "beforeMain", Tm = "main", Sm = "afterMain", qm = "beforeWrite", Om = "write", Am = "afterWrite", Mm = [Em, Cm, _m, Pm, Tm, Sm, qm, Om, Am];
function Tr(e) {
  return e ? (e.nodeName || "").toLowerCase() : null;
}
function fr(e) {
  if (e == null)
    return window;
  if (e.toString() !== "[object Window]") {
    var r = e.ownerDocument;
    return r && r.defaultView || window;
  }
  return e;
}
function ut(e) {
  var r = fr(e).Element;
  return e instanceof r || e instanceof Element;
}
function yr(e) {
  var r = fr(e).HTMLElement;
  return e instanceof r || e instanceof HTMLElement;
}
function ml(e) {
  if (typeof ShadowRoot > "u")
    return !1;
  var r = fr(e).ShadowRoot;
  return e instanceof r || e instanceof ShadowRoot;
}
function km(e) {
  var r = e.state;
  Object.keys(r.elements).forEach(function(t) {
    var n = r.styles[t] || {}, a = r.attributes[t] || {}, o = r.elements[t];
    !yr(o) || !Tr(o) || (Object.assign(o.style, n), Object.keys(a).forEach(function(l) {
      var f = a[l];
      f === !1 ? o.removeAttribute(l) : o.setAttribute(l, f === !0 ? "" : f);
    }));
  });
}
function Dm(e) {
  var r = e.state, t = {
    popper: {
      position: r.options.strategy,
      left: "0",
      top: "0",
      margin: "0"
    },
    arrow: {
      position: "absolute"
    },
    reference: {}
  };
  return Object.assign(r.elements.popper.style, t.popper), r.styles = t, r.elements.arrow && Object.assign(r.elements.arrow.style, t.arrow), function() {
    Object.keys(r.elements).forEach(function(n) {
      var a = r.elements[n], o = r.attributes[n] || {}, l = Object.keys(r.styles.hasOwnProperty(n) ? r.styles[n] : t[n]), f = l.reduce(function(i, s) {
        return i[s] = "", i;
      }, {});
      !yr(a) || !Tr(a) || (Object.assign(a.style, f), Object.keys(o).forEach(function(i) {
        a.removeAttribute(i);
      }));
    });
  };
}
const jm = {
  name: "applyStyles",
  enabled: !0,
  phase: "write",
  fn: km,
  effect: Dm,
  requires: ["computeStyles"]
};
function _r(e) {
  return e.split("-")[0];
}
var it = Math.max, fi = Math.min, Rt = Math.round;
function Vi() {
  var e = navigator.userAgentData;
  return e != null && e.brands && Array.isArray(e.brands) ? e.brands.map(function(r) {
    return r.brand + "/" + r.version;
  }).join(" ") : navigator.userAgent;
}
function ff() {
  return !/^((?!chrome|android).)*safari/i.test(Vi());
}
function xt(e, r, t) {
  r === void 0 && (r = !1), t === void 0 && (t = !1);
  var n = e.getBoundingClientRect(), a = 1, o = 1;
  r && yr(e) && (a = e.offsetWidth > 0 && Rt(n.width) / e.offsetWidth || 1, o = e.offsetHeight > 0 && Rt(n.height) / e.offsetHeight || 1);
  var l = ut(e) ? fr(e) : window, f = l.visualViewport, i = !ff() && t, s = (n.left + (i && f ? f.offsetLeft : 0)) / a, c = (n.top + (i && f ? f.offsetTop : 0)) / o, d = n.width / a, u = n.height / o;
  return {
    width: d,
    height: u,
    top: c,
    right: s + d,
    bottom: c + u,
    left: s,
    x: s,
    y: c
  };
}
function vl(e) {
  var r = xt(e), t = e.offsetWidth, n = e.offsetHeight;
  return Math.abs(r.width - t) <= 1 && (t = r.width), Math.abs(r.height - n) <= 1 && (n = r.height), {
    x: e.offsetLeft,
    y: e.offsetTop,
    width: t,
    height: n
  };
}
function pf(e, r) {
  var t = r.getRootNode && r.getRootNode();
  if (e.contains(r))
    return !0;
  if (t && ml(t)) {
    var n = r;
    do {
      if (n && e.isSameNode(n))
        return !0;
      n = n.parentNode || n.host;
    } while (n);
  }
  return !1;
}
function Ur(e) {
  return fr(e).getComputedStyle(e);
}
function Im(e) {
  return ["table", "td", "th"].indexOf(Tr(e)) >= 0;
}
function Zr(e) {
  return ((ut(e) ? e.ownerDocument : (
    // $FlowFixMe[prop-missing]
    e.document
  )) || window.document).documentElement;
}
function Ri(e) {
  return Tr(e) === "html" ? e : (
    // this is a quicker (but less type safe) way to save quite some bytes from the bundle
    // $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    e.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    e.parentNode || // DOM Element detected
    (ml(e) ? e.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    Zr(e)
  );
}
function os(e) {
  return !yr(e) || // https://github.com/popperjs/popper-core/issues/837
  Ur(e).position === "fixed" ? null : e.offsetParent;
}
function Nm(e) {
  var r = /firefox/i.test(Vi()), t = /Trident/i.test(Vi());
  if (t && yr(e)) {
    var n = Ur(e);
    if (n.position === "fixed")
      return null;
  }
  var a = Ri(e);
  for (ml(a) && (a = a.host); yr(a) && ["html", "body"].indexOf(Tr(a)) < 0; ) {
    var o = Ur(a);
    if (o.transform !== "none" || o.perspective !== "none" || o.contain === "paint" || ["transform", "perspective"].indexOf(o.willChange) !== -1 || r && o.willChange === "filter" || r && o.filter && o.filter !== "none")
      return a;
    a = a.parentNode;
  }
  return null;
}
function Do(e) {
  for (var r = fr(e), t = os(e); t && Im(t) && Ur(t).position === "static"; )
    t = os(t);
  return t && (Tr(t) === "html" || Tr(t) === "body" && Ur(t).position === "static") ? r : t || Nm(e) || r;
}
function hl(e) {
  return ["top", "bottom"].indexOf(e) >= 0 ? "x" : "y";
}
function Eo(e, r, t) {
  return it(e, fi(r, t));
}
function Lm(e, r, t) {
  var n = Eo(e, r, t);
  return n > t ? t : n;
}
function mf() {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
}
function vf(e) {
  return Object.assign({}, mf(), e);
}
function hf(e, r) {
  return r.reduce(function(t, n) {
    return t[n] = e, t;
  }, {});
}
var $m = function(r, t) {
  return r = typeof r == "function" ? r(Object.assign({}, t.rects, {
    placement: t.placement
  })) : r, vf(typeof r != "number" ? r : hf(r, ko));
};
function Fm(e) {
  var r, t = e.state, n = e.name, a = e.options, o = t.elements.arrow, l = t.modifiersData.popperOffsets, f = _r(t.placement), i = hl(f), s = [sr, Rr].indexOf(f) >= 0, c = s ? "height" : "width";
  if (!(!o || !l)) {
    var d = $m(a.padding, t), u = vl(o), m = i === "y" ? lr : sr, v = i === "y" ? gr : Rr, h = t.rects.reference[c] + t.rects.reference[i] - l[i] - t.rects.popper[c], g = l[i] - t.rects.reference[i], p = Do(o), x = p ? i === "y" ? p.clientHeight || 0 : p.clientWidth || 0 : 0, w = h / 2 - g / 2, C = d[m], y = x - u[c] - d[v], b = x / 2 - u[c] / 2 + w, R = Eo(C, b, y), E = i;
    t.modifiersData[n] = (r = {}, r[E] = R, r.centerOffset = R - b, r);
  }
}
function Bm(e) {
  var r = e.state, t = e.options, n = t.element, a = n === void 0 ? "[data-popper-arrow]" : n;
  a != null && (typeof a == "string" && (a = r.elements.popper.querySelector(a), !a) || pf(r.elements.popper, a) && (r.elements.arrow = a));
}
const Hm = {
  name: "arrow",
  enabled: !0,
  phase: "main",
  fn: Fm,
  effect: Bm,
  requires: ["popperOffsets"],
  requiresIfExists: ["preventOverflow"]
};
function wt(e) {
  return e.split("-")[1];
}
var Um = {
  top: "auto",
  right: "auto",
  bottom: "auto",
  left: "auto"
};
function Wm(e, r) {
  var t = e.x, n = e.y, a = r.devicePixelRatio || 1;
  return {
    x: Rt(t * a) / a || 0,
    y: Rt(n * a) / a || 0
  };
}
function is(e) {
  var r, t = e.popper, n = e.popperRect, a = e.placement, o = e.variation, l = e.offsets, f = e.position, i = e.gpuAcceleration, s = e.adaptive, c = e.roundOffsets, d = e.isFixed, u = l.x, m = u === void 0 ? 0 : u, v = l.y, h = v === void 0 ? 0 : v, g = typeof c == "function" ? c({
    x: m,
    y: h
  }) : {
    x: m,
    y: h
  };
  m = g.x, h = g.y;
  var p = l.hasOwnProperty("x"), x = l.hasOwnProperty("y"), w = sr, C = lr, y = window;
  if (s) {
    var b = Do(t), R = "clientHeight", E = "clientWidth";
    if (b === fr(t) && (b = Zr(t), Ur(b).position !== "static" && f === "absolute" && (R = "scrollHeight", E = "scrollWidth")), b = b, a === lr || (a === sr || a === Rr) && o === To) {
      C = gr;
      var M = d && b === y && y.visualViewport ? y.visualViewport.height : (
        // $FlowFixMe[prop-missing]
        b[R]
      );
      h -= M - n.height, h *= i ? 1 : -1;
    }
    if (a === sr || (a === lr || a === gr) && o === To) {
      w = Rr;
      var I = d && b === y && y.visualViewport ? y.visualViewport.width : (
        // $FlowFixMe[prop-missing]
        b[E]
      );
      m -= I - n.width, m *= i ? 1 : -1;
    }
  }
  var $ = Object.assign({
    position: f
  }, s && Um), G = c === !0 ? Wm({
    x: m,
    y: h
  }, fr(t)) : {
    x: m,
    y: h
  };
  if (m = G.x, h = G.y, i) {
    var D;
    return Object.assign({}, $, (D = {}, D[C] = x ? "0" : "", D[w] = p ? "0" : "", D.transform = (y.devicePixelRatio || 1) <= 1 ? "translate(" + m + "px, " + h + "px)" : "translate3d(" + m + "px, " + h + "px, 0)", D));
  }
  return Object.assign({}, $, (r = {}, r[C] = x ? h + "px" : "", r[w] = p ? m + "px" : "", r.transform = "", r));
}
function zm(e) {
  var r = e.state, t = e.options, n = t.gpuAcceleration, a = n === void 0 ? !0 : n, o = t.adaptive, l = o === void 0 ? !0 : o, f = t.roundOffsets, i = f === void 0 ? !0 : f, s = {
    placement: _r(r.placement),
    variation: wt(r.placement),
    popper: r.elements.popper,
    popperRect: r.rects.popper,
    gpuAcceleration: a,
    isFixed: r.options.strategy === "fixed"
  };
  r.modifiersData.popperOffsets != null && (r.styles.popper = Object.assign({}, r.styles.popper, is(Object.assign({}, s, {
    offsets: r.modifiersData.popperOffsets,
    position: r.options.strategy,
    adaptive: l,
    roundOffsets: i
  })))), r.modifiersData.arrow != null && (r.styles.arrow = Object.assign({}, r.styles.arrow, is(Object.assign({}, s, {
    offsets: r.modifiersData.arrow,
    position: "absolute",
    adaptive: !1,
    roundOffsets: i
  })))), r.attributes.popper = Object.assign({}, r.attributes.popper, {
    "data-popper-placement": r.placement
  });
}
const Ym = {
  name: "computeStyles",
  enabled: !0,
  phase: "beforeWrite",
  fn: zm,
  data: {}
};
var Vo = {
  passive: !0
};
function Vm(e) {
  var r = e.state, t = e.instance, n = e.options, a = n.scroll, o = a === void 0 ? !0 : a, l = n.resize, f = l === void 0 ? !0 : l, i = fr(r.elements.popper), s = [].concat(r.scrollParents.reference, r.scrollParents.popper);
  return o && s.forEach(function(c) {
    c.addEventListener("scroll", t.update, Vo);
  }), f && i.addEventListener("resize", t.update, Vo), function() {
    o && s.forEach(function(c) {
      c.removeEventListener("scroll", t.update, Vo);
    }), f && i.removeEventListener("resize", t.update, Vo);
  };
}
const Gm = {
  name: "eventListeners",
  enabled: !0,
  phase: "write",
  fn: function() {
  },
  effect: Vm,
  data: {}
};
var Xm = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
};
function ni(e) {
  return e.replace(/left|right|bottom|top/g, function(r) {
    return Xm[r];
  });
}
var Km = {
  start: "end",
  end: "start"
};
function ls(e) {
  return e.replace(/start|end/g, function(r) {
    return Km[r];
  });
}
function bl(e) {
  var r = fr(e), t = r.pageXOffset, n = r.pageYOffset;
  return {
    scrollLeft: t,
    scrollTop: n
  };
}
function yl(e) {
  return xt(Zr(e)).left + bl(e).scrollLeft;
}
function Jm(e, r) {
  var t = fr(e), n = Zr(e), a = t.visualViewport, o = n.clientWidth, l = n.clientHeight, f = 0, i = 0;
  if (a) {
    o = a.width, l = a.height;
    var s = ff();
    (s || !s && r === "fixed") && (f = a.offsetLeft, i = a.offsetTop);
  }
  return {
    width: o,
    height: l,
    x: f + yl(e),
    y: i
  };
}
function Zm(e) {
  var r, t = Zr(e), n = bl(e), a = (r = e.ownerDocument) == null ? void 0 : r.body, o = it(t.scrollWidth, t.clientWidth, a ? a.scrollWidth : 0, a ? a.clientWidth : 0), l = it(t.scrollHeight, t.clientHeight, a ? a.scrollHeight : 0, a ? a.clientHeight : 0), f = -n.scrollLeft + yl(e), i = -n.scrollTop;
  return Ur(a || t).direction === "rtl" && (f += it(t.clientWidth, a ? a.clientWidth : 0) - o), {
    width: o,
    height: l,
    x: f,
    y: i
  };
}
function gl(e) {
  var r = Ur(e), t = r.overflow, n = r.overflowX, a = r.overflowY;
  return /auto|scroll|overlay|hidden/.test(t + a + n);
}
function bf(e) {
  return ["html", "body", "#document"].indexOf(Tr(e)) >= 0 ? e.ownerDocument.body : yr(e) && gl(e) ? e : bf(Ri(e));
}
function Co(e, r) {
  var t;
  r === void 0 && (r = []);
  var n = bf(e), a = n === ((t = e.ownerDocument) == null ? void 0 : t.body), o = fr(n), l = a ? [o].concat(o.visualViewport || [], gl(n) ? n : []) : n, f = r.concat(l);
  return a ? f : (
    // $FlowFixMe[incompatible-call]: isBody tells us target will be an HTMLElement here
    f.concat(Co(Ri(l)))
  );
}
function Gi(e) {
  return Object.assign({}, e, {
    left: e.x,
    top: e.y,
    right: e.x + e.width,
    bottom: e.y + e.height
  });
}
function Qm(e, r) {
  var t = xt(e, !1, r === "fixed");
  return t.top = t.top + e.clientTop, t.left = t.left + e.clientLeft, t.bottom = t.top + e.clientHeight, t.right = t.left + e.clientWidth, t.width = e.clientWidth, t.height = e.clientHeight, t.x = t.left, t.y = t.top, t;
}
function ss(e, r, t) {
  return r === cf ? Gi(Jm(e, t)) : ut(r) ? Qm(r, t) : Gi(Zm(Zr(e)));
}
function ev(e) {
  var r = Co(Ri(e)), t = ["absolute", "fixed"].indexOf(Ur(e).position) >= 0, n = t && yr(e) ? Do(e) : e;
  return ut(n) ? r.filter(function(a) {
    return ut(a) && pf(a, n) && Tr(a) !== "body";
  }) : [];
}
function rv(e, r, t, n) {
  var a = r === "clippingParents" ? ev(e) : [].concat(r), o = [].concat(a, [t]), l = o[0], f = o.reduce(function(i, s) {
    var c = ss(e, s, n);
    return i.top = it(c.top, i.top), i.right = fi(c.right, i.right), i.bottom = fi(c.bottom, i.bottom), i.left = it(c.left, i.left), i;
  }, ss(e, l, n));
  return f.width = f.right - f.left, f.height = f.bottom - f.top, f.x = f.left, f.y = f.top, f;
}
function yf(e) {
  var r = e.reference, t = e.element, n = e.placement, a = n ? _r(n) : null, o = n ? wt(n) : null, l = r.x + r.width / 2 - t.width / 2, f = r.y + r.height / 2 - t.height / 2, i;
  switch (a) {
    case lr:
      i = {
        x: l,
        y: r.y - t.height
      };
      break;
    case gr:
      i = {
        x: l,
        y: r.y + r.height
      };
      break;
    case Rr:
      i = {
        x: r.x + r.width,
        y: f
      };
      break;
    case sr:
      i = {
        x: r.x - t.width,
        y: f
      };
      break;
    default:
      i = {
        x: r.x,
        y: r.y
      };
  }
  var s = a ? hl(a) : null;
  if (s != null) {
    var c = s === "y" ? "height" : "width";
    switch (o) {
      case gt:
        i[s] = i[s] - (r[c] / 2 - t[c] / 2);
        break;
      case To:
        i[s] = i[s] + (r[c] / 2 - t[c] / 2);
        break;
    }
  }
  return i;
}
function So(e, r) {
  r === void 0 && (r = {});
  var t = r, n = t.placement, a = n === void 0 ? e.placement : n, o = t.strategy, l = o === void 0 ? e.strategy : o, f = t.boundary, i = f === void 0 ? xm : f, s = t.rootBoundary, c = s === void 0 ? cf : s, d = t.elementContext, u = d === void 0 ? Dt : d, m = t.altBoundary, v = m === void 0 ? !1 : m, h = t.padding, g = h === void 0 ? 0 : h, p = vf(typeof g != "number" ? g : hf(g, ko)), x = u === Dt ? wm : Dt, w = e.rects.popper, C = e.elements[v ? x : u], y = rv(ut(C) ? C : C.contextElement || Zr(e.elements.popper), i, c, l), b = xt(e.elements.reference), R = yf({
    reference: b,
    element: w,
    placement: a
  }), E = Gi(Object.assign({}, w, R)), M = u === Dt ? E : b, I = {
    top: y.top - M.top + p.top,
    bottom: M.bottom - y.bottom + p.bottom,
    left: y.left - M.left + p.left,
    right: M.right - y.right + p.right
  }, $ = e.modifiersData.offset;
  if (u === Dt && $) {
    var G = $[a];
    Object.keys(I).forEach(function(D) {
      var k = [Rr, gr].indexOf(D) >= 0 ? 1 : -1, F = [lr, gr].indexOf(D) >= 0 ? "y" : "x";
      I[D] += G[F] * k;
    });
  }
  return I;
}
function tv(e, r) {
  r === void 0 && (r = {});
  var t = r, n = t.placement, a = t.boundary, o = t.rootBoundary, l = t.padding, f = t.flipVariations, i = t.allowedAutoPlacements, s = i === void 0 ? df : i, c = wt(n), d = c ? f ? as : as.filter(function(v) {
    return wt(v) === c;
  }) : ko, u = d.filter(function(v) {
    return s.indexOf(v) >= 0;
  });
  u.length === 0 && (u = d);
  var m = u.reduce(function(v, h) {
    return v[h] = So(e, {
      placement: h,
      boundary: a,
      rootBoundary: o,
      padding: l
    })[_r(h)], v;
  }, {});
  return Object.keys(m).sort(function(v, h) {
    return m[v] - m[h];
  });
}
function nv(e) {
  if (_r(e) === pl)
    return [];
  var r = ni(e);
  return [ls(e), r, ls(r)];
}
function av(e) {
  var r = e.state, t = e.options, n = e.name;
  if (!r.modifiersData[n]._skip) {
    for (var a = t.mainAxis, o = a === void 0 ? !0 : a, l = t.altAxis, f = l === void 0 ? !0 : l, i = t.fallbackPlacements, s = t.padding, c = t.boundary, d = t.rootBoundary, u = t.altBoundary, m = t.flipVariations, v = m === void 0 ? !0 : m, h = t.allowedAutoPlacements, g = r.options.placement, p = _r(g), x = p === g, w = i || (x || !v ? [ni(g)] : nv(g)), C = [g].concat(w).reduce(function(N, V) {
      return N.concat(_r(V) === pl ? tv(r, {
        placement: V,
        boundary: c,
        rootBoundary: d,
        padding: s,
        flipVariations: v,
        allowedAutoPlacements: h
      }) : V);
    }, []), y = r.rects.reference, b = r.rects.popper, R = /* @__PURE__ */ new Map(), E = !0, M = C[0], I = 0; I < C.length; I++) {
      var $ = C[I], G = _r($), D = wt($) === gt, k = [lr, gr].indexOf(G) >= 0, F = k ? "width" : "height", B = So(r, {
        placement: $,
        boundary: c,
        rootBoundary: d,
        altBoundary: u,
        padding: s
      }), H = k ? D ? Rr : sr : D ? gr : lr;
      y[F] > b[F] && (H = ni(H));
      var U = ni(H), ae = [];
      if (o && ae.push(B[G] <= 0), f && ae.push(B[H] <= 0, B[U] <= 0), ae.every(function(N) {
        return N;
      })) {
        M = $, E = !1;
        break;
      }
      R.set($, ae);
    }
    if (E)
      for (var oe = v ? 3 : 1, ce = function(V) {
        var A = C.find(function(le) {
          var X = R.get(le);
          if (X)
            return X.slice(0, V).every(function(q) {
              return q;
            });
        });
        if (A)
          return M = A, "break";
      }, J = oe; J > 0; J--) {
        var O = ce(J);
        if (O === "break") break;
      }
    r.placement !== M && (r.modifiersData[n]._skip = !0, r.placement = M, r.reset = !0);
  }
}
const ov = {
  name: "flip",
  enabled: !0,
  phase: "main",
  fn: av,
  requiresIfExists: ["offset"],
  data: {
    _skip: !1
  }
};
function us(e, r, t) {
  return t === void 0 && (t = {
    x: 0,
    y: 0
  }), {
    top: e.top - r.height - t.y,
    right: e.right - r.width + t.x,
    bottom: e.bottom - r.height + t.y,
    left: e.left - r.width - t.x
  };
}
function cs(e) {
  return [lr, Rr, gr, sr].some(function(r) {
    return e[r] >= 0;
  });
}
function iv(e) {
  var r = e.state, t = e.name, n = r.rects.reference, a = r.rects.popper, o = r.modifiersData.preventOverflow, l = So(r, {
    elementContext: "reference"
  }), f = So(r, {
    altBoundary: !0
  }), i = us(l, n), s = us(f, a, o), c = cs(i), d = cs(s);
  r.modifiersData[t] = {
    referenceClippingOffsets: i,
    popperEscapeOffsets: s,
    isReferenceHidden: c,
    hasPopperEscaped: d
  }, r.attributes.popper = Object.assign({}, r.attributes.popper, {
    "data-popper-reference-hidden": c,
    "data-popper-escaped": d
  });
}
const lv = {
  name: "hide",
  enabled: !0,
  phase: "main",
  requiresIfExists: ["preventOverflow"],
  fn: iv
};
function sv(e, r, t) {
  var n = _r(e), a = [sr, lr].indexOf(n) >= 0 ? -1 : 1, o = typeof t == "function" ? t(Object.assign({}, r, {
    placement: e
  })) : t, l = o[0], f = o[1];
  return l = l || 0, f = (f || 0) * a, [sr, Rr].indexOf(n) >= 0 ? {
    x: f,
    y: l
  } : {
    x: l,
    y: f
  };
}
function uv(e) {
  var r = e.state, t = e.options, n = e.name, a = t.offset, o = a === void 0 ? [0, 0] : a, l = df.reduce(function(c, d) {
    return c[d] = sv(d, r.rects, o), c;
  }, {}), f = l[r.placement], i = f.x, s = f.y;
  r.modifiersData.popperOffsets != null && (r.modifiersData.popperOffsets.x += i, r.modifiersData.popperOffsets.y += s), r.modifiersData[n] = l;
}
const cv = {
  name: "offset",
  enabled: !0,
  phase: "main",
  requires: ["popperOffsets"],
  fn: uv
};
function dv(e) {
  var r = e.state, t = e.name;
  r.modifiersData[t] = yf({
    reference: r.rects.reference,
    element: r.rects.popper,
    placement: r.placement
  });
}
const fv = {
  name: "popperOffsets",
  enabled: !0,
  phase: "read",
  fn: dv,
  data: {}
};
function pv(e) {
  return e === "x" ? "y" : "x";
}
function mv(e) {
  var r = e.state, t = e.options, n = e.name, a = t.mainAxis, o = a === void 0 ? !0 : a, l = t.altAxis, f = l === void 0 ? !1 : l, i = t.boundary, s = t.rootBoundary, c = t.altBoundary, d = t.padding, u = t.tether, m = u === void 0 ? !0 : u, v = t.tetherOffset, h = v === void 0 ? 0 : v, g = So(r, {
    boundary: i,
    rootBoundary: s,
    padding: d,
    altBoundary: c
  }), p = _r(r.placement), x = wt(r.placement), w = !x, C = hl(p), y = pv(C), b = r.modifiersData.popperOffsets, R = r.rects.reference, E = r.rects.popper, M = typeof h == "function" ? h(Object.assign({}, r.rects, {
    placement: r.placement
  })) : h, I = typeof M == "number" ? {
    mainAxis: M,
    altAxis: M
  } : Object.assign({
    mainAxis: 0,
    altAxis: 0
  }, M), $ = r.modifiersData.offset ? r.modifiersData.offset[r.placement] : null, G = {
    x: 0,
    y: 0
  };
  if (b) {
    if (o) {
      var D, k = C === "y" ? lr : sr, F = C === "y" ? gr : Rr, B = C === "y" ? "height" : "width", H = b[C], U = H + g[k], ae = H - g[F], oe = m ? -E[B] / 2 : 0, ce = x === gt ? R[B] : E[B], J = x === gt ? -E[B] : -R[B], O = r.elements.arrow, N = m && O ? vl(O) : {
        width: 0,
        height: 0
      }, V = r.modifiersData["arrow#persistent"] ? r.modifiersData["arrow#persistent"].padding : mf(), A = V[k], le = V[F], X = Eo(0, R[B], N[B]), q = w ? R[B] / 2 - oe - X - A - I.mainAxis : ce - X - A - I.mainAxis, W = w ? -R[B] / 2 + oe + X + le + I.mainAxis : J + X + le + I.mainAxis, L = r.elements.arrow && Do(r.elements.arrow), j = L ? C === "y" ? L.clientTop || 0 : L.clientLeft || 0 : 0, ie = (D = $ == null ? void 0 : $[C]) != null ? D : 0, Z = H + q - ie - j, se = H + W - ie, pe = Eo(m ? fi(U, Z) : U, H, m ? it(ae, se) : ae);
      b[C] = pe, G[C] = pe - H;
    }
    if (f) {
      var de, Re = C === "x" ? lr : sr, Ue = C === "x" ? gr : Rr, xe = b[y], Ke = y === "y" ? "height" : "width", Ge = xe + g[Re], Le = xe - g[Ue], fe = [lr, sr].indexOf(p) !== -1, _e = (de = $ == null ? void 0 : $[y]) != null ? de : 0, Ze = fe ? Ge : xe - R[Ke] - E[Ke] - _e + I.altAxis, er = fe ? xe + R[Ke] + E[Ke] - _e - I.altAxis : Le, $e = m && fe ? Lm(Ze, xe, er) : Eo(m ? Ze : Ge, xe, m ? er : Le);
      b[y] = $e, G[y] = $e - xe;
    }
    r.modifiersData[n] = G;
  }
}
const vv = {
  name: "preventOverflow",
  enabled: !0,
  phase: "main",
  fn: mv,
  requiresIfExists: ["offset"]
};
function hv(e) {
  return {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  };
}
function bv(e) {
  return e === fr(e) || !yr(e) ? bl(e) : hv(e);
}
function yv(e) {
  var r = e.getBoundingClientRect(), t = Rt(r.width) / e.offsetWidth || 1, n = Rt(r.height) / e.offsetHeight || 1;
  return t !== 1 || n !== 1;
}
function gv(e, r, t) {
  t === void 0 && (t = !1);
  var n = yr(r), a = yr(r) && yv(r), o = Zr(r), l = xt(e, a, t), f = {
    scrollLeft: 0,
    scrollTop: 0
  }, i = {
    x: 0,
    y: 0
  };
  return (n || !n && !t) && ((Tr(r) !== "body" || // https://github.com/popperjs/popper-core/issues/1078
  gl(o)) && (f = bv(r)), yr(r) ? (i = xt(r, !0), i.x += r.clientLeft, i.y += r.clientTop) : o && (i.x = yl(o))), {
    x: l.left + f.scrollLeft - i.x,
    y: l.top + f.scrollTop - i.y,
    width: l.width,
    height: l.height
  };
}
function Rv(e) {
  var r = /* @__PURE__ */ new Map(), t = /* @__PURE__ */ new Set(), n = [];
  e.forEach(function(o) {
    r.set(o.name, o);
  });
  function a(o) {
    t.add(o.name);
    var l = [].concat(o.requires || [], o.requiresIfExists || []);
    l.forEach(function(f) {
      if (!t.has(f)) {
        var i = r.get(f);
        i && a(i);
      }
    }), n.push(o);
  }
  return e.forEach(function(o) {
    t.has(o.name) || a(o);
  }), n;
}
function xv(e) {
  var r = Rv(e);
  return Mm.reduce(function(t, n) {
    return t.concat(r.filter(function(a) {
      return a.phase === n;
    }));
  }, []);
}
function wv(e) {
  var r;
  return function() {
    return r || (r = new Promise(function(t) {
      Promise.resolve().then(function() {
        r = void 0, t(e());
      });
    })), r;
  };
}
function Ev(e) {
  var r = e.reduce(function(t, n) {
    var a = t[n.name];
    return t[n.name] = a ? Object.assign({}, a, n, {
      options: Object.assign({}, a.options, n.options),
      data: Object.assign({}, a.data, n.data)
    }) : n, t;
  }, {});
  return Object.keys(r).map(function(t) {
    return r[t];
  });
}
var ds = {
  placement: "bottom",
  modifiers: [],
  strategy: "absolute"
};
function fs() {
  for (var e = arguments.length, r = new Array(e), t = 0; t < e; t++)
    r[t] = arguments[t];
  return !r.some(function(n) {
    return !(n && typeof n.getBoundingClientRect == "function");
  });
}
function Cv(e) {
  e === void 0 && (e = {});
  var r = e, t = r.defaultModifiers, n = t === void 0 ? [] : t, a = r.defaultOptions, o = a === void 0 ? ds : a;
  return function(f, i, s) {
    s === void 0 && (s = o);
    var c = {
      placement: "bottom",
      orderedModifiers: [],
      options: Object.assign({}, ds, o),
      modifiersData: {},
      elements: {
        reference: f,
        popper: i
      },
      attributes: {},
      styles: {}
    }, d = [], u = !1, m = {
      state: c,
      setOptions: function(p) {
        var x = typeof p == "function" ? p(c.options) : p;
        h(), c.options = Object.assign({}, o, c.options, x), c.scrollParents = {
          reference: ut(f) ? Co(f) : f.contextElement ? Co(f.contextElement) : [],
          popper: Co(i)
        };
        var w = xv(Ev([].concat(n, c.options.modifiers)));
        return c.orderedModifiers = w.filter(function(C) {
          return C.enabled;
        }), v(), m.update();
      },
      // Sync update – it will always be executed, even if not necessary. This
      // is useful for low frequency updates where sync behavior simplifies the
      // logic.
      // For high frequency updates (e.g. `resize` and `scroll` events), always
      // prefer the async Popper#update method
      forceUpdate: function() {
        if (!u) {
          var p = c.elements, x = p.reference, w = p.popper;
          if (fs(x, w)) {
            c.rects = {
              reference: gv(x, Do(w), c.options.strategy === "fixed"),
              popper: vl(w)
            }, c.reset = !1, c.placement = c.options.placement, c.orderedModifiers.forEach(function(I) {
              return c.modifiersData[I.name] = Object.assign({}, I.data);
            });
            for (var C = 0; C < c.orderedModifiers.length; C++) {
              if (c.reset === !0) {
                c.reset = !1, C = -1;
                continue;
              }
              var y = c.orderedModifiers[C], b = y.fn, R = y.options, E = R === void 0 ? {} : R, M = y.name;
              typeof b == "function" && (c = b({
                state: c,
                options: E,
                name: M,
                instance: m
              }) || c);
            }
          }
        }
      },
      // Async and optimistically optimized update – it will not be executed if
      // not necessary (debounced to run at most once-per-tick)
      update: wv(function() {
        return new Promise(function(g) {
          m.forceUpdate(), g(c);
        });
      }),
      destroy: function() {
        h(), u = !0;
      }
    };
    if (!fs(f, i))
      return m;
    m.setOptions(s).then(function(g) {
      !u && s.onFirstUpdate && s.onFirstUpdate(g);
    });
    function v() {
      c.orderedModifiers.forEach(function(g) {
        var p = g.name, x = g.options, w = x === void 0 ? {} : x, C = g.effect;
        if (typeof C == "function") {
          var y = C({
            state: c,
            name: p,
            instance: m,
            options: w
          }), b = function() {
          };
          d.push(y || b);
        }
      });
    }
    function h() {
      d.forEach(function(g) {
        return g();
      }), d = [];
    }
    return m;
  };
}
var _v = [Gm, fv, Ym, jm, cv, ov, vv, Hm, lv], Pv = /* @__PURE__ */ Cv({
  defaultModifiers: _v
}), ki, ps;
function Tv() {
  if (ps) return ki;
  ps = 1;
  var e = typeof Element < "u", r = typeof Map == "function", t = typeof Set == "function", n = typeof ArrayBuffer == "function" && !!ArrayBuffer.isView;
  function a(o, l) {
    if (o === l) return !0;
    if (o && l && typeof o == "object" && typeof l == "object") {
      if (o.constructor !== l.constructor) return !1;
      var f, i, s;
      if (Array.isArray(o)) {
        if (f = o.length, f != l.length) return !1;
        for (i = f; i-- !== 0; )
          if (!a(o[i], l[i])) return !1;
        return !0;
      }
      var c;
      if (r && o instanceof Map && l instanceof Map) {
        if (o.size !== l.size) return !1;
        for (c = o.entries(); !(i = c.next()).done; )
          if (!l.has(i.value[0])) return !1;
        for (c = o.entries(); !(i = c.next()).done; )
          if (!a(i.value[1], l.get(i.value[0]))) return !1;
        return !0;
      }
      if (t && o instanceof Set && l instanceof Set) {
        if (o.size !== l.size) return !1;
        for (c = o.entries(); !(i = c.next()).done; )
          if (!l.has(i.value[0])) return !1;
        return !0;
      }
      if (n && ArrayBuffer.isView(o) && ArrayBuffer.isView(l)) {
        if (f = o.length, f != l.length) return !1;
        for (i = f; i-- !== 0; )
          if (o[i] !== l[i]) return !1;
        return !0;
      }
      if (o.constructor === RegExp) return o.source === l.source && o.flags === l.flags;
      if (o.valueOf !== Object.prototype.valueOf && typeof o.valueOf == "function" && typeof l.valueOf == "function") return o.valueOf() === l.valueOf();
      if (o.toString !== Object.prototype.toString && typeof o.toString == "function" && typeof l.toString == "function") return o.toString() === l.toString();
      if (s = Object.keys(o), f = s.length, f !== Object.keys(l).length) return !1;
      for (i = f; i-- !== 0; )
        if (!Object.prototype.hasOwnProperty.call(l, s[i])) return !1;
      if (e && o instanceof Element) return !1;
      for (i = f; i-- !== 0; )
        if (!((s[i] === "_owner" || s[i] === "__v" || s[i] === "__o") && o.$$typeof) && !a(o[s[i]], l[s[i]]))
          return !1;
      return !0;
    }
    return o !== o && l !== l;
  }
  return ki = function(l, f) {
    try {
      return a(l, f);
    } catch (i) {
      if ((i.message || "").match(/stack|recursion/i))
        return console.warn("react-fast-compare cannot handle circular refs"), !1;
      throw i;
    }
  }, ki;
}
var Sv = Tv();
const qv = /* @__PURE__ */ gi(Sv);
var Ov = [], gf = function(r, t, n) {
  n === void 0 && (n = {});
  var a = br.useRef(null), o = {
    onFirstUpdate: n.onFirstUpdate,
    placement: n.placement || "bottom",
    strategy: n.strategy || "absolute",
    modifiers: n.modifiers || Ov
  }, l = br.useState({
    styles: {
      popper: {
        position: o.strategy,
        left: "0",
        top: "0"
      },
      arrow: {
        position: "absolute"
      }
    },
    attributes: {}
  }), f = l[0], i = l[1], s = br.useMemo(function() {
    return {
      name: "updateState",
      enabled: !0,
      phase: "write",
      fn: function(m) {
        var v = m.state, h = Object.keys(v.elements);
        pp.flushSync(function() {
          i({
            styles: ts(h.map(function(g) {
              return [g, v.styles[g] || {}];
            })),
            attributes: ts(h.map(function(g) {
              return [g, v.attributes[g]];
            }))
          });
        });
      },
      requires: ["computeStyles"]
    };
  }, []), c = br.useMemo(function() {
    var u = {
      onFirstUpdate: o.onFirstUpdate,
      placement: o.placement,
      strategy: o.strategy,
      modifiers: [].concat(o.modifiers, [s, {
        name: "applyStyles",
        enabled: !1
      }])
    };
    return qv(a.current, u) ? a.current || u : (a.current = u, u);
  }, [o.onFirstUpdate, o.placement, o.strategy, o.modifiers, s]), d = br.useRef();
  return ns(function() {
    d.current && d.current.setOptions(c);
  }, [c]), ns(function() {
    if (!(r == null || t == null)) {
      var u = n.createPopper || Pv, m = u(r, t, c);
      return d.current = m, function() {
        m.destroy(), d.current = null;
      };
    }
  }, [r, t, n.createPopper]), {
    state: d.current ? d.current.state : null,
    styles: f.styles,
    attributes: f.attributes,
    update: d.current ? d.current.update : null,
    forceUpdate: d.current ? d.current.forceUpdate : null
  };
}, ai = { exports: {} }, Av = ai.exports, ms;
function Mv() {
  return ms || (ms = 1, function(e, r) {
    (function(t, n) {
      e.exports = n(lf());
    })(Av, function(t) {
      function n(u) {
        return u && typeof u == "object" && "default" in u ? u : { default: u };
      }
      var a = n(t);
      function o(u) {
        return u % 10 < 5 && u % 10 > 1 && ~~(u / 10) % 10 != 1;
      }
      function l(u, m, v) {
        var h = u + " ";
        switch (v) {
          case "m":
            return m ? "minuta" : "minutę";
          case "mm":
            return h + (o(u) ? "minuty" : "minut");
          case "h":
            return m ? "godzina" : "godzinę";
          case "hh":
            return h + (o(u) ? "godziny" : "godzin");
          case "MM":
            return h + (o(u) ? "miesiące" : "miesięcy");
          case "yy":
            return h + (o(u) ? "lata" : "lat");
        }
      }
      var f = "stycznia_lutego_marca_kwietnia_maja_czerwca_lipca_sierpnia_września_października_listopada_grudnia".split("_"), i = "styczeń_luty_marzec_kwiecień_maj_czerwiec_lipiec_sierpień_wrzesień_październik_listopad_grudzień".split("_"), s = /D MMMM/, c = function(u, m) {
        return s.test(m) ? f[u.month()] : i[u.month()];
      };
      c.s = i, c.f = f;
      var d = { name: "pl", weekdays: "niedziela_poniedziałek_wtorek_środa_czwartek_piątek_sobota".split("_"), weekdaysShort: "ndz_pon_wt_śr_czw_pt_sob".split("_"), weekdaysMin: "Nd_Pn_Wt_Śr_Cz_Pt_So".split("_"), months: c, monthsShort: "sty_lut_mar_kwi_maj_cze_lip_sie_wrz_paź_lis_gru".split("_"), ordinal: function(u) {
        return u + ".";
      }, weekStart: 1, yearStart: 4, relativeTime: { future: "za %s", past: "%s temu", s: "kilka sekund", m: l, mm: l, h: l, hh: l, d: "1 dzień", dd: "%d dni", M: "miesiąc", MM: l, y: "rok", yy: l }, formats: { LT: "HH:mm", LTS: "HH:mm:ss", L: "DD.MM.YYYY", LL: "D MMMM YYYY", LLL: "D MMMM YYYY HH:mm", LLLL: "dddd, D MMMM YYYY HH:mm" } };
      return a.default.locale(d, null, !0), d;
    });
  }(ai)), ai.exports;
}
Mv();
const vs = Q.div`
    width: ${(e) => e.fullWidth ? null : "270px"};
    border-radius: var(--box-border-radius);
    box-shadow: ${(e) => e.isTab ? "0, 0, 0, 0 " : "0 0 40px 0 rgba(0, 0, 0, 0.10)"};
    background: var(--color-white);
    ${(e) => e.fullWidth ? "max-height: 600px" : null};
    ${(e) => e.fullWidth ? "height: calc(-40% + 100vh)" : null};
    ${(e) => e.fullWidth ? "margin: 15px" : null};
    display: flex;
    flex-direction: column;
    z-index: 100;
`, kv = ({
  referenceElement: e,
  children: r,
  isPopup: t,
  isTab: n
}) => {
  const [a, o] = Se(null), { styles: l, attributes: f } = gf(e, a, {
    placement: "top",
    modifiers: [
      {
        name: "preventOverflow",
        options: {
          altAxis: !0,
          padding: { right: 20 }
        }
      },
      {
        name: "offset",
        options: {
          offset: [0, 10]
        }
      }
    ]
  }), i = (s) => {
    s.preventDefault(), s.stopPropagation();
  };
  return t ? mp(
    /* @__PURE__ */ T.jsx(
      vs,
      {
        onClick: i,
        ref: o,
        style: l.popper,
        ...f.popper,
        children: r
      }
    ),
    document.querySelector("#offer-list")
  ) : /* @__PURE__ */ T.jsx(vs, { fullWidth: !0, isTab: n, children: r });
}, Dv = Q.div`
    display: flex;
    flex-direction: row;
    align-items: center;

    img {
        width: 50px;
        height: 40px;
        border-radius: var(--image-border-radius);
        margin-right: 10px;
        object-fit: cover;
    }

    p {
        --font-size-body: 13px;

        line-height: 20px;
        margin: 0;
    }
`, jv = Q.div`
    display: flex;
    flex-direction: column;
`, Iv = Q.p`
    --font-weight: 600;
    --font-size-body: 11px;

    color: var(--color-alt);
`, Nv = Q.div`
    background: var(--color-white);
    border-radius: var(--box-border-radius);
    margin-bottom: 5px;
`, Lv = Q.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 20px 15px;
    ${(e) => e.contentIsVisible ? "border-bottom: 1px solid #030D451A" : null};

    &:hover {
        cursor: pointer;
    }
`, $v = Q.div`
    padding: 20px 15px;
    ${(e) => e.active ? "background: var(--color-last-message)" : null};

    &:hover {
        cursor: pointer;
    }
`, Fv = Q.div`
    background: var(--color-alt-second);
    border-radius: 50%;
    width: 40px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
`, Bv = Q.div`
    display: flex;
    column-gap: 10px;
`, Hv = Q.div`
    display: flex;
    flex-direction: column;
`, Uv = Q.div`
    display: flex;
    flex-direction: column;
    margin-left: auto;
`, Wv = Q.p`
    --font-size-body: 14px;

    line-height: 20px;
    color: var(--color-primary);
`, zv = Q.p`
    --font-size-body: 11px;

    color: var(--color-primary);
`, Yv = Q.div`
    display: flex;
    align-items: center;
    line-height: 20px;
    justify-content: end;
`, Vv = Q.p`
    --font-size-body: 11px;
    --font-weight: 400;
`, Gv = Q.p`
    --font-size-body: 11px;
    --font-weight: 400;

    text-align: end;
`, Xv = Q.div`
    border-radius: 20px;
    background: var(--color-success);
    padding: 0 4px;
    display: flex;
    align-items: center;
    height: 15px;
    margin-right: 5px;

    p {
        color: var(--color-white);
        font-size: 10px;
        font-weight: 700;
    }
`, Fw = ({ item: e, onMessageClick: r, setVisibleContentId: t, visibleContentId: n, photoBaseUrl: a }) => {
  const [o, l] = Se(null), { title: f, price: i, mainPhoto: s, messages: c, module: d, advertisementId: u } = e, [m, v] = Se(!1), h = () => {
    v(!m);
  }, g = (x, w) => x.length > w ? `${x.substring(0, w - 1)}...` : x, p = (x, w) => {
    l(x), t(u), r(x, w, f, s, i, d, u);
  };
  return /* @__PURE__ */ T.jsxs(Nv, { children: [
    /* @__PURE__ */ T.jsxs(Lv, { contentIsVisible: n === u, onClick: h, children: [
      /* @__PURE__ */ T.jsxs(Dv, { children: [
        /* @__PURE__ */ T.jsx(
          "img",
          {
            src: s ? `${a}image/find?&module=${d}&fileName=${s}&photoSize=NORMAL_PHOTO` : "/defaultImg.png",
            alt: "offer"
          }
        ),
        /* @__PURE__ */ T.jsxs(jv, { children: [
          /* @__PURE__ */ T.jsx("p", { children: f }),
          /* @__PURE__ */ T.jsx(Iv, { children: sf(i == null ? void 0 : i.toString()) })
        ] })
      ] }),
      /* @__PURE__ */ T.jsx(Fv, { children: m ? /* @__PURE__ */ T.jsx(Ve, { icon: Ye.ACCORDION_UP }) : /* @__PURE__ */ T.jsx(Ve, { icon: Ye.ACCORDION_DOWN }) })
    ] }),
    m && c.map(({ name: x, content: w, newMessage: C, sendDate: y, lastMessageId: b, photo: R }, E) => /* @__PURE__ */ T.jsx(
      $v,
      {
        onClick: () => p(b, x),
        active: o === b && n === u,
        children: /* @__PURE__ */ T.jsxs(Bv, { children: [
          /* @__PURE__ */ T.jsx(ql, { img: R ? `${a}image/find?&module=PROFILE&fileName=${R}&photoSize=MINI_PHOTO` : void 0 }),
          /* @__PURE__ */ T.jsxs(Hv, { children: [
            /* @__PURE__ */ T.jsx(Wv, { children: x }),
            /* @__PURE__ */ T.jsx(Vv, { children: g(w, 20) })
          ] }),
          /* @__PURE__ */ T.jsxs(Uv, { children: [
            /* @__PURE__ */ T.jsxs(Yv, { children: [
              C ? /* @__PURE__ */ T.jsx(Xv, { children: /* @__PURE__ */ T.jsx("p", { children: "nowe" }) }) : null,
              /* @__PURE__ */ T.jsx(zv, { children: yt(y).format("HH:mm") })
            ] }),
            /* @__PURE__ */ T.jsx(Gv, { children: yt(y).format("DD.MM.YYYY") })
          ] })
        ] })
      },
      E
    ))
  ] });
};
var _o = /* @__PURE__ */ ((e) => (e.FULL_SCREEN_PHOTO = "FULL_SCREEN_PHOTO", e.NORMAL_PHOTO = "NORMAL_PHOTO", e))(_o || {});
const Kv = Q.div`
    border-radius: var(--box-border-radius);
    border: 3px solid var(--color-white);
    background: var(--color-alt-second);
    display: flex;
    flex-direction: column;
`, Di = Q.hr`
    border: 1px solid #030D451A;
    border-radius: var(--box-border-radius);
    width: 100%;
    height: 1px;
    margin: 0;
`, Jv = Q.div`
    padding: 20px 15px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
`, Zv = Q.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    line-height: 20px;
    color: var(--color-primary);

    p {
        margin-left: 10px;
    }
`, Qv = Q.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 12px 15px;

    img {
        width: 50px;
        height: 40px;
        border-radius: var(--image-border-radius);
        margin-right: 10px;
        object-fit: cover;
    }

    p {
        --font-size-body: 11px;

        line-height: 20px;
        margin: 0;
    }
`, eh = Q.div`
    display: flex;
    flex-direction: column;
`, rh = Q.p`
    --font-weight: 600;

    color: var(--color-alt);
`, th = Q.div`
    padding: 0 15px;
    max-height: ${(e) => e.isPopup ? "200px" : "450px"};
    height: 100%;
    overflow-y: auto;
    scrollbar-width: thin;
    scrollbar-color: var(--color-alt-second-10) var(--color-background);
    scroll-behavior: smooth;
`, nh = Q.div`
    display: grid;
    grid-template-columns: 1fr auto 1fr;
    align-items: center;
    gap: 15px;
    margin-bottom: 15px;
`, ah = Q.div`
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    margin-bottom: 10px;

    div {
        background: var(--color-alt);

        p {
            color: var(--color-white);
        }
    }
`, oh = Q.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    margin-bottom: 10px;

    div {
        background: var(--color-alt-second);

        p {
            color: var(--color-primary);
        }
    }
`, hs = Q.div`
    padding: 10px 15px;
    border-radius: 4px;
    margin-bottom: 2px;

    p {
        --font-size-body: var(--font-size-body-2);
        --font-weight: 400;
    }
`, bs = Q.p`
    --font-size-body: 11px;
    --font-weight: 400;
`, ih = Q.div`
    border-radius: 10px;
    border: 3px solid #FFF;
    background: #F2F5F9;

    & .focus {
        border-radius: 10px;
    }
`;
var Xi = /* @__PURE__ */ ((e) => (e.AD_OWNER = "AD_OWNER", e.INTERESTED = "INTERESTED", e))(Xi || {});
const ys = ({
  referenceElement: e,
  onClose: r,
  onRemove: t,
  username: n,
  userPhoto: a,
  photo: o,
  title: l,
  price: f,
  onSendMessage: i,
  messages: s,
  messageOwnerType: c,
  isPopup: d,
  isTab: u
}) => {
  const [m, v] = Se(""), h = _t(null), g = () => {
    var E, M;
    h.current && ((M = h.current) == null || M.scrollTo(0, (E = h.current) == null ? void 0 : E.scrollHeight));
  }, p = (E) => E.sort((M, I) => new Date(M.sendDate).getTime() - new Date(I.sendDate).getTime()), x = li((E) => {
    const M = [];
    return E == null || E.forEach((I) => {
      const $ = I.sendDate.split("T");
      M[$[0]] = [...M[$[0]] || [], I];
    }), M;
  }, [s]), [w, C] = Se(x(s));
  Pr(() => {
    C(x(s));
  }, [s]), Pr(() => {
    g();
  }, [w]);
  const y = (E) => {
    v(E);
  }, b = () => {
    v(""), i(m);
  }, R = li((E) => E && yt(E).format("HH:mm"), [w]);
  return /* @__PURE__ */ T.jsxs(kv, { referenceElement: e, isPopup: d, isTab: u, children: [
    /* @__PURE__ */ T.jsxs(Kv, { children: [
      /* @__PURE__ */ T.jsxs(Jv, { children: [
        /* @__PURE__ */ T.jsxs(Zv, { children: [
          /* @__PURE__ */ T.jsx(ql, { img: a }),
          /* @__PURE__ */ T.jsx("p", { children: n })
        ] }),
        r && /* @__PURE__ */ T.jsx(Ve, { icon: Ye.CROSS, onClick: r }),
        t && /* @__PURE__ */ T.jsx(
          tw,
          {
            onChange: t,
            title: "Usuwanie wiadomości",
            description: "Czy na pewno chcesz usunąć tę wiadomość?",
            filter: ""
          }
        )
      ] }),
      u ? null : /* @__PURE__ */ T.jsxs(T.Fragment, { children: [
        /* @__PURE__ */ T.jsx(Di, {}),
        /* @__PURE__ */ T.jsxs(Qv, { children: [
          /* @__PURE__ */ T.jsx("img", { src: o.replace("PHOTO_SIZE", _o.NORMAL_PHOTO), alt: "offer" }),
          /* @__PURE__ */ T.jsxs(eh, { children: [
            /* @__PURE__ */ T.jsx("p", { children: l }),
            /* @__PURE__ */ T.jsxs(rh, { children: [
              f,
              " zł"
            ] })
          ] })
        ] })
      ] })
    ] }),
    /* @__PURE__ */ T.jsx(th, { ref: h, isPopup: d, children: w && Object.keys(w).sort((E, M) => new Date(E).getTime() - new Date(M).getTime()).map((E) => /* @__PURE__ */ T.jsxs(Je.Fragment, { children: [
      /* @__PURE__ */ T.jsxs(nh, { children: [
        /* @__PURE__ */ T.jsx(Di, {}),
        /* @__PURE__ */ T.jsx("p", { children: yt(E).locale("pl").format("D MMM").toUpperCase() }),
        /* @__PURE__ */ T.jsx(Di, {})
      ] }),
      p(w[E]).map((M, I) => {
        var $, G;
        return c === M.messageSender ? /* @__PURE__ */ T.jsxs(ah, { children: [
          /* @__PURE__ */ T.jsx(hs, { children: /* @__PURE__ */ T.jsx("p", { children: M.content }) }),
          R(($ = w[E][I + 1]) == null ? void 0 : $.sendDate) !== R(M.sendDate) && /* @__PURE__ */ T.jsx(bs, { children: R(M.sendDate) })
        ] }, M.messageId) : /* @__PURE__ */ T.jsxs(oh, { children: [
          /* @__PURE__ */ T.jsx(hs, { children: /* @__PURE__ */ T.jsx("p", { children: M.content }) }),
          R((G = w[E][I + 1]) == null ? void 0 : G.sendDate) !== R(M.sendDate) && /* @__PURE__ */ T.jsx(bs, { children: R(M.sendDate) })
        ] }, M.messageId);
      })
    ] }, E)) }),
    /* @__PURE__ */ T.jsx(ih, { children: /* @__PURE__ */ T.jsx(
      bh,
      {
        value: m,
        onChange: (E) => y(E.target.value),
        placeholder: "Napisz wiadomość...",
        onAction: b,
        actionIcon: Ye.SEND
      }
    ) })
  ] });
};
function Rf(e) {
  var r, t, n = "";
  if (typeof e == "string" || typeof e == "number") n += e;
  else if (typeof e == "object") if (Array.isArray(e)) {
    var a = e.length;
    for (r = 0; r < a; r++) e[r] && (t = Rf(e[r])) && (n && (n += " "), n += t);
  } else for (t in e) e[t] && (n && (n += " "), n += t);
  return n;
}
function dr() {
  for (var e, r, t = 0, n = "", a = arguments.length; t < a; t++) (e = arguments[t]) && (r = Rf(e)) && (n && (n += " "), n += r);
  return n;
}
const lh = Q.button`
    background: var(--color-success);
    border-radius: 40px;
    height: 50px;
    border: none;
    padding: ${(e) => e.actionIconVisible ? "10px 10px 10px 20px" : "0"};
    display: flex;
    align-items: center;
    justify-content: space-between;
    text-decoration: none !important;
    cursor: pointer;

    img {
        filter: invert(59%) sepia(81%) saturate(4329%) hue-rotate(97deg) brightness(94%) contrast(91%) !important;
    }

    &.disabled,
    &.btn[disabled],
    &:disabled {
        opacity: 0.65;
        cursor: not-allowed;
    }

    &:hover {
        background: #0B8E21;
    }

    &.important {
        background: var(--color-warning);

        img {
            filter: invert(50%) sepia(87%) saturate(698%) hue-rotate(351deg) brightness(98%) contrast(90%) !important;
        }

        &:hover {
            --color-warning: #DA6900;
        }
    }
    
    &.secondary {
        background: var(--color-alt);

        &:hover {
            background: var(--color-alt);
        }
    }

    &.default {
        background: var(--color-alt-second);
        
        div {
            color: var(--color-primary);
        }

        &:hover {
            background: var(--color-alt-second);
        }
    }
`, sh = Q.div`
    display: flex;
    color: white;
    text-align: left;
    font-style: normal;
    font-weight: var(--font-weight);
    font-size: var(--font-size-body-2);
    line-height: 20px;
    text-decoration: none !important;

    .button-icon {
        margin-right: 10px;
        filter: brightness(0) invert(1) !important;
    }
`, uh = Q.div`
    background: white;
    width: 30px;
    height: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    cursor: pointer;
    margin-left: 15px;

    img {
        width: 15px;
        height: 15px;
    }
`, Bw = ({
  disabled: e,
  actionIcon: r,
  children: t,
  onClick: n,
  className: a,
  important: o,
  icon: l,
  actionIconVisible: f = !0,
  secondary: i,
  defaultVariant: s,
  role: c,
  "aria-label": d
}) => /* @__PURE__ */ T.jsxs(lh, { "aria-label": d, role: c, actionIconVisible: f, onClick: n, className: dr(a, {
  disabled: e,
  important: o,
  secondary: i,
  default: s
}), children: [
  /* @__PURE__ */ T.jsxs(sh, { children: [
    l && /* @__PURE__ */ T.jsx(Ve, { classNames: "button-icon", icon: l }),
    t
  ] }),
  f ? /* @__PURE__ */ T.jsx(uh, { children: /* @__PURE__ */ T.jsx(Ve, { classNames: "icon-in-button", icon: r ?? Ye.ARROW_RIGHT }) }) : null
] }), ch = Q.span`
    position: relative;
    display: flex;
    width: 20px;
    height: 20px;
    align-items: center;
    justify-content: center;

    &.clickable {
        cursor: pointer;
    }

`;
var Ye = /* @__PURE__ */ ((e) => (e.ACCORDION_DOWN = "accordion_down", e.ACCORDION_UP = "accordion_up", e.BOOKMARK = "bookmark", e.MAP_PIN = "map_pin", e.CALENDAR = "calendar", e.IN_TYPE = "in_type", e.PRICE = "price", e.PRICE_WHITE = "price_white", e.PRICE_PART = "price_part", e.SQUARE = "square", e.BED = "bed", e.FLOOR_LEVEL = "floor_level", e.TWO_TYPE = "two_type", e.PEOPLE = "people", e.DICTIONARY = "dictionary", e.WORK = "work", e.WORK_WHITE = "work_white", e.PHONE = "phone", e.OPTIONS = "options", e.AUDIO = "audio", e.TIMER = "timer", e.ALERT = "alert", e.ALERT_WHITE = "alert_white", e.ARROW_RIGHT = "arrow_right", e.ARROW_LEFT = "arrow_left", e.ARROW_UP = "arrow_up", e.PLUS = "plus", e.SEARCH = "search", e.ARROW_DOWN = "arrow_down", e.BAG_WHITE = "bag_white", e.CALENDAR_WHITE = "calendar_white", e.PEOPLES_2_WHITE = "peoples_2_white", e.PEOPLES_3_WHITE = "peoples_3_white", e.SQUARE_WHITE = "square_white", e.LIST_WHITE = "list_white", e.ANALYSIS_WHITE = "analysis_white", e.SQUARE_ARROW_LEFT_WHITE = "square_arrow_left_white", e.SQUARE_ARROW_RIGHT_WHITE = "square_arrow_right_white", e.SQUARES = "squares", e.BUILDING = "building", e.LINK = "link", e.BLOCKED = "blocked", e.BLOCKED_WHITE = "blocked_white", e.EYE = "eye", e.LIKE = "like", e.DISLIKE = "dislike", e.MESSAGE = "message", e.MESSAGE_WHITE = "message_white", e.PEOPLES_3 = "peoples_3", e.INFO_WHITE = "info_white", e.CROSS = "cross", e.LEAVE = "leave", e.LEAVE_WHITE = "leave_white", e.SQUARE_TIMER = "square_timer", e.SEND = "send", e.INFO = "info", e.ANGLE_LEFT = "angle_left", e.ANGLE_LEFT_TO_LINE = "angle_left_to_line", e.ANGLE_RIGHT = "angle_right", e.ANGLE_RIGHT_TO_LINE = "angle_right_to_line", e.COG = "cog", e.COG_WHITE = "cog_white", e.BOOKMARK_WHITE = "bookmark_white", e.APPROVE = "approve", e.APPROVE_WHITE = "approve_white", e.DANGER = "danger", e.DELETE = "delete", e.DELETE_WHITE = "delete_white", e.EDIT = "edit", e.EDIT_WHITE = "edit_white", e.QUESTION = "question", e.EMAIL = "email", e.HEART = "heart", e.NOTE = "note", e.NOTE2 = "note2", e.CIRCLE_CROSS = "circle_cross", e.MOON = "moon", e.SUN = "sun", e.QUESTION_CIRCLE = "questionCircle", e.WALLET = "wallet", e.WALLET_WHITE = "wallet_white", e.FULLSCREEN = "fullscreen", e.USER = "user", e.EYE_HIDDEN = "eye_hidden", e.PHOTOS = "photos", e.SAVE = "save", e.TRASH = "trash", e.UPLOAD = "upload", e.STAR = "star", e.HALF_STAR = "half_star", e.FILLED_STAR = "filled_star", e.CSV = "csv", e.PDF = "pdf", e.TXT = "txt", e.UNKNOWN_FILE = "unknown_file", e.KEY = "key", e.CHART = "chart", e.LABEL = "label", e.AI_STARS = "ai_stars", e.AI_STARS_WHITE = "ai_stars_white", e.PAINT_ROLLER = "paint_roller", e.ANDROID = "android", e.IOS = "ios", e.HANDS_SHAKE = "hands_shake", e.RELOAD = "reload", e.CALCULATOR = "calculator", e.CALCULATOR_WHITE = "calculator_white", e.HOUSE = "house", e.HOUSE_CIRCLE = "house_circle", e.GAVEL = "gavel", e.BUILDING_COLUMNS = "building_columns", e.TRIANGLE_WARNING = "triangle_warning", e.BRIEFCASE = "briefcase", e.GRID_2X2 = "grid_2x2", e.CHAT_LINES = "chat_lines", e.SCALE = "scale", e.HEART_NAV = "heart_nav", e.PLUS_CIRCLE = "plus_circle", e.ARROW_UP_RIGHT = "arrow_up_right", e.CIRCLE_DOLLAR = "circle_dollar", e.PICTURE = "picture", e.CAMERA = "camera", e.MICROPHONE = "microphone", e.MICROPHONE_WHITE = "microphone_white", e.PLAY = "play", e.PLAY_WHITE = "play_white", e.PAUSE = "pause", e.PAUSE_WHITE = "pause_white", e.STOP = "stop", e))(Ye || {});
const Ve = ({ icon: e, onClick: r, classNames: t }) => /* @__PURE__ */ T.jsx(ch, { onClick: r, className: dr(t, "icon", { clickable: r }), children: /* @__PURE__ */ T.jsx("img", { src: `/icons/${e}.svg`, alt: e }) }), dh = Q.input`
    font-weight: var(--font-weight);
    font-size: var(--font-size-body-2);
    line-height: 20px;
    width: 100%;
    flex: 1;
    background: transparent;
    border: none;
    color: var(--color-primary);
    outline: none;
    cursor: pointer;
    text-align: left;

    &:focus {
        cursor: auto;
    }

    &::placeholder {
        color: var(--color-primary);
        opacity: 0.7;
        font-weight: var(--font-weight);
        font-size: var(--font-size-body-2);
        line-height: 20px;
    }
    
    &:disabled {
        cursor: not-allowed;
    }
`, fh = Q.textarea`
    font-weight: var(--font-weight);
    font-size: var(--font-size-body-2);
    line-height: 20px;
    width: 100%;
    flex: 1;
    background: transparent;
    border: none;
    color: var(--color-primary);
    outline: none;
    cursor: pointer;
    resize: none;
    height: 100%;

    &:focus {
        cursor: auto;
    }

    &::placeholder {
        color: var(--color-primary);
        opacity: 0.7;
        font-weight: var(--font-weight);
        font-size: var(--font-size-body-2);
        line-height: 20px;
    }
`, xf = Q.div`
    background: var(--color-white);
    width: 30px;
    height: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    cursor: ${(e) => e.isBlocked ? "not-allowed" : "pointer"};
    opacity: ${(e) => e.isBlocked ? 0.5 : 1};
    pointer-events: ${(e) => e.isBlocked ? "none" : "auto"};

    &.orange-button {
        background: #fff;

        .icon {
            filter: invert(50%) sepia(87%) saturate(698%) hue-rotate(351deg) brightness(98%) contrast(90%);
        }
    }
`, ph = Q(xf)`
    margin-right: 5px;
`, mh = Q.span`
    position: relative;
    display: flex;
    gap: 10px;
    width: 100%;
    align-items: center;
    justify-content: flex-start;
    background: ${(e) => e.disabled ? "#DDDDDD" : "var(--color-alt-second)"};
    padding: 10px 10px 10px 20px;
    border-radius: var(--border-radius);
    height: 50px;

    &:hover {
        cursor: pointer;
    }

    &.description {
        height: 270px;
        padding: 15px 20px;
        border-radius: var(--box-border-radius);
    }
    
      &.align-right {
        width: 30%;
        justify-content: flex-end;
        padding: 10px 20px 10px 20px;
    }

    &.focus {
        border: 1px solid var(--color-primary);
    }
    
    &.error {
        border: 1px solid var(--color-error);

        p,
        input {
            color: var(--color-error);
        }
    }

    &.important {
        background: var(--color-warning);

        input {
            color: white !important;
        }

        input::placeholder {
            color: white !important;
            opacity: 0.7;
        }

        &:hover {
            --color-warning: #DA6900;
        }
    }
    
    &.outline {
        background: var(--color-alt-second);
        border: 2px solid var(--color-success);

        input {
            color: var(--color-primary);
        }

        input::placeholder {
            color: var(--color-primary);
            opacity: 1;
        }

        &.variant-warning {
            border-color: var(--color-warning);
        }

        &.variant-error {
            border-color: var(--color-error);
        }

        &.variant-success {
            border-color: var(--color-success);
        }

        &.variant-primary {
            border-color: var(--color-primary);
        }

        &.variant-alt {
            border-color: var(--color-alt);
        }
    }
    
        &.darker {
            background:#DDDDDD;

            input {
                color: #030D45;
            }
        }
`, vh = Q.p`
    margin-right: 10px;
    &.darker {
        color: ${(e) => e.isDark ? "var(--color-primary)" : "#030D45"};
    }
`, hh = Q.p`
    --font-size-body: ${(e) => e.isBigger ? "var(--font-size-body-2)" : "var(--font-size-body-4)"};  
    color: var(--color-error);
    padding: 0 10px;
    grid-column: 1 / -1;
`, bh = fp(({
  onKeyDown: e,
  onFocus: r,
  onBlur: t,
  required: n,
  type: a,
  important: o,
  description: l,
  disabled: f,
  placeholder: i,
  onAction: s,
  actionIcon: c,
  icon: d,
  value: u,
  onChange: m,
  max: v,
  min: h,
  onClick: g,
  suff: p,
  isSaveFilterButton: x,
  tagMode: w,
  isError: C,
  inputValidation: y,
  errorMessage: b,
  darker: R,
  maxLength: E,
  triggerValidation: M,
  pattern: I,
  errorMessageBigger: $,
  outline: G,
  variant: D,
  readOnly: k
}, F) => {
  const [B, H] = Je.useState(!1), [U, ae] = Je.useState(!1), [oe, ce] = Je.useState(!1), [J, O] = Je.useState(!1), N = (j) => {
    E && j.target.value.length > E || m && m(j);
  }, V = (j) => {
    H(!0), r && r(j);
  }, A = (j) => {
    H(!1), t && t(j), w && s && s(j), ae(y ? y(u) : !1);
  }, le = (j) => {
    (j.key === "Enter" || w && j.key === ",") && s && (s(j), ae(y ? y(u) : !1)), e && e(j);
  }, X = () => {
    ce(!oe);
  }, q = Je.useCallback((j) => {
    const ie = c === Ye.ARROW_RIGHT && x;
    ie && J || (ie && (O(!0), setTimeout(() => {
      O(!1);
    }, 1e3)), s == null || s(j));
  }, [
    c,
    x,
    J,
    s
  ]);
  Pr(() => {
    M && y && ae(y(u));
  }, [M]);
  const W = a === "password" && oe ? "text" : a, L = oe ? Ye.EYE : Ye.EYE_HIDDEN;
  return /* @__PURE__ */ T.jsxs(T.Fragment, { children: [
    /* @__PURE__ */ T.jsxs(mh, { disabled: f, onClick: g, className: dr({ important: o, focus: B, error: C || U, darker: R, description: l, outline: G, [`variant-${D}`]: G && D }), children: [
      d && /* @__PURE__ */ T.jsx(Ve, { classNames: dr({ "icon-in-button": o }), icon: d }),
      l ? /* @__PURE__ */ T.jsx(
        fh,
        {
          ref: F,
          onFocus: V,
          onClick: g,
          onBlur: A,
          required: n,
          disabled: f,
          autoComplete: "off",
          role: "textbox",
          placeholder: i,
          onChange: N,
          value: u ?? "",
          onKeyDown: le,
          maxLength: v,
          minLength: h,
          readOnly: k
        }
      ) : /* @__PURE__ */ T.jsx(
        dh,
        {
          ref: F,
          onFocus: V,
          onClick: g,
          onBlur: A,
          required: n,
          role: "input",
          "aria-label": i,
          disabled: f,
          autoComplete: "off",
          autoCapitalize: "off",
          spellCheck: "false",
          placeholder: i,
          type: W ?? "text",
          onChange: N,
          value: u ?? "",
          pattern: I,
          onKeyDown: le,
          max: v,
          min: h,
          readOnly: k
        }
      ),
      p ? /* @__PURE__ */ T.jsx(vh, { className: dr({ darker: R }), children: p }) : null,
      a === "password" && /* @__PURE__ */ T.jsx(ph, { onClick: X, children: /* @__PURE__ */ T.jsx(Ve, { icon: L }) }),
      c && /* @__PURE__ */ T.jsx(
        xf,
        {
          className: dr({ "orange-button": x }),
          onClick: q,
          isBlocked: c === Ye.ARROW_RIGHT && x && J,
          children: /* @__PURE__ */ T.jsx(Ve, { classNames: dr({ "icon-in-button": o }), icon: c })
        }
      )
    ] }),
    U ? /* @__PURE__ */ T.jsx(hh, { isBigger: $, children: b }) : null
  ] });
}), yh = Q.div`
    display: flex;
    align-items: center;
    justify-content: flex-start;
    flex-wrap: wrap;
    border-radius: 20px;
    background: var(--color-white);
    padding: 0 5px;
`, gh = Q.div`
    display: flex;
    padding: 10px;
    gap: 10px;
`, Rh = ({ notInteractiveElements: e }) => {
  const r = si(() => e, [e]);
  return /* @__PURE__ */ T.jsx(yh, { children: r.map((t, n) => /* @__PURE__ */ T.jsxs(gh, { children: [
    /* @__PURE__ */ T.jsx(Ve, { icon: t.icon }),
    t.text
  ] }, n)) });
}, vt = () => {
  try {
    const e = " -webkit- -moz- -o- -ms- ".split(" "), r = (t) => window.matchMedia(t).matches;
    return "ontouchstart" in window || typeof window.DocumentTouch < "u" && document instanceof window.DocumentTouch ? !0 : r([
      "(",
      e.join("touch-enabled),("),
      "heartz",
      ")"
    ].join(""));
  } catch (e) {
    return console.error("(Touch detect failed)", e), !1;
  }
}, xh = Q.div`
    display: flex;
    align-items: center;
    gap: 6px;
    padding: 10px 15px;
    border-radius: 20px;
    width: max-content;
    ${(e) => e.fixedWidth ? "min-width: 180px;" : ""}
    cursor: pointer;

    span {
        margin-right: 10px;
        filter: unset !important;
    }

    img {
        width: 20px;
        height: 20px;
        margin: 0;
    }

    &.is-white {
        color: var(--color-primary);
        background: var(--color-white);
    }

    &.is-warning {
        background: var(--color-warning);
        color: ${(e) => e.darkMode ? "var(--color-primary)" : "var(--color-white)"};
    }

    &.is-success {
        background: var(--color-success);
        color: ${(e) => e.darkMode ? "var(--color-primary)" : "var(--color-white)"};
    }

    &.is-gray {
        background: var(--color-alt-second);
        color: var(--color-primary);
    }

    &.is-ai-different {
        background: var(--label-color-light);
        color: var(--color-primary);
        font-style: italic;
        min-width: 180px;

        &:hover {
            background: var(--background-color-ai-label);
        }
    }

    &.is-ai-predicted {
        background: var(--background-color-ai-label);
        color: var(--color-primary);
        font-style: italic;
        min-width: 180px;
    }
`, gs = ({
  isSuccess: e,
  isWarning: r,
  isWhite: t,
  isGray: n,
  children: a,
  onMouseEnter: o,
  onMouseLeave: l,
  onClick: f,
  isDarkMode: i,
  predictedValue: s,
  aiTooltipText: c = "Dane wygenerowane przez AI",
  icon: d,
  fixedWidth: u
}) => {
  const [m, v] = Se(null), [h, g] = Se(!1), [p, x] = Se(!1), w = !!s, C = !!a && !!s, y = h || vt() && p, b = () => {
    vt() || g(!0), o == null || o();
  }, R = () => {
    vt() || g(!1), l == null || l();
  }, E = ($) => {
    vt() && w && ($.stopPropagation(), x(!p)), f == null || f($);
  }, M = () => C && y || s && !a ? s : a, I = () => C ? y ? "is-ai-predicted" : "is-ai-different" : s && !a ? "is-ai-predicted" : dr({
    "is-success": e,
    "is-warning": r,
    "is-white": t,
    "is-gray": n
  });
  return /* @__PURE__ */ T.jsxs(T.Fragment, { children: [
    /* @__PURE__ */ T.jsxs(
      xh,
      {
        ref: v,
        darkMode: i,
        fixedWidth: u,
        onClick: E,
        onMouseLeave: R,
        onMouseEnter: b,
        className: I(),
        children: [
          d && /* @__PURE__ */ T.jsx(Ve, { icon: d }),
          M(),
          w && /* @__PURE__ */ T.jsx(Ve, { icon: Ye.AI_STARS })
        ]
      }
    ),
    w && c && y && /* @__PURE__ */ T.jsx(ip, { text: c, referenceElement: m, showTooltip: y })
  ] });
}, Hw = ({ error: e, resetErrorBoundary: r }) => /* @__PURE__ */ T.jsxs("div", { role: "alert", style: { padding: "1rem", backgroundColor: "#fdd", color: "#900" }, children: [
  /* @__PURE__ */ T.jsx("p", { children: "Coś poszło nie tak:" }),
  /* @__PURE__ */ T.jsx("pre", { children: e.message }),
  /* @__PURE__ */ T.jsx("button", { onClick: r, children: "Spróbuj ponownie" })
] }), wh = "#F2F5F9", Eh = "#2B2933", Ch = {
  lightModeBackground: wh,
  darkModeBackground: Eh
}, Uw = {
  tooltipStyles: Ch
};
var Go = { exports: {} }, We = {};
/**
 * @license React
 * react-dom-test-utils.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Rs;
function _h() {
  if (Rs) return We;
  Rs = 1;
  var e = Je, r = Br;
  function t(_) {
    var ee = _, K = _;
    if (_.alternate) for (; ee.return; ) ee = ee.return;
    else {
      _ = ee;
      do
        ee = _, ee.flags & 4098 && (K = ee.return), _ = ee.return;
      while (_);
    }
    return ee.tag === 3 ? K : null;
  }
  function n(_) {
    if (t(_) !== _) throw Error("Unable to find node on an unmounted component.");
  }
  function a(_) {
    var ee = _.alternate;
    if (!ee) {
      if (ee = t(_), ee === null) throw Error("Unable to find node on an unmounted component.");
      return ee !== _ ? null : _;
    }
    for (var K = _, me = ee; ; ) {
      var we = K.return;
      if (we === null) break;
      var Ee = we.alternate;
      if (Ee === null) {
        if (me = we.return, me !== null) {
          K = me;
          continue;
        }
        break;
      }
      if (we.child === Ee.child) {
        for (Ee = we.child; Ee; ) {
          if (Ee === K) return n(we), _;
          if (Ee === me) return n(we), ee;
          Ee = Ee.sibling;
        }
        throw Error("Unable to find node on an unmounted component.");
      }
      if (K.return !== me.return) K = we, me = Ee;
      else {
        for (var be = !1, Pe = we.child; Pe; ) {
          if (Pe === K) {
            be = !0, K = we, me = Ee;
            break;
          }
          if (Pe === me) {
            be = !0, me = we, K = Ee;
            break;
          }
          Pe = Pe.sibling;
        }
        if (!be) {
          for (Pe = Ee.child; Pe; ) {
            if (Pe === K) {
              be = !0, K = Ee, me = we;
              break;
            }
            if (Pe === me) {
              be = !0, me = Ee, K = we;
              break;
            }
            Pe = Pe.sibling;
          }
          if (!be) throw Error("Child was not found in either parent set. This indicates a bug in React related to the return pointer. Please file an issue.");
        }
      }
      if (K.alternate !== me) throw Error("Return fibers should always be each others' alternates. This error is likely caused by a bug in React. Please file an issue.");
    }
    if (K.tag !== 3) throw Error("Unable to find node on an unmounted component.");
    return K.stateNode.current === K ? _ : ee;
  }
  var o = Object.assign;
  function l(_) {
    var ee = _.keyCode;
    return "charCode" in _ ? (_ = _.charCode, _ === 0 && ee === 13 && (_ = 13)) : _ = ee, _ === 10 && (_ = 13), 32 <= _ || _ === 13 ? _ : 0;
  }
  function f() {
    return !0;
  }
  function i() {
    return !1;
  }
  function s(_) {
    function ee(K, me, we, Ee, be) {
      this._reactName = K, this._targetInst = we, this.type = me, this.nativeEvent = Ee, this.target = be, this.currentTarget = null;
      for (var Pe in _) _.hasOwnProperty(Pe) && (K = _[Pe], this[Pe] = K ? K(Ee) : Ee[Pe]);
      return this.isDefaultPrevented = (Ee.defaultPrevented != null ? Ee.defaultPrevented : Ee.returnValue === !1) ? f : i, this.isPropagationStopped = i, this;
    }
    return o(ee.prototype, { preventDefault: function() {
      this.defaultPrevented = !0;
      var K = this.nativeEvent;
      K && (K.preventDefault ? K.preventDefault() : typeof K.returnValue != "unknown" && (K.returnValue = !1), this.isDefaultPrevented = f);
    }, stopPropagation: function() {
      var K = this.nativeEvent;
      K && (K.stopPropagation ? K.stopPropagation() : typeof K.cancelBubble != "unknown" && (K.cancelBubble = !0), this.isPropagationStopped = f);
    }, persist: function() {
    }, isPersistent: f }), ee;
  }
  var c = { eventPhase: 0, bubbles: 0, cancelable: 0, timeStamp: function(_) {
    return _.timeStamp || Date.now();
  }, defaultPrevented: 0, isTrusted: 0 }, d = s(c), u = o({}, c, { view: 0, detail: 0 });
  s(u);
  var m, v, h, g = o({}, u, { screenX: 0, screenY: 0, clientX: 0, clientY: 0, pageX: 0, pageY: 0, ctrlKey: 0, shiftKey: 0, altKey: 0, metaKey: 0, getModifierState: I, button: 0, buttons: 0, relatedTarget: function(_) {
    return _.relatedTarget === void 0 ? _.fromElement === _.srcElement ? _.toElement : _.fromElement : _.relatedTarget;
  }, movementX: function(_) {
    return "movementX" in _ ? _.movementX : (_ !== h && (h && _.type === "mousemove" ? (m = _.screenX - h.screenX, v = _.screenY - h.screenY) : v = m = 0, h = _), m);
  }, movementY: function(_) {
    return "movementY" in _ ? _.movementY : v;
  } });
  s(g);
  var p = o({}, g, { dataTransfer: 0 });
  s(p);
  var x = o({}, u, { relatedTarget: 0 });
  s(x);
  var w = o({}, c, { animationName: 0, elapsedTime: 0, pseudoElement: 0 });
  s(w);
  var C = o({}, c, { clipboardData: function(_) {
    return "clipboardData" in _ ? _.clipboardData : window.clipboardData;
  } });
  s(C);
  var y = o({}, c, { data: 0 });
  s(y);
  var b = { Esc: "Escape", Spacebar: " ", Left: "ArrowLeft", Up: "ArrowUp", Right: "ArrowRight", Down: "ArrowDown", Del: "Delete", Win: "OS", Menu: "ContextMenu", Apps: "ContextMenu", Scroll: "ScrollLock", MozPrintableKey: "Unidentified" }, R = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
  }, E = { Alt: "altKey", Control: "ctrlKey", Meta: "metaKey", Shift: "shiftKey" };
  function M(_) {
    var ee = this.nativeEvent;
    return ee.getModifierState ? ee.getModifierState(_) : (_ = E[_]) ? !!ee[_] : !1;
  }
  function I() {
    return M;
  }
  var $ = o({}, u, { key: function(_) {
    if (_.key) {
      var ee = b[_.key] || _.key;
      if (ee !== "Unidentified") return ee;
    }
    return _.type === "keypress" ? (_ = l(_), _ === 13 ? "Enter" : String.fromCharCode(_)) : _.type === "keydown" || _.type === "keyup" ? R[_.keyCode] || "Unidentified" : "";
  }, code: 0, location: 0, ctrlKey: 0, shiftKey: 0, altKey: 0, metaKey: 0, repeat: 0, locale: 0, getModifierState: I, charCode: function(_) {
    return _.type === "keypress" ? l(_) : 0;
  }, keyCode: function(_) {
    return _.type === "keydown" || _.type === "keyup" ? _.keyCode : 0;
  }, which: function(_) {
    return _.type === "keypress" ? l(_) : _.type === "keydown" || _.type === "keyup" ? _.keyCode : 0;
  } });
  s($);
  var G = o({}, g, { pointerId: 0, width: 0, height: 0, pressure: 0, tangentialPressure: 0, tiltX: 0, tiltY: 0, twist: 0, pointerType: 0, isPrimary: 0 });
  s(G);
  var D = o({}, u, { touches: 0, targetTouches: 0, changedTouches: 0, altKey: 0, metaKey: 0, ctrlKey: 0, shiftKey: 0, getModifierState: I });
  s(D);
  var k = o({}, c, { propertyName: 0, elapsedTime: 0, pseudoElement: 0 });
  s(k);
  var F = o({}, g, { deltaX: function(_) {
    return "deltaX" in _ ? _.deltaX : "wheelDeltaX" in _ ? -_.wheelDeltaX : 0;
  }, deltaY: function(_) {
    return "deltaY" in _ ? _.deltaY : "wheelDeltaY" in _ ? -_.wheelDeltaY : "wheelDelta" in _ ? -_.wheelDelta : 0;
  }, deltaZ: 0, deltaMode: 0 });
  s(F);
  function B(_, ee, K, me, we, Ee, be, Pe, Xe) {
    var rr = Array.prototype.slice.call(arguments, 3);
    try {
      ee.apply(K, rr);
    } catch (pr) {
      this.onError(pr);
    }
  }
  var H = !1, U = null, ae = !1, oe = null, ce = { onError: function(_) {
    H = !0, U = _;
  } };
  function J(_, ee, K, me, we, Ee, be, Pe, Xe) {
    H = !1, U = null, B.apply(ce, arguments);
  }
  function O(_, ee, K, me, we, Ee, be, Pe, Xe) {
    if (J.apply(this, arguments), H) {
      if (H) {
        var rr = U;
        H = !1, U = null;
      } else throw Error("clearCaughtError was called but no error was captured. This error is likely caused by a bug in React. Please file an issue.");
      ae || (ae = !0, oe = rr);
    }
  }
  var N = Array.isArray, V = r.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.Events, A = V[0], le = V[1], X = V[2], q = V[3], W = V[4], L = e.unstable_act;
  function j() {
  }
  function ie(_, ee) {
    if (!_) return [];
    if (_ = a(_), !_) return [];
    for (var K = _, me = []; ; ) {
      if (K.tag === 5 || K.tag === 6 || K.tag === 1 || K.tag === 0) {
        var we = K.stateNode;
        ee(we) && me.push(we);
      }
      if (K.child) K.child.return = K, K = K.child;
      else {
        if (K === _) return me;
        for (; !K.sibling; ) {
          if (!K.return || K.return === _) return me;
          K = K.return;
        }
        K.sibling.return = K.return, K = K.sibling;
      }
    }
  }
  function Z(_, ee) {
    if (_ && !_._reactInternals) {
      var K = String(_);
      throw _ = N(_) ? "an array" : _ && _.nodeType === 1 && _.tagName ? "a DOM node" : K === "[object Object]" ? "object with keys {" + Object.keys(_).join(", ") + "}" : K, Error(ee + "(...): the first argument must be a React class instance. Instead received: " + (_ + "."));
    }
  }
  function se(_) {
    return !(!_ || _.nodeType !== 1 || !_.tagName);
  }
  function pe(_) {
    return se(_) ? !1 : _ != null && typeof _.render == "function" && typeof _.setState == "function";
  }
  function de(_, ee) {
    return pe(_) ? _._reactInternals.type === ee : !1;
  }
  function Re(_, ee) {
    return Z(_, "findAllInRenderedTree"), _ ? ie(_._reactInternals, ee) : [];
  }
  function Ue(_, ee) {
    return Z(_, "scryRenderedDOMComponentsWithClass"), Re(_, function(K) {
      if (se(K)) {
        var me = K.className;
        typeof me != "string" && (me = K.getAttribute("class") || "");
        var we = me.split(/\s+/);
        if (!N(ee)) {
          if (ee === void 0) throw Error("TestUtils.scryRenderedDOMComponentsWithClass expects a className as a second argument.");
          ee = ee.split(/\s+/);
        }
        return ee.every(function(Ee) {
          return we.indexOf(Ee) !== -1;
        });
      }
      return !1;
    });
  }
  function xe(_, ee) {
    return Z(_, "scryRenderedDOMComponentsWithTag"), Re(_, function(K) {
      return se(K) && K.tagName.toUpperCase() === ee.toUpperCase();
    });
  }
  function Ke(_, ee) {
    return Z(_, "scryRenderedComponentsWithType"), Re(_, function(K) {
      return de(K, ee);
    });
  }
  function Ge(_, ee, K) {
    var me = _.type || "unknown-event";
    _.currentTarget = le(K), O(me, ee, void 0, _), _.currentTarget = null;
  }
  function Le(_, ee, K) {
    for (var me = []; _; ) {
      me.push(_);
      do
        _ = _.return;
      while (_ && _.tag !== 5);
      _ = _ || null;
    }
    for (_ = me.length; 0 < _--; ) ee(me[_], "captured", K);
    for (_ = 0; _ < me.length; _++) ee(me[_], "bubbled", K);
  }
  function fe(_, ee) {
    var K = _.stateNode;
    if (!K) return null;
    var me = X(K);
    if (!me) return null;
    K = me[ee];
    e: switch (ee) {
      case "onClick":
      case "onClickCapture":
      case "onDoubleClick":
      case "onDoubleClickCapture":
      case "onMouseDown":
      case "onMouseDownCapture":
      case "onMouseMove":
      case "onMouseMoveCapture":
      case "onMouseUp":
      case "onMouseUpCapture":
      case "onMouseEnter":
        (me = !me.disabled) || (_ = _.type, me = !(_ === "button" || _ === "input" || _ === "select" || _ === "textarea")), _ = !me;
        break e;
      default:
        _ = !1;
    }
    if (_) return null;
    if (K && typeof K != "function") throw Error("Expected `" + ee + "` listener to be a function, instead got a value of `" + typeof K + "` type.");
    return K;
  }
  function _e(_, ee, K) {
    _ && K && K._reactName && (ee = fe(_, K._reactName)) && (K._dispatchListeners == null && (K._dispatchListeners = []), K._dispatchInstances == null && (K._dispatchInstances = []), K._dispatchListeners.push(ee), K._dispatchInstances.push(_));
  }
  function Ze(_, ee, K) {
    var me = K._reactName;
    ee === "captured" && (me += "Capture"), (ee = fe(_, me)) && (K._dispatchListeners == null && (K._dispatchListeners = []), K._dispatchInstances == null && (K._dispatchInstances = []), K._dispatchListeners.push(ee), K._dispatchInstances.push(_));
  }
  var er = {}, $e = /* @__PURE__ */ new Set(["mouseEnter", "mouseLeave", "pointerEnter", "pointerLeave"]);
  function zr(_) {
    return function(ee, K) {
      if (e.isValidElement(ee)) throw Error("TestUtils.Simulate expected a DOM node as the first argument but received a React element. Pass the DOM node you wish to simulate the event on instead. Note that TestUtils.Simulate will not work if you are using shallow rendering.");
      if (pe(ee)) throw Error("TestUtils.Simulate expected a DOM node as the first argument but received a component instance. Pass the DOM node you wish to simulate the event on instead.");
      var me = "on" + _[0].toUpperCase() + _.slice(1), we = new j();
      we.target = ee, we.type = _.toLowerCase();
      var Ee = A(ee), be = new d(me, we.type, Ee, we, ee);
      be.persist(), o(be, K), $e.has(_) ? be && be._reactName && _e(be._targetInst, null, be) : be && be._reactName && Le(be._targetInst, Ze, be), r.unstable_batchedUpdates(function() {
        if (q(ee), be) {
          var Pe = be._dispatchListeners, Xe = be._dispatchInstances;
          if (N(Pe)) for (var rr = 0; rr < Pe.length && !be.isPropagationStopped(); rr++) Ge(be, Pe[rr], Xe[rr]);
          else Pe && Ge(be, Pe, Xe);
          be._dispatchListeners = null, be._dispatchInstances = null, be.isPersistent() || be.constructor.release(be);
        }
        if (ae) throw Pe = oe, ae = !1, oe = null, Pe;
      }), W();
    };
  }
  return "blur cancel click close contextMenu copy cut auxClick doubleClick dragEnd dragStart drop focus input invalid keyDown keyPress keyUp mouseDown mouseUp paste pause play pointerCancel pointerDown pointerUp rateChange reset resize seeked submit touchCancel touchEnd touchStart volumeChange drag dragEnter dragExit dragLeave dragOver mouseMove mouseOut mouseOver pointerMove pointerOut pointerOver scroll toggle touchMove wheel abort animationEnd animationIteration animationStart canPlay canPlayThrough durationChange emptied encrypted ended error gotPointerCapture load loadedData loadedMetadata loadStart lostPointerCapture playing progress seeking stalled suspend timeUpdate transitionEnd waiting mouseEnter mouseLeave pointerEnter pointerLeave change select beforeInput compositionEnd compositionStart compositionUpdate".split(" ").forEach(function(_) {
    er[_] = zr(_);
  }), We.Simulate = er, We.act = L, We.findAllInRenderedTree = Re, We.findRenderedComponentWithType = function(_, ee) {
    if (Z(_, "findRenderedComponentWithType"), _ = Ke(_, ee), _.length !== 1) throw Error("Did not find exactly one match (found: " + _.length + ") for componentType:" + ee);
    return _[0];
  }, We.findRenderedDOMComponentWithClass = function(_, ee) {
    if (Z(_, "findRenderedDOMComponentWithClass"), _ = Ue(_, ee), _.length !== 1) throw Error("Did not find exactly one match (found: " + _.length + ") for class:" + ee);
    return _[0];
  }, We.findRenderedDOMComponentWithTag = function(_, ee) {
    if (Z(_, "findRenderedDOMComponentWithTag"), _ = xe(_, ee), _.length !== 1) throw Error("Did not find exactly one match (found: " + _.length + ") for tag:" + ee);
    return _[0];
  }, We.isCompositeComponent = pe, We.isCompositeComponentWithType = de, We.isDOMComponent = se, We.isDOMComponentElement = function(_) {
    return !!(_ && e.isValidElement(_) && _.tagName);
  }, We.isElement = function(_) {
    return e.isValidElement(_);
  }, We.isElementOfType = function(_, ee) {
    return e.isValidElement(_) && _.type === ee;
  }, We.mockComponent = function(_, ee) {
    return ee = ee || _.mockTagName || "div", _.prototype.render.mockImplementation(function() {
      return e.createElement(ee, null, this.props.children);
    }), this;
  }, We.nativeTouchData = function(_, ee) {
    return { touches: [{ pageX: _, pageY: ee }] };
  }, We.renderIntoDocument = function(_) {
    var ee = document.createElement("div");
    return r.render(_, ee);
  }, We.scryRenderedComponentsWithType = Ke, We.scryRenderedDOMComponentsWithClass = Ue, We.scryRenderedDOMComponentsWithTag = xe, We.traverseTwoPhase = Le, We;
}
var ze = {};
/**
 * @license React
 * react-dom-test-utils.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var xs;
function Ph() {
  return xs || (xs = 1, process.env.NODE_ENV !== "production" && function() {
    var e = Je, r = Br, t = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function n(P) {
      {
        for (var z = arguments.length, Y = new Array(z > 1 ? z - 1 : 0), re = 1; re < z; re++)
          Y[re - 1] = arguments[re];
        o("warn", P, Y);
      }
    }
    function a(P) {
      {
        for (var z = arguments.length, Y = new Array(z > 1 ? z - 1 : 0), re = 1; re < z; re++)
          Y[re - 1] = arguments[re];
        o("error", P, Y);
      }
    }
    function o(P, z, Y) {
      {
        var re = t.ReactDebugCurrentFrame, he = re.getStackAddendum();
        he !== "" && (z += "%s", Y = Y.concat([he]));
        var Ce = Y.map(function(He) {
          return String(He);
        });
        Ce.unshift("Warning: " + z), Function.prototype.apply.call(console[P], console, Ce);
      }
    }
    function l(P) {
      return P._reactInternals;
    }
    var f = 0, i = 1, s = 3, c = 5, d = 6, u = (
      /*                      */
      0
    ), m = (
      /*                    */
      2
    ), v = (
      /*                    */
      4096
    );
    t.ReactCurrentOwner;
    function h(P) {
      var z = P, Y = P;
      if (P.alternate)
        for (; z.return; )
          z = z.return;
      else {
        var re = z;
        do
          z = re, (z.flags & (m | v)) !== u && (Y = z.return), re = z.return;
        while (re);
      }
      return z.tag === s ? Y : null;
    }
    function g(P) {
      if (h(P) !== P)
        throw new Error("Unable to find node on an unmounted component.");
    }
    function p(P) {
      var z = P.alternate;
      if (!z) {
        var Y = h(P);
        if (Y === null)
          throw new Error("Unable to find node on an unmounted component.");
        return Y !== P ? null : P;
      }
      for (var re = P, he = z; ; ) {
        var Ce = re.return;
        if (Ce === null)
          break;
        var He = Ce.alternate;
        if (He === null) {
          var mr = Ce.return;
          if (mr !== null) {
            re = he = mr;
            continue;
          }
          break;
        }
        if (Ce.child === He.child) {
          for (var vr = Ce.child; vr; ) {
            if (vr === re)
              return g(Ce), P;
            if (vr === he)
              return g(Ce), z;
            vr = vr.sibling;
          }
          throw new Error("Unable to find node on an unmounted component.");
        }
        if (re.return !== he.return)
          re = Ce, he = He;
        else {
          for (var ur = !1, nr = Ce.child; nr; ) {
            if (nr === re) {
              ur = !0, re = Ce, he = He;
              break;
            }
            if (nr === he) {
              ur = !0, he = Ce, re = He;
              break;
            }
            nr = nr.sibling;
          }
          if (!ur) {
            for (nr = He.child; nr; ) {
              if (nr === re) {
                ur = !0, re = He, he = Ce;
                break;
              }
              if (nr === he) {
                ur = !0, he = He, re = Ce;
                break;
              }
              nr = nr.sibling;
            }
            if (!ur)
              throw new Error("Child was not found in either parent set. This indicates a bug in React related to the return pointer. Please file an issue.");
          }
        }
        if (re.alternate !== he)
          throw new Error("Return fibers should always be each others' alternates. This error is likely caused by a bug in React. Please file an issue.");
      }
      if (re.tag !== s)
        throw new Error("Unable to find node on an unmounted component.");
      return re.stateNode.current === re ? P : z;
    }
    var x = Object.assign;
    function w(P) {
      var z, Y = P.keyCode;
      return "charCode" in P ? (z = P.charCode, z === 0 && Y === 13 && (z = 13)) : z = Y, z === 10 && (z = 13), z >= 32 || z === 13 ? z : 0;
    }
    function C() {
      return !0;
    }
    function y() {
      return !1;
    }
    function b(P) {
      function z(Y, re, he, Ce, He) {
        this._reactName = Y, this._targetInst = he, this.type = re, this.nativeEvent = Ce, this.target = He, this.currentTarget = null;
        for (var mr in P)
          if (P.hasOwnProperty(mr)) {
            var vr = P[mr];
            vr ? this[mr] = vr(Ce) : this[mr] = Ce[mr];
          }
        var ur = Ce.defaultPrevented != null ? Ce.defaultPrevented : Ce.returnValue === !1;
        return ur ? this.isDefaultPrevented = C : this.isDefaultPrevented = y, this.isPropagationStopped = y, this;
      }
      return x(z.prototype, {
        preventDefault: function() {
          this.defaultPrevented = !0;
          var Y = this.nativeEvent;
          Y && (Y.preventDefault ? Y.preventDefault() : typeof Y.returnValue != "unknown" && (Y.returnValue = !1), this.isDefaultPrevented = C);
        },
        stopPropagation: function() {
          var Y = this.nativeEvent;
          Y && (Y.stopPropagation ? Y.stopPropagation() : typeof Y.cancelBubble != "unknown" && (Y.cancelBubble = !0), this.isPropagationStopped = C);
        },
        /**
         * We release all dispatched `SyntheticEvent`s after each event loop, adding
         * them back into the pool. This allows a way to hold onto a reference that
         * won't be added back into the pool.
         */
        persist: function() {
        },
        /**
         * Checks if this event should be released back into the pool.
         *
         * @return {boolean} True if this should not be released, false otherwise.
         */
        isPersistent: C
      }), z;
    }
    var R = {
      eventPhase: 0,
      bubbles: 0,
      cancelable: 0,
      timeStamp: function(P) {
        return P.timeStamp || Date.now();
      },
      defaultPrevented: 0,
      isTrusted: 0
    }, E = b(R), M = x({}, R, {
      view: 0,
      detail: 0
    });
    b(M);
    var I, $, G;
    function D(P) {
      P !== G && (G && P.type === "mousemove" ? (I = P.screenX - G.screenX, $ = P.screenY - G.screenY) : (I = 0, $ = 0), G = P);
    }
    var k = x({}, M, {
      screenX: 0,
      screenY: 0,
      clientX: 0,
      clientY: 0,
      pageX: 0,
      pageY: 0,
      ctrlKey: 0,
      shiftKey: 0,
      altKey: 0,
      metaKey: 0,
      getModifierState: V,
      button: 0,
      buttons: 0,
      relatedTarget: function(P) {
        return P.relatedTarget === void 0 ? P.fromElement === P.srcElement ? P.toElement : P.fromElement : P.relatedTarget;
      },
      movementX: function(P) {
        return "movementX" in P ? P.movementX : (D(P), I);
      },
      movementY: function(P) {
        return "movementY" in P ? P.movementY : $;
      }
    });
    b(k);
    var F = x({}, k, {
      dataTransfer: 0
    });
    b(F);
    var B = x({}, M, {
      relatedTarget: 0
    });
    b(B);
    var H = x({}, R, {
      animationName: 0,
      elapsedTime: 0,
      pseudoElement: 0
    });
    b(H);
    var U = x({}, R, {
      clipboardData: function(P) {
        return "clipboardData" in P ? P.clipboardData : window.clipboardData;
      }
    });
    b(U);
    var ae = x({}, R, {
      data: 0
    });
    b(ae);
    var oe = {
      Esc: "Escape",
      Spacebar: " ",
      Left: "ArrowLeft",
      Up: "ArrowUp",
      Right: "ArrowRight",
      Down: "ArrowDown",
      Del: "Delete",
      Win: "OS",
      Menu: "ContextMenu",
      Apps: "ContextMenu",
      Scroll: "ScrollLock",
      MozPrintableKey: "Unidentified"
    }, ce = {
      8: "Backspace",
      9: "Tab",
      12: "Clear",
      13: "Enter",
      16: "Shift",
      17: "Control",
      18: "Alt",
      19: "Pause",
      20: "CapsLock",
      27: "Escape",
      32: " ",
      33: "PageUp",
      34: "PageDown",
      35: "End",
      36: "Home",
      37: "ArrowLeft",
      38: "ArrowUp",
      39: "ArrowRight",
      40: "ArrowDown",
      45: "Insert",
      46: "Delete",
      112: "F1",
      113: "F2",
      114: "F3",
      115: "F4",
      116: "F5",
      117: "F6",
      118: "F7",
      119: "F8",
      120: "F9",
      121: "F10",
      122: "F11",
      123: "F12",
      144: "NumLock",
      145: "ScrollLock",
      224: "Meta"
    };
    function J(P) {
      if (P.key) {
        var z = oe[P.key] || P.key;
        if (z !== "Unidentified")
          return z;
      }
      if (P.type === "keypress") {
        var Y = w(P);
        return Y === 13 ? "Enter" : String.fromCharCode(Y);
      }
      return P.type === "keydown" || P.type === "keyup" ? ce[P.keyCode] || "Unidentified" : "";
    }
    var O = {
      Alt: "altKey",
      Control: "ctrlKey",
      Meta: "metaKey",
      Shift: "shiftKey"
    };
    function N(P) {
      var z = this, Y = z.nativeEvent;
      if (Y.getModifierState)
        return Y.getModifierState(P);
      var re = O[P];
      return re ? !!Y[re] : !1;
    }
    function V(P) {
      return N;
    }
    var A = x({}, M, {
      key: J,
      code: 0,
      location: 0,
      ctrlKey: 0,
      shiftKey: 0,
      altKey: 0,
      metaKey: 0,
      repeat: 0,
      locale: 0,
      getModifierState: V,
      // Legacy Interface
      charCode: function(P) {
        return P.type === "keypress" ? w(P) : 0;
      },
      keyCode: function(P) {
        return P.type === "keydown" || P.type === "keyup" ? P.keyCode : 0;
      },
      which: function(P) {
        return P.type === "keypress" ? w(P) : P.type === "keydown" || P.type === "keyup" ? P.keyCode : 0;
      }
    });
    b(A);
    var le = x({}, k, {
      pointerId: 0,
      width: 0,
      height: 0,
      pressure: 0,
      tangentialPressure: 0,
      tiltX: 0,
      tiltY: 0,
      twist: 0,
      pointerType: 0,
      isPrimary: 0
    });
    b(le);
    var X = x({}, M, {
      touches: 0,
      targetTouches: 0,
      changedTouches: 0,
      altKey: 0,
      metaKey: 0,
      ctrlKey: 0,
      shiftKey: 0,
      getModifierState: V
    });
    b(X);
    var q = x({}, R, {
      propertyName: 0,
      elapsedTime: 0,
      pseudoElement: 0
    });
    b(q);
    var W = x({}, k, {
      deltaX: function(P) {
        return "deltaX" in P ? P.deltaX : (
          // Fallback to `wheelDeltaX` for Webkit and normalize (right is positive).
          "wheelDeltaX" in P ? -P.wheelDeltaX : 0
        );
      },
      deltaY: function(P) {
        return "deltaY" in P ? P.deltaY : (
          // Fallback to `wheelDeltaY` for Webkit and normalize (down is positive).
          "wheelDeltaY" in P ? -P.wheelDeltaY : (
            // Fallback to `wheelDelta` for IE<9 and normalize (down is positive).
            "wheelDelta" in P ? -P.wheelDelta : 0
          )
        );
      },
      deltaZ: 0,
      // Browsers without "deltaMode" is reporting in raw wheel delta where one
      // notch on the scroll is always +/- 120, roughly equivalent to pixels.
      // A good approximation of DOM_DELTA_LINE (1) is 5% of viewport size or
      // ~40 pixels, for DOM_DELTA_SCREEN (2) it is 87.5% of viewport size.
      deltaMode: 0
    });
    b(W);
    var L = 1;
    function j(P, z, Y, re, he, Ce, He, mr, vr) {
      var ur = Array.prototype.slice.call(arguments, 3);
      try {
        z.apply(Y, ur);
      } catch (nr) {
        this.onError(nr);
      }
    }
    var ie = j;
    if (typeof window < "u" && typeof window.dispatchEvent == "function" && typeof document < "u" && typeof document.createEvent == "function") {
      var Z = document.createElement("react");
      ie = function(z, Y, re, he, Ce, He, mr, vr, ur) {
        if (typeof document > "u" || document === null)
          throw new Error("The `document` global was defined when React was initialized, but is not defined anymore. This can happen in a test environment if a component schedules an update from an asynchronous callback, but the test has already finished running. To solve this, you can either unmount the component at the end of your test (and ensure that any asynchronous operations get canceled in `componentWillUnmount`), or you can change the test itself to be asynchronous.");
        var nr = document.createEvent("Event"), Si = !1, Ol = !0, sp = window.event, Al = Object.getOwnPropertyDescriptor(window, "event");
        function Ml() {
          Z.removeEventListener(qi, kl, !1), typeof window.event < "u" && window.hasOwnProperty("event") && (window.event = sp);
        }
        var up = Array.prototype.slice.call(arguments, 3);
        function kl() {
          Si = !0, Ml(), Y.apply(re, up), Ol = !1;
        }
        var Vr, Dl = !1, jl = !1;
        function Il(Fo) {
          if (Vr = Fo.error, Dl = !0, Vr === null && Fo.colno === 0 && Fo.lineno === 0 && (jl = !0), Fo.defaultPrevented && Vr != null && typeof Vr == "object")
            try {
              Vr._suppressLogging = !0;
            } catch {
            }
        }
        var qi = "react-" + (z || "invokeguardedcallback");
        if (window.addEventListener("error", Il), Z.addEventListener(qi, kl, !1), nr.initEvent(qi, !1, !1), Z.dispatchEvent(nr), Al && Object.defineProperty(window, "event", Al), Si && Ol && (Dl ? jl && (Vr = new Error("A cross-origin error was thrown. React doesn't have access to the actual error object in development. See https://reactjs.org/link/crossorigin-error for more information.")) : Vr = new Error(`An error was thrown inside one of your components, but React doesn't know what it was. This is likely due to browser flakiness. React does its best to preserve the "Pause on exceptions" behavior of the DevTools, which requires some DEV-mode only tricks. It's possible that these don't work in your browser. Try triggering the error in production mode, or switching to a modern browser. If you suspect that this is actually an issue with React, please file an issue.`), this.onError(Vr)), window.removeEventListener("error", Il), !Si)
          return Ml(), j.apply(this, arguments);
      };
    }
    var se = ie, pe = !1, de = null, Re = !1, Ue = null, xe = {
      onError: function(P) {
        pe = !0, de = P;
      }
    };
    function Ke(P, z, Y, re, he, Ce, He, mr, vr) {
      pe = !1, de = null, se.apply(xe, arguments);
    }
    function Ge(P, z, Y, re, he, Ce, He, mr, vr) {
      if (Ke.apply(this, arguments), pe) {
        var ur = fe();
        Re || (Re = !0, Ue = ur);
      }
    }
    function Le() {
      if (Re) {
        var P = Ue;
        throw Re = !1, Ue = null, P;
      }
    }
    function fe() {
      if (pe) {
        var P = de;
        return pe = !1, de = null, P;
      } else
        throw new Error("clearCaughtError was called but no error was captured. This error is likely caused by a bug in React. Please file an issue.");
    }
    var _e = Array.isArray;
    function Ze(P) {
      return _e(P);
    }
    var er = r.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $e = er.Events, zr = $e[0], _ = $e[1], ee = $e[2], K = $e[3], me = $e[4], we = e.unstable_act;
    function Ee(P) {
    }
    var be = !1;
    function Pe(P, z) {
      if (!P)
        return [];
      var Y = p(P);
      if (!Y)
        return [];
      for (var re = Y, he = []; ; ) {
        if (re.tag === c || re.tag === d || re.tag === i || re.tag === f) {
          var Ce = re.stateNode;
          z(Ce) && he.push(Ce);
        }
        if (re.child) {
          re.child.return = re, re = re.child;
          continue;
        }
        if (re === Y)
          return he;
        for (; !re.sibling; ) {
          if (!re.return || re.return === Y)
            return he;
          re = re.return;
        }
        re.sibling.return = re.return, re = re.sibling;
      }
    }
    function Xe(P, z) {
      if (P && !l(P)) {
        var Y, re = String(P);
        throw Ze(P) ? Y = "an array" : P && P.nodeType === L && P.tagName ? Y = "a DOM node" : re === "[object Object]" ? Y = "object with keys {" + Object.keys(P).join(", ") + "}" : Y = re, new Error(z + "(...): the first argument must be a React class instance. " + ("Instead received: " + Y + "."));
      }
    }
    var rr = !1;
    function pr(P) {
      rr || (rr = !0, a("ReactDOMTestUtils is deprecated and will be removed in a future major release, because it exposes internal implementation details that are highly likely to change between releases. Upgrade to a modern testing library, such as @testing-library/react. See https://react.dev/warnings/react-dom-test-utils for more info."));
      var z = document.createElement("div");
      return r.render(P, z);
    }
    function Qr(P) {
      return e.isValidElement(P);
    }
    function et(P, z) {
      return e.isValidElement(P) && P.type === z;
    }
    function Sr(P) {
      return !!(P && P.nodeType === L && P.tagName);
    }
    function St(P) {
      return !!(P && e.isValidElement(P) && P.tagName);
    }
    function Yr(P) {
      return Sr(P) ? !1 : P != null && typeof P.render == "function" && typeof P.setState == "function";
    }
    function pt(P, z) {
      if (!Yr(P))
        return !1;
      var Y = l(P), re = Y.type;
      return re === z;
    }
    function ne(P, z) {
      if (Xe(P, "findAllInRenderedTree"), !P)
        return [];
      var Y = l(P);
      return Pe(Y, z);
    }
    function rt(P, z) {
      return Xe(P, "scryRenderedDOMComponentsWithClass"), ne(P, function(Y) {
        if (Sr(Y)) {
          var re = Y.className;
          typeof re != "string" && (re = Y.getAttribute("class") || "");
          var he = re.split(/\s+/);
          if (!Ze(z)) {
            if (z === void 0)
              throw new Error("TestUtils.scryRenderedDOMComponentsWithClass expects a className as a second argument.");
            z = z.split(/\s+/);
          }
          return z.every(function(Ce) {
            return he.indexOf(Ce) !== -1;
          });
        }
        return !1;
      });
    }
    function qt(P, z) {
      Xe(P, "findRenderedDOMComponentWithClass");
      var Y = rt(P, z);
      if (Y.length !== 1)
        throw new Error("Did not find exactly one match (found: " + Y.length + ") for class:" + z);
      return Y[0];
    }
    function qr(P, z) {
      return Xe(P, "scryRenderedDOMComponentsWithTag"), ne(P, function(Y) {
        return Sr(Y) && Y.tagName.toUpperCase() === z.toUpperCase();
      });
    }
    function No(P, z) {
      Xe(P, "findRenderedDOMComponentWithTag");
      var Y = qr(P, z);
      if (Y.length !== 1)
        throw new Error("Did not find exactly one match (found: " + Y.length + ") for tag:" + z);
      return Y[0];
    }
    function Ot(P, z) {
      return Xe(P, "scryRenderedComponentsWithType"), ne(P, function(Y) {
        return pt(Y, z);
      });
    }
    function Ci(P, z) {
      Xe(P, "findRenderedComponentWithType");
      var Y = Ot(P, z);
      if (Y.length !== 1)
        throw new Error("Did not find exactly one match (found: " + Y.length + ") for componentType:" + z);
      return Y[0];
    }
    function _i(P, z) {
      return be || (be = !0, n(`ReactTestUtils.mockComponent() is deprecated. Use shallow rendering or jest.mock() instead.

See https://reactjs.org/link/test-utils-mock-component for more information.`)), z = z || P.mockTagName || "div", P.prototype.render.mockImplementation(function() {
        return e.createElement(z, null, this.props.children);
      }), this;
    }
    function Pi(P, z) {
      return {
        touches: [{
          pageX: P,
          pageY: z
        }]
      };
    }
    function Lo(P, z, Y) {
      var re = P.type || "unknown-event";
      P.currentTarget = _(Y), Ge(re, z, void 0, P), P.currentTarget = null;
    }
    function S(P) {
      var z = P._dispatchListeners, Y = P._dispatchInstances;
      if (Ze(z))
        for (var re = 0; re < z.length && !P.isPropagationStopped(); re++)
          Lo(P, z[re], Y[re]);
      else z && Lo(P, z, Y);
      P._dispatchListeners = null, P._dispatchInstances = null;
    }
    var te = function(P) {
      P && (S(P), P.isPersistent() || P.constructor.release(P));
    };
    function ue(P) {
      return P === "button" || P === "input" || P === "select" || P === "textarea";
    }
    function ve(P) {
      do
        P = P.return;
      while (P && P.tag !== c);
      return P || null;
    }
    function Te(P, z, Y) {
      for (var re = []; P; )
        re.push(P), P = ve(P);
      var he;
      for (he = re.length; he-- > 0; )
        z(re[he], "captured", Y);
      for (he = 0; he < re.length; he++)
        z(re[he], "bubbled", Y);
    }
    function ke(P, z, Y) {
      switch (P) {
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
          return !!(Y.disabled && ue(z));
        default:
          return !1;
      }
    }
    function ge(P, z) {
      var Y = P.stateNode;
      if (!Y)
        return null;
      var re = ee(Y);
      if (!re)
        return null;
      var he = re[z];
      if (ke(z, P.type, re))
        return null;
      if (he && typeof he != "function")
        throw new Error("Expected `" + z + "` listener to be a function, instead got a value of `" + typeof he + "` type.");
      return he;
    }
    function ye(P, z, Y) {
      var re = z._reactName;
      return Y === "captured" && (re += "Capture"), ge(P, re);
    }
    function Qe(P, z, Y) {
      if (P && Y && Y._reactName) {
        var re = Y._reactName, he = ge(P, re);
        he && (Y._dispatchListeners == null && (Y._dispatchListeners = []), Y._dispatchInstances == null && (Y._dispatchInstances = []), Y._dispatchListeners.push(he), Y._dispatchInstances.push(P));
      }
    }
    function Fe(P, z, Y) {
      P || a("Dispatching inst must not be null");
      var re = ye(P, Y, z);
      re && (Y._dispatchListeners == null && (Y._dispatchListeners = []), Y._dispatchInstances == null && (Y._dispatchInstances = []), Y._dispatchListeners.push(re), Y._dispatchInstances.push(P));
    }
    function Be(P) {
      P && P._reactName && Qe(P._targetInst, null, P);
    }
    function ir(P) {
      P && P._reactName && Te(P._targetInst, Fe, P);
    }
    var Or = {}, Ar = /* @__PURE__ */ new Set(["mouseEnter", "mouseLeave", "pointerEnter", "pointerLeave"]);
    function tr(P) {
      return function(z, Y) {
        if (e.isValidElement(z))
          throw new Error("TestUtils.Simulate expected a DOM node as the first argument but received a React element. Pass the DOM node you wish to simulate the event on instead. Note that TestUtils.Simulate will not work if you are using shallow rendering.");
        if (Yr(z))
          throw new Error("TestUtils.Simulate expected a DOM node as the first argument but received a component instance. Pass the DOM node you wish to simulate the event on instead.");
        var re = "on" + P[0].toUpperCase() + P.slice(1), he = new Ee();
        he.target = z, he.type = P.toLowerCase();
        var Ce = zr(z), He = new E(re, he.type, Ce, he, z);
        He.persist(), x(He, Y), Ar.has(P) ? Be(He) : ir(He), r.unstable_batchedUpdates(function() {
          K(z), te(He), Le();
        }), me();
      };
    }
    var At = ["blur", "cancel", "click", "close", "contextMenu", "copy", "cut", "auxClick", "doubleClick", "dragEnd", "dragStart", "drop", "focus", "input", "invalid", "keyDown", "keyPress", "keyUp", "mouseDown", "mouseUp", "paste", "pause", "play", "pointerCancel", "pointerDown", "pointerUp", "rateChange", "reset", "resize", "seeked", "submit", "touchCancel", "touchEnd", "touchStart", "volumeChange", "drag", "dragEnter", "dragExit", "dragLeave", "dragOver", "mouseMove", "mouseOut", "mouseOver", "pointerMove", "pointerOut", "pointerOver", "scroll", "toggle", "touchMove", "wheel", "abort", "animationEnd", "animationIteration", "animationStart", "canPlay", "canPlayThrough", "durationChange", "emptied", "encrypted", "ended", "error", "gotPointerCapture", "load", "loadedData", "loadedMetadata", "loadStart", "lostPointerCapture", "playing", "progress", "seeking", "stalled", "suspend", "timeUpdate", "transitionEnd", "waiting", "mouseEnter", "mouseLeave", "pointerEnter", "pointerLeave", "change", "select", "beforeInput", "compositionEnd", "compositionStart", "compositionUpdate"];
    function Ti() {
      At.forEach(function(P) {
        Or[P] = tr(P);
      });
    }
    Ti();
    var $o = !1, lp = function(z) {
      return $o || ($o = !0, a("`ReactDOMTestUtils.act` is deprecated in favor of `React.act`. Import `act` from `react` instead of `react-dom/test-utils`. See https://react.dev/warnings/react-dom-test-utils for more info.")), we(z);
    };
    ze.Simulate = Or, ze.act = lp, ze.findAllInRenderedTree = ne, ze.findRenderedComponentWithType = Ci, ze.findRenderedDOMComponentWithClass = qt, ze.findRenderedDOMComponentWithTag = No, ze.isCompositeComponent = Yr, ze.isCompositeComponentWithType = pt, ze.isDOMComponent = Sr, ze.isDOMComponentElement = St, ze.isElement = Qr, ze.isElementOfType = et, ze.mockComponent = _i, ze.nativeTouchData = Pi, ze.renderIntoDocument = pr, ze.scryRenderedComponentsWithType = Ot, ze.scryRenderedDOMComponentsWithClass = rt, ze.scryRenderedDOMComponentsWithTag = qr, ze.traverseTwoPhase = Te;
  }()), ze;
}
var ws;
function Th() {
  return ws || (ws = 1, process.env.NODE_ENV === "production" ? Go.exports = _h() : Go.exports = Ph()), Go.exports;
}
var Sh = Th(), mt = {}, Es;
function qh() {
  if (Es) return mt;
  Es = 1;
  var e = Br;
  if (process.env.NODE_ENV === "production")
    mt.createRoot = e.createRoot, mt.hydrateRoot = e.hydrateRoot;
  else {
    var r = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    mt.createRoot = function(t, n) {
      r.usingClientEntryPoint = !0;
      try {
        return e.createRoot(t, n);
      } finally {
        r.usingClientEntryPoint = !1;
      }
    }, mt.hydrateRoot = function(t, n, a) {
      r.usingClientEntryPoint = !0;
      try {
        return e.hydrateRoot(t, n, a);
      } finally {
        r.usingClientEntryPoint = !1;
      }
    };
  }
  return mt;
}
var Cs = qh(), Er = {}, oi = { exports: {} };
oi.exports;
var _s;
function wf() {
  return _s || (_s = 1, function(e) {
    const t = (o = 0) => (l) => `\x1B[${38 + o};5;${l}m`, n = (o = 0) => (l, f, i) => `\x1B[${38 + o};2;${l};${f};${i}m`;
    function a() {
      const o = /* @__PURE__ */ new Map(), l = {
        modifier: {
          reset: [0, 0],
          // 21 isn't widely supported and 22 does the same thing
          bold: [1, 22],
          dim: [2, 22],
          italic: [3, 23],
          underline: [4, 24],
          overline: [53, 55],
          inverse: [7, 27],
          hidden: [8, 28],
          strikethrough: [9, 29]
        },
        color: {
          black: [30, 39],
          red: [31, 39],
          green: [32, 39],
          yellow: [33, 39],
          blue: [34, 39],
          magenta: [35, 39],
          cyan: [36, 39],
          white: [37, 39],
          // Bright color
          blackBright: [90, 39],
          redBright: [91, 39],
          greenBright: [92, 39],
          yellowBright: [93, 39],
          blueBright: [94, 39],
          magentaBright: [95, 39],
          cyanBright: [96, 39],
          whiteBright: [97, 39]
        },
        bgColor: {
          bgBlack: [40, 49],
          bgRed: [41, 49],
          bgGreen: [42, 49],
          bgYellow: [43, 49],
          bgBlue: [44, 49],
          bgMagenta: [45, 49],
          bgCyan: [46, 49],
          bgWhite: [47, 49],
          // Bright color
          bgBlackBright: [100, 49],
          bgRedBright: [101, 49],
          bgGreenBright: [102, 49],
          bgYellowBright: [103, 49],
          bgBlueBright: [104, 49],
          bgMagentaBright: [105, 49],
          bgCyanBright: [106, 49],
          bgWhiteBright: [107, 49]
        }
      };
      l.color.gray = l.color.blackBright, l.bgColor.bgGray = l.bgColor.bgBlackBright, l.color.grey = l.color.blackBright, l.bgColor.bgGrey = l.bgColor.bgBlackBright;
      for (const [f, i] of Object.entries(l)) {
        for (const [s, c] of Object.entries(i))
          l[s] = {
            open: `\x1B[${c[0]}m`,
            close: `\x1B[${c[1]}m`
          }, i[s] = l[s], o.set(c[0], c[1]);
        Object.defineProperty(l, f, {
          value: i,
          enumerable: !1
        });
      }
      return Object.defineProperty(l, "codes", {
        value: o,
        enumerable: !1
      }), l.color.close = "\x1B[39m", l.bgColor.close = "\x1B[49m", l.color.ansi256 = t(), l.color.ansi16m = n(), l.bgColor.ansi256 = t(10), l.bgColor.ansi16m = n(10), Object.defineProperties(l, {
        rgbToAnsi256: {
          value: (f, i, s) => f === i && i === s ? f < 8 ? 16 : f > 248 ? 231 : Math.round((f - 8) / 247 * 24) + 232 : 16 + 36 * Math.round(f / 255 * 5) + 6 * Math.round(i / 255 * 5) + Math.round(s / 255 * 5),
          enumerable: !1
        },
        hexToRgb: {
          value: (f) => {
            const i = /(?<colorString>[a-f\d]{6}|[a-f\d]{3})/i.exec(f.toString(16));
            if (!i)
              return [0, 0, 0];
            let { colorString: s } = i.groups;
            s.length === 3 && (s = s.split("").map((d) => d + d).join(""));
            const c = Number.parseInt(s, 16);
            return [
              c >> 16 & 255,
              c >> 8 & 255,
              c & 255
            ];
          },
          enumerable: !1
        },
        hexToAnsi256: {
          value: (f) => l.rgbToAnsi256(...l.hexToRgb(f)),
          enumerable: !1
        }
      }), l;
    }
    Object.defineProperty(e, "exports", {
      enumerable: !0,
      get: a
    });
  }(oi)), oi.exports;
}
var tt = {}, Ps;
function xi() {
  if (Ps) return tt;
  Ps = 1, Object.defineProperty(tt, "__esModule", {
    value: !0
  }), tt.printIteratorEntries = r, tt.printIteratorValues = t, tt.printListItems = n, tt.printObjectProperties = a;
  const e = (o, l) => {
    const f = Object.keys(o).sort(l);
    return Object.getOwnPropertySymbols && Object.getOwnPropertySymbols(o).forEach((i) => {
      Object.getOwnPropertyDescriptor(o, i).enumerable && f.push(i);
    }), f;
  };
  function r(o, l, f, i, s, c, d = ": ") {
    let u = "", m = o.next();
    if (!m.done) {
      u += l.spacingOuter;
      const v = f + l.indent;
      for (; !m.done; ) {
        const h = c(
          m.value[0],
          l,
          v,
          i,
          s
        ), g = c(
          m.value[1],
          l,
          v,
          i,
          s
        );
        u += v + h + d + g, m = o.next(), m.done ? l.min || (u += ",") : u += "," + l.spacingInner;
      }
      u += l.spacingOuter + f;
    }
    return u;
  }
  function t(o, l, f, i, s, c) {
    let d = "", u = o.next();
    if (!u.done) {
      d += l.spacingOuter;
      const m = f + l.indent;
      for (; !u.done; )
        d += m + c(u.value, l, m, i, s), u = o.next(), u.done ? l.min || (d += ",") : d += "," + l.spacingInner;
      d += l.spacingOuter + f;
    }
    return d;
  }
  function n(o, l, f, i, s, c) {
    let d = "";
    if (o.length) {
      d += l.spacingOuter;
      const u = f + l.indent;
      for (let m = 0; m < o.length; m++)
        d += u, m in o && (d += c(o[m], l, u, i, s)), m < o.length - 1 ? d += "," + l.spacingInner : l.min || (d += ",");
      d += l.spacingOuter + f;
    }
    return d;
  }
  function a(o, l, f, i, s, c) {
    let d = "";
    const u = e(o, l.compareKeys);
    if (u.length) {
      d += l.spacingOuter;
      const m = f + l.indent;
      for (let v = 0; v < u.length; v++) {
        const h = u[v], g = c(h, l, m, i, s), p = c(o[h], l, m, i, s);
        d += m + g + ": " + p, v < u.length - 1 ? d += "," + l.spacingInner : l.min || (d += ",");
      }
      d += l.spacingOuter + f;
    }
    return d;
  }
  return tt;
}
var Mr = {}, Ts;
function Oh() {
  if (Ts) return Mr;
  Ts = 1, Object.defineProperty(Mr, "__esModule", {
    value: !0
  }), Mr.test = Mr.serialize = Mr.default = void 0;
  var e = xi(), r = function() {
    return typeof globalThis < "u" ? globalThis : typeof r < "u" ? r : typeof self < "u" ? self : typeof window < "u" ? window : Function("return this")();
  }(), t = r["jest-symbol-do-not-touch"] || r.Symbol;
  const n = typeof t == "function" && t.for ? t.for("jest.asymmetricMatcher") : 1267621, a = " ", o = (s, c, d, u, m, v) => {
    const h = s.toString();
    return h === "ArrayContaining" || h === "ArrayNotContaining" ? ++u > c.maxDepth ? "[" + h + "]" : h + a + "[" + (0, e.printListItems)(
      s.sample,
      c,
      d,
      u,
      m,
      v
    ) + "]" : h === "ObjectContaining" || h === "ObjectNotContaining" ? ++u > c.maxDepth ? "[" + h + "]" : h + a + "{" + (0, e.printObjectProperties)(
      s.sample,
      c,
      d,
      u,
      m,
      v
    ) + "}" : h === "StringMatching" || h === "StringNotMatching" || h === "StringContaining" || h === "StringNotContaining" ? h + a + v(s.sample, c, d, u, m) : s.toAsymmetricMatcher();
  };
  Mr.serialize = o;
  const l = (s) => s && s.$$typeof === n;
  Mr.test = l;
  var i = {
    serialize: o,
    test: l
  };
  return Mr.default = i, Mr;
}
var kr = {}, ji, Ss;
function Ah() {
  return Ss || (Ss = 1, ji = ({ onlyFirst: e = !1 } = {}) => {
    const r = [
      "[\\u001B\\u009B][[\\]()#;?]*(?:(?:(?:(?:;[-a-zA-Z\\d\\/#&.:=?%@~_]+)*|[a-zA-Z\\d]+(?:;[-a-zA-Z\\d\\/#&.:=?%@~_]*)*)?\\u0007)",
      "(?:(?:\\d{1,4}(?:;\\d{0,4})*)?[\\dA-PR-TZcf-ntqry=><~]))"
    ].join("|");
    return new RegExp(r, e ? void 0 : "g");
  }), ji;
}
var qs;
function Mh() {
  if (qs) return kr;
  qs = 1, Object.defineProperty(kr, "__esModule", {
    value: !0
  }), kr.test = kr.serialize = kr.default = void 0;
  var e = t(Ah()), r = t(wf());
  function t(i) {
    return i && i.__esModule ? i : { default: i };
  }
  const n = (i) => i.replace((0, e.default)(), (s) => {
    switch (s) {
      case r.default.red.close:
      case r.default.green.close:
      case r.default.cyan.close:
      case r.default.gray.close:
      case r.default.white.close:
      case r.default.yellow.close:
      case r.default.bgRed.close:
      case r.default.bgGreen.close:
      case r.default.bgYellow.close:
      case r.default.inverse.close:
      case r.default.dim.close:
      case r.default.bold.close:
      case r.default.reset.open:
      case r.default.reset.close:
        return "</>";
      case r.default.red.open:
        return "<red>";
      case r.default.green.open:
        return "<green>";
      case r.default.cyan.open:
        return "<cyan>";
      case r.default.gray.open:
        return "<gray>";
      case r.default.white.open:
        return "<white>";
      case r.default.yellow.open:
        return "<yellow>";
      case r.default.bgRed.open:
        return "<bgRed>";
      case r.default.bgGreen.open:
        return "<bgGreen>";
      case r.default.bgYellow.open:
        return "<bgYellow>";
      case r.default.inverse.open:
        return "<inverse>";
      case r.default.dim.open:
        return "<dim>";
      case r.default.bold.open:
        return "<bold>";
      default:
        return "";
    }
  }), a = (i) => typeof i == "string" && !!i.match((0, e.default)());
  kr.test = a;
  const o = (i, s, c, d, u, m) => m(n(i), s, c, d, u);
  kr.serialize = o;
  var f = {
    serialize: o,
    test: a
  };
  return kr.default = f, kr;
}
var Dr = {}, Os;
function kh() {
  if (Os) return Dr;
  Os = 1, Object.defineProperty(Dr, "__esModule", {
    value: !0
  }), Dr.test = Dr.serialize = Dr.default = void 0;
  var e = xi();
  const r = " ", t = ["DOMStringMap", "NamedNodeMap"], n = /^(HTML\w*Collection|NodeList)$/, a = (c) => t.indexOf(c) !== -1 || n.test(c), o = (c) => c && c.constructor && !!c.constructor.name && a(c.constructor.name);
  Dr.test = o;
  const l = (c) => c.constructor.name === "NamedNodeMap", f = (c, d, u, m, v, h) => {
    const g = c.constructor.name;
    return ++m > d.maxDepth ? "[" + g + "]" : (d.min ? "" : g + r) + (t.indexOf(g) !== -1 ? "{" + (0, e.printObjectProperties)(
      l(c) ? Array.from(c).reduce((p, x) => (p[x.name] = x.value, p), {}) : { ...c },
      d,
      u,
      m,
      v,
      h
    ) + "}" : "[" + (0, e.printListItems)(
      Array.from(c),
      d,
      u,
      m,
      v,
      h
    ) + "]");
  };
  Dr.serialize = f;
  var s = {
    serialize: f,
    test: o
  };
  return Dr.default = s, Dr;
}
var jr = {}, or = {}, Xo = {}, As;
function Dh() {
  if (As) return Xo;
  As = 1, Object.defineProperty(Xo, "__esModule", {
    value: !0
  }), Xo.default = e;
  function e(r) {
    return r.replace(/</g, "&lt;").replace(/>/g, "&gt;");
  }
  return Xo;
}
var Ms;
function Rl() {
  if (Ms) return or;
  Ms = 1, Object.defineProperty(or, "__esModule", {
    value: !0
  }), or.printText = or.printProps = or.printElementAsLeaf = or.printElement = or.printComment = or.printChildren = void 0;
  var e = r(Dh());
  function r(i) {
    return i && i.__esModule ? i : { default: i };
  }
  const t = (i, s, c, d, u, m, v) => {
    const h = d + c.indent, g = c.colors;
    return i.map((p) => {
      const x = s[p];
      let w = v(x, c, h, u, m);
      return typeof x != "string" && (w.indexOf(`
`) !== -1 && (w = c.spacingOuter + h + w + c.spacingOuter + d), w = "{" + w + "}"), c.spacingInner + d + g.prop.open + p + g.prop.close + "=" + g.value.open + w + g.value.close;
    }).join("");
  };
  or.printProps = t;
  const n = (i, s, c, d, u, m) => i.map(
    (v) => s.spacingOuter + c + (typeof v == "string" ? a(v, s) : m(v, s, c, d, u))
  ).join("");
  or.printChildren = n;
  const a = (i, s) => {
    const c = s.colors.content;
    return c.open + (0, e.default)(i) + c.close;
  };
  or.printText = a;
  const o = (i, s) => {
    const c = s.colors.comment;
    return c.open + "<!--" + (0, e.default)(i) + "-->" + c.close;
  };
  or.printComment = o;
  const l = (i, s, c, d, u) => {
    const m = d.colors.tag;
    return m.open + "<" + i + (s && m.close + s + d.spacingOuter + u + m.open) + (c ? ">" + m.close + c + d.spacingOuter + u + m.open + "</" + i : (s && !d.min ? "" : " ") + "/") + ">" + m.close;
  };
  or.printElement = l;
  const f = (i, s) => {
    const c = s.colors.tag;
    return c.open + "<" + i + c.close + " …" + c.open + " />" + c.close;
  };
  return or.printElementAsLeaf = f, or;
}
var ks;
function jh() {
  if (ks) return jr;
  ks = 1, Object.defineProperty(jr, "__esModule", {
    value: !0
  }), jr.test = jr.serialize = jr.default = void 0;
  var e = Rl();
  const r = 1, t = 3, n = 8, a = 11, o = /^((HTML|SVG)\w*)?Element$/, l = (h) => {
    try {
      return typeof h.hasAttribute == "function" && h.hasAttribute("is");
    } catch {
      return !1;
    }
  }, f = (h) => {
    const g = h.constructor.name, { nodeType: p, tagName: x } = h, w = typeof x == "string" && x.includes("-") || l(h);
    return p === r && (o.test(g) || w) || p === t && g === "Text" || p === n && g === "Comment" || p === a && g === "DocumentFragment";
  }, i = (h) => {
    var g;
    return (h == null || (g = h.constructor) === null || g === void 0 ? void 0 : g.name) && f(h);
  };
  jr.test = i;
  function s(h) {
    return h.nodeType === t;
  }
  function c(h) {
    return h.nodeType === n;
  }
  function d(h) {
    return h.nodeType === a;
  }
  const u = (h, g, p, x, w, C) => {
    if (s(h))
      return (0, e.printText)(h.data, g);
    if (c(h))
      return (0, e.printComment)(h.data, g);
    const y = d(h) ? "DocumentFragment" : h.tagName.toLowerCase();
    return ++x > g.maxDepth ? (0, e.printElementAsLeaf)(y, g) : (0, e.printElement)(
      y,
      (0, e.printProps)(
        d(h) ? [] : Array.from(h.attributes).map((b) => b.name).sort(),
        d(h) ? {} : Array.from(h.attributes).reduce((b, R) => (b[R.name] = R.value, b), {}),
        g,
        p + g.indent,
        x,
        w,
        C
      ),
      (0, e.printChildren)(
        Array.prototype.slice.call(h.childNodes || h.children),
        g,
        p + g.indent,
        x,
        w,
        C
      ),
      g,
      p
    );
  };
  jr.serialize = u;
  var v = {
    serialize: u,
    test: i
  };
  return jr.default = v, jr;
}
var Ir = {}, Ds;
function Ih() {
  if (Ds) return Ir;
  Ds = 1, Object.defineProperty(Ir, "__esModule", {
    value: !0
  }), Ir.test = Ir.serialize = Ir.default = void 0;
  var e = xi();
  const r = "@@__IMMUTABLE_ITERABLE__@@", t = "@@__IMMUTABLE_LIST__@@", n = "@@__IMMUTABLE_KEYED__@@", a = "@@__IMMUTABLE_MAP__@@", o = "@@__IMMUTABLE_ORDERED__@@", l = "@@__IMMUTABLE_RECORD__@@", f = "@@__IMMUTABLE_SEQ__@@", i = "@@__IMMUTABLE_SET__@@", s = "@@__IMMUTABLE_STACK__@@", c = (R) => "Immutable." + R, d = (R) => "[" + R + "]", u = " ", m = "…", v = (R, E, M, I, $, G, D) => ++I > E.maxDepth ? d(c(D)) : c(D) + u + "{" + (0, e.printIteratorEntries)(
    R.entries(),
    E,
    M,
    I,
    $,
    G
  ) + "}";
  function h(R) {
    let E = 0;
    return {
      next() {
        if (E < R._keys.length) {
          const M = R._keys[E++];
          return {
            done: !1,
            value: [M, R.get(M)]
          };
        }
        return {
          done: !0,
          value: void 0
        };
      }
    };
  }
  const g = (R, E, M, I, $, G) => {
    const D = c(R._name || "Record");
    return ++I > E.maxDepth ? d(D) : D + u + "{" + (0, e.printIteratorEntries)(
      h(R),
      E,
      M,
      I,
      $,
      G
    ) + "}";
  }, p = (R, E, M, I, $, G) => {
    const D = c("Seq");
    return ++I > E.maxDepth ? d(D) : R[n] ? D + u + "{" + // from Immutable collection of entries or from ECMAScript object
    (R._iter || R._object ? (0, e.printIteratorEntries)(
      R.entries(),
      E,
      M,
      I,
      $,
      G
    ) : m) + "}" : D + u + "[" + (R._iter || // from Immutable collection of values
    R._array || // from ECMAScript array
    R._collection || // from ECMAScript collection in immutable v4
    R._iterable ? (0, e.printIteratorValues)(
      R.values(),
      E,
      M,
      I,
      $,
      G
    ) : m) + "]";
  }, x = (R, E, M, I, $, G, D) => ++I > E.maxDepth ? d(c(D)) : c(D) + u + "[" + (0, e.printIteratorValues)(
    R.values(),
    E,
    M,
    I,
    $,
    G
  ) + "]", w = (R, E, M, I, $, G) => R[a] ? v(
    R,
    E,
    M,
    I,
    $,
    G,
    R[o] ? "OrderedMap" : "Map"
  ) : R[t] ? x(
    R,
    E,
    M,
    I,
    $,
    G,
    "List"
  ) : R[i] ? x(
    R,
    E,
    M,
    I,
    $,
    G,
    R[o] ? "OrderedSet" : "Set"
  ) : R[s] ? x(
    R,
    E,
    M,
    I,
    $,
    G,
    "Stack"
  ) : R[f] ? p(R, E, M, I, $, G) : g(R, E, M, I, $, G);
  Ir.serialize = w;
  const C = (R) => R && (R[r] === !0 || R[l] === !0);
  Ir.test = C;
  var b = {
    serialize: w,
    test: C
  };
  return Ir.default = b, Ir;
}
var Nr = {}, Ko = { exports: {} }, De = {};
/** @license React v17.0.2
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var js;
function Nh() {
  if (js) return De;
  js = 1;
  var e = 60103, r = 60106, t = 60107, n = 60108, a = 60114, o = 60109, l = 60110, f = 60112, i = 60113, s = 60120, c = 60115, d = 60116, u = 60121, m = 60122, v = 60117, h = 60129, g = 60131;
  if (typeof Symbol == "function" && Symbol.for) {
    var p = Symbol.for;
    e = p("react.element"), r = p("react.portal"), t = p("react.fragment"), n = p("react.strict_mode"), a = p("react.profiler"), o = p("react.provider"), l = p("react.context"), f = p("react.forward_ref"), i = p("react.suspense"), s = p("react.suspense_list"), c = p("react.memo"), d = p("react.lazy"), u = p("react.block"), m = p("react.server.block"), v = p("react.fundamental"), h = p("react.debug_trace_mode"), g = p("react.legacy_hidden");
  }
  function x(D) {
    if (typeof D == "object" && D !== null) {
      var k = D.$$typeof;
      switch (k) {
        case e:
          switch (D = D.type, D) {
            case t:
            case a:
            case n:
            case i:
            case s:
              return D;
            default:
              switch (D = D && D.$$typeof, D) {
                case l:
                case f:
                case d:
                case c:
                case o:
                  return D;
                default:
                  return k;
              }
          }
        case r:
          return k;
      }
    }
  }
  var w = o, C = e, y = f, b = t, R = d, E = c, M = r, I = a, $ = n, G = i;
  return De.ContextConsumer = l, De.ContextProvider = w, De.Element = C, De.ForwardRef = y, De.Fragment = b, De.Lazy = R, De.Memo = E, De.Portal = M, De.Profiler = I, De.StrictMode = $, De.Suspense = G, De.isAsyncMode = function() {
    return !1;
  }, De.isConcurrentMode = function() {
    return !1;
  }, De.isContextConsumer = function(D) {
    return x(D) === l;
  }, De.isContextProvider = function(D) {
    return x(D) === o;
  }, De.isElement = function(D) {
    return typeof D == "object" && D !== null && D.$$typeof === e;
  }, De.isForwardRef = function(D) {
    return x(D) === f;
  }, De.isFragment = function(D) {
    return x(D) === t;
  }, De.isLazy = function(D) {
    return x(D) === d;
  }, De.isMemo = function(D) {
    return x(D) === c;
  }, De.isPortal = function(D) {
    return x(D) === r;
  }, De.isProfiler = function(D) {
    return x(D) === a;
  }, De.isStrictMode = function(D) {
    return x(D) === n;
  }, De.isSuspense = function(D) {
    return x(D) === i;
  }, De.isValidElementType = function(D) {
    return typeof D == "string" || typeof D == "function" || D === t || D === a || D === h || D === n || D === i || D === s || D === g || typeof D == "object" && D !== null && (D.$$typeof === d || D.$$typeof === c || D.$$typeof === o || D.$$typeof === l || D.$$typeof === f || D.$$typeof === v || D.$$typeof === u || D[0] === m);
  }, De.typeOf = x, De;
}
var je = {};
/** @license React v17.0.2
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Is;
function Lh() {
  return Is || (Is = 1, process.env.NODE_ENV !== "production" && function() {
    var e = 60103, r = 60106, t = 60107, n = 60108, a = 60114, o = 60109, l = 60110, f = 60112, i = 60113, s = 60120, c = 60115, d = 60116, u = 60121, m = 60122, v = 60117, h = 60129, g = 60131;
    if (typeof Symbol == "function" && Symbol.for) {
      var p = Symbol.for;
      e = p("react.element"), r = p("react.portal"), t = p("react.fragment"), n = p("react.strict_mode"), a = p("react.profiler"), o = p("react.provider"), l = p("react.context"), f = p("react.forward_ref"), i = p("react.suspense"), s = p("react.suspense_list"), c = p("react.memo"), d = p("react.lazy"), u = p("react.block"), m = p("react.server.block"), v = p("react.fundamental"), p("react.scope"), p("react.opaque.id"), h = p("react.debug_trace_mode"), p("react.offscreen"), g = p("react.legacy_hidden");
    }
    var x = !1;
    function w(L) {
      return !!(typeof L == "string" || typeof L == "function" || L === t || L === a || L === h || L === n || L === i || L === s || L === g || x || typeof L == "object" && L !== null && (L.$$typeof === d || L.$$typeof === c || L.$$typeof === o || L.$$typeof === l || L.$$typeof === f || L.$$typeof === v || L.$$typeof === u || L[0] === m));
    }
    function C(L) {
      if (typeof L == "object" && L !== null) {
        var j = L.$$typeof;
        switch (j) {
          case e:
            var ie = L.type;
            switch (ie) {
              case t:
              case a:
              case n:
              case i:
              case s:
                return ie;
              default:
                var Z = ie && ie.$$typeof;
                switch (Z) {
                  case l:
                  case f:
                  case d:
                  case c:
                  case o:
                    return Z;
                  default:
                    return j;
                }
            }
          case r:
            return j;
        }
      }
    }
    var y = l, b = o, R = e, E = f, M = t, I = d, $ = c, G = r, D = a, k = n, F = i, B = !1, H = !1;
    function U(L) {
      return B || (B = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function ae(L) {
      return H || (H = !0, console.warn("The ReactIs.isConcurrentMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function oe(L) {
      return C(L) === l;
    }
    function ce(L) {
      return C(L) === o;
    }
    function J(L) {
      return typeof L == "object" && L !== null && L.$$typeof === e;
    }
    function O(L) {
      return C(L) === f;
    }
    function N(L) {
      return C(L) === t;
    }
    function V(L) {
      return C(L) === d;
    }
    function A(L) {
      return C(L) === c;
    }
    function le(L) {
      return C(L) === r;
    }
    function X(L) {
      return C(L) === a;
    }
    function q(L) {
      return C(L) === n;
    }
    function W(L) {
      return C(L) === i;
    }
    je.ContextConsumer = y, je.ContextProvider = b, je.Element = R, je.ForwardRef = E, je.Fragment = M, je.Lazy = I, je.Memo = $, je.Portal = G, je.Profiler = D, je.StrictMode = k, je.Suspense = F, je.isAsyncMode = U, je.isConcurrentMode = ae, je.isContextConsumer = oe, je.isContextProvider = ce, je.isElement = J, je.isForwardRef = O, je.isFragment = N, je.isLazy = V, je.isMemo = A, je.isPortal = le, je.isProfiler = X, je.isStrictMode = q, je.isSuspense = W, je.isValidElementType = w, je.typeOf = C;
  }()), je;
}
var Ns;
function $h() {
  return Ns || (Ns = 1, process.env.NODE_ENV === "production" ? Ko.exports = Nh() : Ko.exports = Lh()), Ko.exports;
}
var Ls;
function Fh() {
  if (Ls) return Nr;
  Ls = 1, Object.defineProperty(Nr, "__esModule", {
    value: !0
  }), Nr.test = Nr.serialize = Nr.default = void 0;
  var e = n($h()), r = Rl();
  function t(d) {
    if (typeof WeakMap != "function") return null;
    var u = /* @__PURE__ */ new WeakMap(), m = /* @__PURE__ */ new WeakMap();
    return (t = function(v) {
      return v ? m : u;
    })(d);
  }
  function n(d, u) {
    if (d && d.__esModule)
      return d;
    if (d === null || typeof d != "object" && typeof d != "function")
      return { default: d };
    var m = t(u);
    if (m && m.has(d))
      return m.get(d);
    var v = {}, h = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for (var g in d)
      if (g !== "default" && Object.prototype.hasOwnProperty.call(d, g)) {
        var p = h ? Object.getOwnPropertyDescriptor(d, g) : null;
        p && (p.get || p.set) ? Object.defineProperty(v, g, p) : v[g] = d[g];
      }
    return v.default = d, m && m.set(d, v), v;
  }
  const a = (d, u = []) => (Array.isArray(d) ? d.forEach((m) => {
    a(m, u);
  }) : d != null && d !== !1 && u.push(d), u), o = (d) => {
    const u = d.type;
    if (typeof u == "string")
      return u;
    if (typeof u == "function")
      return u.displayName || u.name || "Unknown";
    if (e.isFragment(d))
      return "React.Fragment";
    if (e.isSuspense(d))
      return "React.Suspense";
    if (typeof u == "object" && u !== null) {
      if (e.isContextProvider(d))
        return "Context.Provider";
      if (e.isContextConsumer(d))
        return "Context.Consumer";
      if (e.isForwardRef(d)) {
        if (u.displayName)
          return u.displayName;
        const m = u.render.displayName || u.render.name || "";
        return m !== "" ? "ForwardRef(" + m + ")" : "ForwardRef";
      }
      if (e.isMemo(d)) {
        const m = u.displayName || u.type.displayName || u.type.name || "";
        return m !== "" ? "Memo(" + m + ")" : "Memo";
      }
    }
    return "UNDEFINED";
  }, l = (d) => {
    const { props: u } = d;
    return Object.keys(u).filter((m) => m !== "children" && u[m] !== void 0).sort();
  }, f = (d, u, m, v, h, g) => ++v > u.maxDepth ? (0, r.printElementAsLeaf)(o(d), u) : (0, r.printElement)(
    o(d),
    (0, r.printProps)(
      l(d),
      d.props,
      u,
      m + u.indent,
      v,
      h,
      g
    ),
    (0, r.printChildren)(
      a(d.props.children),
      u,
      m + u.indent,
      v,
      h,
      g
    ),
    u,
    m
  );
  Nr.serialize = f;
  const i = (d) => d != null && e.isElement(d);
  Nr.test = i;
  var c = {
    serialize: f,
    test: i
  };
  return Nr.default = c, Nr;
}
var Lr = {}, $s;
function Bh() {
  if ($s) return Lr;
  $s = 1, Object.defineProperty(Lr, "__esModule", {
    value: !0
  }), Lr.test = Lr.serialize = Lr.default = void 0;
  var e = Rl(), r = function() {
    return typeof globalThis < "u" ? globalThis : typeof r < "u" ? r : typeof self < "u" ? self : typeof window < "u" ? window : Function("return this")();
  }(), t = r["jest-symbol-do-not-touch"] || r.Symbol;
  const n = typeof t == "function" && t.for ? t.for("react.test.json") : 245830487, a = (s) => {
    const { props: c } = s;
    return c ? Object.keys(c).filter((d) => c[d] !== void 0).sort() : [];
  }, o = (s, c, d, u, m, v) => ++u > c.maxDepth ? (0, e.printElementAsLeaf)(s.type, c) : (0, e.printElement)(
    s.type,
    s.props ? (0, e.printProps)(
      a(s),
      s.props,
      c,
      d + c.indent,
      u,
      m,
      v
    ) : "",
    s.children ? (0, e.printChildren)(
      s.children,
      c,
      d + c.indent,
      u,
      m,
      v
    ) : "",
    c,
    d
  );
  Lr.serialize = o;
  const l = (s) => s && s.$$typeof === n;
  Lr.test = l;
  var i = {
    serialize: o,
    test: l
  };
  return Lr.default = i, Lr;
}
var Fs;
function Hh() {
  if (Fs) return Er;
  Fs = 1, Object.defineProperty(Er, "__esModule", {
    value: !0
  }), Er.default = Er.DEFAULT_OPTIONS = void 0, Er.format = A, Er.plugins = void 0;
  var e = s(wf()), r = xi(), t = s(
    Oh()
  ), n = s(Mh()), a = s(kh()), o = s(jh()), l = s(Ih()), f = s(Fh()), i = s(
    Bh()
  );
  function s(q) {
    return q && q.__esModule ? q : { default: q };
  }
  const c = Object.prototype.toString, d = Date.prototype.toISOString, u = Error.prototype.toString, m = RegExp.prototype.toString, v = (q) => typeof q.constructor == "function" && q.constructor.name || "Object", h = (q) => typeof window < "u" && q === window, g = /^Symbol\((.*)\)(.*)$/, p = /\n/gi;
  class x extends Error {
    constructor(W, L) {
      super(W), this.stack = L, this.name = this.constructor.name;
    }
  }
  function w(q) {
    return q === "[object Array]" || q === "[object ArrayBuffer]" || q === "[object DataView]" || q === "[object Float32Array]" || q === "[object Float64Array]" || q === "[object Int8Array]" || q === "[object Int16Array]" || q === "[object Int32Array]" || q === "[object Uint8Array]" || q === "[object Uint8ClampedArray]" || q === "[object Uint16Array]" || q === "[object Uint32Array]";
  }
  function C(q) {
    return Object.is(q, -0) ? "-0" : String(q);
  }
  function y(q) {
    return `${q}n`;
  }
  function b(q, W) {
    return W ? "[Function " + (q.name || "anonymous") + "]" : "[Function]";
  }
  function R(q) {
    return String(q).replace(g, "Symbol($1)");
  }
  function E(q) {
    return "[" + u.call(q) + "]";
  }
  function M(q, W, L, j) {
    if (q === !0 || q === !1)
      return "" + q;
    if (q === void 0)
      return "undefined";
    if (q === null)
      return "null";
    const ie = typeof q;
    if (ie === "number")
      return C(q);
    if (ie === "bigint")
      return y(q);
    if (ie === "string")
      return j ? '"' + q.replace(/"|\\/g, "\\$&") + '"' : '"' + q + '"';
    if (ie === "function")
      return b(q, W);
    if (ie === "symbol")
      return R(q);
    const Z = c.call(q);
    return Z === "[object WeakMap]" ? "WeakMap {}" : Z === "[object WeakSet]" ? "WeakSet {}" : Z === "[object Function]" || Z === "[object GeneratorFunction]" ? b(q, W) : Z === "[object Symbol]" ? R(q) : Z === "[object Date]" ? isNaN(+q) ? "Date { NaN }" : d.call(q) : Z === "[object Error]" ? E(q) : Z === "[object RegExp]" ? L ? m.call(q).replace(/[\\^$*+?.()|[\]{}]/g, "\\$&") : m.call(q) : q instanceof Error ? E(q) : null;
  }
  function I(q, W, L, j, ie, Z) {
    if (ie.indexOf(q) !== -1)
      return "[Circular]";
    ie = ie.slice(), ie.push(q);
    const se = ++j > W.maxDepth, pe = W.min;
    if (W.callToJSON && !se && q.toJSON && typeof q.toJSON == "function" && !Z)
      return k(q.toJSON(), W, L, j, ie, !0);
    const de = c.call(q);
    return de === "[object Arguments]" ? se ? "[Arguments]" : (pe ? "" : "Arguments ") + "[" + (0, r.printListItems)(
      q,
      W,
      L,
      j,
      ie,
      k
    ) + "]" : w(de) ? se ? "[" + q.constructor.name + "]" : (pe || !W.printBasicPrototype && q.constructor.name === "Array" ? "" : q.constructor.name + " ") + "[" + (0, r.printListItems)(
      q,
      W,
      L,
      j,
      ie,
      k
    ) + "]" : de === "[object Map]" ? se ? "[Map]" : "Map {" + (0, r.printIteratorEntries)(
      q.entries(),
      W,
      L,
      j,
      ie,
      k,
      " => "
    ) + "}" : de === "[object Set]" ? se ? "[Set]" : "Set {" + (0, r.printIteratorValues)(
      q.values(),
      W,
      L,
      j,
      ie,
      k
    ) + "}" : se || h(q) ? "[" + v(q) + "]" : (pe || !W.printBasicPrototype && v(q) === "Object" ? "" : v(q) + " ") + "{" + (0, r.printObjectProperties)(
      q,
      W,
      L,
      j,
      ie,
      k
    ) + "}";
  }
  function $(q) {
    return q.serialize != null;
  }
  function G(q, W, L, j, ie, Z) {
    let se;
    try {
      se = $(q) ? q.serialize(W, L, j, ie, Z, k) : q.print(
        W,
        (pe) => k(pe, L, j, ie, Z),
        (pe) => {
          const de = j + L.indent;
          return de + pe.replace(p, `
` + de);
        },
        {
          edgeSpacing: L.spacingOuter,
          min: L.min,
          spacing: L.spacingInner
        },
        L.colors
      );
    } catch (pe) {
      throw new x(pe.message, pe.stack);
    }
    if (typeof se != "string")
      throw new Error(
        `pretty-format: Plugin must return type "string" but instead returned "${typeof se}".`
      );
    return se;
  }
  function D(q, W) {
    for (let L = 0; L < q.length; L++)
      try {
        if (q[L].test(W))
          return q[L];
      } catch (j) {
        throw new x(j.message, j.stack);
      }
    return null;
  }
  function k(q, W, L, j, ie, Z) {
    const se = D(W.plugins, q);
    if (se !== null)
      return G(se, q, W, L, j, ie);
    const pe = M(
      q,
      W.printFunctionName,
      W.escapeRegex,
      W.escapeString
    );
    return pe !== null ? pe : I(
      q,
      W,
      L,
      j,
      ie,
      Z
    );
  }
  const F = {
    comment: "gray",
    content: "reset",
    prop: "yellow",
    tag: "cyan",
    value: "green"
  }, B = Object.keys(F), H = {
    callToJSON: !0,
    compareKeys: void 0,
    escapeRegex: !1,
    escapeString: !0,
    highlight: !1,
    indent: 2,
    maxDepth: 1 / 0,
    min: !1,
    plugins: [],
    printBasicPrototype: !0,
    printFunctionName: !0,
    theme: F
  };
  Er.DEFAULT_OPTIONS = H;
  function U(q) {
    if (Object.keys(q).forEach((W) => {
      if (!H.hasOwnProperty(W))
        throw new Error(`pretty-format: Unknown option "${W}".`);
    }), q.min && q.indent !== void 0 && q.indent !== 0)
      throw new Error(
        'pretty-format: Options "min" and "indent" cannot be used together.'
      );
    if (q.theme !== void 0) {
      if (q.theme === null)
        throw new Error('pretty-format: Option "theme" must not be null.');
      if (typeof q.theme != "object")
        throw new Error(
          `pretty-format: Option "theme" must be of type "object" but instead received "${typeof q.theme}".`
        );
    }
  }
  const ae = (q) => B.reduce((W, L) => {
    const j = q.theme && q.theme[L] !== void 0 ? q.theme[L] : F[L], ie = j && e.default[j];
    if (ie && typeof ie.close == "string" && typeof ie.open == "string")
      W[L] = ie;
    else
      throw new Error(
        `pretty-format: Option "theme" has a key "${L}" whose value "${j}" is undefined in ansi-styles.`
      );
    return W;
  }, /* @__PURE__ */ Object.create(null)), oe = () => B.reduce((q, W) => (q[W] = {
    close: "",
    open: ""
  }, q), /* @__PURE__ */ Object.create(null)), ce = (q) => q && q.printFunctionName !== void 0 ? q.printFunctionName : H.printFunctionName, J = (q) => q && q.escapeRegex !== void 0 ? q.escapeRegex : H.escapeRegex, O = (q) => q && q.escapeString !== void 0 ? q.escapeString : H.escapeString, N = (q) => {
    var W;
    return {
      callToJSON: q && q.callToJSON !== void 0 ? q.callToJSON : H.callToJSON,
      colors: q && q.highlight ? ae(q) : oe(),
      compareKeys: q && typeof q.compareKeys == "function" ? q.compareKeys : H.compareKeys,
      escapeRegex: J(q),
      escapeString: O(q),
      indent: q && q.min ? "" : V(
        q && q.indent !== void 0 ? q.indent : H.indent
      ),
      maxDepth: q && q.maxDepth !== void 0 ? q.maxDepth : H.maxDepth,
      min: q && q.min !== void 0 ? q.min : H.min,
      plugins: q && q.plugins !== void 0 ? q.plugins : H.plugins,
      printBasicPrototype: (W = q == null ? void 0 : q.printBasicPrototype) !== null && W !== void 0 ? W : !0,
      printFunctionName: ce(q),
      spacingInner: q && q.min ? " " : `
`,
      spacingOuter: q && q.min ? "" : `
`
    };
  };
  function V(q) {
    return new Array(q + 1).join(" ");
  }
  function A(q, W) {
    if (W && (U(W), W.plugins)) {
      const j = D(W.plugins, q);
      if (j !== null)
        return G(j, q, N(W), "", 0, []);
    }
    const L = M(
      q,
      ce(W),
      J(W),
      O(W)
    );
    return L !== null ? L : I(q, N(W), "", 0, []);
  }
  const le = {
    AsymmetricMatcher: t.default,
    ConvertAnsi: n.default,
    DOMCollection: a.default,
    DOMElement: o.default,
    Immutable: l.default,
    ReactElement: f.default,
    ReactTestComponent: i.default
  };
  Er.plugins = le;
  var X = A;
  return Er.default = X, Er;
}
var Ef = Hh(), Uh = Object.prototype.toString;
function Wh(e) {
  return typeof e == "function" || Uh.call(e) === "[object Function]";
}
function zh(e) {
  var r = Number(e);
  return isNaN(r) ? 0 : r === 0 || !isFinite(r) ? r : (r > 0 ? 1 : -1) * Math.floor(Math.abs(r));
}
var Yh = Math.pow(2, 53) - 1;
function Vh(e) {
  var r = zh(e);
  return Math.min(Math.max(r, 0), Yh);
}
function wr(e, r) {
  var t = Array, n = Object(e);
  if (e == null)
    throw new TypeError("Array.from requires an array-like object - not null or undefined");
  for (var a = Vh(n.length), o = Wh(t) ? Object(new t(a)) : new Array(a), l = 0, f; l < a; )
    f = n[l], o[l] = f, l += 1;
  return o.length = a, o;
}
function qo(e) {
  "@babel/helpers - typeof";
  return qo = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(r) {
    return typeof r;
  } : function(r) {
    return r && typeof Symbol == "function" && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
  }, qo(e);
}
function Gh(e, r) {
  if (!(e instanceof r))
    throw new TypeError("Cannot call a class as a function");
}
function Xh(e, r) {
  for (var t = 0; t < r.length; t++) {
    var n = r[t];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, Cf(n.key), n);
  }
}
function Kh(e, r, t) {
  return r && Xh(e.prototype, r), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function Jh(e, r, t) {
  return r = Cf(r), r in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e;
}
function Cf(e) {
  var r = Zh(e, "string");
  return qo(r) === "symbol" ? r : String(r);
}
function Zh(e, r) {
  if (qo(e) !== "object" || e === null) return e;
  var t = e[Symbol.toPrimitive];
  if (t !== void 0) {
    var n = t.call(e, r);
    if (qo(n) !== "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (r === "string" ? String : Number)(e);
}
var Qh = /* @__PURE__ */ function() {
  function e() {
    var r = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    Gh(this, e), Jh(this, "items", void 0), this.items = r;
  }
  return Kh(e, [{
    key: "add",
    value: function(t) {
      return this.has(t) === !1 && this.items.push(t), this;
    }
  }, {
    key: "clear",
    value: function() {
      this.items = [];
    }
  }, {
    key: "delete",
    value: function(t) {
      var n = this.items.length;
      return this.items = this.items.filter(function(a) {
        return a !== t;
      }), n !== this.items.length;
    }
  }, {
    key: "forEach",
    value: function(t) {
      var n = this;
      this.items.forEach(function(a) {
        t(a, a, n);
      });
    }
  }, {
    key: "has",
    value: function(t) {
      return this.items.indexOf(t) !== -1;
    }
  }, {
    key: "size",
    get: function() {
      return this.items.length;
    }
  }]), e;
}();
const eb = typeof Set > "u" ? Set : Qh;
function ar(e) {
  var r;
  return (
    // eslint-disable-next-line no-restricted-properties -- actual guard for environments without localName
    (r = e.localName) !== null && r !== void 0 ? r : (
      // eslint-disable-next-line no-restricted-properties -- required for the fallback
      e.tagName.toLowerCase()
    )
  );
}
var rb = {
  article: "article",
  aside: "complementary",
  button: "button",
  datalist: "listbox",
  dd: "definition",
  details: "group",
  dialog: "dialog",
  dt: "term",
  fieldset: "group",
  figure: "figure",
  // WARNING: Only with an accessible name
  form: "form",
  footer: "contentinfo",
  h1: "heading",
  h2: "heading",
  h3: "heading",
  h4: "heading",
  h5: "heading",
  h6: "heading",
  header: "banner",
  hr: "separator",
  html: "document",
  legend: "legend",
  li: "listitem",
  math: "math",
  main: "main",
  menu: "list",
  nav: "navigation",
  ol: "list",
  optgroup: "group",
  // WARNING: Only in certain context
  option: "option",
  output: "status",
  progress: "progressbar",
  // WARNING: Only with an accessible name
  section: "region",
  summary: "button",
  table: "table",
  tbody: "rowgroup",
  textarea: "textbox",
  tfoot: "rowgroup",
  // WARNING: Only in certain context
  td: "cell",
  th: "columnheader",
  thead: "rowgroup",
  tr: "row",
  ul: "list"
}, tb = {
  caption: /* @__PURE__ */ new Set(["aria-label", "aria-labelledby"]),
  code: /* @__PURE__ */ new Set(["aria-label", "aria-labelledby"]),
  deletion: /* @__PURE__ */ new Set(["aria-label", "aria-labelledby"]),
  emphasis: /* @__PURE__ */ new Set(["aria-label", "aria-labelledby"]),
  generic: /* @__PURE__ */ new Set(["aria-label", "aria-labelledby", "aria-roledescription"]),
  insertion: /* @__PURE__ */ new Set(["aria-label", "aria-labelledby"]),
  paragraph: /* @__PURE__ */ new Set(["aria-label", "aria-labelledby"]),
  presentation: /* @__PURE__ */ new Set(["aria-label", "aria-labelledby"]),
  strong: /* @__PURE__ */ new Set(["aria-label", "aria-labelledby"]),
  subscript: /* @__PURE__ */ new Set(["aria-label", "aria-labelledby"]),
  superscript: /* @__PURE__ */ new Set(["aria-label", "aria-labelledby"])
};
function nb(e, r) {
  return [
    "aria-atomic",
    "aria-busy",
    "aria-controls",
    "aria-current",
    "aria-describedby",
    "aria-details",
    // "disabled",
    "aria-dropeffect",
    // "errormessage",
    "aria-flowto",
    "aria-grabbed",
    // "haspopup",
    "aria-hidden",
    // "invalid",
    "aria-keyshortcuts",
    "aria-label",
    "aria-labelledby",
    "aria-live",
    "aria-owns",
    "aria-relevant",
    "aria-roledescription"
  ].some(function(t) {
    var n;
    return e.hasAttribute(t) && !((n = tb[r]) !== null && n !== void 0 && n.has(t));
  });
}
function _f(e, r) {
  return nb(e, r);
}
function ab(e) {
  var r = ib(e);
  if (r === null || r === "presentation") {
    var t = ob(e);
    if (r !== "presentation" || _f(e, t || ""))
      return t;
  }
  return r;
}
function ob(e) {
  var r = rb[ar(e)];
  if (r !== void 0)
    return r;
  switch (ar(e)) {
    case "a":
    case "area":
    case "link":
      if (e.hasAttribute("href"))
        return "link";
      break;
    case "img":
      return e.getAttribute("alt") === "" && !_f(e, "img") ? "presentation" : "img";
    case "input": {
      var t = e, n = t.type;
      switch (n) {
        case "button":
        case "image":
        case "reset":
        case "submit":
          return "button";
        case "checkbox":
        case "radio":
          return n;
        case "range":
          return "slider";
        case "email":
        case "tel":
        case "text":
        case "url":
          return e.hasAttribute("list") ? "combobox" : "textbox";
        case "search":
          return e.hasAttribute("list") ? "combobox" : "searchbox";
        case "number":
          return "spinbutton";
        default:
          return null;
      }
    }
    case "select":
      return e.hasAttribute("multiple") || e.size > 1 ? "listbox" : "combobox";
  }
  return null;
}
function ib(e) {
  var r = e.getAttribute("role");
  if (r !== null) {
    var t = r.trim().split(" ")[0];
    if (t.length > 0)
      return t;
  }
  return null;
}
function Ne(e) {
  return e !== null && e.nodeType === e.ELEMENT_NODE;
}
function Pf(e) {
  return Ne(e) && ar(e) === "caption";
}
function ii(e) {
  return Ne(e) && ar(e) === "input";
}
function lb(e) {
  return Ne(e) && ar(e) === "optgroup";
}
function sb(e) {
  return Ne(e) && ar(e) === "select";
}
function ub(e) {
  return Ne(e) && ar(e) === "table";
}
function cb(e) {
  return Ne(e) && ar(e) === "textarea";
}
function db(e) {
  var r = e.ownerDocument === null ? e : e.ownerDocument, t = r.defaultView;
  if (t === null)
    throw new TypeError("no window available");
  return t;
}
function fb(e) {
  return Ne(e) && ar(e) === "fieldset";
}
function pb(e) {
  return Ne(e) && ar(e) === "legend";
}
function mb(e) {
  return Ne(e) && ar(e) === "slot";
}
function vb(e) {
  return Ne(e) && e.ownerSVGElement !== void 0;
}
function hb(e) {
  return Ne(e) && ar(e) === "svg";
}
function bb(e) {
  return vb(e) && ar(e) === "title";
}
function pi(e, r) {
  if (Ne(e) && e.hasAttribute(r)) {
    var t = e.getAttribute(r).split(" "), n = e.getRootNode ? e.getRootNode() : e.ownerDocument;
    return t.map(function(a) {
      return n.getElementById(a);
    }).filter(
      function(a) {
        return a !== null;
      }
      // TODO: why does this not narrow?
    );
  }
  return [];
}
function Fr(e, r) {
  return Ne(e) ? r.indexOf(ab(e)) !== -1 : !1;
}
function yb(e) {
  return e.trim().replace(/\s\s+/g, " ");
}
function gb(e, r) {
  if (!Ne(e))
    return !1;
  if (e.hasAttribute("hidden") || e.getAttribute("aria-hidden") === "true")
    return !0;
  var t = r(e);
  return t.getPropertyValue("display") === "none" || t.getPropertyValue("visibility") === "hidden";
}
function Rb(e) {
  return Fr(e, ["button", "combobox", "listbox", "textbox"]) || Tf(e, "range");
}
function Tf(e, r) {
  if (!Ne(e))
    return !1;
  switch (r) {
    case "range":
      return Fr(e, ["meter", "progressbar", "scrollbar", "slider", "spinbutton"]);
    default:
      throw new TypeError("No knowledge about abstract role '".concat(r, "'. This is likely a bug :("));
  }
}
function Bs(e, r) {
  var t = wr(e.querySelectorAll(r));
  return pi(e, "aria-owns").forEach(function(n) {
    t.push.apply(t, wr(n.querySelectorAll(r)));
  }), t;
}
function xb(e) {
  return sb(e) ? e.selectedOptions || Bs(e, "[selected]") : Bs(e, '[aria-selected="true"]');
}
function wb(e) {
  return Fr(e, ["none", "presentation"]);
}
function Eb(e) {
  return Pf(e);
}
function Cb(e) {
  return Fr(e, ["button", "cell", "checkbox", "columnheader", "gridcell", "heading", "label", "legend", "link", "menuitem", "menuitemcheckbox", "menuitemradio", "option", "radio", "row", "rowheader", "switch", "tab", "tooltip", "treeitem"]);
}
function _b(e) {
  return !1;
}
function Pb(e) {
  return ii(e) || cb(e) ? e.value : e.textContent || "";
}
function Hs(e) {
  var r = e.getPropertyValue("content");
  return /^["'].*["']$/.test(r) ? r.slice(1, -1) : "";
}
function Sf(e) {
  var r = ar(e);
  return r === "button" || r === "input" && e.getAttribute("type") !== "hidden" || r === "meter" || r === "output" || r === "progress" || r === "select" || r === "textarea";
}
function qf(e) {
  if (Sf(e))
    return e;
  var r = null;
  return e.childNodes.forEach(function(t) {
    if (r === null && Ne(t)) {
      var n = qf(t);
      n !== null && (r = n);
    }
  }), r;
}
function Tb(e) {
  if (e.control !== void 0)
    return e.control;
  var r = e.getAttribute("for");
  return r !== null ? e.ownerDocument.getElementById(r) : qf(e);
}
function Sb(e) {
  var r = e.labels;
  if (r === null)
    return r;
  if (r !== void 0)
    return wr(r);
  if (!Sf(e))
    return null;
  var t = e.ownerDocument;
  return wr(t.querySelectorAll("label")).filter(function(n) {
    return Tb(n) === e;
  });
}
function qb(e) {
  var r = e.assignedNodes();
  return r.length === 0 ? wr(e.childNodes) : r;
}
function Of(e) {
  var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, t = new eb(), n = db(e), a = r.compute, o = a === void 0 ? "name" : a, l = r.computedStyleSupportsPseudoElements, f = l === void 0 ? r.getComputedStyle !== void 0 : l, i = r.getComputedStyle, s = i === void 0 ? n.getComputedStyle.bind(n) : i, c = r.hidden, d = c === void 0 ? !1 : c;
  function u(p, x) {
    var w = "";
    if (Ne(p) && f) {
      var C = s(p, "::before"), y = Hs(C);
      w = "".concat(y, " ").concat(w);
    }
    var b = mb(p) ? qb(p) : wr(p.childNodes).concat(pi(p, "aria-owns"));
    if (b.forEach(function(M) {
      var I = g(M, {
        isEmbeddedInLabel: x.isEmbeddedInLabel,
        isReferenced: !1,
        recursion: !0
      }), $ = Ne(M) ? s(M).getPropertyValue("display") : "inline", G = $ !== "inline" ? " " : "";
      w += "".concat(G).concat(I).concat(G);
    }), Ne(p) && f) {
      var R = s(p, "::after"), E = Hs(R);
      w = "".concat(w, " ").concat(E);
    }
    return w.trim();
  }
  function m(p, x) {
    var w = p.getAttributeNode(x);
    return w !== null && !t.has(w) && w.value.trim() !== "" ? (t.add(w), w.value) : null;
  }
  function v(p) {
    return Ne(p) ? m(p, "title") : null;
  }
  function h(p) {
    if (!Ne(p))
      return null;
    if (fb(p)) {
      t.add(p);
      for (var x = wr(p.childNodes), w = 0; w < x.length; w += 1) {
        var C = x[w];
        if (pb(C))
          return g(C, {
            isEmbeddedInLabel: !1,
            isReferenced: !1,
            recursion: !1
          });
      }
    } else if (ub(p)) {
      t.add(p);
      for (var y = wr(p.childNodes), b = 0; b < y.length; b += 1) {
        var R = y[b];
        if (Pf(R))
          return g(R, {
            isEmbeddedInLabel: !1,
            isReferenced: !1,
            recursion: !1
          });
      }
    } else if (hb(p)) {
      t.add(p);
      for (var E = wr(p.childNodes), M = 0; M < E.length; M += 1) {
        var I = E[M];
        if (bb(I))
          return I.textContent;
      }
      return null;
    } else if (ar(p) === "img" || ar(p) === "area") {
      var $ = m(p, "alt");
      if ($ !== null)
        return $;
    } else if (lb(p)) {
      var G = m(p, "label");
      if (G !== null)
        return G;
    }
    if (ii(p) && (p.type === "button" || p.type === "submit" || p.type === "reset")) {
      var D = m(p, "value");
      if (D !== null)
        return D;
      if (p.type === "submit")
        return "Submit";
      if (p.type === "reset")
        return "Reset";
    }
    var k = Sb(p);
    if (k !== null && k.length !== 0)
      return t.add(p), wr(k).map(function(U) {
        return g(U, {
          isEmbeddedInLabel: !0,
          isReferenced: !1,
          recursion: !0
        });
      }).filter(function(U) {
        return U.length > 0;
      }).join(" ");
    if (ii(p) && p.type === "image") {
      var F = m(p, "alt");
      if (F !== null)
        return F;
      var B = m(p, "title");
      return B !== null ? B : "Submit Query";
    }
    if (Fr(p, ["button"])) {
      var H = u(p, {
        isEmbeddedInLabel: !1
      });
      if (H !== "")
        return H;
    }
    return null;
  }
  function g(p, x) {
    if (t.has(p))
      return "";
    if (!d && gb(p, s) && !x.isReferenced)
      return t.add(p), "";
    var w = Ne(p) ? p.getAttributeNode("aria-labelledby") : null, C = w !== null && !t.has(w) ? pi(p, "aria-labelledby") : [];
    if (o === "name" && !x.isReferenced && C.length > 0)
      return t.add(w), C.map(function($) {
        return g($, {
          isEmbeddedInLabel: x.isEmbeddedInLabel,
          isReferenced: !0,
          // this isn't recursion as specified, otherwise we would skip
          // `aria-label` in
          // <input id="myself" aria-label="foo" aria-labelledby="myself"
          recursion: !1
        });
      }).join(" ");
    var y = x.recursion && Rb(p) && o === "name";
    if (!y) {
      var b = (Ne(p) && p.getAttribute("aria-label") || "").trim();
      if (b !== "" && o === "name")
        return t.add(p), b;
      if (!wb(p)) {
        var R = h(p);
        if (R !== null)
          return t.add(p), R;
      }
    }
    if (Fr(p, ["menu"]))
      return t.add(p), "";
    if (y || x.isEmbeddedInLabel || x.isReferenced) {
      if (Fr(p, ["combobox", "listbox"])) {
        t.add(p);
        var E = xb(p);
        return E.length === 0 ? ii(p) ? p.value : "" : wr(E).map(function($) {
          return g($, {
            isEmbeddedInLabel: x.isEmbeddedInLabel,
            isReferenced: !1,
            recursion: !0
          });
        }).join(" ");
      }
      if (Tf(p, "range"))
        return t.add(p), p.hasAttribute("aria-valuetext") ? p.getAttribute("aria-valuetext") : p.hasAttribute("aria-valuenow") ? p.getAttribute("aria-valuenow") : p.getAttribute("value") || "";
      if (Fr(p, ["textbox"]))
        return t.add(p), Pb(p);
    }
    if (Cb(p) || Ne(p) && x.isReferenced || Eb(p) || _b()) {
      var M = u(p, {
        isEmbeddedInLabel: x.isEmbeddedInLabel
      });
      if (M !== "")
        return t.add(p), M;
    }
    if (p.nodeType === p.TEXT_NODE)
      return t.add(p), p.textContent || "";
    if (x.recursion)
      return t.add(p), u(p, {
        isEmbeddedInLabel: x.isEmbeddedInLabel
      });
    var I = v(p);
    return I !== null ? (t.add(p), I) : (t.add(p), "");
  }
  return yb(g(e, {
    isEmbeddedInLabel: !1,
    // by spec computeAccessibleDescription starts with the referenced elements as roots
    isReferenced: o === "description",
    recursion: !1
  }));
}
function Oo(e) {
  "@babel/helpers - typeof";
  return Oo = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(r) {
    return typeof r;
  } : function(r) {
    return r && typeof Symbol == "function" && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
  }, Oo(e);
}
function Us(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    r && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), t.push.apply(t, n);
  }
  return t;
}
function Ws(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = arguments[r] != null ? arguments[r] : {};
    r % 2 ? Us(Object(t), !0).forEach(function(n) {
      Ob(e, n, t[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : Us(Object(t)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(t, n));
    });
  }
  return e;
}
function Ob(e, r, t) {
  return r = Ab(r), r in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e;
}
function Ab(e) {
  var r = Mb(e, "string");
  return Oo(r) === "symbol" ? r : String(r);
}
function Mb(e, r) {
  if (Oo(e) !== "object" || e === null) return e;
  var t = e[Symbol.toPrimitive];
  if (t !== void 0) {
    var n = t.call(e, r);
    if (Oo(n) !== "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (r === "string" ? String : Number)(e);
}
function Af(e) {
  var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, t = pi(e, "aria-describedby").map(function(a) {
    return Of(a, Ws(Ws({}, r), {}, {
      compute: "description"
    }));
  }).join(" ");
  if (t === "") {
    var n = e.getAttribute("title");
    t = n === null ? "" : n;
  }
  return t;
}
function kb(e) {
  return Fr(e, ["caption", "code", "deletion", "emphasis", "generic", "insertion", "paragraph", "presentation", "strong", "subscript", "superscript"]);
}
function xl(e) {
  var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  return kb(e) ? "" : Of(e, r);
}
var cr = {}, jt = {}, Jo = {}, It = {}, zs;
function Db() {
  if (zs) return It;
  zs = 1, Object.defineProperty(It, "__esModule", {
    value: !0
  }), It.default = void 0;
  function e() {
    var t = this, n = 0, a = {
      "@@iterator": function() {
        return a;
      },
      next: function() {
        if (n < t.length) {
          var l = t[n];
          return n = n + 1, {
            done: !1,
            value: l
          };
        } else
          return {
            done: !0
          };
      }
    };
    return a;
  }
  var r = e;
  return It.default = r, It;
}
var Ys;
function jo() {
  if (Ys) return Jo;
  Ys = 1, Object.defineProperty(Jo, "__esModule", {
    value: !0
  }), Jo.default = n;
  var e = r(Db());
  function r(a) {
    return a && a.__esModule ? a : { default: a };
  }
  function t(a) {
    "@babel/helpers - typeof";
    return t = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(o) {
      return typeof o;
    } : function(o) {
      return o && typeof Symbol == "function" && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, t(a);
  }
  function n(a, o) {
    return typeof Symbol == "function" && t(Symbol.iterator) === "symbol" && Object.defineProperty(a, Symbol.iterator, {
      value: e.default.bind(o)
    }), a;
  }
  return Jo;
}
var Vs;
function jb() {
  if (Vs) return jt;
  Vs = 1, Object.defineProperty(jt, "__esModule", {
    value: !0
  }), jt.default = void 0;
  var e = r(jo());
  function r(u) {
    return u && u.__esModule ? u : { default: u };
  }
  function t(u, m) {
    return o(u) || a(u, m) || f(u, m) || n();
  }
  function n() {
    throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  function a(u, m) {
    var v = u == null ? null : typeof Symbol < "u" && u[Symbol.iterator] || u["@@iterator"];
    if (v != null) {
      var h = [], g = !0, p = !1, x, w;
      try {
        for (v = v.call(u); !(g = (x = v.next()).done) && (h.push(x.value), !(m && h.length === m)); g = !0)
          ;
      } catch (C) {
        p = !0, w = C;
      } finally {
        try {
          !g && v.return != null && v.return();
        } finally {
          if (p) throw w;
        }
      }
      return h;
    }
  }
  function o(u) {
    if (Array.isArray(u)) return u;
  }
  function l(u, m) {
    var v = typeof Symbol < "u" && u[Symbol.iterator] || u["@@iterator"];
    if (!v) {
      if (Array.isArray(u) || (v = f(u)) || m) {
        v && (u = v);
        var h = 0, g = function() {
        };
        return { s: g, n: function() {
          return h >= u.length ? { done: !0 } : { done: !1, value: u[h++] };
        }, e: function(y) {
          throw y;
        }, f: g };
      }
      throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
    }
    var p = !0, x = !1, w;
    return { s: function() {
      v = v.call(u);
    }, n: function() {
      var y = v.next();
      return p = y.done, y;
    }, e: function(y) {
      x = !0, w = y;
    }, f: function() {
      try {
        !p && v.return != null && v.return();
      } finally {
        if (x) throw w;
      }
    } };
  }
  function f(u, m) {
    if (u) {
      if (typeof u == "string") return i(u, m);
      var v = Object.prototype.toString.call(u).slice(8, -1);
      if (v === "Object" && u.constructor && (v = u.constructor.name), v === "Map" || v === "Set") return Array.from(u);
      if (v === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(v)) return i(u, m);
    }
  }
  function i(u, m) {
    (m == null || m > u.length) && (m = u.length);
    for (var v = 0, h = new Array(m); v < m; v++)
      h[v] = u[v];
    return h;
  }
  var s = [["aria-activedescendant", {
    type: "id"
  }], ["aria-atomic", {
    type: "boolean"
  }], ["aria-autocomplete", {
    type: "token",
    values: ["inline", "list", "both", "none"]
  }], ["aria-braillelabel", {
    type: "string"
  }], ["aria-brailleroledescription", {
    type: "string"
  }], ["aria-busy", {
    type: "boolean"
  }], ["aria-checked", {
    type: "tristate"
  }], ["aria-colcount", {
    type: "integer"
  }], ["aria-colindex", {
    type: "integer"
  }], ["aria-colspan", {
    type: "integer"
  }], ["aria-controls", {
    type: "idlist"
  }], ["aria-current", {
    type: "token",
    values: ["page", "step", "location", "date", "time", !0, !1]
  }], ["aria-describedby", {
    type: "idlist"
  }], ["aria-description", {
    type: "string"
  }], ["aria-details", {
    type: "id"
  }], ["aria-disabled", {
    type: "boolean"
  }], ["aria-dropeffect", {
    type: "tokenlist",
    values: ["copy", "execute", "link", "move", "none", "popup"]
  }], ["aria-errormessage", {
    type: "id"
  }], ["aria-expanded", {
    type: "boolean",
    allowundefined: !0
  }], ["aria-flowto", {
    type: "idlist"
  }], ["aria-grabbed", {
    type: "boolean",
    allowundefined: !0
  }], ["aria-haspopup", {
    type: "token",
    values: [!1, !0, "menu", "listbox", "tree", "grid", "dialog"]
  }], ["aria-hidden", {
    type: "boolean",
    allowundefined: !0
  }], ["aria-invalid", {
    type: "token",
    values: ["grammar", !1, "spelling", !0]
  }], ["aria-keyshortcuts", {
    type: "string"
  }], ["aria-label", {
    type: "string"
  }], ["aria-labelledby", {
    type: "idlist"
  }], ["aria-level", {
    type: "integer"
  }], ["aria-live", {
    type: "token",
    values: ["assertive", "off", "polite"]
  }], ["aria-modal", {
    type: "boolean"
  }], ["aria-multiline", {
    type: "boolean"
  }], ["aria-multiselectable", {
    type: "boolean"
  }], ["aria-orientation", {
    type: "token",
    values: ["vertical", "undefined", "horizontal"]
  }], ["aria-owns", {
    type: "idlist"
  }], ["aria-placeholder", {
    type: "string"
  }], ["aria-posinset", {
    type: "integer"
  }], ["aria-pressed", {
    type: "tristate"
  }], ["aria-readonly", {
    type: "boolean"
  }], ["aria-relevant", {
    type: "tokenlist",
    values: ["additions", "all", "removals", "text"]
  }], ["aria-required", {
    type: "boolean"
  }], ["aria-roledescription", {
    type: "string"
  }], ["aria-rowcount", {
    type: "integer"
  }], ["aria-rowindex", {
    type: "integer"
  }], ["aria-rowspan", {
    type: "integer"
  }], ["aria-selected", {
    type: "boolean",
    allowundefined: !0
  }], ["aria-setsize", {
    type: "integer"
  }], ["aria-sort", {
    type: "token",
    values: ["ascending", "descending", "none", "other"]
  }], ["aria-valuemax", {
    type: "number"
  }], ["aria-valuemin", {
    type: "number"
  }], ["aria-valuenow", {
    type: "number"
  }], ["aria-valuetext", {
    type: "string"
  }]], c = {
    entries: function() {
      return s;
    },
    forEach: function(m) {
      var v = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null, h = l(s), g;
      try {
        for (h.s(); !(g = h.n()).done; ) {
          var p = t(g.value, 2), x = p[0], w = p[1];
          m.call(v, w, x, s);
        }
      } catch (C) {
        h.e(C);
      } finally {
        h.f();
      }
    },
    get: function(m) {
      var v = s.find(function(h) {
        return h[0] === m;
      });
      return v && v[1];
    },
    has: function(m) {
      return !!c.get(m);
    },
    keys: function() {
      return s.map(function(m) {
        var v = t(m, 1), h = v[0];
        return h;
      });
    },
    values: function() {
      return s.map(function(m) {
        var v = t(m, 2), h = v[1];
        return h;
      });
    }
  }, d = (0, e.default)(c, c.entries());
  return jt.default = d, jt;
}
var Nt = {}, Gs;
function Ib() {
  if (Gs) return Nt;
  Gs = 1, Object.defineProperty(Nt, "__esModule", {
    value: !0
  }), Nt.default = void 0;
  var e = r(jo());
  function r(u) {
    return u && u.__esModule ? u : { default: u };
  }
  function t(u, m) {
    return o(u) || a(u, m) || f(u, m) || n();
  }
  function n() {
    throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  function a(u, m) {
    var v = u == null ? null : typeof Symbol < "u" && u[Symbol.iterator] || u["@@iterator"];
    if (v != null) {
      var h = [], g = !0, p = !1, x, w;
      try {
        for (v = v.call(u); !(g = (x = v.next()).done) && (h.push(x.value), !(m && h.length === m)); g = !0)
          ;
      } catch (C) {
        p = !0, w = C;
      } finally {
        try {
          !g && v.return != null && v.return();
        } finally {
          if (p) throw w;
        }
      }
      return h;
    }
  }
  function o(u) {
    if (Array.isArray(u)) return u;
  }
  function l(u, m) {
    var v = typeof Symbol < "u" && u[Symbol.iterator] || u["@@iterator"];
    if (!v) {
      if (Array.isArray(u) || (v = f(u)) || m) {
        v && (u = v);
        var h = 0, g = function() {
        };
        return { s: g, n: function() {
          return h >= u.length ? { done: !0 } : { done: !1, value: u[h++] };
        }, e: function(y) {
          throw y;
        }, f: g };
      }
      throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
    }
    var p = !0, x = !1, w;
    return { s: function() {
      v = v.call(u);
    }, n: function() {
      var y = v.next();
      return p = y.done, y;
    }, e: function(y) {
      x = !0, w = y;
    }, f: function() {
      try {
        !p && v.return != null && v.return();
      } finally {
        if (x) throw w;
      }
    } };
  }
  function f(u, m) {
    if (u) {
      if (typeof u == "string") return i(u, m);
      var v = Object.prototype.toString.call(u).slice(8, -1);
      if (v === "Object" && u.constructor && (v = u.constructor.name), v === "Map" || v === "Set") return Array.from(u);
      if (v === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(v)) return i(u, m);
    }
  }
  function i(u, m) {
    (m == null || m > u.length) && (m = u.length);
    for (var v = 0, h = new Array(m); v < m; v++)
      h[v] = u[v];
    return h;
  }
  var s = [["a", {
    reserved: !1
  }], ["abbr", {
    reserved: !1
  }], ["acronym", {
    reserved: !1
  }], ["address", {
    reserved: !1
  }], ["applet", {
    reserved: !1
  }], ["area", {
    reserved: !1
  }], ["article", {
    reserved: !1
  }], ["aside", {
    reserved: !1
  }], ["audio", {
    reserved: !1
  }], ["b", {
    reserved: !1
  }], ["base", {
    reserved: !0
  }], ["bdi", {
    reserved: !1
  }], ["bdo", {
    reserved: !1
  }], ["big", {
    reserved: !1
  }], ["blink", {
    reserved: !1
  }], ["blockquote", {
    reserved: !1
  }], ["body", {
    reserved: !1
  }], ["br", {
    reserved: !1
  }], ["button", {
    reserved: !1
  }], ["canvas", {
    reserved: !1
  }], ["caption", {
    reserved: !1
  }], ["center", {
    reserved: !1
  }], ["cite", {
    reserved: !1
  }], ["code", {
    reserved: !1
  }], ["col", {
    reserved: !0
  }], ["colgroup", {
    reserved: !0
  }], ["content", {
    reserved: !1
  }], ["data", {
    reserved: !1
  }], ["datalist", {
    reserved: !1
  }], ["dd", {
    reserved: !1
  }], ["del", {
    reserved: !1
  }], ["details", {
    reserved: !1
  }], ["dfn", {
    reserved: !1
  }], ["dialog", {
    reserved: !1
  }], ["dir", {
    reserved: !1
  }], ["div", {
    reserved: !1
  }], ["dl", {
    reserved: !1
  }], ["dt", {
    reserved: !1
  }], ["em", {
    reserved: !1
  }], ["embed", {
    reserved: !1
  }], ["fieldset", {
    reserved: !1
  }], ["figcaption", {
    reserved: !1
  }], ["figure", {
    reserved: !1
  }], ["font", {
    reserved: !1
  }], ["footer", {
    reserved: !1
  }], ["form", {
    reserved: !1
  }], ["frame", {
    reserved: !1
  }], ["frameset", {
    reserved: !1
  }], ["h1", {
    reserved: !1
  }], ["h2", {
    reserved: !1
  }], ["h3", {
    reserved: !1
  }], ["h4", {
    reserved: !1
  }], ["h5", {
    reserved: !1
  }], ["h6", {
    reserved: !1
  }], ["head", {
    reserved: !0
  }], ["header", {
    reserved: !1
  }], ["hgroup", {
    reserved: !1
  }], ["hr", {
    reserved: !1
  }], ["html", {
    reserved: !0
  }], ["i", {
    reserved: !1
  }], ["iframe", {
    reserved: !1
  }], ["img", {
    reserved: !1
  }], ["input", {
    reserved: !1
  }], ["ins", {
    reserved: !1
  }], ["kbd", {
    reserved: !1
  }], ["keygen", {
    reserved: !1
  }], ["label", {
    reserved: !1
  }], ["legend", {
    reserved: !1
  }], ["li", {
    reserved: !1
  }], ["link", {
    reserved: !0
  }], ["main", {
    reserved: !1
  }], ["map", {
    reserved: !1
  }], ["mark", {
    reserved: !1
  }], ["marquee", {
    reserved: !1
  }], ["menu", {
    reserved: !1
  }], ["menuitem", {
    reserved: !1
  }], ["meta", {
    reserved: !0
  }], ["meter", {
    reserved: !1
  }], ["nav", {
    reserved: !1
  }], ["noembed", {
    reserved: !0
  }], ["noscript", {
    reserved: !0
  }], ["object", {
    reserved: !1
  }], ["ol", {
    reserved: !1
  }], ["optgroup", {
    reserved: !1
  }], ["option", {
    reserved: !1
  }], ["output", {
    reserved: !1
  }], ["p", {
    reserved: !1
  }], ["param", {
    reserved: !0
  }], ["picture", {
    reserved: !0
  }], ["pre", {
    reserved: !1
  }], ["progress", {
    reserved: !1
  }], ["q", {
    reserved: !1
  }], ["rp", {
    reserved: !1
  }], ["rt", {
    reserved: !1
  }], ["rtc", {
    reserved: !1
  }], ["ruby", {
    reserved: !1
  }], ["s", {
    reserved: !1
  }], ["samp", {
    reserved: !1
  }], ["script", {
    reserved: !0
  }], ["section", {
    reserved: !1
  }], ["select", {
    reserved: !1
  }], ["small", {
    reserved: !1
  }], ["source", {
    reserved: !0
  }], ["spacer", {
    reserved: !1
  }], ["span", {
    reserved: !1
  }], ["strike", {
    reserved: !1
  }], ["strong", {
    reserved: !1
  }], ["style", {
    reserved: !0
  }], ["sub", {
    reserved: !1
  }], ["summary", {
    reserved: !1
  }], ["sup", {
    reserved: !1
  }], ["table", {
    reserved: !1
  }], ["tbody", {
    reserved: !1
  }], ["td", {
    reserved: !1
  }], ["textarea", {
    reserved: !1
  }], ["tfoot", {
    reserved: !1
  }], ["th", {
    reserved: !1
  }], ["thead", {
    reserved: !1
  }], ["time", {
    reserved: !1
  }], ["title", {
    reserved: !0
  }], ["tr", {
    reserved: !1
  }], ["track", {
    reserved: !0
  }], ["tt", {
    reserved: !1
  }], ["u", {
    reserved: !1
  }], ["ul", {
    reserved: !1
  }], ["var", {
    reserved: !1
  }], ["video", {
    reserved: !1
  }], ["wbr", {
    reserved: !1
  }], ["xmp", {
    reserved: !1
  }]], c = {
    entries: function() {
      return s;
    },
    forEach: function(m) {
      var v = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null, h = l(s), g;
      try {
        for (h.s(); !(g = h.n()).done; ) {
          var p = t(g.value, 2), x = p[0], w = p[1];
          m.call(v, w, x, s);
        }
      } catch (C) {
        h.e(C);
      } finally {
        h.f();
      }
    },
    get: function(m) {
      var v = s.find(function(h) {
        return h[0] === m;
      });
      return v && v[1];
    },
    has: function(m) {
      return !!c.get(m);
    },
    keys: function() {
      return s.map(function(m) {
        var v = t(m, 1), h = v[0];
        return h;
      });
    },
    values: function() {
      return s.map(function(m) {
        var v = t(m, 2), h = v[1];
        return h;
      });
    }
  }, d = (0, e.default)(c, c.entries());
  return Nt.default = d, Nt;
}
var Lt = {}, $t = {}, Ft = {}, Xs;
function Nb() {
  if (Xs) return Ft;
  Xs = 1, Object.defineProperty(Ft, "__esModule", {
    value: !0
  }), Ft.default = void 0;
  var e = {
    abstract: !0,
    accessibleNameRequired: !1,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author"],
    prohibitedProps: [],
    props: {},
    relatedConcepts: [],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "widget"]]
  }, r = e;
  return Ft.default = r, Ft;
}
var Bt = {}, Ks;
function Lb() {
  if (Ks) return Bt;
  Ks = 1, Object.defineProperty(Bt, "__esModule", {
    value: !0
  }), Bt.default = void 0;
  var e = {
    abstract: !0,
    accessibleNameRequired: !1,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author"],
    prohibitedProps: [],
    props: {
      "aria-activedescendant": null,
      "aria-disabled": null
    },
    relatedConcepts: [],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "widget"]]
  }, r = e;
  return Bt.default = r, Bt;
}
var Ht = {}, Js;
function $b() {
  if (Js) return Ht;
  Js = 1, Object.defineProperty(Ht, "__esModule", {
    value: !0
  }), Ht.default = void 0;
  var e = {
    abstract: !0,
    accessibleNameRequired: !1,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author"],
    prohibitedProps: [],
    props: {
      "aria-disabled": null
    },
    relatedConcepts: [{
      concept: {
        name: "input"
      },
      module: "XForms"
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "widget"]]
  }, r = e;
  return Ht.default = r, Ht;
}
var Ut = {}, Zs;
function Fb() {
  if (Zs) return Ut;
  Zs = 1, Object.defineProperty(Ut, "__esModule", {
    value: !0
  }), Ut.default = void 0;
  var e = {
    abstract: !0,
    accessibleNameRequired: !1,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author"],
    prohibitedProps: [],
    props: {},
    relatedConcepts: [],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "structure", "section"]]
  }, r = e;
  return Ut.default = r, Ut;
}
var Wt = {}, Qs;
function Bb() {
  if (Qs) return Wt;
  Qs = 1, Object.defineProperty(Wt, "__esModule", {
    value: !0
  }), Wt.default = void 0;
  var e = {
    abstract: !0,
    accessibleNameRequired: !1,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author"],
    prohibitedProps: [],
    props: {
      "aria-valuemax": null,
      "aria-valuemin": null,
      "aria-valuenow": null
    },
    relatedConcepts: [],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "structure"]]
  }, r = e;
  return Wt.default = r, Wt;
}
var zt = {}, eu;
function Hb() {
  if (eu) return zt;
  eu = 1, Object.defineProperty(zt, "__esModule", {
    value: !0
  }), zt.default = void 0;
  var e = {
    abstract: !0,
    accessibleNameRequired: !1,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: [],
    prohibitedProps: [],
    props: {
      "aria-atomic": null,
      "aria-busy": null,
      "aria-controls": null,
      "aria-current": null,
      "aria-describedby": null,
      "aria-details": null,
      "aria-dropeffect": null,
      "aria-flowto": null,
      "aria-grabbed": null,
      "aria-hidden": null,
      "aria-keyshortcuts": null,
      "aria-label": null,
      "aria-labelledby": null,
      "aria-live": null,
      "aria-owns": null,
      "aria-relevant": null,
      "aria-roledescription": null
    },
    relatedConcepts: [{
      concept: {
        name: "role"
      },
      module: "XHTML"
    }, {
      concept: {
        name: "type"
      },
      module: "Dublin Core"
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: []
  }, r = e;
  return zt.default = r, zt;
}
var Yt = {}, ru;
function Ub() {
  if (ru) return Yt;
  ru = 1, Object.defineProperty(Yt, "__esModule", {
    value: !0
  }), Yt.default = void 0;
  var e = {
    abstract: !0,
    accessibleNameRequired: !1,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: [],
    prohibitedProps: [],
    props: {},
    relatedConcepts: [{
      concept: {
        name: "frontmatter"
      },
      module: "DTB"
    }, {
      concept: {
        name: "level"
      },
      module: "DTB"
    }, {
      concept: {
        name: "level"
      },
      module: "SMIL"
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "structure"]]
  }, r = e;
  return Yt.default = r, Yt;
}
var Vt = {}, tu;
function Wb() {
  if (tu) return Vt;
  tu = 1, Object.defineProperty(Vt, "__esModule", {
    value: !0
  }), Vt.default = void 0;
  var e = {
    abstract: !0,
    accessibleNameRequired: !1,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author", "contents"],
    prohibitedProps: [],
    props: {},
    relatedConcepts: [],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "structure"]]
  }, r = e;
  return Vt.default = r, Vt;
}
var Gt = {}, nu;
function zb() {
  if (nu) return Gt;
  nu = 1, Object.defineProperty(Gt, "__esModule", {
    value: !0
  }), Gt.default = void 0;
  var e = {
    abstract: !0,
    accessibleNameRequired: !1,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author"],
    prohibitedProps: [],
    props: {
      "aria-orientation": null
    },
    relatedConcepts: [],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "widget", "composite"], ["roletype", "structure", "section", "group"]]
  }, r = e;
  return Gt.default = r, Gt;
}
var Xt = {}, au;
function Yb() {
  if (au) return Xt;
  au = 1, Object.defineProperty(Xt, "__esModule", {
    value: !0
  }), Xt.default = void 0;
  var e = {
    abstract: !0,
    accessibleNameRequired: !1,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: [],
    prohibitedProps: [],
    props: {},
    relatedConcepts: [],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype"]]
  }, r = e;
  return Xt.default = r, Xt;
}
var Kt = {}, ou;
function Vb() {
  if (ou) return Kt;
  ou = 1, Object.defineProperty(Kt, "__esModule", {
    value: !0
  }), Kt.default = void 0;
  var e = {
    abstract: !0,
    accessibleNameRequired: !1,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: [],
    prohibitedProps: [],
    props: {},
    relatedConcepts: [],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype"]]
  }, r = e;
  return Kt.default = r, Kt;
}
var Jt = {}, iu;
function Gb() {
  if (iu) return Jt;
  iu = 1, Object.defineProperty(Jt, "__esModule", {
    value: !0
  }), Jt.default = void 0;
  var e = {
    abstract: !0,
    accessibleNameRequired: !1,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author"],
    prohibitedProps: [],
    props: {
      "aria-modal": null
    },
    relatedConcepts: [],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype"]]
  }, r = e;
  return Jt.default = r, Jt;
}
var lu;
function Xb() {
  if (lu) return $t;
  lu = 1, Object.defineProperty($t, "__esModule", {
    value: !0
  }), $t.default = void 0;
  var e = u(Nb()), r = u(Lb()), t = u($b()), n = u(Fb()), a = u(Bb()), o = u(Hb()), l = u(Ub()), f = u(Wb()), i = u(zb()), s = u(Yb()), c = u(Vb()), d = u(Gb());
  function u(h) {
    return h && h.__esModule ? h : { default: h };
  }
  var m = [["command", e.default], ["composite", r.default], ["input", t.default], ["landmark", n.default], ["range", a.default], ["roletype", o.default], ["section", l.default], ["sectionhead", f.default], ["select", i.default], ["structure", s.default], ["widget", c.default], ["window", d.default]], v = m;
  return $t.default = v, $t;
}
var Zt = {}, Qt = {}, su;
function Kb() {
  if (su) return Qt;
  su = 1, Object.defineProperty(Qt, "__esModule", {
    value: !0
  }), Qt.default = void 0;
  var e = {
    abstract: !1,
    accessibleNameRequired: !1,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author"],
    prohibitedProps: [],
    props: {
      "aria-atomic": "true",
      "aria-live": "assertive"
    },
    relatedConcepts: [{
      concept: {
        name: "alert"
      },
      module: "XForms"
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "structure", "section"]]
  }, r = e;
  return Qt.default = r, Qt;
}
var en = {}, uu;
function Jb() {
  if (uu) return en;
  uu = 1, Object.defineProperty(en, "__esModule", {
    value: !0
  }), en.default = void 0;
  var e = {
    abstract: !1,
    accessibleNameRequired: !0,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author"],
    prohibitedProps: [],
    props: {},
    relatedConcepts: [{
      concept: {
        name: "alert"
      },
      module: "XForms"
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "structure", "section", "alert"], ["roletype", "window", "dialog"]]
  }, r = e;
  return en.default = r, en;
}
var rn = {}, cu;
function Zb() {
  if (cu) return rn;
  cu = 1, Object.defineProperty(rn, "__esModule", {
    value: !0
  }), rn.default = void 0;
  var e = {
    abstract: !1,
    accessibleNameRequired: !0,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author"],
    prohibitedProps: [],
    props: {
      "aria-activedescendant": null,
      "aria-disabled": null,
      "aria-errormessage": null,
      "aria-expanded": null,
      "aria-haspopup": null,
      "aria-invalid": null
    },
    relatedConcepts: [{
      concept: {
        name: "Device Independence Delivery Unit"
      }
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "structure"]]
  }, r = e;
  return rn.default = r, rn;
}
var tn = {}, du;
function Qb() {
  if (du) return tn;
  du = 1, Object.defineProperty(tn, "__esModule", {
    value: !0
  }), tn.default = void 0;
  var e = {
    abstract: !1,
    accessibleNameRequired: !1,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author"],
    prohibitedProps: [],
    props: {
      "aria-posinset": null,
      "aria-setsize": null
    },
    relatedConcepts: [{
      concept: {
        name: "article"
      },
      module: "HTML"
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "structure", "document"]]
  }, r = e;
  return tn.default = r, tn;
}
var nn = {}, fu;
function ey() {
  if (fu) return nn;
  fu = 1, Object.defineProperty(nn, "__esModule", {
    value: !0
  }), nn.default = void 0;
  var e = {
    abstract: !1,
    accessibleNameRequired: !1,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author"],
    prohibitedProps: [],
    props: {},
    relatedConcepts: [{
      concept: {
        constraints: ["scoped to the body element"],
        name: "header"
      },
      module: "HTML"
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "structure", "section", "landmark"]]
  }, r = e;
  return nn.default = r, nn;
}
var an = {}, pu;
function ry() {
  if (pu) return an;
  pu = 1, Object.defineProperty(an, "__esModule", {
    value: !0
  }), an.default = void 0;
  var e = {
    abstract: !1,
    accessibleNameRequired: !1,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author"],
    prohibitedProps: [],
    props: {},
    relatedConcepts: [{
      concept: {
        name: "blockquote"
      },
      module: "HTML"
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "structure", "section"]]
  }, r = e;
  return an.default = r, an;
}
var on = {}, mu;
function ty() {
  if (mu) return on;
  mu = 1, Object.defineProperty(on, "__esModule", {
    value: !0
  }), on.default = void 0;
  var e = {
    abstract: !1,
    accessibleNameRequired: !0,
    baseConcepts: [],
    childrenPresentational: !0,
    nameFrom: ["author", "contents"],
    prohibitedProps: [],
    props: {
      "aria-disabled": null,
      "aria-expanded": null,
      "aria-haspopup": null,
      "aria-pressed": null
    },
    relatedConcepts: [{
      concept: {
        attributes: [{
          name: "type",
          value: "button"
        }],
        name: "input"
      },
      module: "HTML"
    }, {
      concept: {
        attributes: [{
          name: "type",
          value: "image"
        }],
        name: "input"
      },
      module: "HTML"
    }, {
      concept: {
        attributes: [{
          name: "type",
          value: "reset"
        }],
        name: "input"
      },
      module: "HTML"
    }, {
      concept: {
        attributes: [{
          name: "type",
          value: "submit"
        }],
        name: "input"
      },
      module: "HTML"
    }, {
      concept: {
        name: "button"
      },
      module: "HTML"
    }, {
      concept: {
        name: "trigger"
      },
      module: "XForms"
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "widget", "command"]]
  }, r = e;
  return on.default = r, on;
}
var ln = {}, vu;
function ny() {
  if (vu) return ln;
  vu = 1, Object.defineProperty(ln, "__esModule", {
    value: !0
  }), ln.default = void 0;
  var e = {
    abstract: !1,
    accessibleNameRequired: !1,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["prohibited"],
    prohibitedProps: ["aria-label", "aria-labelledby"],
    props: {},
    relatedConcepts: [{
      concept: {
        name: "caption"
      },
      module: "HTML"
    }],
    requireContextRole: ["figure", "grid", "table"],
    requiredContextRole: ["figure", "grid", "table"],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "structure", "section"]]
  }, r = e;
  return ln.default = r, ln;
}
var sn = {}, hu;
function ay() {
  if (hu) return sn;
  hu = 1, Object.defineProperty(sn, "__esModule", {
    value: !0
  }), sn.default = void 0;
  var e = {
    abstract: !1,
    accessibleNameRequired: !1,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author", "contents"],
    prohibitedProps: [],
    props: {
      "aria-colindex": null,
      "aria-colspan": null,
      "aria-rowindex": null,
      "aria-rowspan": null
    },
    relatedConcepts: [{
      concept: {
        constraints: ["ancestor table element has table role"],
        name: "td"
      },
      module: "HTML"
    }],
    requireContextRole: ["row"],
    requiredContextRole: ["row"],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "structure", "section"]]
  }, r = e;
  return sn.default = r, sn;
}
var un = {}, bu;
function oy() {
  if (bu) return un;
  bu = 1, Object.defineProperty(un, "__esModule", {
    value: !0
  }), un.default = void 0;
  var e = {
    abstract: !1,
    accessibleNameRequired: !0,
    baseConcepts: [],
    childrenPresentational: !0,
    nameFrom: ["author", "contents"],
    prohibitedProps: [],
    props: {
      "aria-checked": null,
      "aria-errormessage": null,
      "aria-expanded": null,
      "aria-invalid": null,
      "aria-readonly": null,
      "aria-required": null
    },
    relatedConcepts: [{
      concept: {
        attributes: [{
          name: "type",
          value: "checkbox"
        }],
        name: "input"
      },
      module: "HTML"
    }, {
      concept: {
        name: "option"
      },
      module: "ARIA"
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {
      "aria-checked": null
    },
    superClass: [["roletype", "widget", "input"]]
  }, r = e;
  return un.default = r, un;
}
var cn = {}, yu;
function iy() {
  if (yu) return cn;
  yu = 1, Object.defineProperty(cn, "__esModule", {
    value: !0
  }), cn.default = void 0;
  var e = {
    abstract: !1,
    accessibleNameRequired: !1,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["prohibited"],
    prohibitedProps: ["aria-label", "aria-labelledby"],
    props: {},
    relatedConcepts: [{
      concept: {
        name: "code"
      },
      module: "HTML"
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "structure", "section"]]
  }, r = e;
  return cn.default = r, cn;
}
var dn = {}, gu;
function ly() {
  if (gu) return dn;
  gu = 1, Object.defineProperty(dn, "__esModule", {
    value: !0
  }), dn.default = void 0;
  var e = {
    abstract: !1,
    accessibleNameRequired: !0,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author", "contents"],
    prohibitedProps: [],
    props: {
      "aria-sort": null
    },
    relatedConcepts: [{
      concept: {
        name: "th"
      },
      module: "HTML"
    }, {
      concept: {
        attributes: [{
          name: "scope",
          value: "col"
        }],
        name: "th"
      },
      module: "HTML"
    }, {
      concept: {
        attributes: [{
          name: "scope",
          value: "colgroup"
        }],
        name: "th"
      },
      module: "HTML"
    }],
    requireContextRole: ["row"],
    requiredContextRole: ["row"],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "structure", "section", "cell"], ["roletype", "structure", "section", "cell", "gridcell"], ["roletype", "widget", "gridcell"], ["roletype", "structure", "sectionhead"]]
  }, r = e;
  return dn.default = r, dn;
}
var fn = {}, Ru;
function sy() {
  if (Ru) return fn;
  Ru = 1, Object.defineProperty(fn, "__esModule", {
    value: !0
  }), fn.default = void 0;
  var e = {
    abstract: !1,
    accessibleNameRequired: !0,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author"],
    prohibitedProps: [],
    props: {
      "aria-activedescendant": null,
      "aria-autocomplete": null,
      "aria-errormessage": null,
      "aria-invalid": null,
      "aria-readonly": null,
      "aria-required": null,
      "aria-expanded": "false",
      "aria-haspopup": "listbox"
    },
    relatedConcepts: [{
      concept: {
        attributes: [{
          constraints: ["set"],
          name: "list"
        }, {
          name: "type",
          value: "email"
        }],
        name: "input"
      },
      module: "HTML"
    }, {
      concept: {
        attributes: [{
          constraints: ["set"],
          name: "list"
        }, {
          name: "type",
          value: "search"
        }],
        name: "input"
      },
      module: "HTML"
    }, {
      concept: {
        attributes: [{
          constraints: ["set"],
          name: "list"
        }, {
          name: "type",
          value: "tel"
        }],
        name: "input"
      },
      module: "HTML"
    }, {
      concept: {
        attributes: [{
          constraints: ["set"],
          name: "list"
        }, {
          name: "type",
          value: "text"
        }],
        name: "input"
      },
      module: "HTML"
    }, {
      concept: {
        attributes: [{
          constraints: ["set"],
          name: "list"
        }, {
          name: "type",
          value: "url"
        }],
        name: "input"
      },
      module: "HTML"
    }, {
      concept: {
        attributes: [{
          constraints: ["set"],
          name: "list"
        }, {
          name: "type",
          value: "url"
        }],
        name: "input"
      },
      module: "HTML"
    }, {
      concept: {
        attributes: [{
          constraints: ["undefined"],
          name: "multiple"
        }, {
          constraints: ["undefined"],
          name: "size"
        }],
        constraints: ["the multiple attribute is not set and the size attribute does not have a value greater than 1"],
        name: "select"
      },
      module: "HTML"
    }, {
      concept: {
        name: "select"
      },
      module: "XForms"
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {
      "aria-controls": null,
      "aria-expanded": "false"
    },
    superClass: [["roletype", "widget", "input"]]
  }, r = e;
  return fn.default = r, fn;
}
var pn = {}, xu;
function uy() {
  if (xu) return pn;
  xu = 1, Object.defineProperty(pn, "__esModule", {
    value: !0
  }), pn.default = void 0;
  var e = {
    abstract: !1,
    accessibleNameRequired: !1,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author"],
    prohibitedProps: [],
    props: {},
    relatedConcepts: [{
      concept: {
        name: "aside"
      },
      module: "HTML"
    }, {
      concept: {
        attributes: [{
          constraints: ["set"],
          name: "aria-label"
        }],
        constraints: ["scoped to a sectioning content element", "scoped to a sectioning root element other than body"],
        name: "aside"
      },
      module: "HTML"
    }, {
      concept: {
        attributes: [{
          constraints: ["set"],
          name: "aria-labelledby"
        }],
        constraints: ["scoped to a sectioning content element", "scoped to a sectioning root element other than body"],
        name: "aside"
      },
      module: "HTML"
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "structure", "section", "landmark"]]
  }, r = e;
  return pn.default = r, pn;
}
var mn = {}, wu;
function cy() {
  if (wu) return mn;
  wu = 1, Object.defineProperty(mn, "__esModule", {
    value: !0
  }), mn.default = void 0;
  var e = {
    abstract: !1,
    accessibleNameRequired: !1,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author"],
    prohibitedProps: [],
    props: {},
    relatedConcepts: [{
      concept: {
        constraints: ["scoped to the body element"],
        name: "footer"
      },
      module: "HTML"
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "structure", "section", "landmark"]]
  }, r = e;
  return mn.default = r, mn;
}
var vn = {}, Eu;
function dy() {
  if (Eu) return vn;
  Eu = 1, Object.defineProperty(vn, "__esModule", {
    value: !0
  }), vn.default = void 0;
  var e = {
    abstract: !1,
    accessibleNameRequired: !1,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author"],
    prohibitedProps: [],
    props: {},
    relatedConcepts: [{
      concept: {
        name: "dd"
      },
      module: "HTML"
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "structure", "section"]]
  }, r = e;
  return vn.default = r, vn;
}
var hn = {}, Cu;
function fy() {
  if (Cu) return hn;
  Cu = 1, Object.defineProperty(hn, "__esModule", {
    value: !0
  }), hn.default = void 0;
  var e = {
    abstract: !1,
    accessibleNameRequired: !1,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["prohibited"],
    prohibitedProps: ["aria-label", "aria-labelledby"],
    props: {},
    relatedConcepts: [{
      concept: {
        name: "del"
      },
      module: "HTML"
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "structure", "section"]]
  }, r = e;
  return hn.default = r, hn;
}
var bn = {}, _u;
function py() {
  if (_u) return bn;
  _u = 1, Object.defineProperty(bn, "__esModule", {
    value: !0
  }), bn.default = void 0;
  var e = {
    abstract: !1,
    accessibleNameRequired: !0,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author"],
    prohibitedProps: [],
    props: {},
    relatedConcepts: [{
      concept: {
        name: "dialog"
      },
      module: "HTML"
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "window"]]
  }, r = e;
  return bn.default = r, bn;
}
var yn = {}, Pu;
function my() {
  if (Pu) return yn;
  Pu = 1, Object.defineProperty(yn, "__esModule", {
    value: !0
  }), yn.default = void 0;
  var e = {
    abstract: !1,
    accessibleNameRequired: !1,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author"],
    prohibitedProps: [],
    props: {},
    relatedConcepts: [{
      module: "DAISY Guide"
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "structure", "section", "list"]]
  }, r = e;
  return yn.default = r, yn;
}
var gn = {}, Tu;
function vy() {
  if (Tu) return gn;
  Tu = 1, Object.defineProperty(gn, "__esModule", {
    value: !0
  }), gn.default = void 0;
  var e = {
    abstract: !1,
    accessibleNameRequired: !1,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author"],
    prohibitedProps: [],
    props: {},
    relatedConcepts: [{
      concept: {
        name: "Device Independence Delivery Unit"
      }
    }, {
      concept: {
        name: "html"
      },
      module: "HTML"
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "structure"]]
  }, r = e;
  return gn.default = r, gn;
}
var Rn = {}, Su;
function hy() {
  if (Su) return Rn;
  Su = 1, Object.defineProperty(Rn, "__esModule", {
    value: !0
  }), Rn.default = void 0;
  var e = {
    abstract: !1,
    accessibleNameRequired: !1,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["prohibited"],
    prohibitedProps: ["aria-label", "aria-labelledby"],
    props: {},
    relatedConcepts: [{
      concept: {
        name: "em"
      },
      module: "HTML"
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "structure", "section"]]
  }, r = e;
  return Rn.default = r, Rn;
}
var xn = {}, qu;
function by() {
  if (qu) return xn;
  qu = 1, Object.defineProperty(xn, "__esModule", {
    value: !0
  }), xn.default = void 0;
  var e = {
    abstract: !1,
    accessibleNameRequired: !1,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author"],
    prohibitedProps: [],
    props: {},
    relatedConcepts: [],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [["article"]],
    requiredProps: {},
    superClass: [["roletype", "structure", "section", "list"]]
  }, r = e;
  return xn.default = r, xn;
}
var wn = {}, Ou;
function yy() {
  if (Ou) return wn;
  Ou = 1, Object.defineProperty(wn, "__esModule", {
    value: !0
  }), wn.default = void 0;
  var e = {
    abstract: !1,
    accessibleNameRequired: !1,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author"],
    prohibitedProps: [],
    props: {},
    relatedConcepts: [{
      concept: {
        name: "figure"
      },
      module: "HTML"
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "structure", "section"]]
  }, r = e;
  return wn.default = r, wn;
}
var En = {}, Au;
function gy() {
  if (Au) return En;
  Au = 1, Object.defineProperty(En, "__esModule", {
    value: !0
  }), En.default = void 0;
  var e = {
    abstract: !1,
    accessibleNameRequired: !1,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author"],
    prohibitedProps: [],
    props: {},
    relatedConcepts: [{
      concept: {
        attributes: [{
          constraints: ["set"],
          name: "aria-label"
        }],
        name: "form"
      },
      module: "HTML"
    }, {
      concept: {
        attributes: [{
          constraints: ["set"],
          name: "aria-labelledby"
        }],
        name: "form"
      },
      module: "HTML"
    }, {
      concept: {
        attributes: [{
          constraints: ["set"],
          name: "name"
        }],
        name: "form"
      },
      module: "HTML"
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "structure", "section", "landmark"]]
  }, r = e;
  return En.default = r, En;
}
var Cn = {}, Mu;
function Ry() {
  if (Mu) return Cn;
  Mu = 1, Object.defineProperty(Cn, "__esModule", {
    value: !0
  }), Cn.default = void 0;
  var e = {
    abstract: !1,
    accessibleNameRequired: !1,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["prohibited"],
    prohibitedProps: ["aria-label", "aria-labelledby"],
    props: {},
    relatedConcepts: [{
      concept: {
        name: "a"
      },
      module: "HTML"
    }, {
      concept: {
        name: "area"
      },
      module: "HTML"
    }, {
      concept: {
        name: "aside"
      },
      module: "HTML"
    }, {
      concept: {
        name: "b"
      },
      module: "HTML"
    }, {
      concept: {
        name: "bdo"
      },
      module: "HTML"
    }, {
      concept: {
        name: "body"
      },
      module: "HTML"
    }, {
      concept: {
        name: "data"
      },
      module: "HTML"
    }, {
      concept: {
        name: "div"
      },
      module: "HTML"
    }, {
      concept: {
        constraints: ["scoped to the main element", "scoped to a sectioning content element", "scoped to a sectioning root element other than body"],
        name: "footer"
      },
      module: "HTML"
    }, {
      concept: {
        constraints: ["scoped to the main element", "scoped to a sectioning content element", "scoped to a sectioning root element other than body"],
        name: "header"
      },
      module: "HTML"
    }, {
      concept: {
        name: "hgroup"
      },
      module: "HTML"
    }, {
      concept: {
        name: "i"
      },
      module: "HTML"
    }, {
      concept: {
        name: "pre"
      },
      module: "HTML"
    }, {
      concept: {
        name: "q"
      },
      module: "HTML"
    }, {
      concept: {
        name: "samp"
      },
      module: "HTML"
    }, {
      concept: {
        name: "section"
      },
      module: "HTML"
    }, {
      concept: {
        name: "small"
      },
      module: "HTML"
    }, {
      concept: {
        name: "span"
      },
      module: "HTML"
    }, {
      concept: {
        name: "u"
      },
      module: "HTML"
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "structure"]]
  }, r = e;
  return Cn.default = r, Cn;
}
var _n = {}, ku;
function xy() {
  if (ku) return _n;
  ku = 1, Object.defineProperty(_n, "__esModule", {
    value: !0
  }), _n.default = void 0;
  var e = {
    abstract: !1,
    accessibleNameRequired: !0,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author"],
    prohibitedProps: [],
    props: {
      "aria-multiselectable": null,
      "aria-readonly": null
    },
    relatedConcepts: [],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [["row"], ["row", "rowgroup"]],
    requiredProps: {},
    superClass: [["roletype", "widget", "composite"], ["roletype", "structure", "section", "table"]]
  }, r = e;
  return _n.default = r, _n;
}
var Pn = {}, Du;
function wy() {
  if (Du) return Pn;
  Du = 1, Object.defineProperty(Pn, "__esModule", {
    value: !0
  }), Pn.default = void 0;
  var e = {
    abstract: !1,
    accessibleNameRequired: !1,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author", "contents"],
    prohibitedProps: [],
    props: {
      "aria-disabled": null,
      "aria-errormessage": null,
      "aria-expanded": null,
      "aria-haspopup": null,
      "aria-invalid": null,
      "aria-readonly": null,
      "aria-required": null,
      "aria-selected": null
    },
    relatedConcepts: [{
      concept: {
        constraints: ["ancestor table element has grid role", "ancestor table element has treegrid role"],
        name: "td"
      },
      module: "HTML"
    }],
    requireContextRole: ["row"],
    requiredContextRole: ["row"],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "structure", "section", "cell"], ["roletype", "widget"]]
  }, r = e;
  return Pn.default = r, Pn;
}
var Tn = {}, ju;
function Ey() {
  if (ju) return Tn;
  ju = 1, Object.defineProperty(Tn, "__esModule", {
    value: !0
  }), Tn.default = void 0;
  var e = {
    abstract: !1,
    accessibleNameRequired: !1,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author"],
    prohibitedProps: [],
    props: {
      "aria-activedescendant": null,
      "aria-disabled": null
    },
    relatedConcepts: [{
      concept: {
        name: "details"
      },
      module: "HTML"
    }, {
      concept: {
        name: "fieldset"
      },
      module: "HTML"
    }, {
      concept: {
        name: "optgroup"
      },
      module: "HTML"
    }, {
      concept: {
        name: "address"
      },
      module: "HTML"
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "structure", "section"]]
  }, r = e;
  return Tn.default = r, Tn;
}
var Sn = {}, Iu;
function Cy() {
  if (Iu) return Sn;
  Iu = 1, Object.defineProperty(Sn, "__esModule", {
    value: !0
  }), Sn.default = void 0;
  var e = {
    abstract: !1,
    accessibleNameRequired: !0,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author", "contents"],
    prohibitedProps: [],
    props: {
      "aria-level": "2"
    },
    relatedConcepts: [{
      concept: {
        name: "h1"
      },
      module: "HTML"
    }, {
      concept: {
        name: "h2"
      },
      module: "HTML"
    }, {
      concept: {
        name: "h3"
      },
      module: "HTML"
    }, {
      concept: {
        name: "h4"
      },
      module: "HTML"
    }, {
      concept: {
        name: "h5"
      },
      module: "HTML"
    }, {
      concept: {
        name: "h6"
      },
      module: "HTML"
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {
      "aria-level": "2"
    },
    superClass: [["roletype", "structure", "sectionhead"]]
  }, r = e;
  return Sn.default = r, Sn;
}
var qn = {}, Nu;
function _y() {
  if (Nu) return qn;
  Nu = 1, Object.defineProperty(qn, "__esModule", {
    value: !0
  }), qn.default = void 0;
  var e = {
    abstract: !1,
    accessibleNameRequired: !0,
    baseConcepts: [],
    childrenPresentational: !0,
    nameFrom: ["author"],
    prohibitedProps: [],
    props: {},
    relatedConcepts: [{
      concept: {
        attributes: [{
          constraints: ["set"],
          name: "alt"
        }],
        name: "img"
      },
      module: "HTML"
    }, {
      concept: {
        attributes: [{
          constraints: ["undefined"],
          name: "alt"
        }],
        name: "img"
      },
      module: "HTML"
    }, {
      concept: {
        name: "imggroup"
      },
      module: "DTB"
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "structure", "section"]]
  }, r = e;
  return qn.default = r, qn;
}
var On = {}, Lu;
function Py() {
  if (Lu) return On;
  Lu = 1, Object.defineProperty(On, "__esModule", {
    value: !0
  }), On.default = void 0;
  var e = {
    abstract: !1,
    accessibleNameRequired: !1,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["prohibited"],
    prohibitedProps: ["aria-label", "aria-labelledby"],
    props: {},
    relatedConcepts: [{
      concept: {
        name: "ins"
      },
      module: "HTML"
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "structure", "section"]]
  }, r = e;
  return On.default = r, On;
}
var An = {}, $u;
function Ty() {
  if ($u) return An;
  $u = 1, Object.defineProperty(An, "__esModule", {
    value: !0
  }), An.default = void 0;
  var e = {
    abstract: !1,
    accessibleNameRequired: !0,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author", "contents"],
    prohibitedProps: [],
    props: {
      "aria-disabled": null,
      "aria-expanded": null,
      "aria-haspopup": null
    },
    relatedConcepts: [{
      concept: {
        attributes: [{
          constraints: ["set"],
          name: "href"
        }],
        name: "a"
      },
      module: "HTML"
    }, {
      concept: {
        attributes: [{
          constraints: ["set"],
          name: "href"
        }],
        name: "area"
      },
      module: "HTML"
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "widget", "command"]]
  }, r = e;
  return An.default = r, An;
}
var Mn = {}, Fu;
function Sy() {
  if (Fu) return Mn;
  Fu = 1, Object.defineProperty(Mn, "__esModule", {
    value: !0
  }), Mn.default = void 0;
  var e = {
    abstract: !1,
    accessibleNameRequired: !1,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author"],
    prohibitedProps: [],
    props: {},
    relatedConcepts: [{
      concept: {
        name: "menu"
      },
      module: "HTML"
    }, {
      concept: {
        name: "ol"
      },
      module: "HTML"
    }, {
      concept: {
        name: "ul"
      },
      module: "HTML"
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [["listitem"]],
    requiredProps: {},
    superClass: [["roletype", "structure", "section"]]
  }, r = e;
  return Mn.default = r, Mn;
}
var kn = {}, Bu;
function qy() {
  if (Bu) return kn;
  Bu = 1, Object.defineProperty(kn, "__esModule", {
    value: !0
  }), kn.default = void 0;
  var e = {
    abstract: !1,
    accessibleNameRequired: !0,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author"],
    prohibitedProps: [],
    props: {
      "aria-errormessage": null,
      "aria-expanded": null,
      "aria-invalid": null,
      "aria-multiselectable": null,
      "aria-readonly": null,
      "aria-required": null,
      "aria-orientation": "vertical"
    },
    relatedConcepts: [{
      concept: {
        attributes: [{
          constraints: [">1"],
          name: "size"
        }],
        constraints: ["the size attribute value is greater than 1"],
        name: "select"
      },
      module: "HTML"
    }, {
      concept: {
        attributes: [{
          name: "multiple"
        }],
        name: "select"
      },
      module: "HTML"
    }, {
      concept: {
        name: "datalist"
      },
      module: "HTML"
    }, {
      concept: {
        name: "list"
      },
      module: "ARIA"
    }, {
      concept: {
        name: "select"
      },
      module: "XForms"
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [["option", "group"], ["option"]],
    requiredProps: {},
    superClass: [["roletype", "widget", "composite", "select"], ["roletype", "structure", "section", "group", "select"]]
  }, r = e;
  return kn.default = r, kn;
}
var Dn = {}, Hu;
function Oy() {
  if (Hu) return Dn;
  Hu = 1, Object.defineProperty(Dn, "__esModule", {
    value: !0
  }), Dn.default = void 0;
  var e = {
    abstract: !1,
    accessibleNameRequired: !1,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author"],
    prohibitedProps: [],
    props: {
      "aria-level": null,
      "aria-posinset": null,
      "aria-setsize": null
    },
    relatedConcepts: [{
      concept: {
        constraints: ["direct descendant of ol", "direct descendant of ul", "direct descendant of menu"],
        name: "li"
      },
      module: "HTML"
    }, {
      concept: {
        name: "item"
      },
      module: "XForms"
    }],
    requireContextRole: ["directory", "list"],
    requiredContextRole: ["directory", "list"],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "structure", "section"]]
  }, r = e;
  return Dn.default = r, Dn;
}
var jn = {}, Uu;
function Ay() {
  if (Uu) return jn;
  Uu = 1, Object.defineProperty(jn, "__esModule", {
    value: !0
  }), jn.default = void 0;
  var e = {
    abstract: !1,
    accessibleNameRequired: !1,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author"],
    prohibitedProps: [],
    props: {
      "aria-live": "polite"
    },
    relatedConcepts: [],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "structure", "section"]]
  }, r = e;
  return jn.default = r, jn;
}
var In = {}, Wu;
function My() {
  if (Wu) return In;
  Wu = 1, Object.defineProperty(In, "__esModule", {
    value: !0
  }), In.default = void 0;
  var e = {
    abstract: !1,
    accessibleNameRequired: !1,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author"],
    prohibitedProps: [],
    props: {},
    relatedConcepts: [{
      concept: {
        name: "main"
      },
      module: "HTML"
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "structure", "section", "landmark"]]
  }, r = e;
  return In.default = r, In;
}
var Nn = {}, zu;
function ky() {
  if (zu) return Nn;
  zu = 1, Object.defineProperty(Nn, "__esModule", {
    value: !0
  }), Nn.default = void 0;
  var e = {
    abstract: !1,
    accessibleNameRequired: !1,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["prohibited"],
    prohibitedProps: [],
    props: {
      "aria-braillelabel": null,
      "aria-brailleroledescription": null,
      "aria-description": null
    },
    relatedConcepts: [{
      concept: {
        name: "mark"
      },
      module: "HTML"
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "structure", "section"]]
  }, r = e;
  return Nn.default = r, Nn;
}
var Ln = {}, Yu;
function Dy() {
  if (Yu) return Ln;
  Yu = 1, Object.defineProperty(Ln, "__esModule", {
    value: !0
  }), Ln.default = void 0;
  var e = {
    abstract: !1,
    accessibleNameRequired: !0,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author"],
    prohibitedProps: [],
    props: {},
    relatedConcepts: [],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "structure", "section"]]
  }, r = e;
  return Ln.default = r, Ln;
}
var $n = {}, Vu;
function jy() {
  if (Vu) return $n;
  Vu = 1, Object.defineProperty($n, "__esModule", {
    value: !0
  }), $n.default = void 0;
  var e = {
    abstract: !1,
    accessibleNameRequired: !1,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author"],
    prohibitedProps: [],
    props: {},
    relatedConcepts: [{
      concept: {
        name: "math"
      },
      module: "HTML"
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "structure", "section"]]
  }, r = e;
  return $n.default = r, $n;
}
var Fn = {}, Gu;
function Iy() {
  if (Gu) return Fn;
  Gu = 1, Object.defineProperty(Fn, "__esModule", {
    value: !0
  }), Fn.default = void 0;
  var e = {
    abstract: !1,
    accessibleNameRequired: !1,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author"],
    prohibitedProps: [],
    props: {
      "aria-orientation": "vertical"
    },
    relatedConcepts: [{
      concept: {
        name: "MENU"
      },
      module: "JAPI"
    }, {
      concept: {
        name: "list"
      },
      module: "ARIA"
    }, {
      concept: {
        name: "select"
      },
      module: "XForms"
    }, {
      concept: {
        name: "sidebar"
      },
      module: "DTB"
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [["menuitem", "group"], ["menuitemradio", "group"], ["menuitemcheckbox", "group"], ["menuitem"], ["menuitemcheckbox"], ["menuitemradio"]],
    requiredProps: {},
    superClass: [["roletype", "widget", "composite", "select"], ["roletype", "structure", "section", "group", "select"]]
  }, r = e;
  return Fn.default = r, Fn;
}
var Bn = {}, Xu;
function Ny() {
  if (Xu) return Bn;
  Xu = 1, Object.defineProperty(Bn, "__esModule", {
    value: !0
  }), Bn.default = void 0;
  var e = {
    abstract: !1,
    accessibleNameRequired: !1,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author"],
    prohibitedProps: [],
    props: {
      "aria-orientation": "horizontal"
    },
    relatedConcepts: [{
      concept: {
        name: "toolbar"
      },
      module: "ARIA"
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [["menuitem", "group"], ["menuitemradio", "group"], ["menuitemcheckbox", "group"], ["menuitem"], ["menuitemcheckbox"], ["menuitemradio"]],
    requiredProps: {},
    superClass: [["roletype", "widget", "composite", "select", "menu"], ["roletype", "structure", "section", "group", "select", "menu"]]
  }, r = e;
  return Bn.default = r, Bn;
}
var Hn = {}, Ku;
function Ly() {
  if (Ku) return Hn;
  Ku = 1, Object.defineProperty(Hn, "__esModule", {
    value: !0
  }), Hn.default = void 0;
  var e = {
    abstract: !1,
    accessibleNameRequired: !0,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author", "contents"],
    prohibitedProps: [],
    props: {
      "aria-disabled": null,
      "aria-expanded": null,
      "aria-haspopup": null,
      "aria-posinset": null,
      "aria-setsize": null
    },
    relatedConcepts: [{
      concept: {
        name: "MENU_ITEM"
      },
      module: "JAPI"
    }, {
      concept: {
        name: "listitem"
      },
      module: "ARIA"
    }, {
      concept: {
        name: "option"
      },
      module: "ARIA"
    }],
    requireContextRole: ["group", "menu", "menubar"],
    requiredContextRole: ["group", "menu", "menubar"],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "widget", "command"]]
  }, r = e;
  return Hn.default = r, Hn;
}
var Un = {}, Ju;
function $y() {
  if (Ju) return Un;
  Ju = 1, Object.defineProperty(Un, "__esModule", {
    value: !0
  }), Un.default = void 0;
  var e = {
    abstract: !1,
    accessibleNameRequired: !0,
    baseConcepts: [],
    childrenPresentational: !0,
    nameFrom: ["author", "contents"],
    prohibitedProps: [],
    props: {},
    relatedConcepts: [{
      concept: {
        name: "menuitem"
      },
      module: "ARIA"
    }],
    requireContextRole: ["group", "menu", "menubar"],
    requiredContextRole: ["group", "menu", "menubar"],
    requiredOwnedElements: [],
    requiredProps: {
      "aria-checked": null
    },
    superClass: [["roletype", "widget", "input", "checkbox"], ["roletype", "widget", "command", "menuitem"]]
  }, r = e;
  return Un.default = r, Un;
}
var Wn = {}, Zu;
function Fy() {
  if (Zu) return Wn;
  Zu = 1, Object.defineProperty(Wn, "__esModule", {
    value: !0
  }), Wn.default = void 0;
  var e = {
    abstract: !1,
    accessibleNameRequired: !0,
    baseConcepts: [],
    childrenPresentational: !0,
    nameFrom: ["author", "contents"],
    prohibitedProps: [],
    props: {},
    relatedConcepts: [{
      concept: {
        name: "menuitem"
      },
      module: "ARIA"
    }],
    requireContextRole: ["group", "menu", "menubar"],
    requiredContextRole: ["group", "menu", "menubar"],
    requiredOwnedElements: [],
    requiredProps: {
      "aria-checked": null
    },
    superClass: [["roletype", "widget", "input", "checkbox", "menuitemcheckbox"], ["roletype", "widget", "command", "menuitem", "menuitemcheckbox"], ["roletype", "widget", "input", "radio"]]
  }, r = e;
  return Wn.default = r, Wn;
}
var zn = {}, Qu;
function By() {
  if (Qu) return zn;
  Qu = 1, Object.defineProperty(zn, "__esModule", {
    value: !0
  }), zn.default = void 0;
  var e = {
    abstract: !1,
    accessibleNameRequired: !0,
    baseConcepts: [],
    childrenPresentational: !0,
    nameFrom: ["author"],
    prohibitedProps: [],
    props: {
      "aria-valuetext": null,
      "aria-valuemax": "100",
      "aria-valuemin": "0"
    },
    relatedConcepts: [{
      concept: {
        name: "meter"
      },
      module: "HTML"
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {
      "aria-valuenow": null
    },
    superClass: [["roletype", "structure", "range"]]
  }, r = e;
  return zn.default = r, zn;
}
var Yn = {}, ec;
function Hy() {
  if (ec) return Yn;
  ec = 1, Object.defineProperty(Yn, "__esModule", {
    value: !0
  }), Yn.default = void 0;
  var e = {
    abstract: !1,
    accessibleNameRequired: !1,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author"],
    prohibitedProps: [],
    props: {},
    relatedConcepts: [{
      concept: {
        name: "nav"
      },
      module: "HTML"
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "structure", "section", "landmark"]]
  }, r = e;
  return Yn.default = r, Yn;
}
var Vn = {}, rc;
function Uy() {
  if (rc) return Vn;
  rc = 1, Object.defineProperty(Vn, "__esModule", {
    value: !0
  }), Vn.default = void 0;
  var e = {
    abstract: !1,
    accessibleNameRequired: !1,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: [],
    prohibitedProps: [],
    props: {},
    relatedConcepts: [],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: []
  }, r = e;
  return Vn.default = r, Vn;
}
var Gn = {}, tc;
function Wy() {
  if (tc) return Gn;
  tc = 1, Object.defineProperty(Gn, "__esModule", {
    value: !0
  }), Gn.default = void 0;
  var e = {
    abstract: !1,
    accessibleNameRequired: !1,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author"],
    prohibitedProps: [],
    props: {},
    relatedConcepts: [],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "structure", "section"]]
  }, r = e;
  return Gn.default = r, Gn;
}
var Xn = {}, nc;
function zy() {
  if (nc) return Xn;
  nc = 1, Object.defineProperty(Xn, "__esModule", {
    value: !0
  }), Xn.default = void 0;
  var e = {
    abstract: !1,
    accessibleNameRequired: !0,
    baseConcepts: [],
    childrenPresentational: !0,
    nameFrom: ["author", "contents"],
    prohibitedProps: [],
    props: {
      "aria-checked": null,
      "aria-posinset": null,
      "aria-setsize": null,
      "aria-selected": "false"
    },
    relatedConcepts: [{
      concept: {
        name: "item"
      },
      module: "XForms"
    }, {
      concept: {
        name: "listitem"
      },
      module: "ARIA"
    }, {
      concept: {
        name: "option"
      },
      module: "HTML"
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {
      "aria-selected": "false"
    },
    superClass: [["roletype", "widget", "input"]]
  }, r = e;
  return Xn.default = r, Xn;
}
var Kn = {}, ac;
function Yy() {
  if (ac) return Kn;
  ac = 1, Object.defineProperty(Kn, "__esModule", {
    value: !0
  }), Kn.default = void 0;
  var e = {
    abstract: !1,
    accessibleNameRequired: !1,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["prohibited"],
    prohibitedProps: ["aria-label", "aria-labelledby"],
    props: {},
    relatedConcepts: [{
      concept: {
        name: "p"
      },
      module: "HTML"
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "structure", "section"]]
  }, r = e;
  return Kn.default = r, Kn;
}
var Jn = {}, oc;
function Vy() {
  if (oc) return Jn;
  oc = 1, Object.defineProperty(Jn, "__esModule", {
    value: !0
  }), Jn.default = void 0;
  var e = {
    abstract: !1,
    accessibleNameRequired: !1,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["prohibited"],
    prohibitedProps: ["aria-label", "aria-labelledby"],
    props: {},
    relatedConcepts: [{
      concept: {
        attributes: [{
          name: "alt",
          value: ""
        }],
        name: "img"
      },
      module: "HTML"
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "structure"]]
  }, r = e;
  return Jn.default = r, Jn;
}
var Zn = {}, ic;
function Gy() {
  if (ic) return Zn;
  ic = 1, Object.defineProperty(Zn, "__esModule", {
    value: !0
  }), Zn.default = void 0;
  var e = {
    abstract: !1,
    accessibleNameRequired: !0,
    baseConcepts: [],
    childrenPresentational: !0,
    nameFrom: ["author"],
    prohibitedProps: [],
    props: {
      "aria-valuetext": null
    },
    relatedConcepts: [{
      concept: {
        name: "progress"
      },
      module: "HTML"
    }, {
      concept: {
        name: "status"
      },
      module: "ARIA"
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "structure", "range"], ["roletype", "widget"]]
  }, r = e;
  return Zn.default = r, Zn;
}
var Qn = {}, lc;
function Xy() {
  if (lc) return Qn;
  lc = 1, Object.defineProperty(Qn, "__esModule", {
    value: !0
  }), Qn.default = void 0;
  var e = {
    abstract: !1,
    accessibleNameRequired: !0,
    baseConcepts: [],
    childrenPresentational: !0,
    nameFrom: ["author", "contents"],
    prohibitedProps: [],
    props: {
      "aria-checked": null,
      "aria-posinset": null,
      "aria-setsize": null
    },
    relatedConcepts: [{
      concept: {
        attributes: [{
          name: "type",
          value: "radio"
        }],
        name: "input"
      },
      module: "HTML"
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {
      "aria-checked": null
    },
    superClass: [["roletype", "widget", "input"]]
  }, r = e;
  return Qn.default = r, Qn;
}
var ea = {}, sc;
function Ky() {
  if (sc) return ea;
  sc = 1, Object.defineProperty(ea, "__esModule", {
    value: !0
  }), ea.default = void 0;
  var e = {
    abstract: !1,
    accessibleNameRequired: !0,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author"],
    prohibitedProps: [],
    props: {
      "aria-errormessage": null,
      "aria-invalid": null,
      "aria-readonly": null,
      "aria-required": null
    },
    relatedConcepts: [{
      concept: {
        name: "list"
      },
      module: "ARIA"
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [["radio"]],
    requiredProps: {},
    superClass: [["roletype", "widget", "composite", "select"], ["roletype", "structure", "section", "group", "select"]]
  }, r = e;
  return ea.default = r, ea;
}
var ra = {}, uc;
function Jy() {
  if (uc) return ra;
  uc = 1, Object.defineProperty(ra, "__esModule", {
    value: !0
  }), ra.default = void 0;
  var e = {
    abstract: !1,
    accessibleNameRequired: !0,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author"],
    prohibitedProps: [],
    props: {},
    relatedConcepts: [{
      concept: {
        attributes: [{
          constraints: ["set"],
          name: "aria-label"
        }],
        name: "section"
      },
      module: "HTML"
    }, {
      concept: {
        attributes: [{
          constraints: ["set"],
          name: "aria-labelledby"
        }],
        name: "section"
      },
      module: "HTML"
    }, {
      concept: {
        name: "Device Independence Glossart perceivable unit"
      }
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "structure", "section", "landmark"]]
  }, r = e;
  return ra.default = r, ra;
}
var ta = {}, cc;
function Zy() {
  if (cc) return ta;
  cc = 1, Object.defineProperty(ta, "__esModule", {
    value: !0
  }), ta.default = void 0;
  var e = {
    abstract: !1,
    accessibleNameRequired: !1,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author", "contents"],
    prohibitedProps: [],
    props: {
      "aria-colindex": null,
      "aria-expanded": null,
      "aria-level": null,
      "aria-posinset": null,
      "aria-rowindex": null,
      "aria-selected": null,
      "aria-setsize": null
    },
    relatedConcepts: [{
      concept: {
        name: "tr"
      },
      module: "HTML"
    }],
    requireContextRole: ["grid", "rowgroup", "table", "treegrid"],
    requiredContextRole: ["grid", "rowgroup", "table", "treegrid"],
    requiredOwnedElements: [["cell"], ["columnheader"], ["gridcell"], ["rowheader"]],
    requiredProps: {},
    superClass: [["roletype", "structure", "section", "group"], ["roletype", "widget"]]
  }, r = e;
  return ta.default = r, ta;
}
var na = {}, dc;
function Qy() {
  if (dc) return na;
  dc = 1, Object.defineProperty(na, "__esModule", {
    value: !0
  }), na.default = void 0;
  var e = {
    abstract: !1,
    accessibleNameRequired: !1,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author", "contents"],
    prohibitedProps: [],
    props: {},
    relatedConcepts: [{
      concept: {
        name: "tbody"
      },
      module: "HTML"
    }, {
      concept: {
        name: "tfoot"
      },
      module: "HTML"
    }, {
      concept: {
        name: "thead"
      },
      module: "HTML"
    }],
    requireContextRole: ["grid", "table", "treegrid"],
    requiredContextRole: ["grid", "table", "treegrid"],
    requiredOwnedElements: [["row"]],
    requiredProps: {},
    superClass: [["roletype", "structure"]]
  }, r = e;
  return na.default = r, na;
}
var aa = {}, fc;
function eg() {
  if (fc) return aa;
  fc = 1, Object.defineProperty(aa, "__esModule", {
    value: !0
  }), aa.default = void 0;
  var e = {
    abstract: !1,
    accessibleNameRequired: !0,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author", "contents"],
    prohibitedProps: [],
    props: {
      "aria-sort": null
    },
    relatedConcepts: [{
      concept: {
        attributes: [{
          name: "scope",
          value: "row"
        }],
        name: "th"
      },
      module: "HTML"
    }, {
      concept: {
        attributes: [{
          name: "scope",
          value: "rowgroup"
        }],
        name: "th"
      },
      module: "HTML"
    }],
    requireContextRole: ["row", "rowgroup"],
    requiredContextRole: ["row", "rowgroup"],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "structure", "section", "cell"], ["roletype", "structure", "section", "cell", "gridcell"], ["roletype", "widget", "gridcell"], ["roletype", "structure", "sectionhead"]]
  }, r = e;
  return aa.default = r, aa;
}
var oa = {}, pc;
function rg() {
  if (pc) return oa;
  pc = 1, Object.defineProperty(oa, "__esModule", {
    value: !0
  }), oa.default = void 0;
  var e = {
    abstract: !1,
    accessibleNameRequired: !1,
    baseConcepts: [],
    childrenPresentational: !0,
    nameFrom: ["author"],
    prohibitedProps: [],
    props: {
      "aria-disabled": null,
      "aria-valuetext": null,
      "aria-orientation": "vertical",
      "aria-valuemax": "100",
      "aria-valuemin": "0"
    },
    relatedConcepts: [],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {
      "aria-controls": null,
      "aria-valuenow": null
    },
    superClass: [["roletype", "structure", "range"], ["roletype", "widget"]]
  }, r = e;
  return oa.default = r, oa;
}
var ia = {}, mc;
function tg() {
  if (mc) return ia;
  mc = 1, Object.defineProperty(ia, "__esModule", {
    value: !0
  }), ia.default = void 0;
  var e = {
    abstract: !1,
    accessibleNameRequired: !1,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author"],
    prohibitedProps: [],
    props: {},
    relatedConcepts: [],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "structure", "section", "landmark"]]
  }, r = e;
  return ia.default = r, ia;
}
var la = {}, vc;
function ng() {
  if (vc) return la;
  vc = 1, Object.defineProperty(la, "__esModule", {
    value: !0
  }), la.default = void 0;
  var e = {
    abstract: !1,
    accessibleNameRequired: !0,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author"],
    prohibitedProps: [],
    props: {},
    relatedConcepts: [{
      concept: {
        attributes: [{
          constraints: ["undefined"],
          name: "list"
        }, {
          name: "type",
          value: "search"
        }],
        constraints: ["the list attribute is not set"],
        name: "input"
      },
      module: "HTML"
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "widget", "input", "textbox"]]
  }, r = e;
  return la.default = r, la;
}
var sa = {}, hc;
function ag() {
  if (hc) return sa;
  hc = 1, Object.defineProperty(sa, "__esModule", {
    value: !0
  }), sa.default = void 0;
  var e = {
    abstract: !1,
    accessibleNameRequired: !1,
    baseConcepts: [],
    childrenPresentational: !0,
    nameFrom: ["author"],
    prohibitedProps: [],
    props: {
      "aria-disabled": null,
      "aria-orientation": "horizontal",
      "aria-valuemax": "100",
      "aria-valuemin": "0",
      "aria-valuenow": null,
      "aria-valuetext": null
    },
    relatedConcepts: [{
      concept: {
        name: "hr"
      },
      module: "HTML"
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "structure"]]
  }, r = e;
  return sa.default = r, sa;
}
var ua = {}, bc;
function og() {
  if (bc) return ua;
  bc = 1, Object.defineProperty(ua, "__esModule", {
    value: !0
  }), ua.default = void 0;
  var e = {
    abstract: !1,
    accessibleNameRequired: !0,
    baseConcepts: [],
    childrenPresentational: !0,
    nameFrom: ["author"],
    prohibitedProps: [],
    props: {
      "aria-errormessage": null,
      "aria-haspopup": null,
      "aria-invalid": null,
      "aria-readonly": null,
      "aria-valuetext": null,
      "aria-orientation": "horizontal",
      "aria-valuemax": "100",
      "aria-valuemin": "0"
    },
    relatedConcepts: [{
      concept: {
        attributes: [{
          name: "type",
          value: "range"
        }],
        name: "input"
      },
      module: "HTML"
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {
      "aria-valuenow": null
    },
    superClass: [["roletype", "widget", "input"], ["roletype", "structure", "range"]]
  }, r = e;
  return ua.default = r, ua;
}
var ca = {}, yc;
function ig() {
  if (yc) return ca;
  yc = 1, Object.defineProperty(ca, "__esModule", {
    value: !0
  }), ca.default = void 0;
  var e = {
    abstract: !1,
    accessibleNameRequired: !0,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author"],
    prohibitedProps: [],
    props: {
      "aria-errormessage": null,
      "aria-invalid": null,
      "aria-readonly": null,
      "aria-required": null,
      "aria-valuetext": null,
      "aria-valuenow": "0"
    },
    relatedConcepts: [{
      concept: {
        attributes: [{
          name: "type",
          value: "number"
        }],
        name: "input"
      },
      module: "HTML"
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "widget", "composite"], ["roletype", "widget", "input"], ["roletype", "structure", "range"]]
  }, r = e;
  return ca.default = r, ca;
}
var da = {}, gc;
function lg() {
  if (gc) return da;
  gc = 1, Object.defineProperty(da, "__esModule", {
    value: !0
  }), da.default = void 0;
  var e = {
    abstract: !1,
    accessibleNameRequired: !1,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author"],
    prohibitedProps: [],
    props: {
      "aria-atomic": "true",
      "aria-live": "polite"
    },
    relatedConcepts: [{
      concept: {
        name: "output"
      },
      module: "HTML"
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "structure", "section"]]
  }, r = e;
  return da.default = r, da;
}
var fa = {}, Rc;
function sg() {
  if (Rc) return fa;
  Rc = 1, Object.defineProperty(fa, "__esModule", {
    value: !0
  }), fa.default = void 0;
  var e = {
    abstract: !1,
    accessibleNameRequired: !1,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["prohibited"],
    prohibitedProps: ["aria-label", "aria-labelledby"],
    props: {},
    relatedConcepts: [{
      concept: {
        name: "strong"
      },
      module: "HTML"
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "structure", "section"]]
  }, r = e;
  return fa.default = r, fa;
}
var pa = {}, xc;
function ug() {
  if (xc) return pa;
  xc = 1, Object.defineProperty(pa, "__esModule", {
    value: !0
  }), pa.default = void 0;
  var e = {
    abstract: !1,
    accessibleNameRequired: !1,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["prohibited"],
    prohibitedProps: ["aria-label", "aria-labelledby"],
    props: {},
    relatedConcepts: [{
      concept: {
        name: "sub"
      },
      module: "HTML"
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "structure", "section"]]
  }, r = e;
  return pa.default = r, pa;
}
var ma = {}, wc;
function cg() {
  if (wc) return ma;
  wc = 1, Object.defineProperty(ma, "__esModule", {
    value: !0
  }), ma.default = void 0;
  var e = {
    abstract: !1,
    accessibleNameRequired: !1,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["prohibited"],
    prohibitedProps: ["aria-label", "aria-labelledby"],
    props: {},
    relatedConcepts: [{
      concept: {
        name: "sup"
      },
      module: "HTML"
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "structure", "section"]]
  }, r = e;
  return ma.default = r, ma;
}
var va = {}, Ec;
function dg() {
  if (Ec) return va;
  Ec = 1, Object.defineProperty(va, "__esModule", {
    value: !0
  }), va.default = void 0;
  var e = {
    abstract: !1,
    accessibleNameRequired: !0,
    baseConcepts: [],
    childrenPresentational: !0,
    nameFrom: ["author", "contents"],
    prohibitedProps: [],
    props: {},
    relatedConcepts: [{
      concept: {
        name: "button"
      },
      module: "ARIA"
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {
      "aria-checked": null
    },
    superClass: [["roletype", "widget", "input", "checkbox"]]
  }, r = e;
  return va.default = r, va;
}
var ha = {}, Cc;
function fg() {
  if (Cc) return ha;
  Cc = 1, Object.defineProperty(ha, "__esModule", {
    value: !0
  }), ha.default = void 0;
  var e = {
    abstract: !1,
    accessibleNameRequired: !1,
    baseConcepts: [],
    childrenPresentational: !0,
    nameFrom: ["author", "contents"],
    prohibitedProps: [],
    props: {
      "aria-disabled": null,
      "aria-expanded": null,
      "aria-haspopup": null,
      "aria-posinset": null,
      "aria-setsize": null,
      "aria-selected": "false"
    },
    relatedConcepts: [],
    requireContextRole: ["tablist"],
    requiredContextRole: ["tablist"],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "structure", "sectionhead"], ["roletype", "widget"]]
  }, r = e;
  return ha.default = r, ha;
}
var ba = {}, _c;
function pg() {
  if (_c) return ba;
  _c = 1, Object.defineProperty(ba, "__esModule", {
    value: !0
  }), ba.default = void 0;
  var e = {
    abstract: !1,
    accessibleNameRequired: !0,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author"],
    prohibitedProps: [],
    props: {
      "aria-colcount": null,
      "aria-rowcount": null
    },
    relatedConcepts: [{
      concept: {
        name: "table"
      },
      module: "HTML"
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [["row"], ["row", "rowgroup"]],
    requiredProps: {},
    superClass: [["roletype", "structure", "section"]]
  }, r = e;
  return ba.default = r, ba;
}
var ya = {}, Pc;
function mg() {
  if (Pc) return ya;
  Pc = 1, Object.defineProperty(ya, "__esModule", {
    value: !0
  }), ya.default = void 0;
  var e = {
    abstract: !1,
    accessibleNameRequired: !1,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author"],
    prohibitedProps: [],
    props: {
      "aria-level": null,
      "aria-multiselectable": null,
      "aria-orientation": "horizontal"
    },
    relatedConcepts: [{
      module: "DAISY",
      concept: {
        name: "guide"
      }
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [["tab"]],
    requiredProps: {},
    superClass: [["roletype", "widget", "composite"]]
  }, r = e;
  return ya.default = r, ya;
}
var ga = {}, Tc;
function vg() {
  if (Tc) return ga;
  Tc = 1, Object.defineProperty(ga, "__esModule", {
    value: !0
  }), ga.default = void 0;
  var e = {
    abstract: !1,
    accessibleNameRequired: !0,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author"],
    prohibitedProps: [],
    props: {},
    relatedConcepts: [],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "structure", "section"]]
  }, r = e;
  return ga.default = r, ga;
}
var Ra = {}, Sc;
function hg() {
  if (Sc) return Ra;
  Sc = 1, Object.defineProperty(Ra, "__esModule", {
    value: !0
  }), Ra.default = void 0;
  var e = {
    abstract: !1,
    accessibleNameRequired: !1,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author"],
    prohibitedProps: [],
    props: {},
    relatedConcepts: [{
      concept: {
        name: "dfn"
      },
      module: "HTML"
    }, {
      concept: {
        name: "dt"
      },
      module: "HTML"
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "structure", "section"]]
  }, r = e;
  return Ra.default = r, Ra;
}
var xa = {}, qc;
function bg() {
  if (qc) return xa;
  qc = 1, Object.defineProperty(xa, "__esModule", {
    value: !0
  }), xa.default = void 0;
  var e = {
    abstract: !1,
    accessibleNameRequired: !0,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author"],
    prohibitedProps: [],
    props: {
      "aria-activedescendant": null,
      "aria-autocomplete": null,
      "aria-errormessage": null,
      "aria-haspopup": null,
      "aria-invalid": null,
      "aria-multiline": null,
      "aria-placeholder": null,
      "aria-readonly": null,
      "aria-required": null
    },
    relatedConcepts: [{
      concept: {
        attributes: [{
          constraints: ["undefined"],
          name: "type"
        }, {
          constraints: ["undefined"],
          name: "list"
        }],
        constraints: ["the list attribute is not set"],
        name: "input"
      },
      module: "HTML"
    }, {
      concept: {
        attributes: [{
          constraints: ["undefined"],
          name: "list"
        }, {
          name: "type",
          value: "email"
        }],
        constraints: ["the list attribute is not set"],
        name: "input"
      },
      module: "HTML"
    }, {
      concept: {
        attributes: [{
          constraints: ["undefined"],
          name: "list"
        }, {
          name: "type",
          value: "tel"
        }],
        constraints: ["the list attribute is not set"],
        name: "input"
      },
      module: "HTML"
    }, {
      concept: {
        attributes: [{
          constraints: ["undefined"],
          name: "list"
        }, {
          name: "type",
          value: "text"
        }],
        constraints: ["the list attribute is not set"],
        name: "input"
      },
      module: "HTML"
    }, {
      concept: {
        attributes: [{
          constraints: ["undefined"],
          name: "list"
        }, {
          name: "type",
          value: "url"
        }],
        constraints: ["the list attribute is not set"],
        name: "input"
      },
      module: "HTML"
    }, {
      concept: {
        name: "input"
      },
      module: "XForms"
    }, {
      concept: {
        name: "textarea"
      },
      module: "HTML"
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "widget", "input"]]
  }, r = e;
  return xa.default = r, xa;
}
var wa = {}, Oc;
function yg() {
  if (Oc) return wa;
  Oc = 1, Object.defineProperty(wa, "__esModule", {
    value: !0
  }), wa.default = void 0;
  var e = {
    abstract: !1,
    accessibleNameRequired: !1,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author"],
    prohibitedProps: [],
    props: {},
    relatedConcepts: [{
      concept: {
        name: "time"
      },
      module: "HTML"
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "structure", "section"]]
  }, r = e;
  return wa.default = r, wa;
}
var Ea = {}, Ac;
function gg() {
  if (Ac) return Ea;
  Ac = 1, Object.defineProperty(Ea, "__esModule", {
    value: !0
  }), Ea.default = void 0;
  var e = {
    abstract: !1,
    accessibleNameRequired: !1,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author"],
    prohibitedProps: [],
    props: {},
    relatedConcepts: [],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "structure", "section", "status"]]
  }, r = e;
  return Ea.default = r, Ea;
}
var Ca = {}, Mc;
function Rg() {
  if (Mc) return Ca;
  Mc = 1, Object.defineProperty(Ca, "__esModule", {
    value: !0
  }), Ca.default = void 0;
  var e = {
    abstract: !1,
    accessibleNameRequired: !1,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author"],
    prohibitedProps: [],
    props: {
      "aria-orientation": "horizontal"
    },
    relatedConcepts: [{
      concept: {
        name: "menubar"
      },
      module: "ARIA"
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "structure", "section", "group"]]
  }, r = e;
  return Ca.default = r, Ca;
}
var _a = {}, kc;
function xg() {
  if (kc) return _a;
  kc = 1, Object.defineProperty(_a, "__esModule", {
    value: !0
  }), _a.default = void 0;
  var e = {
    abstract: !1,
    accessibleNameRequired: !0,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author", "contents"],
    prohibitedProps: [],
    props: {},
    relatedConcepts: [],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "structure", "section"]]
  }, r = e;
  return _a.default = r, _a;
}
var Pa = {}, Dc;
function wg() {
  if (Dc) return Pa;
  Dc = 1, Object.defineProperty(Pa, "__esModule", {
    value: !0
  }), Pa.default = void 0;
  var e = {
    abstract: !1,
    accessibleNameRequired: !0,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author"],
    prohibitedProps: [],
    props: {
      "aria-errormessage": null,
      "aria-invalid": null,
      "aria-multiselectable": null,
      "aria-required": null,
      "aria-orientation": "vertical"
    },
    relatedConcepts: [],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [["treeitem", "group"], ["treeitem"]],
    requiredProps: {},
    superClass: [["roletype", "widget", "composite", "select"], ["roletype", "structure", "section", "group", "select"]]
  }, r = e;
  return Pa.default = r, Pa;
}
var Ta = {}, jc;
function Eg() {
  if (jc) return Ta;
  jc = 1, Object.defineProperty(Ta, "__esModule", {
    value: !0
  }), Ta.default = void 0;
  var e = {
    abstract: !1,
    accessibleNameRequired: !0,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author"],
    prohibitedProps: [],
    props: {},
    relatedConcepts: [],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [["row"], ["row", "rowgroup"]],
    requiredProps: {},
    superClass: [["roletype", "widget", "composite", "grid"], ["roletype", "structure", "section", "table", "grid"], ["roletype", "widget", "composite", "select", "tree"], ["roletype", "structure", "section", "group", "select", "tree"]]
  }, r = e;
  return Ta.default = r, Ta;
}
var Sa = {}, Ic;
function Cg() {
  if (Ic) return Sa;
  Ic = 1, Object.defineProperty(Sa, "__esModule", {
    value: !0
  }), Sa.default = void 0;
  var e = {
    abstract: !1,
    accessibleNameRequired: !0,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author", "contents"],
    prohibitedProps: [],
    props: {
      "aria-expanded": null,
      "aria-haspopup": null
    },
    relatedConcepts: [],
    requireContextRole: ["group", "tree"],
    requiredContextRole: ["group", "tree"],
    requiredOwnedElements: [],
    requiredProps: {
      "aria-selected": null
    },
    superClass: [["roletype", "structure", "section", "listitem"], ["roletype", "widget", "input", "option"]]
  }, r = e;
  return Sa.default = r, Sa;
}
var Nc;
function _g() {
  if (Nc) return Zt;
  Nc = 1, Object.defineProperty(Zt, "__esModule", {
    value: !0
  }), Zt.default = void 0;
  var e = ne(Kb()), r = ne(Jb()), t = ne(Zb()), n = ne(Qb()), a = ne(ey()), o = ne(ry()), l = ne(ty()), f = ne(ny()), i = ne(ay()), s = ne(oy()), c = ne(iy()), d = ne(ly()), u = ne(sy()), m = ne(uy()), v = ne(cy()), h = ne(dy()), g = ne(fy()), p = ne(py()), x = ne(my()), w = ne(vy()), C = ne(hy()), y = ne(by()), b = ne(yy()), R = ne(gy()), E = ne(Ry()), M = ne(xy()), I = ne(wy()), $ = ne(Ey()), G = ne(Cy()), D = ne(_y()), k = ne(Py()), F = ne(Ty()), B = ne(Sy()), H = ne(qy()), U = ne(Oy()), ae = ne(Ay()), oe = ne(My()), ce = ne(ky()), J = ne(Dy()), O = ne(jy()), N = ne(Iy()), V = ne(Ny()), A = ne(Ly()), le = ne($y()), X = ne(Fy()), q = ne(By()), W = ne(Hy()), L = ne(Uy()), j = ne(Wy()), ie = ne(zy()), Z = ne(Yy()), se = ne(Vy()), pe = ne(Gy()), de = ne(Xy()), Re = ne(Ky()), Ue = ne(Jy()), xe = ne(Zy()), Ke = ne(Qy()), Ge = ne(eg()), Le = ne(rg()), fe = ne(tg()), _e = ne(ng()), Ze = ne(ag()), er = ne(og()), $e = ne(ig()), zr = ne(lg()), _ = ne(sg()), ee = ne(ug()), K = ne(cg()), me = ne(dg()), we = ne(fg()), Ee = ne(pg()), be = ne(mg()), Pe = ne(vg()), Xe = ne(hg()), rr = ne(bg()), pr = ne(yg()), Qr = ne(gg()), et = ne(Rg()), Sr = ne(xg()), St = ne(wg()), Yr = ne(Eg()), pt = ne(Cg());
  function ne(qr) {
    return qr && qr.__esModule ? qr : { default: qr };
  }
  var rt = [["alert", e.default], ["alertdialog", r.default], ["application", t.default], ["article", n.default], ["banner", a.default], ["blockquote", o.default], ["button", l.default], ["caption", f.default], ["cell", i.default], ["checkbox", s.default], ["code", c.default], ["columnheader", d.default], ["combobox", u.default], ["complementary", m.default], ["contentinfo", v.default], ["definition", h.default], ["deletion", g.default], ["dialog", p.default], ["directory", x.default], ["document", w.default], ["emphasis", C.default], ["feed", y.default], ["figure", b.default], ["form", R.default], ["generic", E.default], ["grid", M.default], ["gridcell", I.default], ["group", $.default], ["heading", G.default], ["img", D.default], ["insertion", k.default], ["link", F.default], ["list", B.default], ["listbox", H.default], ["listitem", U.default], ["log", ae.default], ["main", oe.default], ["mark", ce.default], ["marquee", J.default], ["math", O.default], ["menu", N.default], ["menubar", V.default], ["menuitem", A.default], ["menuitemcheckbox", le.default], ["menuitemradio", X.default], ["meter", q.default], ["navigation", W.default], ["none", L.default], ["note", j.default], ["option", ie.default], ["paragraph", Z.default], ["presentation", se.default], ["progressbar", pe.default], ["radio", de.default], ["radiogroup", Re.default], ["region", Ue.default], ["row", xe.default], ["rowgroup", Ke.default], ["rowheader", Ge.default], ["scrollbar", Le.default], ["search", fe.default], ["searchbox", _e.default], ["separator", Ze.default], ["slider", er.default], ["spinbutton", $e.default], ["status", zr.default], ["strong", _.default], ["subscript", ee.default], ["superscript", K.default], ["switch", me.default], ["tab", we.default], ["table", Ee.default], ["tablist", be.default], ["tabpanel", Pe.default], ["term", Xe.default], ["textbox", rr.default], ["time", pr.default], ["timer", Qr.default], ["toolbar", et.default], ["tooltip", Sr.default], ["tree", St.default], ["treegrid", Yr.default], ["treeitem", pt.default]], qt = rt;
  return Zt.default = qt, Zt;
}
var qa = {}, Oa = {}, Lc;
function Pg() {
  if (Lc) return Oa;
  Lc = 1, Object.defineProperty(Oa, "__esModule", {
    value: !0
  }), Oa.default = void 0;
  var e = {
    abstract: !1,
    accessibleNameRequired: !1,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author"],
    prohibitedProps: [],
    props: {
      "aria-disabled": null,
      "aria-errormessage": null,
      "aria-expanded": null,
      "aria-haspopup": null,
      "aria-invalid": null
    },
    relatedConcepts: [{
      concept: {
        name: "abstract [EPUB-SSV]"
      },
      module: "EPUB"
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "structure", "section"]]
  }, r = e;
  return Oa.default = r, Oa;
}
var Aa = {}, $c;
function Tg() {
  if ($c) return Aa;
  $c = 1, Object.defineProperty(Aa, "__esModule", {
    value: !0
  }), Aa.default = void 0;
  var e = {
    abstract: !1,
    accessibleNameRequired: !1,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author"],
    prohibitedProps: [],
    props: {
      "aria-disabled": null,
      "aria-errormessage": null,
      "aria-expanded": null,
      "aria-haspopup": null,
      "aria-invalid": null
    },
    relatedConcepts: [{
      concept: {
        name: "acknowledgments [EPUB-SSV]"
      },
      module: "EPUB"
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "structure", "section", "landmark"]]
  }, r = e;
  return Aa.default = r, Aa;
}
var Ma = {}, Fc;
function Sg() {
  if (Fc) return Ma;
  Fc = 1, Object.defineProperty(Ma, "__esModule", {
    value: !0
  }), Ma.default = void 0;
  var e = {
    abstract: !1,
    accessibleNameRequired: !1,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author"],
    prohibitedProps: [],
    props: {
      "aria-disabled": null,
      "aria-errormessage": null,
      "aria-expanded": null,
      "aria-haspopup": null,
      "aria-invalid": null
    },
    relatedConcepts: [{
      concept: {
        name: "afterword [EPUB-SSV]"
      },
      module: "EPUB"
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "structure", "section", "landmark"]]
  }, r = e;
  return Ma.default = r, Ma;
}
var ka = {}, Bc;
function qg() {
  if (Bc) return ka;
  Bc = 1, Object.defineProperty(ka, "__esModule", {
    value: !0
  }), ka.default = void 0;
  var e = {
    abstract: !1,
    accessibleNameRequired: !1,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author"],
    prohibitedProps: [],
    props: {
      "aria-disabled": null,
      "aria-errormessage": null,
      "aria-expanded": null,
      "aria-haspopup": null,
      "aria-invalid": null
    },
    relatedConcepts: [{
      concept: {
        name: "appendix [EPUB-SSV]"
      },
      module: "EPUB"
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "structure", "section", "landmark"]]
  }, r = e;
  return ka.default = r, ka;
}
var Da = {}, Hc;
function Og() {
  if (Hc) return Da;
  Hc = 1, Object.defineProperty(Da, "__esModule", {
    value: !0
  }), Da.default = void 0;
  var e = {
    abstract: !1,
    accessibleNameRequired: !0,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author", "contents"],
    prohibitedProps: [],
    props: {
      "aria-errormessage": null,
      "aria-invalid": null
    },
    relatedConcepts: [{
      concept: {
        name: "referrer [EPUB-SSV]"
      },
      module: "EPUB"
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "widget", "command", "link"]]
  }, r = e;
  return Da.default = r, Da;
}
var ja = {}, Uc;
function Ag() {
  if (Uc) return ja;
  Uc = 1, Object.defineProperty(ja, "__esModule", {
    value: !0
  }), ja.default = void 0;
  var e = {
    abstract: !1,
    accessibleNameRequired: !0,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author"],
    prohibitedProps: [],
    props: {
      "aria-disabled": null,
      "aria-errormessage": null,
      "aria-expanded": null,
      "aria-haspopup": null,
      "aria-invalid": null
    },
    relatedConcepts: [{
      concept: {
        name: "EPUB biblioentry [EPUB-SSV]"
      },
      module: "EPUB"
    }],
    requireContextRole: ["doc-bibliography"],
    requiredContextRole: ["doc-bibliography"],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "structure", "section", "listitem"]]
  }, r = e;
  return ja.default = r, ja;
}
var Ia = {}, Wc;
function Mg() {
  if (Wc) return Ia;
  Wc = 1, Object.defineProperty(Ia, "__esModule", {
    value: !0
  }), Ia.default = void 0;
  var e = {
    abstract: !1,
    accessibleNameRequired: !1,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author"],
    prohibitedProps: [],
    props: {
      "aria-disabled": null,
      "aria-errormessage": null,
      "aria-expanded": null,
      "aria-haspopup": null,
      "aria-invalid": null
    },
    relatedConcepts: [{
      concept: {
        name: "bibliography [EPUB-SSV]"
      },
      module: "EPUB"
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [["doc-biblioentry"]],
    requiredProps: {},
    superClass: [["roletype", "structure", "section", "landmark"]]
  }, r = e;
  return Ia.default = r, Ia;
}
var Na = {}, zc;
function kg() {
  if (zc) return Na;
  zc = 1, Object.defineProperty(Na, "__esModule", {
    value: !0
  }), Na.default = void 0;
  var e = {
    abstract: !1,
    accessibleNameRequired: !0,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author", "contents"],
    prohibitedProps: [],
    props: {
      "aria-errormessage": null,
      "aria-invalid": null
    },
    relatedConcepts: [{
      concept: {
        name: "biblioref [EPUB-SSV]"
      },
      module: "EPUB"
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "widget", "command", "link"]]
  }, r = e;
  return Na.default = r, Na;
}
var La = {}, Yc;
function Dg() {
  if (Yc) return La;
  Yc = 1, Object.defineProperty(La, "__esModule", {
    value: !0
  }), La.default = void 0;
  var e = {
    abstract: !1,
    accessibleNameRequired: !1,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author"],
    prohibitedProps: [],
    props: {
      "aria-disabled": null,
      "aria-errormessage": null,
      "aria-expanded": null,
      "aria-haspopup": null,
      "aria-invalid": null
    },
    relatedConcepts: [{
      concept: {
        name: "chapter [EPUB-SSV]"
      },
      module: "EPUB"
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "structure", "section", "landmark"]]
  }, r = e;
  return La.default = r, La;
}
var $a = {}, Vc;
function jg() {
  if (Vc) return $a;
  Vc = 1, Object.defineProperty($a, "__esModule", {
    value: !0
  }), $a.default = void 0;
  var e = {
    abstract: !1,
    accessibleNameRequired: !1,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author"],
    prohibitedProps: [],
    props: {
      "aria-disabled": null,
      "aria-errormessage": null,
      "aria-expanded": null,
      "aria-haspopup": null,
      "aria-invalid": null
    },
    relatedConcepts: [{
      concept: {
        name: "colophon [EPUB-SSV]"
      },
      module: "EPUB"
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "structure", "section"]]
  }, r = e;
  return $a.default = r, $a;
}
var Fa = {}, Gc;
function Ig() {
  if (Gc) return Fa;
  Gc = 1, Object.defineProperty(Fa, "__esModule", {
    value: !0
  }), Fa.default = void 0;
  var e = {
    abstract: !1,
    accessibleNameRequired: !1,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author"],
    prohibitedProps: [],
    props: {
      "aria-disabled": null,
      "aria-errormessage": null,
      "aria-expanded": null,
      "aria-haspopup": null,
      "aria-invalid": null
    },
    relatedConcepts: [{
      concept: {
        name: "conclusion [EPUB-SSV]"
      },
      module: "EPUB"
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "structure", "section", "landmark"]]
  }, r = e;
  return Fa.default = r, Fa;
}
var Ba = {}, Xc;
function Ng() {
  if (Xc) return Ba;
  Xc = 1, Object.defineProperty(Ba, "__esModule", {
    value: !0
  }), Ba.default = void 0;
  var e = {
    abstract: !1,
    accessibleNameRequired: !1,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author"],
    prohibitedProps: [],
    props: {
      "aria-disabled": null,
      "aria-errormessage": null,
      "aria-expanded": null,
      "aria-haspopup": null,
      "aria-invalid": null
    },
    relatedConcepts: [{
      concept: {
        name: "cover [EPUB-SSV]"
      },
      module: "EPUB"
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "structure", "section", "img"]]
  }, r = e;
  return Ba.default = r, Ba;
}
var Ha = {}, Kc;
function Lg() {
  if (Kc) return Ha;
  Kc = 1, Object.defineProperty(Ha, "__esModule", {
    value: !0
  }), Ha.default = void 0;
  var e = {
    abstract: !1,
    accessibleNameRequired: !1,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author"],
    prohibitedProps: [],
    props: {
      "aria-disabled": null,
      "aria-errormessage": null,
      "aria-expanded": null,
      "aria-haspopup": null,
      "aria-invalid": null
    },
    relatedConcepts: [{
      concept: {
        name: "credit [EPUB-SSV]"
      },
      module: "EPUB"
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "structure", "section"]]
  }, r = e;
  return Ha.default = r, Ha;
}
var Ua = {}, Jc;
function $g() {
  if (Jc) return Ua;
  Jc = 1, Object.defineProperty(Ua, "__esModule", {
    value: !0
  }), Ua.default = void 0;
  var e = {
    abstract: !1,
    accessibleNameRequired: !1,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author"],
    prohibitedProps: [],
    props: {
      "aria-disabled": null,
      "aria-errormessage": null,
      "aria-expanded": null,
      "aria-haspopup": null,
      "aria-invalid": null
    },
    relatedConcepts: [{
      concept: {
        name: "credits [EPUB-SSV]"
      },
      module: "EPUB"
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "structure", "section", "landmark"]]
  }, r = e;
  return Ua.default = r, Ua;
}
var Wa = {}, Zc;
function Fg() {
  if (Zc) return Wa;
  Zc = 1, Object.defineProperty(Wa, "__esModule", {
    value: !0
  }), Wa.default = void 0;
  var e = {
    abstract: !1,
    accessibleNameRequired: !1,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author"],
    prohibitedProps: [],
    props: {
      "aria-disabled": null,
      "aria-errormessage": null,
      "aria-expanded": null,
      "aria-haspopup": null,
      "aria-invalid": null
    },
    relatedConcepts: [{
      concept: {
        name: "dedication [EPUB-SSV]"
      },
      module: "EPUB"
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "structure", "section"]]
  }, r = e;
  return Wa.default = r, Wa;
}
var za = {}, Qc;
function Bg() {
  if (Qc) return za;
  Qc = 1, Object.defineProperty(za, "__esModule", {
    value: !0
  }), za.default = void 0;
  var e = {
    abstract: !1,
    accessibleNameRequired: !1,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author"],
    prohibitedProps: [],
    props: {
      "aria-disabled": null,
      "aria-errormessage": null,
      "aria-expanded": null,
      "aria-haspopup": null,
      "aria-invalid": null
    },
    relatedConcepts: [{
      concept: {
        name: "rearnote [EPUB-SSV]"
      },
      module: "EPUB"
    }],
    requireContextRole: ["doc-endnotes"],
    requiredContextRole: ["doc-endnotes"],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "structure", "section", "listitem"]]
  }, r = e;
  return za.default = r, za;
}
var Ya = {}, ed;
function Hg() {
  if (ed) return Ya;
  ed = 1, Object.defineProperty(Ya, "__esModule", {
    value: !0
  }), Ya.default = void 0;
  var e = {
    abstract: !1,
    accessibleNameRequired: !1,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author"],
    prohibitedProps: [],
    props: {
      "aria-disabled": null,
      "aria-errormessage": null,
      "aria-expanded": null,
      "aria-haspopup": null,
      "aria-invalid": null
    },
    relatedConcepts: [{
      concept: {
        name: "rearnotes [EPUB-SSV]"
      },
      module: "EPUB"
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [["doc-endnote"]],
    requiredProps: {},
    superClass: [["roletype", "structure", "section", "landmark"]]
  }, r = e;
  return Ya.default = r, Ya;
}
var Va = {}, rd;
function Ug() {
  if (rd) return Va;
  rd = 1, Object.defineProperty(Va, "__esModule", {
    value: !0
  }), Va.default = void 0;
  var e = {
    abstract: !1,
    accessibleNameRequired: !1,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author"],
    prohibitedProps: [],
    props: {
      "aria-disabled": null,
      "aria-errormessage": null,
      "aria-expanded": null,
      "aria-haspopup": null,
      "aria-invalid": null
    },
    relatedConcepts: [{
      concept: {
        name: "epigraph [EPUB-SSV]"
      },
      module: "EPUB"
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "structure", "section"]]
  }, r = e;
  return Va.default = r, Va;
}
var Ga = {}, td;
function Wg() {
  if (td) return Ga;
  td = 1, Object.defineProperty(Ga, "__esModule", {
    value: !0
  }), Ga.default = void 0;
  var e = {
    abstract: !1,
    accessibleNameRequired: !1,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author"],
    prohibitedProps: [],
    props: {
      "aria-disabled": null,
      "aria-errormessage": null,
      "aria-expanded": null,
      "aria-haspopup": null,
      "aria-invalid": null
    },
    relatedConcepts: [{
      concept: {
        name: "epilogue [EPUB-SSV]"
      },
      module: "EPUB"
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "structure", "section", "landmark"]]
  }, r = e;
  return Ga.default = r, Ga;
}
var Xa = {}, nd;
function zg() {
  if (nd) return Xa;
  nd = 1, Object.defineProperty(Xa, "__esModule", {
    value: !0
  }), Xa.default = void 0;
  var e = {
    abstract: !1,
    accessibleNameRequired: !1,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author"],
    prohibitedProps: [],
    props: {
      "aria-disabled": null,
      "aria-errormessage": null,
      "aria-expanded": null,
      "aria-haspopup": null,
      "aria-invalid": null
    },
    relatedConcepts: [{
      concept: {
        name: "errata [EPUB-SSV]"
      },
      module: "EPUB"
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "structure", "section", "landmark"]]
  }, r = e;
  return Xa.default = r, Xa;
}
var Ka = {}, ad;
function Yg() {
  if (ad) return Ka;
  ad = 1, Object.defineProperty(Ka, "__esModule", {
    value: !0
  }), Ka.default = void 0;
  var e = {
    abstract: !1,
    accessibleNameRequired: !1,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author"],
    prohibitedProps: [],
    props: {
      "aria-disabled": null,
      "aria-errormessage": null,
      "aria-expanded": null,
      "aria-haspopup": null,
      "aria-invalid": null
    },
    relatedConcepts: [],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "structure", "section"]]
  }, r = e;
  return Ka.default = r, Ka;
}
var Ja = {}, od;
function Vg() {
  if (od) return Ja;
  od = 1, Object.defineProperty(Ja, "__esModule", {
    value: !0
  }), Ja.default = void 0;
  var e = {
    abstract: !1,
    accessibleNameRequired: !1,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author"],
    prohibitedProps: [],
    props: {
      "aria-disabled": null,
      "aria-errormessage": null,
      "aria-expanded": null,
      "aria-haspopup": null,
      "aria-invalid": null
    },
    relatedConcepts: [{
      concept: {
        name: "footnote [EPUB-SSV]"
      },
      module: "EPUB"
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "structure", "section"]]
  }, r = e;
  return Ja.default = r, Ja;
}
var Za = {}, id;
function Gg() {
  if (id) return Za;
  id = 1, Object.defineProperty(Za, "__esModule", {
    value: !0
  }), Za.default = void 0;
  var e = {
    abstract: !1,
    accessibleNameRequired: !1,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author"],
    prohibitedProps: [],
    props: {
      "aria-disabled": null,
      "aria-errormessage": null,
      "aria-expanded": null,
      "aria-haspopup": null,
      "aria-invalid": null
    },
    relatedConcepts: [{
      concept: {
        name: "foreword [EPUB-SSV]"
      },
      module: "EPUB"
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "structure", "section", "landmark"]]
  }, r = e;
  return Za.default = r, Za;
}
var Qa = {}, ld;
function Xg() {
  if (ld) return Qa;
  ld = 1, Object.defineProperty(Qa, "__esModule", {
    value: !0
  }), Qa.default = void 0;
  var e = {
    abstract: !1,
    accessibleNameRequired: !1,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author"],
    prohibitedProps: [],
    props: {
      "aria-disabled": null,
      "aria-errormessage": null,
      "aria-expanded": null,
      "aria-haspopup": null,
      "aria-invalid": null
    },
    relatedConcepts: [{
      concept: {
        name: "glossary [EPUB-SSV]"
      },
      module: "EPUB"
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [["definition"], ["term"]],
    requiredProps: {},
    superClass: [["roletype", "structure", "section", "landmark"]]
  }, r = e;
  return Qa.default = r, Qa;
}
var eo = {}, sd;
function Kg() {
  if (sd) return eo;
  sd = 1, Object.defineProperty(eo, "__esModule", {
    value: !0
  }), eo.default = void 0;
  var e = {
    abstract: !1,
    accessibleNameRequired: !0,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author", "contents"],
    prohibitedProps: [],
    props: {
      "aria-errormessage": null,
      "aria-invalid": null
    },
    relatedConcepts: [{
      concept: {
        name: "glossref [EPUB-SSV]"
      },
      module: "EPUB"
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "widget", "command", "link"]]
  }, r = e;
  return eo.default = r, eo;
}
var ro = {}, ud;
function Jg() {
  if (ud) return ro;
  ud = 1, Object.defineProperty(ro, "__esModule", {
    value: !0
  }), ro.default = void 0;
  var e = {
    abstract: !1,
    accessibleNameRequired: !1,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author"],
    prohibitedProps: [],
    props: {
      "aria-disabled": null,
      "aria-errormessage": null,
      "aria-expanded": null,
      "aria-haspopup": null,
      "aria-invalid": null
    },
    relatedConcepts: [{
      concept: {
        name: "index [EPUB-SSV]"
      },
      module: "EPUB"
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "structure", "section", "landmark", "navigation"]]
  }, r = e;
  return ro.default = r, ro;
}
var to = {}, cd;
function Zg() {
  if (cd) return to;
  cd = 1, Object.defineProperty(to, "__esModule", {
    value: !0
  }), to.default = void 0;
  var e = {
    abstract: !1,
    accessibleNameRequired: !1,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author"],
    prohibitedProps: [],
    props: {
      "aria-disabled": null,
      "aria-errormessage": null,
      "aria-expanded": null,
      "aria-haspopup": null,
      "aria-invalid": null
    },
    relatedConcepts: [{
      concept: {
        name: "introduction [EPUB-SSV]"
      },
      module: "EPUB"
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "structure", "section", "landmark"]]
  }, r = e;
  return to.default = r, to;
}
var no = {}, dd;
function Qg() {
  if (dd) return no;
  dd = 1, Object.defineProperty(no, "__esModule", {
    value: !0
  }), no.default = void 0;
  var e = {
    abstract: !1,
    accessibleNameRequired: !0,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author", "contents"],
    prohibitedProps: [],
    props: {
      "aria-errormessage": null,
      "aria-invalid": null
    },
    relatedConcepts: [{
      concept: {
        name: "noteref [EPUB-SSV]"
      },
      module: "EPUB"
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "widget", "command", "link"]]
  }, r = e;
  return no.default = r, no;
}
var ao = {}, fd;
function eR() {
  if (fd) return ao;
  fd = 1, Object.defineProperty(ao, "__esModule", {
    value: !0
  }), ao.default = void 0;
  var e = {
    abstract: !1,
    accessibleNameRequired: !1,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author"],
    prohibitedProps: [],
    props: {
      "aria-disabled": null,
      "aria-errormessage": null,
      "aria-expanded": null,
      "aria-haspopup": null,
      "aria-invalid": null
    },
    relatedConcepts: [{
      concept: {
        name: "notice [EPUB-SSV]"
      },
      module: "EPUB"
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "structure", "section", "note"]]
  }, r = e;
  return ao.default = r, ao;
}
var oo = {}, pd;
function rR() {
  if (pd) return oo;
  pd = 1, Object.defineProperty(oo, "__esModule", {
    value: !0
  }), oo.default = void 0;
  var e = {
    abstract: !1,
    accessibleNameRequired: !0,
    baseConcepts: [],
    childrenPresentational: !0,
    nameFrom: ["author"],
    prohibitedProps: [],
    props: {
      "aria-errormessage": null,
      "aria-expanded": null,
      "aria-haspopup": null,
      "aria-invalid": null
    },
    relatedConcepts: [{
      concept: {
        name: "pagebreak [EPUB-SSV]"
      },
      module: "EPUB"
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "structure", "separator"]]
  }, r = e;
  return oo.default = r, oo;
}
var io = {}, md;
function tR() {
  if (md) return io;
  md = 1, Object.defineProperty(io, "__esModule", {
    value: !0
  }), io.default = void 0;
  var e = {
    abstract: !1,
    accessibleNameRequired: !1,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author"],
    prohibitedProps: [],
    props: {
      "aria-disabled": null,
      "aria-errormessage": null,
      "aria-expanded": null,
      "aria-haspopup": null,
      "aria-invalid": null
    },
    relatedConcepts: [{
      concept: {
        name: "page-list [EPUB-SSV]"
      },
      module: "EPUB"
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "structure", "section", "landmark", "navigation"]]
  }, r = e;
  return io.default = r, io;
}
var lo = {}, vd;
function nR() {
  if (vd) return lo;
  vd = 1, Object.defineProperty(lo, "__esModule", {
    value: !0
  }), lo.default = void 0;
  var e = {
    abstract: !1,
    accessibleNameRequired: !0,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author"],
    prohibitedProps: [],
    props: {
      "aria-disabled": null,
      "aria-errormessage": null,
      "aria-expanded": null,
      "aria-haspopup": null,
      "aria-invalid": null
    },
    relatedConcepts: [{
      concept: {
        name: "part [EPUB-SSV]"
      },
      module: "EPUB"
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "structure", "section", "landmark"]]
  }, r = e;
  return lo.default = r, lo;
}
var so = {}, hd;
function aR() {
  if (hd) return so;
  hd = 1, Object.defineProperty(so, "__esModule", {
    value: !0
  }), so.default = void 0;
  var e = {
    abstract: !1,
    accessibleNameRequired: !1,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author"],
    prohibitedProps: [],
    props: {
      "aria-disabled": null,
      "aria-errormessage": null,
      "aria-expanded": null,
      "aria-haspopup": null,
      "aria-invalid": null
    },
    relatedConcepts: [{
      concept: {
        name: "preface [EPUB-SSV]"
      },
      module: "EPUB"
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "structure", "section", "landmark"]]
  }, r = e;
  return so.default = r, so;
}
var uo = {}, bd;
function oR() {
  if (bd) return uo;
  bd = 1, Object.defineProperty(uo, "__esModule", {
    value: !0
  }), uo.default = void 0;
  var e = {
    abstract: !1,
    accessibleNameRequired: !1,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author"],
    prohibitedProps: [],
    props: {
      "aria-disabled": null,
      "aria-errormessage": null,
      "aria-expanded": null,
      "aria-haspopup": null,
      "aria-invalid": null
    },
    relatedConcepts: [{
      concept: {
        name: "prologue [EPUB-SSV]"
      },
      module: "EPUB"
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "structure", "section", "landmark"]]
  }, r = e;
  return uo.default = r, uo;
}
var co = {}, yd;
function iR() {
  if (yd) return co;
  yd = 1, Object.defineProperty(co, "__esModule", {
    value: !0
  }), co.default = void 0;
  var e = {
    abstract: !1,
    accessibleNameRequired: !1,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author"],
    prohibitedProps: [],
    props: {},
    relatedConcepts: [{
      concept: {
        name: "pullquote [EPUB-SSV]"
      },
      module: "EPUB"
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["none"]]
  }, r = e;
  return co.default = r, co;
}
var fo = {}, gd;
function lR() {
  if (gd) return fo;
  gd = 1, Object.defineProperty(fo, "__esModule", {
    value: !0
  }), fo.default = void 0;
  var e = {
    abstract: !1,
    accessibleNameRequired: !1,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author"],
    prohibitedProps: [],
    props: {
      "aria-disabled": null,
      "aria-errormessage": null,
      "aria-expanded": null,
      "aria-haspopup": null,
      "aria-invalid": null
    },
    relatedConcepts: [{
      concept: {
        name: "qna [EPUB-SSV]"
      },
      module: "EPUB"
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "structure", "section"]]
  }, r = e;
  return fo.default = r, fo;
}
var po = {}, Rd;
function sR() {
  if (Rd) return po;
  Rd = 1, Object.defineProperty(po, "__esModule", {
    value: !0
  }), po.default = void 0;
  var e = {
    abstract: !1,
    accessibleNameRequired: !1,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author"],
    prohibitedProps: [],
    props: {
      "aria-disabled": null,
      "aria-errormessage": null,
      "aria-expanded": null,
      "aria-haspopup": null,
      "aria-invalid": null
    },
    relatedConcepts: [{
      concept: {
        name: "subtitle [EPUB-SSV]"
      },
      module: "EPUB"
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "structure", "sectionhead"]]
  }, r = e;
  return po.default = r, po;
}
var mo = {}, xd;
function uR() {
  if (xd) return mo;
  xd = 1, Object.defineProperty(mo, "__esModule", {
    value: !0
  }), mo.default = void 0;
  var e = {
    abstract: !1,
    accessibleNameRequired: !1,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author"],
    prohibitedProps: [],
    props: {
      "aria-disabled": null,
      "aria-errormessage": null,
      "aria-expanded": null,
      "aria-haspopup": null,
      "aria-invalid": null
    },
    relatedConcepts: [{
      concept: {
        name: "help [EPUB-SSV]"
      },
      module: "EPUB"
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "structure", "section", "note"]]
  }, r = e;
  return mo.default = r, mo;
}
var vo = {}, wd;
function cR() {
  if (wd) return vo;
  wd = 1, Object.defineProperty(vo, "__esModule", {
    value: !0
  }), vo.default = void 0;
  var e = {
    abstract: !1,
    accessibleNameRequired: !1,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author"],
    prohibitedProps: [],
    props: {
      "aria-disabled": null,
      "aria-errormessage": null,
      "aria-expanded": null,
      "aria-haspopup": null,
      "aria-invalid": null
    },
    relatedConcepts: [{
      concept: {
        name: "toc [EPUB-SSV]"
      },
      module: "EPUB"
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "structure", "section", "landmark", "navigation"]]
  }, r = e;
  return vo.default = r, vo;
}
var Ed;
function dR() {
  if (Ed) return qa;
  Ed = 1, Object.defineProperty(qa, "__esModule", {
    value: !0
  }), qa.default = void 0;
  var e = O(Pg()), r = O(Tg()), t = O(Sg()), n = O(qg()), a = O(Og()), o = O(Ag()), l = O(Mg()), f = O(kg()), i = O(Dg()), s = O(jg()), c = O(Ig()), d = O(Ng()), u = O(Lg()), m = O($g()), v = O(Fg()), h = O(Bg()), g = O(Hg()), p = O(Ug()), x = O(Wg()), w = O(zg()), C = O(Yg()), y = O(Vg()), b = O(Gg()), R = O(Xg()), E = O(Kg()), M = O(Jg()), I = O(Zg()), $ = O(Qg()), G = O(eR()), D = O(rR()), k = O(tR()), F = O(nR()), B = O(aR()), H = O(oR()), U = O(iR()), ae = O(lR()), oe = O(sR()), ce = O(uR()), J = O(cR());
  function O(A) {
    return A && A.__esModule ? A : { default: A };
  }
  var N = [["doc-abstract", e.default], ["doc-acknowledgments", r.default], ["doc-afterword", t.default], ["doc-appendix", n.default], ["doc-backlink", a.default], ["doc-biblioentry", o.default], ["doc-bibliography", l.default], ["doc-biblioref", f.default], ["doc-chapter", i.default], ["doc-colophon", s.default], ["doc-conclusion", c.default], ["doc-cover", d.default], ["doc-credit", u.default], ["doc-credits", m.default], ["doc-dedication", v.default], ["doc-endnote", h.default], ["doc-endnotes", g.default], ["doc-epigraph", p.default], ["doc-epilogue", x.default], ["doc-errata", w.default], ["doc-example", C.default], ["doc-footnote", y.default], ["doc-foreword", b.default], ["doc-glossary", R.default], ["doc-glossref", E.default], ["doc-index", M.default], ["doc-introduction", I.default], ["doc-noteref", $.default], ["doc-notice", G.default], ["doc-pagebreak", D.default], ["doc-pagelist", k.default], ["doc-part", F.default], ["doc-preface", B.default], ["doc-prologue", H.default], ["doc-pullquote", U.default], ["doc-qna", ae.default], ["doc-subtitle", oe.default], ["doc-tip", ce.default], ["doc-toc", J.default]], V = N;
  return qa.default = V, qa;
}
var ho = {}, bo = {}, Cd;
function fR() {
  if (Cd) return bo;
  Cd = 1, Object.defineProperty(bo, "__esModule", {
    value: !0
  }), bo.default = void 0;
  var e = {
    abstract: !1,
    accessibleNameRequired: !0,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author"],
    prohibitedProps: [],
    props: {
      "aria-disabled": null,
      "aria-errormessage": null,
      "aria-expanded": null,
      "aria-haspopup": null,
      "aria-invalid": null
    },
    relatedConcepts: [{
      module: "GRAPHICS",
      concept: {
        name: "graphics-object"
      }
    }, {
      module: "ARIA",
      concept: {
        name: "img"
      }
    }, {
      module: "ARIA",
      concept: {
        name: "article"
      }
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "structure", "document"]]
  }, r = e;
  return bo.default = r, bo;
}
var yo = {}, _d;
function pR() {
  if (_d) return yo;
  _d = 1, Object.defineProperty(yo, "__esModule", {
    value: !0
  }), yo.default = void 0;
  var e = {
    abstract: !1,
    accessibleNameRequired: !1,
    baseConcepts: [],
    childrenPresentational: !1,
    nameFrom: ["author", "contents"],
    prohibitedProps: [],
    props: {
      "aria-errormessage": null,
      "aria-expanded": null,
      "aria-haspopup": null,
      "aria-invalid": null
    },
    relatedConcepts: [{
      module: "GRAPHICS",
      concept: {
        name: "graphics-document"
      }
    }, {
      module: "ARIA",
      concept: {
        name: "group"
      }
    }, {
      module: "ARIA",
      concept: {
        name: "img"
      }
    }, {
      module: "GRAPHICS",
      concept: {
        name: "graphics-symbol"
      }
    }],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "structure", "section", "group"]]
  }, r = e;
  return yo.default = r, yo;
}
var go = {}, Pd;
function mR() {
  if (Pd) return go;
  Pd = 1, Object.defineProperty(go, "__esModule", {
    value: !0
  }), go.default = void 0;
  var e = {
    abstract: !1,
    accessibleNameRequired: !0,
    baseConcepts: [],
    childrenPresentational: !0,
    nameFrom: ["author"],
    prohibitedProps: [],
    props: {
      "aria-disabled": null,
      "aria-errormessage": null,
      "aria-expanded": null,
      "aria-haspopup": null,
      "aria-invalid": null
    },
    relatedConcepts: [],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [["roletype", "structure", "section", "img"]]
  }, r = e;
  return go.default = r, go;
}
var Td;
function vR() {
  if (Td) return ho;
  Td = 1, Object.defineProperty(ho, "__esModule", {
    value: !0
  }), ho.default = void 0;
  var e = n(fR()), r = n(pR()), t = n(mR());
  function n(l) {
    return l && l.__esModule ? l : { default: l };
  }
  var a = [["graphics-document", e.default], ["graphics-object", r.default], ["graphics-symbol", t.default]], o = a;
  return ho.default = o, ho;
}
var Sd;
function wl() {
  if (Sd) return Lt;
  Sd = 1, Object.defineProperty(Lt, "__esModule", {
    value: !0
  }), Lt.default = void 0;
  var e = o(Xb()), r = o(_g()), t = o(dR()), n = o(vR()), a = o(jo());
  function o(p) {
    return p && p.__esModule ? p : { default: p };
  }
  function l(p, x, w) {
    return x in p ? Object.defineProperty(p, x, { value: w, enumerable: !0, configurable: !0, writable: !0 }) : p[x] = w, p;
  }
  function f(p, x) {
    var w = typeof Symbol < "u" && p[Symbol.iterator] || p["@@iterator"];
    if (!w) {
      if (Array.isArray(p) || (w = c(p)) || x) {
        w && (p = w);
        var C = 0, y = function() {
        };
        return { s: y, n: function() {
          return C >= p.length ? { done: !0 } : { done: !1, value: p[C++] };
        }, e: function(I) {
          throw I;
        }, f: y };
      }
      throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
    }
    var b = !0, R = !1, E;
    return { s: function() {
      w = w.call(p);
    }, n: function() {
      var I = w.next();
      return b = I.done, I;
    }, e: function(I) {
      R = !0, E = I;
    }, f: function() {
      try {
        !b && w.return != null && w.return();
      } finally {
        if (R) throw E;
      }
    } };
  }
  function i(p, x) {
    return m(p) || u(p, x) || c(p, x) || s();
  }
  function s() {
    throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  function c(p, x) {
    if (p) {
      if (typeof p == "string") return d(p, x);
      var w = Object.prototype.toString.call(p).slice(8, -1);
      if (w === "Object" && p.constructor && (w = p.constructor.name), w === "Map" || w === "Set") return Array.from(p);
      if (w === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(w)) return d(p, x);
    }
  }
  function d(p, x) {
    (x == null || x > p.length) && (x = p.length);
    for (var w = 0, C = new Array(x); w < x; w++)
      C[w] = p[w];
    return C;
  }
  function u(p, x) {
    var w = p == null ? null : typeof Symbol < "u" && p[Symbol.iterator] || p["@@iterator"];
    if (w != null) {
      var C = [], y = !0, b = !1, R, E;
      try {
        for (w = w.call(p); !(y = (R = w.next()).done) && (C.push(R.value), !(x && C.length === x)); y = !0)
          ;
      } catch (M) {
        b = !0, E = M;
      } finally {
        try {
          !y && w.return != null && w.return();
        } finally {
          if (b) throw E;
        }
      }
      return C;
    }
  }
  function m(p) {
    if (Array.isArray(p)) return p;
  }
  var v = [].concat(e.default, r.default, t.default, n.default);
  v.forEach(function(p) {
    var x = i(p, 2), w = x[1], C = f(w.superClass), y;
    try {
      for (C.s(); !(y = C.n()).done; ) {
        var b = y.value, R = f(b), E;
        try {
          var M = function() {
            var $ = E.value, G = v.find(function(H) {
              var U = i(H, 1), ae = U[0];
              return ae === $;
            });
            if (G)
              for (var D = G[1], k = 0, F = Object.keys(D.props); k < F.length; k++) {
                var B = F[k];
                Object.prototype.hasOwnProperty.call(w.props, B) || Object.assign(w.props, l({}, B, D.props[B]));
              }
          };
          for (R.s(); !(E = R.n()).done; )
            M();
        } catch (I) {
          R.e(I);
        } finally {
          R.f();
        }
      }
    } catch (I) {
      C.e(I);
    } finally {
      C.f();
    }
  });
  var h = {
    entries: function() {
      return v;
    },
    forEach: function(x) {
      var w = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null, C = f(v), y;
      try {
        for (C.s(); !(y = C.n()).done; ) {
          var b = i(y.value, 2), R = b[0], E = b[1];
          x.call(w, E, R, v);
        }
      } catch (M) {
        C.e(M);
      } finally {
        C.f();
      }
    },
    get: function(x) {
      var w = v.find(function(C) {
        return C[0] === x;
      });
      return w && w[1];
    },
    has: function(x) {
      return !!h.get(x);
    },
    keys: function() {
      return v.map(function(x) {
        var w = i(x, 1), C = w[0];
        return C;
      });
    },
    values: function() {
      return v.map(function(x) {
        var w = i(x, 2), C = w[1];
        return C;
      });
    }
  }, g = (0, a.default)(h, h.entries());
  return Lt.default = g, Lt;
}
var Ro = {}, Ii = {}, qd;
function hR() {
  if (qd) return Ii;
  qd = 1;
  var e = Object.prototype.hasOwnProperty;
  function r(t, n) {
    var a, o;
    if (t === n) return !0;
    if (t && n && (a = t.constructor) === n.constructor) {
      if (a === Date) return t.getTime() === n.getTime();
      if (a === RegExp) return t.toString() === n.toString();
      if (a === Array) {
        if ((o = t.length) === n.length)
          for (; o-- && r(t[o], n[o]); ) ;
        return o === -1;
      }
      if (!a || typeof t == "object") {
        o = 0;
        for (a in t)
          if (e.call(t, a) && ++o && !e.call(n, a) || !(a in n) || !r(t[a], n[a])) return !1;
        return Object.keys(n).length === o;
      }
    }
    return t !== t && n !== n;
  }
  return Ii.dequal = r, Ii;
}
var Od;
function bR() {
  if (Od) return Ro;
  Od = 1, Object.defineProperty(Ro, "__esModule", {
    value: !0
  }), Ro.default = void 0;
  var e = hR(), r = n(jo()), t = n(wl());
  function n(y) {
    return y && y.__esModule ? y : { default: y };
  }
  function a(y, b) {
    return f(y) || l(y, b) || s(y, b) || o();
  }
  function o() {
    throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  function l(y, b) {
    var R = y == null ? null : typeof Symbol < "u" && y[Symbol.iterator] || y["@@iterator"];
    if (R != null) {
      var E = [], M = !0, I = !1, $, G;
      try {
        for (R = R.call(y); !(M = ($ = R.next()).done) && (E.push($.value), !(b && E.length === b)); M = !0)
          ;
      } catch (D) {
        I = !0, G = D;
      } finally {
        try {
          !M && R.return != null && R.return();
        } finally {
          if (I) throw G;
        }
      }
      return E;
    }
  }
  function f(y) {
    if (Array.isArray(y)) return y;
  }
  function i(y, b) {
    var R = typeof Symbol < "u" && y[Symbol.iterator] || y["@@iterator"];
    if (!R) {
      if (Array.isArray(y) || (R = s(y)) || b) {
        R && (y = R);
        var E = 0, M = function() {
        };
        return { s: M, n: function() {
          return E >= y.length ? { done: !0 } : { done: !1, value: y[E++] };
        }, e: function(k) {
          throw k;
        }, f: M };
      }
      throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
    }
    var I = !0, $ = !1, G;
    return { s: function() {
      R = R.call(y);
    }, n: function() {
      var k = R.next();
      return I = k.done, k;
    }, e: function(k) {
      $ = !0, G = k;
    }, f: function() {
      try {
        !I && R.return != null && R.return();
      } finally {
        if ($) throw G;
      }
    } };
  }
  function s(y, b) {
    if (y) {
      if (typeof y == "string") return c(y, b);
      var R = Object.prototype.toString.call(y).slice(8, -1);
      if (R === "Object" && y.constructor && (R = y.constructor.name), R === "Map" || R === "Set") return Array.from(y);
      if (R === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(R)) return c(y, b);
    }
  }
  function c(y, b) {
    (b == null || b > y.length) && (b = y.length);
    for (var R = 0, E = new Array(b); R < b; R++)
      E[R] = y[R];
    return E;
  }
  for (var d = [], u = t.default.keys(), m = 0; m < u.length; m++) {
    var v = u[m], h = t.default.get(v);
    if (h)
      for (var g = [].concat(h.baseConcepts, h.relatedConcepts), p = 0; p < g.length; p++) {
        var x = g[p];
        x.module === "HTML" && function() {
          var y = x.concept;
          if (y) {
            var b = d.find(function(I) {
              return (0, e.dequal)(I, y);
            }), R;
            b ? R = b[1] : R = [];
            for (var E = !0, M = 0; M < R.length; M++)
              if (R[M] === v) {
                E = !1;
                break;
              }
            E && R.push(v), d.push([y, R]);
          }
        }();
      }
  }
  var w = {
    entries: function() {
      return d;
    },
    forEach: function(b) {
      var R = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null, E = i(d), M;
      try {
        for (E.s(); !(M = E.n()).done; ) {
          var I = a(M.value, 2), $ = I[0], G = I[1];
          b.call(R, G, $, d);
        }
      } catch (D) {
        E.e(D);
      } finally {
        E.f();
      }
    },
    get: function(b) {
      var R = d.find(function(E) {
        return b.name === E[0].name && (0, e.dequal)(b.attributes, E[0].attributes);
      });
      return R && R[1];
    },
    has: function(b) {
      return !!w.get(b);
    },
    keys: function() {
      return d.map(function(b) {
        var R = a(b, 1), E = R[0];
        return E;
      });
    },
    values: function() {
      return d.map(function(b) {
        var R = a(b, 2), E = R[1];
        return E;
      });
    }
  }, C = (0, r.default)(w, w.entries());
  return Ro.default = C, Ro;
}
var xo = {}, Ad;
function yR() {
  if (Ad) return xo;
  Ad = 1, Object.defineProperty(xo, "__esModule", {
    value: !0
  }), xo.default = void 0;
  var e = t(jo()), r = t(wl());
  function t(b) {
    return b && b.__esModule ? b : { default: b };
  }
  function n(b, R) {
    return l(b) || o(b, R) || i(b, R) || a();
  }
  function a() {
    throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  function o(b, R) {
    var E = b == null ? null : typeof Symbol < "u" && b[Symbol.iterator] || b["@@iterator"];
    if (E != null) {
      var M = [], I = !0, $ = !1, G, D;
      try {
        for (E = E.call(b); !(I = (G = E.next()).done) && (M.push(G.value), !(R && M.length === R)); I = !0)
          ;
      } catch (k) {
        $ = !0, D = k;
      } finally {
        try {
          !I && E.return != null && E.return();
        } finally {
          if ($) throw D;
        }
      }
      return M;
    }
  }
  function l(b) {
    if (Array.isArray(b)) return b;
  }
  function f(b, R) {
    var E = typeof Symbol < "u" && b[Symbol.iterator] || b["@@iterator"];
    if (!E) {
      if (Array.isArray(b) || (E = i(b)) || R) {
        E && (b = E);
        var M = 0, I = function() {
        };
        return { s: I, n: function() {
          return M >= b.length ? { done: !0 } : { done: !1, value: b[M++] };
        }, e: function(F) {
          throw F;
        }, f: I };
      }
      throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
    }
    var $ = !0, G = !1, D;
    return { s: function() {
      E = E.call(b);
    }, n: function() {
      var F = E.next();
      return $ = F.done, F;
    }, e: function(F) {
      G = !0, D = F;
    }, f: function() {
      try {
        !$ && E.return != null && E.return();
      } finally {
        if (G) throw D;
      }
    } };
  }
  function i(b, R) {
    if (b) {
      if (typeof b == "string") return s(b, R);
      var E = Object.prototype.toString.call(b).slice(8, -1);
      if (E === "Object" && b.constructor && (E = b.constructor.name), E === "Map" || E === "Set") return Array.from(b);
      if (E === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(E)) return s(b, R);
    }
  }
  function s(b, R) {
    (R == null || R > b.length) && (R = b.length);
    for (var E = 0, M = new Array(R); E < R; E++)
      M[E] = b[E];
    return M;
  }
  for (var c = [], d = r.default.keys(), u = 0; u < d.length; u++) {
    var m = d[u], v = r.default.get(m), h = [];
    if (v) {
      for (var g = [].concat(v.baseConcepts, v.relatedConcepts), p = 0; p < g.length; p++) {
        var x = g[p];
        if (x.module === "HTML") {
          var w = x.concept;
          w != null && h.push(w);
        }
      }
      h.length > 0 && c.push([m, h]);
    }
  }
  var C = {
    entries: function() {
      return c;
    },
    forEach: function(R) {
      var E = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null, M = f(c), I;
      try {
        for (M.s(); !(I = M.n()).done; ) {
          var $ = n(I.value, 2), G = $[0], D = $[1];
          R.call(E, D, G, c);
        }
      } catch (k) {
        M.e(k);
      } finally {
        M.f();
      }
    },
    get: function(R) {
      var E = c.find(function(M) {
        return M[0] === R;
      });
      return E && E[1];
    },
    has: function(R) {
      return !!C.get(R);
    },
    keys: function() {
      return c.map(function(R) {
        var E = n(R, 1), M = E[0];
        return M;
      });
    },
    values: function() {
      return c.map(function(R) {
        var E = n(R, 2), M = E[1];
        return M;
      });
    }
  }, y = (0, e.default)(C, C.entries());
  return xo.default = y, xo;
}
var Md;
function gR() {
  if (Md) return cr;
  Md = 1, Object.defineProperty(cr, "__esModule", {
    value: !0
  }), cr.roles = cr.roleElements = cr.elementRoles = cr.dom = cr.aria = void 0;
  var e = o(jb()), r = o(Ib()), t = o(wl()), n = o(bR()), a = o(yR());
  function o(d) {
    return d && d.__esModule ? d : { default: d };
  }
  var l = e.default;
  cr.aria = l;
  var f = r.default;
  cr.dom = f;
  var i = t.default;
  cr.roles = i;
  var s = n.default;
  cr.elementRoles = s;
  var c = a.default;
  return cr.roleElements = c, cr;
}
var hr = gR(), Ni = { exports: {} }, kd;
function RR() {
  return kd || (kd = 1, function(e) {
    var r = function() {
      var t = String.fromCharCode, n = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=", a = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+-$", o = {};
      function l(i, s) {
        if (!o[i]) {
          o[i] = {};
          for (var c = 0; c < i.length; c++)
            o[i][i.charAt(c)] = c;
        }
        return o[i][s];
      }
      var f = {
        compressToBase64: function(i) {
          if (i == null) return "";
          var s = f._compress(i, 6, function(c) {
            return n.charAt(c);
          });
          switch (s.length % 4) {
            // To produce valid Base64
            default:
            // When could this happen ?
            case 0:
              return s;
            case 1:
              return s + "===";
            case 2:
              return s + "==";
            case 3:
              return s + "=";
          }
        },
        decompressFromBase64: function(i) {
          return i == null ? "" : i == "" ? null : f._decompress(i.length, 32, function(s) {
            return l(n, i.charAt(s));
          });
        },
        compressToUTF16: function(i) {
          return i == null ? "" : f._compress(i, 15, function(s) {
            return t(s + 32);
          }) + " ";
        },
        decompressFromUTF16: function(i) {
          return i == null ? "" : i == "" ? null : f._decompress(i.length, 16384, function(s) {
            return i.charCodeAt(s) - 32;
          });
        },
        //compress into uint8array (UCS-2 big endian format)
        compressToUint8Array: function(i) {
          for (var s = f.compress(i), c = new Uint8Array(s.length * 2), d = 0, u = s.length; d < u; d++) {
            var m = s.charCodeAt(d);
            c[d * 2] = m >>> 8, c[d * 2 + 1] = m % 256;
          }
          return c;
        },
        //decompress from uint8array (UCS-2 big endian format)
        decompressFromUint8Array: function(i) {
          if (i == null)
            return f.decompress(i);
          for (var s = new Array(i.length / 2), c = 0, d = s.length; c < d; c++)
            s[c] = i[c * 2] * 256 + i[c * 2 + 1];
          var u = [];
          return s.forEach(function(m) {
            u.push(t(m));
          }), f.decompress(u.join(""));
        },
        //compress into a string that is already URI encoded
        compressToEncodedURIComponent: function(i) {
          return i == null ? "" : f._compress(i, 6, function(s) {
            return a.charAt(s);
          });
        },
        //decompress from an output of compressToEncodedURIComponent
        decompressFromEncodedURIComponent: function(i) {
          return i == null ? "" : i == "" ? null : (i = i.replace(/ /g, "+"), f._decompress(i.length, 32, function(s) {
            return l(a, i.charAt(s));
          }));
        },
        compress: function(i) {
          return f._compress(i, 16, function(s) {
            return t(s);
          });
        },
        _compress: function(i, s, c) {
          if (i == null) return "";
          var d, u, m = {}, v = {}, h = "", g = "", p = "", x = 2, w = 3, C = 2, y = [], b = 0, R = 0, E;
          for (E = 0; E < i.length; E += 1)
            if (h = i.charAt(E), Object.prototype.hasOwnProperty.call(m, h) || (m[h] = w++, v[h] = !0), g = p + h, Object.prototype.hasOwnProperty.call(m, g))
              p = g;
            else {
              if (Object.prototype.hasOwnProperty.call(v, p)) {
                if (p.charCodeAt(0) < 256) {
                  for (d = 0; d < C; d++)
                    b = b << 1, R == s - 1 ? (R = 0, y.push(c(b)), b = 0) : R++;
                  for (u = p.charCodeAt(0), d = 0; d < 8; d++)
                    b = b << 1 | u & 1, R == s - 1 ? (R = 0, y.push(c(b)), b = 0) : R++, u = u >> 1;
                } else {
                  for (u = 1, d = 0; d < C; d++)
                    b = b << 1 | u, R == s - 1 ? (R = 0, y.push(c(b)), b = 0) : R++, u = 0;
                  for (u = p.charCodeAt(0), d = 0; d < 16; d++)
                    b = b << 1 | u & 1, R == s - 1 ? (R = 0, y.push(c(b)), b = 0) : R++, u = u >> 1;
                }
                x--, x == 0 && (x = Math.pow(2, C), C++), delete v[p];
              } else
                for (u = m[p], d = 0; d < C; d++)
                  b = b << 1 | u & 1, R == s - 1 ? (R = 0, y.push(c(b)), b = 0) : R++, u = u >> 1;
              x--, x == 0 && (x = Math.pow(2, C), C++), m[g] = w++, p = String(h);
            }
          if (p !== "") {
            if (Object.prototype.hasOwnProperty.call(v, p)) {
              if (p.charCodeAt(0) < 256) {
                for (d = 0; d < C; d++)
                  b = b << 1, R == s - 1 ? (R = 0, y.push(c(b)), b = 0) : R++;
                for (u = p.charCodeAt(0), d = 0; d < 8; d++)
                  b = b << 1 | u & 1, R == s - 1 ? (R = 0, y.push(c(b)), b = 0) : R++, u = u >> 1;
              } else {
                for (u = 1, d = 0; d < C; d++)
                  b = b << 1 | u, R == s - 1 ? (R = 0, y.push(c(b)), b = 0) : R++, u = 0;
                for (u = p.charCodeAt(0), d = 0; d < 16; d++)
                  b = b << 1 | u & 1, R == s - 1 ? (R = 0, y.push(c(b)), b = 0) : R++, u = u >> 1;
              }
              x--, x == 0 && (x = Math.pow(2, C), C++), delete v[p];
            } else
              for (u = m[p], d = 0; d < C; d++)
                b = b << 1 | u & 1, R == s - 1 ? (R = 0, y.push(c(b)), b = 0) : R++, u = u >> 1;
            x--, x == 0 && (x = Math.pow(2, C), C++);
          }
          for (u = 2, d = 0; d < C; d++)
            b = b << 1 | u & 1, R == s - 1 ? (R = 0, y.push(c(b)), b = 0) : R++, u = u >> 1;
          for (; ; )
            if (b = b << 1, R == s - 1) {
              y.push(c(b));
              break;
            } else R++;
          return y.join("");
        },
        decompress: function(i) {
          return i == null ? "" : i == "" ? null : f._decompress(i.length, 32768, function(s) {
            return i.charCodeAt(s);
          });
        },
        _decompress: function(i, s, c) {
          var d = [], u = 4, m = 4, v = 3, h = "", g = [], p, x, w, C, y, b, R, E = { val: c(0), position: s, index: 1 };
          for (p = 0; p < 3; p += 1)
            d[p] = p;
          for (w = 0, y = Math.pow(2, 2), b = 1; b != y; )
            C = E.val & E.position, E.position >>= 1, E.position == 0 && (E.position = s, E.val = c(E.index++)), w |= (C > 0 ? 1 : 0) * b, b <<= 1;
          switch (w) {
            case 0:
              for (w = 0, y = Math.pow(2, 8), b = 1; b != y; )
                C = E.val & E.position, E.position >>= 1, E.position == 0 && (E.position = s, E.val = c(E.index++)), w |= (C > 0 ? 1 : 0) * b, b <<= 1;
              R = t(w);
              break;
            case 1:
              for (w = 0, y = Math.pow(2, 16), b = 1; b != y; )
                C = E.val & E.position, E.position >>= 1, E.position == 0 && (E.position = s, E.val = c(E.index++)), w |= (C > 0 ? 1 : 0) * b, b <<= 1;
              R = t(w);
              break;
            case 2:
              return "";
          }
          for (d[3] = R, x = R, g.push(R); ; ) {
            if (E.index > i)
              return "";
            for (w = 0, y = Math.pow(2, v), b = 1; b != y; )
              C = E.val & E.position, E.position >>= 1, E.position == 0 && (E.position = s, E.val = c(E.index++)), w |= (C > 0 ? 1 : 0) * b, b <<= 1;
            switch (R = w) {
              case 0:
                for (w = 0, y = Math.pow(2, 8), b = 1; b != y; )
                  C = E.val & E.position, E.position >>= 1, E.position == 0 && (E.position = s, E.val = c(E.index++)), w |= (C > 0 ? 1 : 0) * b, b <<= 1;
                d[m++] = t(w), R = m - 1, u--;
                break;
              case 1:
                for (w = 0, y = Math.pow(2, 16), b = 1; b != y; )
                  C = E.val & E.position, E.position >>= 1, E.position == 0 && (E.position = s, E.val = c(E.index++)), w |= (C > 0 ? 1 : 0) * b, b <<= 1;
                d[m++] = t(w), R = m - 1, u--;
                break;
              case 2:
                return g.join("");
            }
            if (u == 0 && (u = Math.pow(2, v), v++), d[R])
              h = d[R];
            else if (R === m)
              h = x + x.charAt(0);
            else
              return null;
            g.push(h), d[m++] = x + h.charAt(0), u--, x = h, u == 0 && (u = Math.pow(2, v), v++);
          }
        }
      };
      return f;
    }();
    e != null ? e.exports = r : typeof angular < "u" && angular != null && angular.module("LZString", []).factory("LZString", function() {
      return r;
    });
  }(Ni)), Ni.exports;
}
var xR = RR();
const wR = /* @__PURE__ */ gi(xR);
function Mf(e) {
  return e.replace(/</g, "&lt;").replace(/>/g, "&gt;");
}
const ER = (e, r, t, n, a, o, l) => {
  const f = n + t.indent, i = t.colors;
  return e.map((s) => {
    const c = r[s];
    let d = l(c, t, f, a, o);
    return typeof c != "string" && (d.indexOf(`
`) !== -1 && (d = t.spacingOuter + f + d + t.spacingOuter + n), d = "{" + d + "}"), t.spacingInner + n + i.prop.open + s + i.prop.close + "=" + i.value.open + d + i.value.close;
  }).join("");
}, CR = 3, _R = (e, r, t, n, a, o) => e.map((l) => {
  const f = typeof l == "string" ? kf(l, r) : o(l, r, t, n, a);
  return f === "" && typeof l == "object" && l !== null && l.nodeType !== CR ? "" : r.spacingOuter + t + f;
}).join(""), kf = (e, r) => {
  const t = r.colors.content;
  return t.open + Mf(e) + t.close;
}, PR = (e, r) => {
  const t = r.colors.comment;
  return t.open + "<!--" + Mf(e) + "-->" + t.close;
}, TR = (e, r, t, n, a) => {
  const o = n.colors.tag;
  return o.open + "<" + e + (r && o.close + r + n.spacingOuter + a + o.open) + (t ? ">" + o.close + t + n.spacingOuter + a + o.open + "</" + e : (r && !n.min ? "" : " ") + "/") + ">" + o.close;
}, SR = (e, r) => {
  const t = r.colors.tag;
  return t.open + "<" + e + t.close + " …" + t.open + " />" + t.close;
}, qR = 1, Df = 3, jf = 8, If = 11, OR = /^((HTML|SVG)\w*)?Element$/, Nf = (e) => {
  const {
    tagName: r
  } = e;
  return !!(typeof r == "string" && r.includes("-") || typeof e.hasAttribute == "function" && e.hasAttribute("is"));
}, AR = (e) => {
  const r = e.constructor.name, {
    nodeType: t
  } = e;
  return t === qR && (OR.test(r) || Nf(e)) || t === Df && r === "Text" || t === jf && r === "Comment" || t === If && r === "DocumentFragment";
};
function MR(e) {
  return e.nodeType === Df;
}
function kR(e) {
  return e.nodeType === jf;
}
function Li(e) {
  return e.nodeType === If;
}
function DR(e) {
  return {
    test: (r) => {
      var t;
      return ((r == null || (t = r.constructor) == null ? void 0 : t.name) || Nf(r)) && AR(r);
    },
    serialize: (r, t, n, a, o, l) => {
      if (MR(r))
        return kf(r.data, t);
      if (kR(r))
        return PR(r.data, t);
      const f = Li(r) ? "DocumentFragment" : r.tagName.toLowerCase();
      return ++a > t.maxDepth ? SR(f, t) : TR(f, ER(Li(r) ? [] : Array.from(r.attributes).map((i) => i.name).sort(), Li(r) ? {} : Array.from(r.attributes).reduce((i, s) => (i[s.name] = s.value, i), {}), t, n + t.indent, a, o, l), _R(Array.prototype.slice.call(r.childNodes || r.children).filter(e), t, n + t.indent, a, o, l), t, n);
    }
  };
}
let Lf = null, El = null, Cl = null;
try {
  const e = module && module.require;
  El = e.call(module, "fs").readFileSync, Cl = e.call(module, "@babel/code-frame").codeFrameColumns, Lf = e.call(module, "chalk");
} catch {
}
function jR(e) {
  const r = e.indexOf("(") + 1, t = e.indexOf(")"), n = e.slice(r, t), a = n.split(":"), [o, l, f] = [a[0], parseInt(a[1], 10), parseInt(a[2], 10)];
  let i = "";
  try {
    i = El(o, "utf-8");
  } catch {
    return "";
  }
  const s = Cl(i, {
    start: {
      line: l,
      column: f
    }
  }, {
    highlightCode: !0,
    linesBelow: 0
  });
  return Lf.dim(n) + `
` + s + `
`;
}
function IR() {
  if (!El || !Cl)
    return "";
  const r = new Error().stack.split(`
`).slice(1).find((t) => !t.includes("node_modules/"));
  return jR(r);
}
const $f = 3;
function $i() {
  return typeof jest < "u" && jest !== null ? (
    // legacy timers
    setTimeout._isMockFunction === !0 || // modern timers
    // eslint-disable-next-line prefer-object-has-own -- not supported by our support matrix
    Object.prototype.hasOwnProperty.call(setTimeout, "clock")
  ) : !1;
}
function _l() {
  if (typeof window > "u")
    throw new Error("Could not find default container");
  return window.document;
}
function Ff(e) {
  if (e.defaultView)
    return e.defaultView;
  if (e.ownerDocument && e.ownerDocument.defaultView)
    return e.ownerDocument.defaultView;
  if (e.window)
    return e.window;
  throw e.ownerDocument && e.ownerDocument.defaultView === null ? new Error("It looks like the window object is not available for the provided node.") : e.then instanceof Function ? new Error("It looks like you passed a Promise object instead of a DOM node. Did you do something like `fireEvent.click(screen.findBy...` when you meant to use a `getBy` query `fireEvent.click(screen.getBy...`, or await the findBy query `fireEvent.click(await screen.findBy...`?") : Array.isArray(e) ? new Error("It looks like you passed an Array instead of a DOM node. Did you do something like `fireEvent.click(screen.getAllBy...` when you meant to use a `getBy` query `fireEvent.click(screen.getBy...`?") : typeof e.debug == "function" && typeof e.logTestingPlaygroundURL == "function" ? new Error("It looks like you passed a `screen` object. Did you do something like `fireEvent.click(screen, ...` when you meant to use a query, e.g. `fireEvent.click(screen.getBy..., `?") : new Error("The given node is not an Element, the node type is: " + typeof e + ".");
}
function Wr(e) {
  if (!e || typeof e.querySelector != "function" || typeof e.querySelectorAll != "function")
    throw new TypeError("Expected container to be an Element, a Document or a DocumentFragment but got " + r(e) + ".");
  function r(t) {
    return typeof t == "object" ? t === null ? "null" : t.constructor.name : typeof t;
  }
}
const NR = () => {
  if (typeof process > "u")
    return !1;
  let e;
  try {
    var r;
    const t = (r = process.env) == null ? void 0 : r.COLORS;
    t && (e = JSON.parse(t));
  } catch {
  }
  return typeof e == "boolean" ? e : process.versions !== void 0 && process.versions.node !== void 0;
}, {
  DOMCollection: LR
} = Ef.plugins, $R = 1, FR = 8;
function BR(e) {
  return e.nodeType !== FR && (e.nodeType !== $R || !e.matches(Ie().defaultIgnore));
}
function Et(e, r, t) {
  if (t === void 0 && (t = {}), e || (e = _l().body), typeof r != "number" && (r = typeof process < "u" && typeof process.env < "u" && process.env.DEBUG_PRINT_LIMIT || 7e3), r === 0)
    return "";
  e.documentElement && (e = e.documentElement);
  let n = typeof e;
  if (n === "object" ? n = e.constructor.name : e = {}, !("outerHTML" in e))
    throw new TypeError("Expected an element or document but got " + n);
  const {
    filterNode: a = BR,
    ...o
  } = t, l = Ef.format(e, {
    plugins: [DR(a), LR],
    printFunctionName: !1,
    highlight: NR(),
    ...o
  });
  return r !== void 0 && e.outerHTML.length > r ? l.slice(0, r) + "..." : l;
}
const Dd = function() {
  const e = IR();
  console.log(e ? Et(...arguments) + `

` + e : Et(...arguments));
};
let lt = {
  testIdAttribute: "data-testid",
  asyncUtilTimeout: 1e3,
  // asyncWrapper and advanceTimersWrapper is to support React's async `act` function.
  // forcing react-testing-library to wrap all async functions would've been
  // a total nightmare (consider wrapping every findBy* query and then also
  // updating `within` so those would be wrapped too. Total nightmare).
  // so we have this config option that's really only intended for
  // react-testing-library to use. For that reason, this feature will remain
  // undocumented.
  asyncWrapper: (e) => e(),
  unstable_advanceTimersWrapper: (e) => e(),
  eventWrapper: (e) => e(),
  // default value for the `hidden` option in `ByRole` queries
  defaultHidden: !1,
  // default value for the `ignore` option in `ByText` queries
  defaultIgnore: "script, style",
  // showOriginalStackTrace flag to show the full error stack traces for async errors
  showOriginalStackTrace: !1,
  // throw errors w/ suggestions for better queries. Opt in so off by default.
  throwSuggestions: !1,
  // called when getBy* queries fail. (message, container) => Error
  getElementError(e, r) {
    const t = Et(r), n = new Error([e, "Ignored nodes: comments, " + lt.defaultIgnore + `
` + t].filter(Boolean).join(`

`));
    return n.name = "TestingLibraryElementError", n;
  },
  _disableExpensiveErrorDiagnostics: !1,
  computedStyleSupportsPseudoElements: !1
};
function HR(e) {
  try {
    return lt._disableExpensiveErrorDiagnostics = !0, e();
  } finally {
    lt._disableExpensiveErrorDiagnostics = !1;
  }
}
function UR(e) {
  typeof e == "function" && (e = e(lt)), lt = {
    ...lt,
    ...e
  };
}
function Ie() {
  return lt;
}
const WR = ["button", "meter", "output", "progress", "select", "textarea", "input"];
function Bf(e) {
  return WR.includes(e.nodeName.toLowerCase()) ? "" : e.nodeType === $f ? e.textContent : Array.from(e.childNodes).map((r) => Bf(r)).join("");
}
function Ki(e) {
  let r;
  return e.tagName.toLowerCase() === "label" ? r = Bf(e) : r = e.value || e.textContent, r;
}
function Hf(e) {
  if (e.labels !== void 0) {
    var r;
    return (r = e.labels) != null ? r : [];
  }
  if (!zR(e)) return [];
  const t = e.ownerDocument.querySelectorAll("label");
  return Array.from(t).filter((n) => n.control === e);
}
function zR(e) {
  return /BUTTON|METER|OUTPUT|PROGRESS|SELECT|TEXTAREA/.test(e.tagName) || e.tagName === "INPUT" && e.getAttribute("type") !== "hidden";
}
function Uf(e, r, t) {
  let {
    selector: n = "*"
  } = t === void 0 ? {} : t;
  const a = r.getAttribute("aria-labelledby"), o = a ? a.split(" ") : [];
  return o.length ? o.map((l) => {
    const f = e.querySelector('[id="' + l + '"]');
    return f ? {
      content: Ki(f),
      formControl: null
    } : {
      content: "",
      formControl: null
    };
  }) : Array.from(Hf(r)).map((l) => {
    const f = Ki(l), s = Array.from(l.querySelectorAll("button, input, meter, output, progress, select, textarea")).filter((c) => c.matches(n))[0];
    return {
      content: f,
      formControl: s
    };
  });
}
function Wf(e) {
  if (e == null)
    throw new Error(
      // eslint-disable-next-line @typescript-eslint/restrict-template-expressions -- implicitly converting `T` to `string`
      "It looks like " + e + " was passed instead of a matcher. Did you do something like getByText(" + e + ")?"
    );
}
function Tt(e, r, t, n) {
  if (typeof e != "string")
    return !1;
  Wf(t);
  const a = n(e);
  return typeof t == "string" || typeof t == "number" ? a.toLowerCase().includes(t.toString().toLowerCase()) : typeof t == "function" ? t(a, r) : Yf(t, a);
}
function Hr(e, r, t, n) {
  if (typeof e != "string")
    return !1;
  Wf(t);
  const a = n(e);
  return t instanceof Function ? t(a, r) : t instanceof RegExp ? Yf(t, a) : a === String(t);
}
function zf(e) {
  let {
    trim: r = !0,
    collapseWhitespace: t = !0
  } = e === void 0 ? {} : e;
  return (n) => {
    let a = n;
    return a = r ? a.trim() : a, a = t ? a.replace(/\s+/g, " ") : a, a;
  };
}
function dt(e) {
  let {
    trim: r,
    collapseWhitespace: t,
    normalizer: n
  } = e;
  if (!n)
    return zf({
      trim: r,
      collapseWhitespace: t
    });
  if (typeof r < "u" || typeof t < "u")
    throw new Error('trim and collapseWhitespace are not supported with a normalizer. If you want to use the default trim and collapseWhitespace logic in your normalizer, use "getDefaultNormalizer({trim, collapseWhitespace})" and compose that into your normalizer');
  return n;
}
function Yf(e, r) {
  const t = e.test(r);
  return e.global && e.lastIndex !== 0 && (console.warn("To match all elements we had to reset the lastIndex of the RegExp because the global flag is enabled. We encourage to remove the global flag from the RegExp."), e.lastIndex = 0), t;
}
function wi(e) {
  return e.matches("input[type=submit], input[type=button], input[type=reset]") ? e.value : Array.from(e.childNodes).filter((r) => r.nodeType === $f && !!r.textContent).map((r) => r.textContent).join("");
}
const YR = VR(hr.elementRoles);
function Vf(e) {
  return e.hidden === !0 || e.getAttribute("aria-hidden") === "true" || e.ownerDocument.defaultView.getComputedStyle(e).display === "none";
}
function Pl(e, r) {
  r === void 0 && (r = {});
  const {
    isSubtreeInaccessible: t = Vf
  } = r;
  if (e.ownerDocument.defaultView.getComputedStyle(e).visibility === "hidden")
    return !0;
  let a = e;
  for (; a; ) {
    if (t(a))
      return !0;
    a = a.parentElement;
  }
  return !1;
}
function Tl(e) {
  for (const {
    match: r,
    roles: t
  } of YR)
    if (r(e))
      return [...t];
  return [];
}
function VR(e) {
  function r(l) {
    let {
      name: f,
      attributes: i
    } = l;
    return "" + f + i.map((s) => {
      let {
        name: c,
        value: d,
        constraints: u = []
      } = s;
      const m = u.indexOf("undefined") !== -1, v = u.indexOf("set") !== -1;
      return typeof d < "u" ? "[" + c + '="' + d + '"]' : m ? ":not([" + c + "])" : v ? "[" + c + "]:not([" + c + '=""])' : "[" + c + "]";
    }).join("");
  }
  function t(l) {
    let {
      attributes: f = []
    } = l;
    return f.length;
  }
  function n(l, f) {
    let {
      specificity: i
    } = l, {
      specificity: s
    } = f;
    return s - i;
  }
  function a(l) {
    let {
      attributes: f = []
    } = l;
    const i = f.findIndex((c) => c.value && c.name === "type" && c.value === "text");
    i >= 0 && (f = [...f.slice(0, i), ...f.slice(i + 1)]);
    const s = r({
      ...l,
      attributes: f
    });
    return (c) => i >= 0 && c.type !== "text" ? !1 : c.matches(s);
  }
  let o = [];
  for (const [l, f] of e.entries())
    o = [...o, {
      match: a(l),
      roles: Array.from(f),
      specificity: t(l)
    }];
  return o.sort(n);
}
function GR(e, r) {
  let {
    hidden: t = !1
  } = r === void 0 ? {} : r;
  function n(a) {
    return [a, ...Array.from(a.children).reduce((o, l) => [...o, ...n(l)], [])];
  }
  return n(e).filter((a) => t === !1 ? Pl(a) === !1 : !0).reduce((a, o) => {
    let l = [];
    return o.hasAttribute("role") ? l = o.getAttribute("role").split(" ").slice(0, 1) : l = Tl(o), l.reduce((f, i) => Array.isArray(f[i]) ? {
      ...f,
      [i]: [...f[i], o]
    } : {
      ...f,
      [i]: [o]
    }, a);
  }, {});
}
function XR(e, r) {
  let {
    hidden: t,
    includeDescription: n
  } = r;
  const a = GR(e, {
    hidden: t
  });
  return Object.entries(a).filter((o) => {
    let [l] = o;
    return l !== "generic";
  }).map((o) => {
    let [l, f] = o;
    const i = "-".repeat(50), s = f.map((c) => {
      const d = 'Name "' + xl(c, {
        computedStyleSupportsPseudoElements: Ie().computedStyleSupportsPseudoElements
      }) + `":
`, u = Et(c.cloneNode(!1));
      if (n) {
        const m = 'Description "' + Af(c, {
          computedStyleSupportsPseudoElements: Ie().computedStyleSupportsPseudoElements
        }) + `":
`;
        return "" + d + m + u;
      }
      return "" + d + u;
    }).join(`

`);
    return l + `:

` + s + `

` + i;
  }).join(`
`);
}
function KR(e) {
  return e.tagName === "OPTION" ? e.selected : Io(e, "aria-selected");
}
function JR(e) {
  return e.getAttribute("aria-busy") === "true";
}
function ZR(e) {
  if (!("indeterminate" in e && e.indeterminate))
    return "checked" in e ? e.checked : Io(e, "aria-checked");
}
function QR(e) {
  return Io(e, "aria-pressed");
}
function e0(e) {
  var r, t;
  return (r = (t = Io(e, "aria-current")) != null ? t : e.getAttribute("aria-current")) != null ? r : !1;
}
function r0(e) {
  return Io(e, "aria-expanded");
}
function Io(e, r) {
  const t = e.getAttribute(r);
  if (t === "true")
    return !0;
  if (t === "false")
    return !1;
}
function t0(e) {
  const r = {
    H1: 1,
    H2: 2,
    H3: 3,
    H4: 4,
    H5: 5,
    H6: 6
  };
  return e.getAttribute("aria-level") && Number(e.getAttribute("aria-level")) || r[e.tagName];
}
function n0(e) {
  const r = e.getAttribute("aria-valuenow");
  return r === null ? void 0 : +r;
}
function a0(e) {
  const r = e.getAttribute("aria-valuemax");
  return r === null ? void 0 : +r;
}
function o0(e) {
  const r = e.getAttribute("aria-valuemin");
  return r === null ? void 0 : +r;
}
function i0(e) {
  const r = e.getAttribute("aria-valuetext");
  return r === null ? void 0 : r;
}
const jd = zf();
function l0(e) {
  return e.replace(/[.*+\-?^${}()|[\]\\]/g, "\\$&");
}
function Id(e) {
  return new RegExp(l0(e.toLowerCase()), "i");
}
function Gr(e, r, t, n) {
  let {
    variant: a,
    name: o
  } = n, l = "";
  const f = {}, i = [["Role", "TestId"].includes(e) ? t : Id(t)];
  o && (f.name = Id(o)), e === "Role" && Pl(r) && (f.hidden = !0, l = `Element is inaccessible. This means that the element and all its children are invisible to screen readers.
    If you are using the aria-hidden prop, make sure this is the right choice for your case.
    `), Object.keys(f).length > 0 && i.push(f);
  const s = a + "By" + e;
  return {
    queryName: e,
    queryMethod: s,
    queryArgs: i,
    variant: a,
    warning: l,
    toString() {
      l && console.warn(l);
      let [c, d] = i;
      return c = typeof c == "string" ? "'" + c + "'" : c, d = d ? ", { " + Object.entries(d).map((u) => {
        let [m, v] = u;
        return m + ": " + v;
      }).join(", ") + " }" : "", s + "(" + c + d + ")";
    }
  };
}
function Xr(e, r, t) {
  return t && !0;
}
function Ji(e, r, t) {
  var n, a;
  if (r === void 0 && (r = "get"), e.matches(Ie().defaultIgnore))
    return;
  const o = (n = e.getAttribute("role")) != null ? n : (a = Tl(e)) == null ? void 0 : a[0];
  if (o !== "generic" && Xr("Role", t, o))
    return Gr("Role", e, o, {
      variant: r,
      name: xl(e, {
        computedStyleSupportsPseudoElements: Ie().computedStyleSupportsPseudoElements
      })
    });
  const l = Uf(document, e).map((u) => u.content).join(" ");
  if (Xr("LabelText", t, l))
    return Gr("LabelText", e, l, {
      variant: r
    });
  const f = e.getAttribute("placeholder");
  if (Xr("PlaceholderText", t, f))
    return Gr("PlaceholderText", e, f, {
      variant: r
    });
  const i = jd(wi(e));
  if (Xr("Text", t, i))
    return Gr("Text", e, i, {
      variant: r
    });
  if (Xr("DisplayValue", t, e.value))
    return Gr("DisplayValue", e, jd(e.value), {
      variant: r
    });
  const s = e.getAttribute("alt");
  if (Xr("AltText", t, s))
    return Gr("AltText", e, s, {
      variant: r
    });
  const c = e.getAttribute("title");
  if (Xr("Title", t, c))
    return Gr("Title", e, c, {
      variant: r
    });
  const d = e.getAttribute(Ie().testIdAttribute);
  if (Xr("TestId", t, d))
    return Gr("TestId", e, d, {
      variant: r
    });
}
function Zo(e, r) {
  e.stack = r.stack.replace(r.message, e.message);
}
function s0(e, r) {
  let {
    container: t = _l(),
    timeout: n = Ie().asyncUtilTimeout,
    showOriginalStackTrace: a = Ie().showOriginalStackTrace,
    stackTraceError: o,
    interval: l = 50,
    onTimeout: f = (s) => (Object.defineProperty(s, "message", {
      value: Ie().getElementError(s.message, t).message
    }), s),
    mutationObserverOptions: i = {
      subtree: !0,
      childList: !0,
      attributes: !0,
      characterData: !0
    }
  } = r;
  if (typeof e != "function")
    throw new TypeError("Received `callback` arg must be a function");
  return new Promise(async (s, c) => {
    let d, u, m, v = !1, h = "idle";
    const g = setTimeout(y, n), p = $i();
    if (p) {
      const {
        unstable_advanceTimersWrapper: b
      } = Ie();
      for (C(); !v; ) {
        if (!$i()) {
          const R = new Error("Changed from using fake timers to real timers while using waitFor. This is not allowed and will result in very strange behavior. Please ensure you're awaiting all async things your test is doing before changing to real timers. For more info, please go to https://github.com/testing-library/dom-testing-library/issues/830");
          a || Zo(R, o), c(R);
          return;
        }
        if (await b(async () => {
          jest.advanceTimersByTime(l);
        }), v)
          break;
        C();
      }
    } else {
      try {
        Wr(t);
      } catch (R) {
        c(R);
        return;
      }
      u = setInterval(w, l);
      const {
        MutationObserver: b
      } = Ff(t);
      m = new b(w), m.observe(t, i), C();
    }
    function x(b, R) {
      v = !0, clearTimeout(g), p || (clearInterval(u), m.disconnect()), b ? c(b) : s(R);
    }
    function w() {
      if ($i()) {
        const b = new Error("Changed from using real timers to fake timers while using waitFor. This is not allowed and will result in very strange behavior. Please ensure you're awaiting all async things your test is doing before changing to fake timers. For more info, please go to https://github.com/testing-library/dom-testing-library/issues/830");
        return a || Zo(b, o), c(b);
      } else
        return C();
    }
    function C() {
      if (h !== "pending")
        try {
          const b = HR(e);
          typeof (b == null ? void 0 : b.then) == "function" ? (h = "pending", b.then((R) => {
            h = "resolved", x(null, R);
          }, (R) => {
            h = "rejected", d = R;
          })) : x(null, b);
        } catch (b) {
          d = b;
        }
    }
    function y() {
      let b;
      d ? (b = d, !a && b.name === "TestingLibraryElementError" && Zo(b, o)) : (b = new Error("Timed out in waitFor."), a || Zo(b, o)), x(f(b), null);
    }
  });
}
function u0(e, r) {
  const t = new Error("STACK_TRACE_MESSAGE");
  return Ie().asyncWrapper(() => s0(e, {
    stackTraceError: t,
    ...r
  }));
}
function Gf(e, r) {
  return Ie().getElementError(e, r);
}
function c0(e, r) {
  return Gf(e + "\n\n(If this is intentional, then use the `*AllBy*` variant of the query (like `queryAllByText`, `getAllByText`, or `findAllByText`)).", r);
}
function Ei(e, r, t, n) {
  let {
    exact: a = !0,
    collapseWhitespace: o,
    trim: l,
    normalizer: f
  } = n === void 0 ? {} : n;
  const i = a ? Hr : Tt, s = dt({
    collapseWhitespace: o,
    trim: l,
    normalizer: f
  });
  return Array.from(r.querySelectorAll("[" + e + "]")).filter((c) => i(c.getAttribute(e), c, t, s));
}
function mi(e, r) {
  return function(t) {
    for (var n = arguments.length, a = new Array(n > 1 ? n - 1 : 0), o = 1; o < n; o++)
      a[o - 1] = arguments[o];
    const l = e(t, ...a);
    if (l.length > 1) {
      const f = l.map((i) => Gf(null, i).message).join(`

`);
      throw c0(r(t, ...a) + `

Here are the matching elements:

` + f, t);
    }
    return l[0] || null;
  };
}
function Xf(e, r) {
  return Ie().getElementError(`A better query is available, try this:
` + e.toString() + `
`, r);
}
function d0(e, r) {
  return function(t) {
    for (var n = arguments.length, a = new Array(n > 1 ? n - 1 : 0), o = 1; o < n; o++)
      a[o - 1] = arguments[o];
    const l = e(t, ...a);
    if (!l.length)
      throw Ie().getElementError(r(t, ...a), t);
    return l;
  };
}
function vi(e) {
  return (r, t, n, a) => u0(() => e(r, t, n), {
    container: r,
    ...a
  });
}
const ht = (e, r, t) => function(n) {
  for (var a = arguments.length, o = new Array(a > 1 ? a - 1 : 0), l = 1; l < a; l++)
    o[l - 1] = arguments[l];
  const f = e(n, ...o), [{
    suggest: i = Ie().throwSuggestions
  } = {}] = o.slice(-1);
  if (f && i) {
    const s = Ji(f, t);
    if (s && !r.endsWith(s.queryName))
      throw Xf(s.toString(), n);
  }
  return f;
}, xr = (e, r, t) => function(n) {
  for (var a = arguments.length, o = new Array(a > 1 ? a - 1 : 0), l = 1; l < a; l++)
    o[l - 1] = arguments[l];
  const f = e(n, ...o), [{
    suggest: i = Ie().throwSuggestions
  } = {}] = o.slice(-1);
  if (f.length && i) {
    const s = [...new Set(f.map((c) => {
      var d;
      return (d = Ji(c, t)) == null ? void 0 : d.toString();
    }))];
    if (
      // only want to suggest if all the els have the same suggestion.
      s.length === 1 && !r.endsWith(
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion -- TODO: Can this be null at runtime?
        Ji(f[0], t).queryName
      )
    )
      throw Xf(s[0], n);
  }
  return f;
};
function ft(e, r, t) {
  const n = ht(mi(e, r), e.name, "query"), a = d0(e, t), o = mi(a, r), l = ht(o, e.name, "get"), f = xr(a, e.name.replace("query", "get"), "getAll"), i = vi(xr(a, e.name, "findAll")), s = vi(ht(o, e.name, "find"));
  return [n, f, l, i, s];
}
function f0(e) {
  return Array.from(e.querySelectorAll("label,input")).map((r) => ({
    node: r,
    textToMatch: Ki(r)
  })).filter((r) => {
    let {
      textToMatch: t
    } = r;
    return t !== null;
  });
}
const p0 = function(e, r, t) {
  let {
    exact: n = !0,
    trim: a,
    collapseWhitespace: o,
    normalizer: l
  } = t === void 0 ? {} : t;
  const f = n ? Hr : Tt, i = dt({
    collapseWhitespace: o,
    trim: a,
    normalizer: l
  });
  return f0(e).filter((c) => {
    let {
      node: d,
      textToMatch: u
    } = c;
    return f(u, d, r, i);
  }).map((c) => {
    let {
      node: d
    } = c;
    return d;
  });
}, Ao = function(e, r, t) {
  let {
    selector: n = "*",
    exact: a = !0,
    collapseWhitespace: o,
    trim: l,
    normalizer: f
  } = t === void 0 ? {} : t;
  Wr(e);
  const i = a ? Hr : Tt, s = dt({
    collapseWhitespace: o,
    trim: l,
    normalizer: f
  }), c = Array.from(e.querySelectorAll("*")).filter((d) => Hf(d).length || d.hasAttribute("aria-labelledby")).reduce((d, u) => {
    const m = Uf(e, u, {
      selector: n
    });
    m.filter((h) => !!h.formControl).forEach((h) => {
      i(h.content, h.formControl, r, s) && h.formControl && d.push(h.formControl);
    });
    const v = m.filter((h) => !!h.content).map((h) => h.content);
    return i(v.join(" "), u, r, s) && d.push(u), v.length > 1 && v.forEach((h, g) => {
      i(h, u, r, s) && d.push(u);
      const p = [...v];
      p.splice(g, 1), p.length > 1 && i(p.join(" "), u, r, s) && d.push(u);
    }), d;
  }, []).concat(Ei("aria-label", e, r, {
    exact: a,
    normalizer: s
  }));
  return Array.from(new Set(c)).filter((d) => d.matches(n));
}, ct = function(e, r) {
  for (var t = arguments.length, n = new Array(t > 2 ? t - 2 : 0), a = 2; a < t; a++)
    n[a - 2] = arguments[a];
  const o = Ao(e, r, ...n);
  if (!o.length) {
    const l = p0(e, r, ...n);
    if (l.length) {
      const f = l.map((i) => m0(e, i)).filter((i) => !!i);
      throw f.length ? Ie().getElementError(f.map((i) => "Found a label with the text of: " + r + ", however the element associated with this label (<" + i + " />) is non-labellable [https://html.spec.whatwg.org/multipage/forms.html#category-label]. If you really need to label a <" + i + " />, you can use aria-label or aria-labelledby instead.").join(`

`), e) : Ie().getElementError("Found a label with the text of: " + r + `, however no form control was found associated to that label. Make sure you're using the "for" attribute or "aria-labelledby" attribute correctly.`, e);
    } else
      throw Ie().getElementError("Unable to find a label with the text of: " + r, e);
  }
  return o;
};
function m0(e, r) {
  const t = r.getAttribute("for");
  if (!t)
    return null;
  const n = e.querySelector('[id="' + t + '"]');
  return n ? n.tagName.toLowerCase() : null;
}
const Kf = (e, r) => "Found multiple elements with the text of: " + r, v0 = ht(mi(Ao, Kf), Ao.name, "query"), Jf = mi(ct, Kf), h0 = vi(xr(ct, ct.name, "findAll")), b0 = vi(ht(Jf, ct.name, "find")), y0 = xr(ct, ct.name, "getAll"), g0 = ht(Jf, ct.name, "get"), R0 = xr(Ao, Ao.name, "queryAll"), Zi = function() {
  for (var e = arguments.length, r = new Array(e), t = 0; t < e; t++)
    r[t] = arguments[t];
  return Wr(r[0]), Ei("placeholder", ...r);
}, x0 = (e, r) => "Found multiple elements with the placeholder text of: " + r, w0 = (e, r) => "Unable to find an element with the placeholder text of: " + r, E0 = xr(Zi, Zi.name, "queryAll"), [C0, _0, P0, T0, S0] = ft(Zi, x0, w0), Qi = function(e, r, t) {
  let {
    selector: n = "*",
    exact: a = !0,
    collapseWhitespace: o,
    trim: l,
    ignore: f = Ie().defaultIgnore,
    normalizer: i
  } = t === void 0 ? {} : t;
  Wr(e);
  const s = a ? Hr : Tt, c = dt({
    collapseWhitespace: o,
    trim: l,
    normalizer: i
  });
  let d = [];
  return typeof e.matches == "function" && e.matches(n) && (d = [e]), [...d, ...Array.from(e.querySelectorAll(n))].filter((u) => !f || !u.matches(f)).filter((u) => s(wi(u), u, r, c));
}, q0 = (e, r) => "Found multiple elements with the text: " + r, O0 = function(e, r, t) {
  t === void 0 && (t = {});
  const {
    collapseWhitespace: n,
    trim: a,
    normalizer: o,
    selector: l
  } = t, i = dt({
    collapseWhitespace: n,
    trim: a,
    normalizer: o
  })(r.toString()), s = i !== r.toString(), c = (l ?? "*") !== "*";
  return "Unable to find an element with the text: " + (s ? i + " (normalized from '" + r + "')" : r) + (c ? ", which matches selector '" + l + "'" : "") + ". This could be because the text is broken up by multiple elements. In this case, you can provide a function for your text matcher to make your matcher more flexible.";
}, A0 = xr(Qi, Qi.name, "queryAll"), [M0, k0, D0, j0, I0] = ft(Qi, q0, O0), el = function(e, r, t) {
  let {
    exact: n = !0,
    collapseWhitespace: a,
    trim: o,
    normalizer: l
  } = t === void 0 ? {} : t;
  Wr(e);
  const f = n ? Hr : Tt, i = dt({
    collapseWhitespace: a,
    trim: o,
    normalizer: l
  });
  return Array.from(e.querySelectorAll("input,textarea,select")).filter((s) => s.tagName === "SELECT" ? Array.from(s.options).filter((d) => d.selected).some((d) => f(wi(d), d, r, i)) : f(s.value, s, r, i));
}, N0 = (e, r) => "Found multiple elements with the display value: " + r + ".", L0 = (e, r) => "Unable to find an element with the display value: " + r + ".", $0 = xr(el, el.name, "queryAll"), [F0, B0, H0, U0, W0] = ft(el, N0, L0), z0 = /^(img|input|area|.+-.+)$/i, rl = function(e, r, t) {
  return t === void 0 && (t = {}), Wr(e), Ei("alt", e, r, t).filter((n) => z0.test(n.tagName));
}, Y0 = (e, r) => "Found multiple elements with the alt text: " + r, V0 = (e, r) => "Unable to find an element with the alt text: " + r, G0 = xr(rl, rl.name, "queryAll"), [X0, K0, J0, Z0, Q0] = ft(rl, Y0, V0), ex = (e) => {
  var r;
  return e.tagName.toLowerCase() === "title" && ((r = e.parentElement) == null ? void 0 : r.tagName.toLowerCase()) === "svg";
}, tl = function(e, r, t) {
  let {
    exact: n = !0,
    collapseWhitespace: a,
    trim: o,
    normalizer: l
  } = t === void 0 ? {} : t;
  Wr(e);
  const f = n ? Hr : Tt, i = dt({
    collapseWhitespace: a,
    trim: o,
    normalizer: l
  });
  return Array.from(e.querySelectorAll("[title], svg > title")).filter((s) => f(s.getAttribute("title"), s, r, i) || ex(s) && f(wi(s), s, r, i));
}, rx = (e, r) => "Found multiple elements with the title: " + r + ".", tx = (e, r) => "Unable to find an element with the title: " + r + ".", nx = xr(tl, tl.name, "queryAll"), [ax, ox, ix, lx, sx] = ft(tl, rx, tx), nl = function(e, r, t) {
  let {
    hidden: n = Ie().defaultHidden,
    name: a,
    description: o,
    queryFallbacks: l = !1,
    selected: f,
    busy: i,
    checked: s,
    pressed: c,
    current: d,
    level: u,
    expanded: m,
    value: {
      now: v,
      min: h,
      max: g,
      text: p
    } = {}
  } = t === void 0 ? {} : t;
  if (Wr(e), f !== void 0) {
    var x;
    if (((x = hr.roles.get(r)) == null ? void 0 : x.props["aria-selected"]) === void 0)
      throw new Error('"aria-selected" is not supported on role "' + r + '".');
  }
  if (i !== void 0) {
    var w;
    if (((w = hr.roles.get(r)) == null ? void 0 : w.props["aria-busy"]) === void 0)
      throw new Error('"aria-busy" is not supported on role "' + r + '".');
  }
  if (s !== void 0) {
    var C;
    if (((C = hr.roles.get(r)) == null ? void 0 : C.props["aria-checked"]) === void 0)
      throw new Error('"aria-checked" is not supported on role "' + r + '".');
  }
  if (c !== void 0) {
    var y;
    if (((y = hr.roles.get(r)) == null ? void 0 : y.props["aria-pressed"]) === void 0)
      throw new Error('"aria-pressed" is not supported on role "' + r + '".');
  }
  if (d !== void 0) {
    var b;
    if (((b = hr.roles.get(r)) == null ? void 0 : b.props["aria-current"]) === void 0)
      throw new Error('"aria-current" is not supported on role "' + r + '".');
  }
  if (u !== void 0 && r !== "heading")
    throw new Error('Role "' + r + '" cannot have "level" property.');
  if (v !== void 0) {
    var R;
    if (((R = hr.roles.get(r)) == null ? void 0 : R.props["aria-valuenow"]) === void 0)
      throw new Error('"aria-valuenow" is not supported on role "' + r + '".');
  }
  if (g !== void 0) {
    var E;
    if (((E = hr.roles.get(r)) == null ? void 0 : E.props["aria-valuemax"]) === void 0)
      throw new Error('"aria-valuemax" is not supported on role "' + r + '".');
  }
  if (h !== void 0) {
    var M;
    if (((M = hr.roles.get(r)) == null ? void 0 : M.props["aria-valuemin"]) === void 0)
      throw new Error('"aria-valuemin" is not supported on role "' + r + '".');
  }
  if (p !== void 0) {
    var I;
    if (((I = hr.roles.get(r)) == null ? void 0 : I.props["aria-valuetext"]) === void 0)
      throw new Error('"aria-valuetext" is not supported on role "' + r + '".');
  }
  if (m !== void 0) {
    var $;
    if ((($ = hr.roles.get(r)) == null ? void 0 : $.props["aria-expanded"]) === void 0)
      throw new Error('"aria-expanded" is not supported on role "' + r + '".');
  }
  const G = /* @__PURE__ */ new WeakMap();
  function D(k) {
    return G.has(k) || G.set(k, Vf(k)), G.get(k);
  }
  return Array.from(e.querySelectorAll(
    // Only query elements that can be matched by the following filters
    ux(r)
  )).filter((k) => {
    if (k.hasAttribute("role")) {
      const H = k.getAttribute("role");
      if (l)
        return H.split(" ").filter(Boolean).some((ae) => ae === r);
      const [U] = H.split(" ");
      return U === r;
    }
    return Tl(k).some((H) => H === r);
  }).filter((k) => {
    if (f !== void 0)
      return f === KR(k);
    if (i !== void 0)
      return i === JR(k);
    if (s !== void 0)
      return s === ZR(k);
    if (c !== void 0)
      return c === QR(k);
    if (d !== void 0)
      return d === e0(k);
    if (m !== void 0)
      return m === r0(k);
    if (u !== void 0)
      return u === t0(k);
    if (v !== void 0 || g !== void 0 || h !== void 0 || p !== void 0) {
      let B = !0;
      if (v !== void 0 && B && (B = v === n0(k)), g !== void 0 && B && (B = g === a0(k)), h !== void 0 && B && (B = h === o0(k)), p !== void 0) {
        var F;
        B && (B = Hr((F = i0(k)) != null ? F : null, k, p, (H) => H));
      }
      return B;
    }
    return !0;
  }).filter((k) => a === void 0 ? !0 : Hr(xl(k, {
    computedStyleSupportsPseudoElements: Ie().computedStyleSupportsPseudoElements
  }), k, a, (F) => F)).filter((k) => o === void 0 ? !0 : Hr(Af(k, {
    computedStyleSupportsPseudoElements: Ie().computedStyleSupportsPseudoElements
  }), k, o, (F) => F)).filter((k) => n === !1 ? Pl(k, {
    isSubtreeInaccessible: D
  }) === !1 : !0);
};
function ux(e) {
  var r;
  const t = '*[role~="' + e + '"]', n = (r = hr.roleElements.get(e)) != null ? r : /* @__PURE__ */ new Set(), a = new Set(Array.from(n).map((o) => {
    let {
      name: l
    } = o;
    return l;
  }));
  return [t].concat(Array.from(a)).join(",");
}
const Zf = (e) => {
  let r = "";
  return e === void 0 ? r = "" : typeof e == "string" ? r = ' and name "' + e + '"' : r = " and name `" + e + "`", r;
}, cx = function(e, r, t) {
  let {
    name: n
  } = t === void 0 ? {} : t;
  return 'Found multiple elements with the role "' + r + '"' + Zf(n);
}, dx = function(e, r, t) {
  let {
    hidden: n = Ie().defaultHidden,
    name: a,
    description: o
  } = t === void 0 ? {} : t;
  if (Ie()._disableExpensiveErrorDiagnostics)
    return 'Unable to find role="' + r + '"' + Zf(a);
  let l = "";
  Array.from(e.children).forEach((c) => {
    l += XR(c, {
      hidden: n,
      includeDescription: o !== void 0
    });
  });
  let f;
  l.length === 0 ? n === !1 ? f = "There are no accessible roles. But there might be some inaccessible roles. If you wish to access them, then set the `hidden` option to `true`. Learn more about this here: https://testing-library.com/docs/dom-testing-library/api-queries#byrole" : f = "There are no available roles." : f = (`
Here are the ` + (n === !1 ? "accessible" : "available") + ` roles:

  ` + l.replace(/\n/g, `
  `).replace(/\n\s\s\n/g, `

`) + `
`).trim();
  let i = "";
  a === void 0 ? i = "" : typeof a == "string" ? i = ' and name "' + a + '"' : i = " and name `" + a + "`";
  let s = "";
  return o === void 0 ? s = "" : typeof o == "string" ? s = ' and description "' + o + '"' : s = " and description `" + o + "`", (`
Unable to find an ` + (n === !1 ? "accessible " : "") + 'element with the role "' + r + '"' + i + s + `

` + f).trim();
}, fx = xr(nl, nl.name, "queryAll"), [px, mx, vx, hx, bx] = ft(nl, cx, dx), Sl = () => Ie().testIdAttribute, al = function() {
  for (var e = arguments.length, r = new Array(e), t = 0; t < e; t++)
    r[t] = arguments[t];
  return Wr(r[0]), Ei(Sl(), ...r);
}, yx = (e, r) => "Found multiple elements by: [" + Sl() + '="' + r + '"]', gx = (e, r) => "Unable to find an element by: [" + Sl() + '="' + r + '"]', Rx = xr(al, al.name, "queryAll"), [xx, wx, Ex, Cx, _x] = ft(al, yx, gx);
var ol = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  queryAllByLabelText: R0,
  queryByLabelText: v0,
  getAllByLabelText: y0,
  getByLabelText: g0,
  findAllByLabelText: h0,
  findByLabelText: b0,
  queryByPlaceholderText: C0,
  queryAllByPlaceholderText: E0,
  getByPlaceholderText: P0,
  getAllByPlaceholderText: _0,
  findAllByPlaceholderText: T0,
  findByPlaceholderText: S0,
  queryByText: M0,
  queryAllByText: A0,
  getByText: D0,
  getAllByText: k0,
  findAllByText: j0,
  findByText: I0,
  queryByDisplayValue: F0,
  queryAllByDisplayValue: $0,
  getByDisplayValue: H0,
  getAllByDisplayValue: B0,
  findAllByDisplayValue: U0,
  findByDisplayValue: W0,
  queryByAltText: X0,
  queryAllByAltText: G0,
  getByAltText: J0,
  getAllByAltText: K0,
  findAllByAltText: Z0,
  findByAltText: Q0,
  queryByTitle: ax,
  queryAllByTitle: nx,
  getByTitle: ix,
  getAllByTitle: ox,
  findAllByTitle: lx,
  findByTitle: sx,
  queryByRole: px,
  queryAllByRole: fx,
  getAllByRole: mx,
  getByRole: vx,
  findAllByRole: hx,
  findByRole: bx,
  queryByTestId: xx,
  queryAllByTestId: Rx,
  getByTestId: Ex,
  getAllByTestId: wx,
  findAllByTestId: Cx,
  findByTestId: _x
});
function Qf(e, r, t) {
  return r === void 0 && (r = ol), t === void 0 && (t = {}), Object.keys(r).reduce((n, a) => {
    const o = r[a];
    return n[a] = o.bind(null, e), n;
  }, t);
}
const Nd = {
  // Clipboard Events
  copy: {
    EventType: "ClipboardEvent",
    defaultInit: {
      bubbles: !0,
      cancelable: !0,
      composed: !0
    }
  },
  cut: {
    EventType: "ClipboardEvent",
    defaultInit: {
      bubbles: !0,
      cancelable: !0,
      composed: !0
    }
  },
  paste: {
    EventType: "ClipboardEvent",
    defaultInit: {
      bubbles: !0,
      cancelable: !0,
      composed: !0
    }
  },
  // Composition Events
  compositionEnd: {
    EventType: "CompositionEvent",
    defaultInit: {
      bubbles: !0,
      cancelable: !0,
      composed: !0
    }
  },
  compositionStart: {
    EventType: "CompositionEvent",
    defaultInit: {
      bubbles: !0,
      cancelable: !0,
      composed: !0
    }
  },
  compositionUpdate: {
    EventType: "CompositionEvent",
    defaultInit: {
      bubbles: !0,
      cancelable: !0,
      composed: !0
    }
  },
  // Keyboard Events
  keyDown: {
    EventType: "KeyboardEvent",
    defaultInit: {
      bubbles: !0,
      cancelable: !0,
      charCode: 0,
      composed: !0
    }
  },
  keyPress: {
    EventType: "KeyboardEvent",
    defaultInit: {
      bubbles: !0,
      cancelable: !0,
      charCode: 0,
      composed: !0
    }
  },
  keyUp: {
    EventType: "KeyboardEvent",
    defaultInit: {
      bubbles: !0,
      cancelable: !0,
      charCode: 0,
      composed: !0
    }
  },
  // Focus Events
  focus: {
    EventType: "FocusEvent",
    defaultInit: {
      bubbles: !1,
      cancelable: !1,
      composed: !0
    }
  },
  blur: {
    EventType: "FocusEvent",
    defaultInit: {
      bubbles: !1,
      cancelable: !1,
      composed: !0
    }
  },
  focusIn: {
    EventType: "FocusEvent",
    defaultInit: {
      bubbles: !0,
      cancelable: !1,
      composed: !0
    }
  },
  focusOut: {
    EventType: "FocusEvent",
    defaultInit: {
      bubbles: !0,
      cancelable: !1,
      composed: !0
    }
  },
  // Form Events
  change: {
    EventType: "Event",
    defaultInit: {
      bubbles: !0,
      cancelable: !1
    }
  },
  input: {
    EventType: "InputEvent",
    defaultInit: {
      bubbles: !0,
      cancelable: !1,
      composed: !0
    }
  },
  invalid: {
    EventType: "Event",
    defaultInit: {
      bubbles: !1,
      cancelable: !0
    }
  },
  submit: {
    EventType: "Event",
    defaultInit: {
      bubbles: !0,
      cancelable: !0
    }
  },
  reset: {
    EventType: "Event",
    defaultInit: {
      bubbles: !0,
      cancelable: !0
    }
  },
  // Mouse Events
  click: {
    EventType: "MouseEvent",
    defaultInit: {
      bubbles: !0,
      cancelable: !0,
      button: 0,
      composed: !0
    }
  },
  contextMenu: {
    EventType: "MouseEvent",
    defaultInit: {
      bubbles: !0,
      cancelable: !0,
      composed: !0
    }
  },
  dblClick: {
    EventType: "MouseEvent",
    defaultInit: {
      bubbles: !0,
      cancelable: !0,
      composed: !0
    }
  },
  drag: {
    EventType: "DragEvent",
    defaultInit: {
      bubbles: !0,
      cancelable: !0,
      composed: !0
    }
  },
  dragEnd: {
    EventType: "DragEvent",
    defaultInit: {
      bubbles: !0,
      cancelable: !1,
      composed: !0
    }
  },
  dragEnter: {
    EventType: "DragEvent",
    defaultInit: {
      bubbles: !0,
      cancelable: !0,
      composed: !0
    }
  },
  dragExit: {
    EventType: "DragEvent",
    defaultInit: {
      bubbles: !0,
      cancelable: !1,
      composed: !0
    }
  },
  dragLeave: {
    EventType: "DragEvent",
    defaultInit: {
      bubbles: !0,
      cancelable: !1,
      composed: !0
    }
  },
  dragOver: {
    EventType: "DragEvent",
    defaultInit: {
      bubbles: !0,
      cancelable: !0,
      composed: !0
    }
  },
  dragStart: {
    EventType: "DragEvent",
    defaultInit: {
      bubbles: !0,
      cancelable: !0,
      composed: !0
    }
  },
  drop: {
    EventType: "DragEvent",
    defaultInit: {
      bubbles: !0,
      cancelable: !0,
      composed: !0
    }
  },
  mouseDown: {
    EventType: "MouseEvent",
    defaultInit: {
      bubbles: !0,
      cancelable: !0,
      composed: !0
    }
  },
  mouseEnter: {
    EventType: "MouseEvent",
    defaultInit: {
      bubbles: !1,
      cancelable: !1,
      composed: !0
    }
  },
  mouseLeave: {
    EventType: "MouseEvent",
    defaultInit: {
      bubbles: !1,
      cancelable: !1,
      composed: !0
    }
  },
  mouseMove: {
    EventType: "MouseEvent",
    defaultInit: {
      bubbles: !0,
      cancelable: !0,
      composed: !0
    }
  },
  mouseOut: {
    EventType: "MouseEvent",
    defaultInit: {
      bubbles: !0,
      cancelable: !0,
      composed: !0
    }
  },
  mouseOver: {
    EventType: "MouseEvent",
    defaultInit: {
      bubbles: !0,
      cancelable: !0,
      composed: !0
    }
  },
  mouseUp: {
    EventType: "MouseEvent",
    defaultInit: {
      bubbles: !0,
      cancelable: !0,
      composed: !0
    }
  },
  // Selection Events
  select: {
    EventType: "Event",
    defaultInit: {
      bubbles: !0,
      cancelable: !1
    }
  },
  // Touch Events
  touchCancel: {
    EventType: "TouchEvent",
    defaultInit: {
      bubbles: !0,
      cancelable: !1,
      composed: !0
    }
  },
  touchEnd: {
    EventType: "TouchEvent",
    defaultInit: {
      bubbles: !0,
      cancelable: !0,
      composed: !0
    }
  },
  touchMove: {
    EventType: "TouchEvent",
    defaultInit: {
      bubbles: !0,
      cancelable: !0,
      composed: !0
    }
  },
  touchStart: {
    EventType: "TouchEvent",
    defaultInit: {
      bubbles: !0,
      cancelable: !0,
      composed: !0
    }
  },
  // UI Events
  resize: {
    EventType: "UIEvent",
    defaultInit: {
      bubbles: !1,
      cancelable: !1
    }
  },
  scroll: {
    EventType: "UIEvent",
    defaultInit: {
      bubbles: !1,
      cancelable: !1
    }
  },
  // Wheel Events
  wheel: {
    EventType: "WheelEvent",
    defaultInit: {
      bubbles: !0,
      cancelable: !0,
      composed: !0
    }
  },
  // Media Events
  abort: {
    EventType: "Event",
    defaultInit: {
      bubbles: !1,
      cancelable: !1
    }
  },
  canPlay: {
    EventType: "Event",
    defaultInit: {
      bubbles: !1,
      cancelable: !1
    }
  },
  canPlayThrough: {
    EventType: "Event",
    defaultInit: {
      bubbles: !1,
      cancelable: !1
    }
  },
  durationChange: {
    EventType: "Event",
    defaultInit: {
      bubbles: !1,
      cancelable: !1
    }
  },
  emptied: {
    EventType: "Event",
    defaultInit: {
      bubbles: !1,
      cancelable: !1
    }
  },
  encrypted: {
    EventType: "Event",
    defaultInit: {
      bubbles: !1,
      cancelable: !1
    }
  },
  ended: {
    EventType: "Event",
    defaultInit: {
      bubbles: !1,
      cancelable: !1
    }
  },
  loadedData: {
    EventType: "Event",
    defaultInit: {
      bubbles: !1,
      cancelable: !1
    }
  },
  loadedMetadata: {
    EventType: "Event",
    defaultInit: {
      bubbles: !1,
      cancelable: !1
    }
  },
  loadStart: {
    EventType: "ProgressEvent",
    defaultInit: {
      bubbles: !1,
      cancelable: !1
    }
  },
  pause: {
    EventType: "Event",
    defaultInit: {
      bubbles: !1,
      cancelable: !1
    }
  },
  play: {
    EventType: "Event",
    defaultInit: {
      bubbles: !1,
      cancelable: !1
    }
  },
  playing: {
    EventType: "Event",
    defaultInit: {
      bubbles: !1,
      cancelable: !1
    }
  },
  progress: {
    EventType: "ProgressEvent",
    defaultInit: {
      bubbles: !1,
      cancelable: !1
    }
  },
  rateChange: {
    EventType: "Event",
    defaultInit: {
      bubbles: !1,
      cancelable: !1
    }
  },
  seeked: {
    EventType: "Event",
    defaultInit: {
      bubbles: !1,
      cancelable: !1
    }
  },
  seeking: {
    EventType: "Event",
    defaultInit: {
      bubbles: !1,
      cancelable: !1
    }
  },
  stalled: {
    EventType: "Event",
    defaultInit: {
      bubbles: !1,
      cancelable: !1
    }
  },
  suspend: {
    EventType: "Event",
    defaultInit: {
      bubbles: !1,
      cancelable: !1
    }
  },
  timeUpdate: {
    EventType: "Event",
    defaultInit: {
      bubbles: !1,
      cancelable: !1
    }
  },
  volumeChange: {
    EventType: "Event",
    defaultInit: {
      bubbles: !1,
      cancelable: !1
    }
  },
  waiting: {
    EventType: "Event",
    defaultInit: {
      bubbles: !1,
      cancelable: !1
    }
  },
  // Events
  load: {
    // TODO: load events can be UIEvent or Event depending on what generated them
    // This is where this abstraction breaks down.
    // But the common targets are <img />, <script /> and window.
    // Neither of these targets receive a UIEvent
    EventType: "Event",
    defaultInit: {
      bubbles: !1,
      cancelable: !1
    }
  },
  error: {
    EventType: "Event",
    defaultInit: {
      bubbles: !1,
      cancelable: !1
    }
  },
  // Animation Events
  animationStart: {
    EventType: "AnimationEvent",
    defaultInit: {
      bubbles: !0,
      cancelable: !1
    }
  },
  animationEnd: {
    EventType: "AnimationEvent",
    defaultInit: {
      bubbles: !0,
      cancelable: !1
    }
  },
  animationIteration: {
    EventType: "AnimationEvent",
    defaultInit: {
      bubbles: !0,
      cancelable: !1
    }
  },
  // Transition Events
  transitionCancel: {
    EventType: "TransitionEvent",
    defaultInit: {
      bubbles: !0,
      cancelable: !1
    }
  },
  transitionEnd: {
    EventType: "TransitionEvent",
    defaultInit: {
      bubbles: !0,
      cancelable: !0
    }
  },
  transitionRun: {
    EventType: "TransitionEvent",
    defaultInit: {
      bubbles: !0,
      cancelable: !1
    }
  },
  transitionStart: {
    EventType: "TransitionEvent",
    defaultInit: {
      bubbles: !0,
      cancelable: !1
    }
  },
  // pointer events
  pointerOver: {
    EventType: "PointerEvent",
    defaultInit: {
      bubbles: !0,
      cancelable: !0,
      composed: !0
    }
  },
  pointerEnter: {
    EventType: "PointerEvent",
    defaultInit: {
      bubbles: !1,
      cancelable: !1
    }
  },
  pointerDown: {
    EventType: "PointerEvent",
    defaultInit: {
      bubbles: !0,
      cancelable: !0,
      composed: !0
    }
  },
  pointerMove: {
    EventType: "PointerEvent",
    defaultInit: {
      bubbles: !0,
      cancelable: !0,
      composed: !0
    }
  },
  pointerUp: {
    EventType: "PointerEvent",
    defaultInit: {
      bubbles: !0,
      cancelable: !0,
      composed: !0
    }
  },
  pointerCancel: {
    EventType: "PointerEvent",
    defaultInit: {
      bubbles: !0,
      cancelable: !1,
      composed: !0
    }
  },
  pointerOut: {
    EventType: "PointerEvent",
    defaultInit: {
      bubbles: !0,
      cancelable: !0,
      composed: !0
    }
  },
  pointerLeave: {
    EventType: "PointerEvent",
    defaultInit: {
      bubbles: !1,
      cancelable: !1
    }
  },
  gotPointerCapture: {
    EventType: "PointerEvent",
    defaultInit: {
      bubbles: !0,
      cancelable: !1,
      composed: !0
    }
  },
  lostPointerCapture: {
    EventType: "PointerEvent",
    defaultInit: {
      bubbles: !0,
      cancelable: !1,
      composed: !0
    }
  },
  // history events
  popState: {
    EventType: "PopStateEvent",
    defaultInit: {
      bubbles: !0,
      cancelable: !1
    }
  },
  // window events
  offline: {
    EventType: "Event",
    defaultInit: {
      bubbles: !1,
      cancelable: !1
    }
  },
  online: {
    EventType: "Event",
    defaultInit: {
      bubbles: !1,
      cancelable: !1
    }
  },
  pageHide: {
    EventType: "PageTransitionEvent",
    defaultInit: {
      bubbles: !0,
      cancelable: !0
    }
  },
  pageShow: {
    EventType: "PageTransitionEvent",
    defaultInit: {
      bubbles: !0,
      cancelable: !0
    }
  }
}, Ld = {
  doubleClick: "dblClick"
};
function Mo(e, r) {
  return Ie().eventWrapper(() => {
    if (!r)
      throw new Error("Unable to fire an event - please provide an event object.");
    if (!e)
      throw new Error('Unable to fire a "' + r.type + '" event - please provide a DOM element.');
    return e.dispatchEvent(r);
  });
}
function Fi(e, r, t, n) {
  let {
    EventType: a = "Event",
    defaultInit: o = {}
  } = n === void 0 ? {} : n;
  if (!r)
    throw new Error('Unable to fire a "' + e + '" event - please provide a DOM element.');
  const l = {
    ...o,
    ...t
  }, {
    target: {
      value: f,
      files: i,
      ...s
    } = {}
  } = l;
  f !== void 0 && Px(r, f), i !== void 0 && Object.defineProperty(r, "files", {
    configurable: !0,
    enumerable: !0,
    writable: !0,
    value: i
  }), Object.assign(r, s);
  const c = Ff(r), d = c[a] || c.Event;
  let u;
  if (typeof d == "function")
    u = new d(e, l);
  else {
    u = c.document.createEvent(a);
    const {
      bubbles: v,
      cancelable: h,
      detail: g,
      ...p
    } = l;
    u.initEvent(e, v, h, g), Object.keys(p).forEach((x) => {
      u[x] = p[x];
    });
  }
  return ["dataTransfer", "clipboardData"].forEach((v) => {
    const h = l[v];
    typeof h == "object" && (typeof c.DataTransfer == "function" ? Object.defineProperty(u, v, {
      value: Object.getOwnPropertyNames(h).reduce((g, p) => (Object.defineProperty(g, p, {
        value: h[p]
      }), g), new c.DataTransfer())
    }) : Object.defineProperty(u, v, {
      value: h
    }));
  }), u;
}
Object.keys(Nd).forEach((e) => {
  const {
    EventType: r,
    defaultInit: t
  } = Nd[e], n = e.toLowerCase();
  Fi[e] = (a, o) => Fi(n, a, o, {
    EventType: r,
    defaultInit: t
  }), Mo[e] = (a, o) => Mo(a, Fi[e](a, o));
});
function Px(e, r) {
  const {
    set: t
  } = Object.getOwnPropertyDescriptor(e, "value") || {}, n = Object.getPrototypeOf(e), {
    set: a
  } = Object.getOwnPropertyDescriptor(n, "value") || {};
  if (a && t !== a)
    a.call(e, r);
  else if (t)
    t.call(e, r);
  else
    throw new Error("The given element does not have a value setter");
}
Object.keys(Ld).forEach((e) => {
  const r = Ld[e];
  Mo[e] = function() {
    return Mo[r](...arguments);
  };
});
function Tx(e) {
  return e.replace(/[ \t]*[\n][ \t]*/g, `
`);
}
function Sx(e) {
  return wR.compressToEncodedURIComponent(Tx(e));
}
function qx(e) {
  return "https://testing-playground.com/#markup=" + Sx(e);
}
const Ox = (e, r, t) => Array.isArray(e) ? e.forEach((n) => Dd(n, r, t)) : Dd(e, r, t), Ax = function(e) {
  if (e === void 0 && (e = _l().body), !e || !("innerHTML" in e)) {
    console.log("The element you're providing isn't a valid DOM element.");
    return;
  }
  if (!e.innerHTML) {
    console.log("The provided element doesn't have any children.");
    return;
  }
  const r = qx(e.innerHTML);
  return console.log(`Open this URL in your browser

` + r), r;
}, $d = {
  debug: Ox,
  logTestingPlaygroundURL: Ax
};
typeof document < "u" && document.body ? Qf(document.body, ol, $d) : Object.keys(ol).reduce((e, r) => (e[r] = () => {
  throw new TypeError("For queries bound to document.body a global document has to be available... Learn more: https://testing-library.com/s/screen-global-error");
}, e), $d);
const Mx = typeof br.act == "function" ? br.act : Sh.act;
function ep() {
  if (typeof globalThis < "u")
    return globalThis;
  if (typeof self < "u")
    return self;
  if (typeof window < "u")
    return window;
  if (typeof global < "u")
    return global;
  throw new Error("unable to locate global object");
}
function $r(e) {
  ep().IS_REACT_ACT_ENVIRONMENT = e;
}
function hi() {
  return ep().IS_REACT_ACT_ENVIRONMENT;
}
function kx(e) {
  return (r) => {
    const t = hi();
    $r(!0);
    try {
      let n = !1;
      const a = e(() => {
        const o = r();
        return o !== null && typeof o == "object" && typeof o.then == "function" && (n = !0), o;
      });
      if (n) {
        const o = a;
        return {
          then: (l, f) => {
            o.then((i) => {
              $r(t), l(i);
            }, (i) => {
              $r(t), f(i);
            });
          }
        };
      } else
        return $r(t), a;
    } catch (n) {
      throw $r(t), n;
    }
  };
}
const Ct = kx(Mx);
Object.keys(Mo).forEach((e) => {
});
let Dx = {
  reactStrictMode: !1
};
function jx() {
  return {
    ...Ie(),
    ...Dx
  };
}
function Ix() {
  return typeof jest < "u" && jest !== null ? (
    // legacy timers
    setTimeout._isMockFunction === !0 || // modern timers
    // eslint-disable-next-line prefer-object-has-own -- No Object.hasOwn in all target environments we support.
    Object.prototype.hasOwnProperty.call(setTimeout, "clock")
  ) : !1;
}
UR({
  unstable_advanceTimersWrapper: (e) => Ct(e),
  // We just want to run `waitFor` without IS_REACT_ACT_ENVIRONMENT
  // But that's not necessarily how `asyncWrapper` is used since it's a public method.
  // Let's just hope nobody else is using it.
  asyncWrapper: async (e) => {
    const r = hi();
    $r(!1);
    try {
      const t = await e();
      return await new Promise((n) => {
        setTimeout(() => {
          n();
        }, 0), Ix() && jest.advanceTimersByTime(0);
      }), t;
    } finally {
      $r(r);
    }
  },
  eventWrapper: (e) => {
    let r;
    return Ct(() => {
      r = e();
    }), r;
  }
});
const il = /* @__PURE__ */ new Set(), bi = [];
function ll(e) {
  return jx().reactStrictMode ? /* @__PURE__ */ br.createElement(br.StrictMode, null, e) : e;
}
function sl(e, r) {
  return r ? /* @__PURE__ */ br.createElement(r, null, e) : e;
}
function Nx(e, r) {
  let {
    hydrate: t,
    ui: n,
    wrapper: a
  } = r, o;
  return t ? Ct(() => {
    o = Cs.hydrateRoot(e, ll(sl(n, a)));
  }) : o = Cs.createRoot(e), {
    hydrate() {
      if (!t)
        throw new Error("Attempted to hydrate a non-hydrateable root. This is a bug in `@testing-library/react`.");
    },
    render(l) {
      o.render(l);
    },
    unmount() {
      o.unmount();
    }
  };
}
function Lx(e) {
  return {
    hydrate(r) {
      Br.hydrate(r, e);
    },
    render(r) {
      Br.render(r, e);
    },
    unmount() {
      Br.unmountComponentAtNode(e);
    }
  };
}
function rp(e, r) {
  let {
    baseElement: t,
    container: n,
    hydrate: a,
    queries: o,
    root: l,
    wrapper: f
  } = r;
  return Ct(() => {
    a ? l.hydrate(ll(sl(e, f)), n) : l.render(ll(sl(e, f)), n);
  }), {
    container: n,
    baseElement: t,
    debug: function(i, s, c) {
      return i === void 0 && (i = t), Array.isArray(i) ? (
        // eslint-disable-next-line no-console
        i.forEach((d) => console.log(Et(d, s, c)))
      ) : (
        // eslint-disable-next-line no-console,
        console.log(Et(i, s, c))
      );
    },
    unmount: () => {
      Ct(() => {
        l.unmount();
      });
    },
    rerender: (i) => {
      rp(i, {
        container: n,
        baseElement: t,
        root: l,
        wrapper: f
      });
    },
    asFragment: () => {
      if (typeof document.createRange == "function")
        return document.createRange().createContextualFragment(n.innerHTML);
      {
        const i = document.createElement("template");
        return i.innerHTML = n.innerHTML, i.content;
      }
    },
    ...Qf(t, o)
  };
}
function tp(e, r) {
  let {
    container: t,
    baseElement: n = t,
    legacyRoot: a = !1,
    queries: o,
    hydrate: l = !1,
    wrapper: f
  } = r === void 0 ? {} : r;
  if (a && typeof Br.render != "function") {
    const s = new Error("`legacyRoot: true` is not supported in this version of React. If your app runs React 19 or later, you should remove this flag. If your app runs React 18 or earlier, visit https://react.dev/blog/2022/03/08/react-18-upgrade-guide for upgrade instructions.");
    throw Error.captureStackTrace(s, tp), s;
  }
  n || (n = document.body), t || (t = n.appendChild(document.createElement("div")));
  let i;
  return il.has(t) ? bi.forEach((s) => {
    s.container === t && (i = s.root);
  }) : (i = (a ? Lx : Nx)(t, {
    hydrate: l,
    ui: e,
    wrapper: f
  }), bi.push({
    container: t,
    root: i
  }), il.add(t)), rp(e, {
    container: t,
    baseElement: n,
    queries: o,
    hydrate: l,
    wrapper: f,
    root: i
  });
}
function Fd() {
  bi.forEach((e) => {
    let {
      root: r,
      container: t
    } = e;
    Ct(() => {
      r.unmount();
    }), t.parentNode === document.body && document.body.removeChild(t);
  }), bi.length = 0, il.clear();
}
var Yd;
if ((typeof process > "u" || !((Yd = process.env) != null && Yd.RTL_SKIP_AUTO_CLEANUP)) && (typeof afterEach == "function" ? afterEach(() => {
  Fd();
}) : typeof teardown == "function" && teardown(() => {
  Fd();
}), typeof beforeAll == "function" && typeof afterAll == "function")) {
  let e = hi();
  beforeAll(() => {
    e = hi(), $r(!0);
  }), afterAll(() => {
    $r(e);
  });
}
const $x = lm`
    * {
        box-sizing: border-box;
        font-family: 'Poppins', sans-serif !important;

        //Fonts
        --font-weight: 500;
        --font-size-body-1: 14px;
        --font-size-body-2: 13px;
        --font-size-body-3: 12px;
        --font-size-body-4: 10px;
        --font-size-body: var(--font-size-body-1);

        //Border
        --border-radius: 40px;
        --input-border-radius-default: 25px;
        --input-border-radius-list: 10px;
        --image-border-radius: 6px;
        --box-border-radius: 10px;

        // z-index
        --z-index-options-menu: 100;
        --z-index-nav-badge: 2;

        .light {
            //Colors
            --color-primary: #030D45;
            --color-primary-70: #030D45B3;
            --color-alt: #0255AA;
            --color-alt-hover: #1a65b2;
            --color-alt-second: #F2F5F9;
            --color-alt-second-10: #a7acaf;
            --color-white: #FFFFFF;
            --color-error: #BA000B;
            --color-warning: #ED811D;
            --color-success: #0BAC25;
            --color-background: #D9D9D9;
            --color-scroll: #E0E0E0;
            --color-last-message: #E1E5EC;

            //backgrounds
            --color-success-background: #e8f5e8;
            --color-error-background: #ffeaea;
            --color-info-background: #e3f2fd;

            //Other
            --checkbox-color: var(--color-primary);
            --checkbox-background-color: var(--color-white);
            --radio-color: var(--color-primary);
            --radio-background-color: var(--color-white);
            --active-message-color: var(--color-alt);

            background-color: var(--color-alt-second);
        }

        .dark {
            //Colors
            --color-primary: #F2F5F9;
            --color-primary-70: #F2F5F9B3;
            --color-alt: #0255AA;
            --color-alt-hover: #2B2933;
            --color-alt-second: #0F0F0F;
            --color-alt-second-10: #a7acaf;
            --color-white: #201F26;
            --color-error: #BA000B;
            --color-warning: #C36C1B;
            --color-success: #0B8E21;
            --color-background: #D9D9D9;
            --color-scroll: #1A1A1A;
            --color-last-message: #E1E5EC;

            //Other
            --checkbox-color: var(--color-primary);
            --checkbox-background-color: var(--color-white);
            --radio-color: var(--color-primary);
            --radio-background-color: var(--color-white);

            background-color: var(--color-alt-second);

            #offer-list .icon:not(.icon-in-button),
            .offers-list .icon:not(.icon-in-button),
            .header-input-container .on-dark-theme,
            .dark-mode-icons .icon:not(.icon-in-button),
            #filters .icon:not(.icon-in-button) {
                filter: invert(100%) sepia(100%) saturate(0%) hue-rotate(79deg) brightness(105%) contrast(102%);
            }
        }

        scrollbar-width: thin;
    }

    *::-webkit-scrollbar {
        width: 4px;
    }

    *::-webkit-scrollbar-track {
        background: var(--color-white)
    }

    *::-webkit-scrollbar-thumb {
        background-color: var(--color-scroll);
        border-radius: 2px;
        border: 3px solid var(--color-background);
    }

    html {
        font-size: 16px;
        min-height: 100%;
        overflow-x: hidden;
    }


    h1 {
        margin: 0;
        font-size: 18px;
        font-weight: var(--font-weight);
        color: var(--color-primary);

        @media (min-width: 961px) {
            font-size: 20px;
        }
    }

    h2 {
        margin: 0;
        font-size: 16px;
        font-weight: var(--font-weight);
        color: var(--color-primary);
    }

    p, span, div, input, li {
        margin: 0;
        font-weight: var(--font-weight);
        font-size: var(--font-size-body);
        color: var(--color-primary);
    }

    button {
        background-color: var(--color-alt-second);
        color: var(--color-primary);
    }

    button:active,
    button:hover {
        background-color: var(--color-alt);
        color: #fff;
    }

    input[type="checkbox"] {
        -webkit-appearance: none;
        appearance: none;
        background-color: var(--checkbox-background-color);
        margin: 0;
        font: inherit;
        color: currentColor;
        width: 20px;
        height: 20px;
        border: 2px solid var(--checkbox-color);
        border-radius: 2px;
        display: grid;
        place-content: center;
    }

    input[type="checkbox"]:checked::before {
        content: "";
        width: 3px;
        height: 6px;
        transition: 120ms transform ease-in-out;
        border: solid var(--checkbox-color);
        border-width: 0 2px 2px 0;
        transform: rotate(45deg);
        margin-bottom: 2px;
    }

    input[type="radio"] {
        appearance: none;
        background-color: var(--radio-background-color);
        margin: 0;
        font: inherit;
        color: currentColor;
        width: 20px;
        height: 20px;
        border: 2px solid var(--radio-color);
        border-radius: 50%;
        transform: translateY(-0.075em);
        display: grid;
        place-content: center;
    }

    input[type="radio"]:checked::before {
        content: "";
        width: 5px;
        height: 8px;
        transition: 120ms transform ease-in-out;
        border: solid var(--checkbox-color);
        border-width: 0 2px 2px 0;
        transform: rotate(45deg);
    }

    body {
        margin: 0;
        padding: 0;
        height: 100%;
        scroll-behavior: smooth;
        overflow-y: scroll;
        scrollbar-width: thin;
        -webkit-overflow-scrolling: touch;

        .dark {
            background-color: #0F0F0F;
        }
    }

    ul {
        list-style: none;
        margin: 0;
        padding: 0;
    }
`, Ww = (e) => tp(
  /* @__PURE__ */ T.jsxs(T.Fragment, { children: [
    /* @__PURE__ */ T.jsx($x, {}),
    e
  ] })
), Bd = (e) => `
    transition: background-color ease-in .2s;
    background-color: var(--color-alt);
    cursor: pointer;

    img {
        filter: ${e ? "unset" : "invert(100%) sepia(100%) saturate(0%) hue-rotate(79deg) brightness(105%) contrast(102%)"};
    }

    & .user-photo-icon-img {
        filter: none;
    }
`, Fx = Q.div`
    position: relative;
    background-color: var(--color-alt-second);
    border-radius: 50%;
    min-width: 40px;
    height: 40px;
    display: grid;

    &.disabled {
        opacity: 0.5;
        pointer-events: none;
        cursor: not-allowed;
    }

    &.active {
        ${(e) => Bd(e.darkMode)}
    }

    &.hover {
        &:hover {
            ${(e) => Bd(e.darkMode)}
        }
     }

    &.is-blocked {
        pointer-events: none;
    }

    &.is-link.no-text {
        span {
            margin-right: 0;
        }

        a {
            position: absolute;
            left: 0;
            width: 100%;
            height: 100%;
        }
    }

    &.is-link {
        display: flex;
        align-items: center;
        padding: 10px;
        border-radius: 20px;
        color: var(--color-primary);

        a {
            color: var(--color-primary);
            text-decoration: none;

            &:hover {
                color: white;
            }
        }

        &:hover a {
            color: white;
        }

        span {
            margin-right: 10px;
        }

        & .user-photo-icon-img {
            margin-right: 10px;
        }
    }

    span {
        align-self: center;
        justify-self: center;
    }

    &.message {
        display: flex;
        width: fit-content;
        margin-left: auto;
        margin-bottom: 15px;
        align-items: center;
        padding: 10px;
        border-radius: 20px;
        color: var(--color-primary);
        gap: 10px;
        @media (max-width: 990px) {
            margin-left: 0;
        }
    }

    @media (min-width: 990px) {
        &.modal-message {
            position: absolute;
            top: 210px;
            left: 25px;
        }

        &.modal-phone {
            position: absolute;
            top: 195px;
            left: -80px;

            &:hover {
                p {
                    color: var(--color-white);
                }

            }
        }

        &.is-photo {
            position: absolute;
            padding: 10px;
            top: 270px;
            right: -50px;
        }

        &.is-my-offer {
            :hover {
                transition: none;
                background-color: var(--color-alt-second);
                cursor: unset;

                p {
                    color: var(--color-primary);
                }

                img {
                    filter: unset;
                }
            }
        }

        &.is-user-name {
            position: absolute;
            top: 140px;
            left: -270px;
            display: flex;
            align-items: center;
            padding: 10px;
            border-radius: 20px;
            color: var(--color-primary);

            @media (max-width: 990px) {
                top: 215px;
            }
        }
    }

    &:hover {
        p {
            color: white;
        }
    }
`, Bx = Q.span`
    --font-weight: 700;
    --font-size-body: var(--font-size-body-4);
    position: absolute;
    top: -5px;
    right: -5px;
    background: var(--color-primary);
    color: var(--color-white);
    border-radius: 50%;
    width: 16px;
    height: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
`, Qo = ({
  counter: e,
  isLink: r,
  isMessageBtn: t,
  isPhoneBtn: n,
  isPhotoBtn: a,
  isUserNameBtn: o,
  active: l,
  disabled: f,
  icon: i,
  text: s,
  onClick: c,
  noText: d,
  bottomTooltip: u,
  tooltipText: m,
  isModalOpen: v,
  isMyOffer: h,
  userPhoto: g,
  isDarkMode: p
}) => {
  const [x, w] = Se(!1), [C, y] = Se(null), [b, R] = Se(!1), [E, M] = Se(!1);
  Pr(() => {
    R(vt());
  }, []);
  const I = ($) => {
    $.stopPropagation(), !E && (c == null || c($), M(!0), setTimeout(() => M(!1), 400));
  };
  return /* @__PURE__ */ T.jsxs(T.Fragment, { children: [
    /* @__PURE__ */ T.jsxs(
      Fx,
      {
        ref: y,
        darkMode: p,
        onMouseEnter: () => w(!0),
        onMouseLeave: () => w(!1),
        onClick: I,
        className: dr({
          disabled: f,
          active: l,
          "is-link": r,
          "is-my-offer": h,
          message: t,
          "modal-phone": v && n,
          "modal-message": v && t,
          "is-photo": v && a,
          "is-user-name": v && o,
          "no-text": d,
          "show-triangle": m && m.length > 0,
          hover: !b,
          "is-blocked": E
        }),
        children: [
          e && /* @__PURE__ */ T.jsx(Bx, { children: e }),
          i && !g && /* @__PURE__ */ T.jsx(Ve, { icon: i }),
          o && g && /* @__PURE__ */ T.jsx(ql, { img: g }),
          s
        ]
      }
    ),
    /* @__PURE__ */ T.jsx(ip, { referenceElement: C, showTooltip: x, text: m, bottomTooltip: u, isDarkMode: p })
  ] });
}, Hx = Q.div`
    display: flex;
    width: 100%;
    align-self: center;
    flex-wrap: wrap;
    gap: 10px;
    position: relative;

    @media (min-width: 991px) {
        justify-content: flex-end;
    }

    &.notInteractive {
        justify-content: space-between;
        flex-wrap: nowrap;
    }

    .interactive-phone {
        display: flex;
        align-items: center;
        padding: 10px;
        border-radius: 20px;
        color: var(--color-primary);

        a {
            color: var(--color-primary);

            &:hover {
                color: white;
            }
        }

        span {
            margin-right: 10px;
        }
    }
`, Hd = Q.div`
    width: fit-content;
    ${(e) => e.isModalOpen ? "margin-top: 220px; margin-left: -150px;" : "margin-left: auto;"};

    @media (max-width: 991px) {
        display: none;
    }
`, np = ({
  className: e,
  isModalOpen: r,
  userDetails: t,
  isNotInteractive: n,
  notInteractiveElements: a,
  interactiveElements: o,
  showMessages: l,
  setShowMessages: f,
  openOfferTab: i,
  isDarkMode: s
}) => {
  const c = _t(null), [d, u] = Se(null), [m, v] = Se(!1), h = si(() => o, [o]), g = (w) => {
    w.stopPropagation(), w.preventDefault(), f && f(!l);
  }, p = () => {
    v(!m);
  }, x = (w, C) => {
    C.sliderElements ? p() : C.openTabOnClick ? i && i(C.openTabOnClick) : C.onClick && C.onClick(w);
  };
  return /* @__PURE__ */ T.jsxs(T.Fragment, { children: [
    l && t && t.userName && !r && /* @__PURE__ */ T.jsx(
      ys,
      {
        username: t.userName,
        referenceElement: d,
        onClose: g,
        title: t.title,
        photo: t.offerPhoto,
        userPhoto: t.userPhoto,
        price: t.price,
        onSendMessage: t.handleSendMessages,
        messages: t.userMessages,
        messageOwnerType: Xi.INTERESTED,
        isPopup: !0
      }
    ),
    t && t.showMessageButton && !r && /* @__PURE__ */ T.jsx(Hd, { isModalOpen: r, ref: u, children: /* @__PURE__ */ T.jsx(
      Qo,
      {
        icon: Ye.EMAIL,
        isModalOpen: r,
        isMessageBtn: !0,
        onClick: g,
        text: /* @__PURE__ */ T.jsx("p", { children: "Wyślij wiadomość" })
      }
    ) }),
    /* @__PURE__ */ T.jsxs(Hx, { ref: c, "data-testid": "interactive-icons-wrapper", className: dr(e, { notInteractive: n }), children: [
      a && a.length > 0 ? /* @__PURE__ */ T.jsx(Rh, { notInteractiveElements: a }) : null,
      h && h.map((w, C) => /* @__PURE__ */ T.jsxs(Je.Fragment, { children: [
        w.visibleDuringModal ? r ? /* @__PURE__ */ T.jsx(Qo, { ...w, onClick: (y) => x(y, w) }, C) : null : /* @__PURE__ */ T.jsx(Qo, { ...w, onClick: (y) => x(y, w), bottomTooltip: r }, C),
        w.additionalJSXSibling ? w.additionalJSXSibling : null,
        w.sliderElements && m ? /* @__PURE__ */ T.jsx(
          op,
          {
            isDarkMode: s,
            images: w.sliderElements.photos,
            title: w.sliderElements.title,
            modalOpen: !0,
            modalMode: !0,
            toggleIsModalSlider: p
          }
        ) : null
      ] }, C))
    ] }),
    l && t && t.userName && r && /* @__PURE__ */ T.jsx(
      ys,
      {
        username: t.userName,
        referenceElement: d,
        onClose: g,
        title: t.title,
        photo: t.offerPhoto,
        userPhoto: t.userPhoto,
        price: t.price,
        onSendMessage: t.handleSendMessages,
        messages: t.userMessages,
        messageOwnerType: Xi.INTERESTED,
        isPopup: !0
      }
    ),
    t && t.showMessageButton && r ? /* @__PURE__ */ T.jsx(Hd, { isModalOpen: r, ref: u, children: /* @__PURE__ */ T.jsx(
      Qo,
      {
        icon: Ye.EMAIL,
        isModalOpen: r,
        isMessageBtn: !0,
        onClick: g,
        text: /* @__PURE__ */ T.jsx("p", { children: "Wyślij wiadomość" })
      }
    ) }) : null
  ] });
}, ot = Q.div`
    padding: 30px;
    background-color: var(--color-white);
    border-radius: var(--box-border-radius);
    position: relative;
    margin-bottom: 15px;
    grid-column-end: span 2;
    ${({ isTwoColumns: e }) => e && "display: flex; flex-direction: column; justify-content: space-between;"}

    & {
        @media (min-width: 790px) {
            ${({ isTwoColumns: e }) => e && "flex-direction: row;"}
        }
    }


    &.users-media {
        padding: 10px 0;
    }

    &.swipeable {
        @media (max-width: 1100px) {
            padding: 30px 0;
        }
    }

    & > h1 {
        padding: 10px 15px;
    }
`, ei = Q.h1`
    overflow: hidden;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 3;
    line-break: anywhere;
`, Ux = Q.div`
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: ${(e) => e.darkMode ? `rgba(7, 7, 7, ${e.fullOpacity ? "1" : "0.9"})` : `rgba(242, 245, 249, ${e.fullOpacity ? "1" : "0.9"})`};
`, Wx = Q.div`
    z-index: 100;
    position: fixed;
    top: 0;
    left: 0;
    display: flex;
    width: 100%;
    height: ${(e) => e.centeredContent ? "100%" : "auto"};
    ${(e) => e.centeredContent ? "justify-content: center" : null};
    ${(e) => e.strictContentHeight ? "align-items: center" : null};
`, zx = Q.div`
    position: relative;
    width: 100%;
    max-width: 1000px;
    max-height: 95vh;
    border-radius: var(--box-border-radius);
    display: flex;
    flex-direction: column;
    overflow: ${(e) => e.overflowing ? "unset" : "hidden"};
    margin-top: 20px;
    z-index: 1;
    ${(e) => e.strictContentHeight ? "height: min-content" : null};
`, Yx = Q.div`
    position: absolute;
    right: 15px;
    top: 15px;
    background: ${(e) => e.isDarkMode ? "var(--color-primary)" : "var(--color-white)"};
    border-radius: 50%;
    box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
    padding: 10px;
    transition: transform 0.2s ease-in-out;
    cursor: pointer;

    &:hover {
        transition: transform 0.2s ease-in-out;
        transform: rotateZ(90deg) scale(1.1);
    }

    z-index: 2;
`, Vx = Q.div`
    position: relative;
    width: 100%;
    height: ${(e) => e.centeredContent ? "100%" : "auto"};
    ${(e) => e.centeredContent ? null : "overflow-y: scroll"};
    ${(e) => e.centeredContent ? "display: flex" : null};
    ${(e) => e.centeredContent ? "flex-direction: column" : null};
    ${(e) => e.centeredContent ? "justify-content: center" : null};
    background-color: ${(e) => e.backgroundColor ? e.backgroundColor : "var(--color-alt-second)"};
`, Gx = ({ isOpen: e, onClose: r, children: t, centeredContent: n, fullOpacity: a, strictContentHeight: o, backgroundColor: l, overflowing: f, isDarkMode: i, withoutCloseButton: s }) => {
  const [c, d] = Se(e);
  if (Pr(() => {
    d(e);
  }, [e]), !c)
    return null;
  const u = /* @__PURE__ */ T.jsxs(Wx, { "data-notclickable": !0, centeredContent: n, strictContentHeight: o, children: [
    /* @__PURE__ */ T.jsx(Ux, { fullOpacity: a, darkMode: i, onClick: a ? void 0 : r }),
    /* @__PURE__ */ T.jsxs(zx, { overflowing: f, strictContentHeight: o, children: [
      !s && /* @__PURE__ */ T.jsx(Yx, { isDarkMode: i, onClick: r, children: /* @__PURE__ */ T.jsx(Ve, { icon: Ye.CROSS }) }),
      /* @__PURE__ */ T.jsx(Vx, { centeredContent: n, backgroundColor: l, children: t })
    ] })
  ] });
  return Br.createPortal(
    u,
    document.body
  );
}, Xx = Q.div`
    position: fixed;
    width: 100vw;
    height: 100vh;

    top: 0;
    left: 0;

    z-index: 101;

    display: flex;
    align-items: flex-start;
    text-align: center;
    justify-content: center;

    h1 {
        line-height: 30px;
        margin: 0 0 4px 0;

    }

    h2 {
        font-size: var(--font-size-body-1);
        margin: 0 0 10px 0;

    }

    p {
        font-size: var(--font-size-body-1);
        font-weight: 400;
        margin: 0 0 20px 0;
    }
`, Kx = Q.div`
    position: absolute;
    width: 100%;
    height: 100%;
    background: ${(e) => e.darkMode ? "rgba(7, 7, 7, 0.7)" : "rgba(242, 245, 249, 0.7)"};
`, Jx = Q.div`
    position: relative;
    width: 100%;
    height: auto;
    max-width: 600px;
    max-height: 95vh;
    border-radius: var(--box-border-radius);
    display: flex;
    flex-direction: column;
    overflow: hidden;
    margin: auto;
    z-index: 101;
    box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0.04);
`, Zx = Q.div`
    position: relative;
    width: 100%;
    height: auto;
    padding: 40px 70px;
    overflow-y: scroll;
    background-color: var(--color-white);
    border-radius: 10px;
`, Qx = Q.div`
  position: absolute;
  width: 40px;
  height: 40px;
  right: 15px;
  top: 15px;
  padding: 10px;
  transition: transform 0.2s ease-in-out;
  cursor: pointer;
    
  &:hover {
    transition: transform 0.2s ease-in-out;
    transform: rotateZ(90deg) scale(1.1);
  }

  z-index: 102;
`, ew = Q.div`
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 20px;
    margin-top: 20px;
`, Ud = Q.button`
    color: var(--color-primary);
    font-weight: normal;
    background: var(--color-alt-second);
    border-radius: 20px;
    width: 160px;
    height: 40px;
    padding: 10px 60px;
    border: none;
    outline: none;
    cursor: pointer;
    font-size: 14px;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;

    &:hover {
        color: var(--color-primary);
        background: var(--color-alt-second);
    }

    &.delete {
        background: var(--color-error);
        color: var(--color-white);
    }
`, rw = Q.div`
    padding: 4px;
    border: 1px solid transparent;
    border-radius: 50%;
    min-width: 40px;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 8px;
    cursor: pointer;

    span {
        margin-right: 0;
    }
  
  &.iconText {
    border-radius: 20px;
  }
`, tw = ({
  onChange: e,
  filter: r,
  title: t,
  description: n,
  iconText: a,
  isDarkMode: o
}) => {
  const [l, f] = Se(!1), i = (d) => {
    d.stopPropagation(), f((u) => !u);
  }, s = (d) => {
    d.stopPropagation(), i(d);
  }, c = (d) => {
    i(d), e();
  };
  return /* @__PURE__ */ T.jsxs(T.Fragment, { children: [
    /* @__PURE__ */ T.jsxs(rw, { className: dr({ iconText: "iconText" }), onClick: (d) => s(d), children: [
      /* @__PURE__ */ T.jsx(Ve, { icon: Ye.DELETE }),
      a && /* @__PURE__ */ T.jsx("p", { children: a })
    ] }),
    l && Br.createPortal(
      /* @__PURE__ */ T.jsxs(Xx, { children: [
        /* @__PURE__ */ T.jsx(Kx, { darkMode: o, onClick: (d) => i(d) }),
        /* @__PURE__ */ T.jsxs(Jx, { children: [
          /* @__PURE__ */ T.jsx(Qx, { onClick: (d) => i(d), children: /* @__PURE__ */ T.jsx(Ve, { icon: Ye.CROSS }) }),
          /* @__PURE__ */ T.jsxs(Zx, { children: [
            /* @__PURE__ */ T.jsx("h1", { children: t }),
            /* @__PURE__ */ T.jsx("h2", { children: r }),
            /* @__PURE__ */ T.jsx("p", { children: n }),
            /* @__PURE__ */ T.jsxs(ew, { children: [
              /* @__PURE__ */ T.jsx(Ud, { onClick: (d) => i(d), children: "Anuluj" }),
              /* @__PURE__ */ T.jsx(Ud, { className: "delete", onClick: (d) => c(d), children: "Usuń" })
            ] })
          ] })
        ] })
      ] }),
      document.body
    )
  ] });
};
Q.div`
    display: flex;
    gap: 2px;
    
    .icon {
        width: min-content;
    }
`;
const nw = ({ slideIndex: e, currentIndex: r }) => /* @__PURE__ */ T.jsxs("svg", { width: "20", height: "20", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
  /* @__PURE__ */ T.jsx("g", { filter: "url(#filter0_d_602_13126)", children: /* @__PURE__ */ T.jsx(
    "circle",
    {
      cx: "10",
      cy: "10",
      r: e === r ? "5" : "4",
      stroke: "white",
      fill: e === r ? "white" : "none",
      strokeWidth: "2",
      shapeRendering: "geometricPrecision"
    }
  ) }),
  /* @__PURE__ */ T.jsx("defs", { children: /* @__PURE__ */ T.jsxs(
    "filter",
    {
      id: "filter0_d_602_13126",
      x: "0",
      y: "0",
      width: "20",
      height: "20",
      filterUnits: "userSpaceOnUse",
      colorInterpolationFilters: "sRGB",
      children: [
        /* @__PURE__ */ T.jsx("feFlood", { floodOpacity: "0", result: "BackgroundImageFix" }),
        /* @__PURE__ */ T.jsx(
          "feColorMatrix",
          {
            in: "SourceAlpha",
            type: "matrix",
            values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
            result: "hardAlpha"
          }
        ),
        /* @__PURE__ */ T.jsx("feOffset", {}),
        /* @__PURE__ */ T.jsx("feGaussianBlur", { stdDeviation: "2.5" }),
        /* @__PURE__ */ T.jsx("feComposite", { in2: "hardAlpha", operator: "out" }),
        /* @__PURE__ */ T.jsx("feColorMatrix", { type: "matrix", values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0" }),
        /* @__PURE__ */ T.jsx(
          "feBlend",
          {
            mode: "normal",
            in2: "BackgroundImageFix",
            result: "effect1_dropShadow_602_13126"
          }
        ),
        /* @__PURE__ */ T.jsx(
          "feBlend",
          {
            mode: "normal",
            in: "SourceGraphic",
            in2: "effect1_dropShadow_602_13126",
            result: "shape"
          }
        )
      ]
    }
  ) })
] }), aw = /iPad|iPhone|iPod/.test(navigator.userAgent), ap = /Mac/.test(navigator.userAgent), Kr = aw || ap, ow = Q.div`
    width: 100%;
    height: 100%;
    overflow: hidden;
    position: relative;
    cursor: ${(e) => e.isBiggerSlider ? "default" : "pointer"};
    ${(e) => e.isBiggerSlider ? `
        max-width: 1200px;
        max-height: calc(100vh - 200px);
    ` : ""}

    @media (max-width: 990px) {
        max-width: 100%;
        height: 240px;
    }
`, iw = Q.img`
    object-fit: cover;
    width: 100%;
    height: 100%;
    ${(e) => e.isBiggerSlider ? "max-width: 1200px" : null};
    ${(e) => e.isBiggerSlider ? "max-height: calc(100vh - 200px)" : null};
    ${(e) => e.isBiggerSlider ? "justify-self: center" : null};
    ${(e) => e.isBiggerSlider ? "border-radius: 10px" : null};
    ${(e) => {
  const r = e.scale || 1, t = e.translateX || 0, n = e.translateY || 0;
  return r > 1 ? `transform: scale(${r}) translate(${t}px, ${n}px)` : null;
}};
    ${(e) => e.scale && e.scale > 1 ? "transition: transform 0.1s ease-out" : null};
    transform-origin: center center;
    cursor: ${(e) => e.scale && e.scale > 1 ? "grab" : e.isBiggerSlider ? "default" : "pointer"};

    &:active {
        cursor: ${(e) => e.scale && e.scale > 1 ? "grabbing" : e.isBiggerSlider ? "default" : "pointer"};
    }

    @media (max-width: 990px) {
        object-fit: cover;
        height: 240px;
        width: 100%;
    }
`, lw = Q.img`
    width: 100%;
    height: 100%;
    max-width: 160px;
    max-height: 80px;
    border-radius: 6px;
    ${(e) => e.active ? null : "opacity: .5"};
    object-fit: cover;
`, Bi = Q.div`
    background: white;
    width: 30px;
    height: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    cursor: pointer;
    margin: 0 14px;
    pointer-events: auto;

    img {
        width: 15px;
        height: 15px;
    }
`, sw = Q.div`
    position: absolute;
    top: 22px;
    width: 100%;
    display: flex;
    justify-content: end;
    z-index: 20;
    pointer-events: none;
`, uw = Q.div`
    z-index: 100;
    height: 100%;
    display: grid;
    ${(e) => e.isBiggerSlider ? "justify-items: center;" : ""}
`, cw = Q.div`
    position: absolute;
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-self: center;
    z-index: 20;
    ${(e) => e.isBiggerSlider ? "max-width: 1200px;" : ""}
    pointer-events: none;

    ${Kr && `
        top: 50%;
        transform: translateY(-50%);
    `}

    @media (min-width: 991px) {
        ${(e) => e.isBiggerSlider && ap && `
            left: 50%;
            top: 50%;
            transform: translate(-50%, calc(-50% - 10px));
        `}
    }

    @media (max-width: 990px) {
        ${Kr && `
            left: 0;
        `}
    }
`, dw = Q.div`
    position: absolute;
    display: flex;
    width: 100%;
    justify-content: center;
    bottom: ${(e) => e.isBiggerSlider ? "30px" : "5px"};
    left: 0;
    right: 0; 
    pointer-events: none;
    
    > div {
        pointer-events: auto;
    }
    
`, fw = Q.div`
    h1 {
        margin-bottom: 40px;
        text-align: center;

        @media (max-width: 990px) {
            display: none;
        }
    }
`, pw = Q.div`
    display: flex;
    overflow-x: auto;
    gap: 40px;
    justify-content: flex-start;
    margin-top: 20px;
    margin-bottom: 20px;
    padding: 0 20px;
    scroll-snap-type: x mandatory;
    -webkit-overflow-scrolling: touch;

    &::-webkit-scrollbar {
        display: none;
    }
    scrollbar-width: none;

    div {
        flex-shrink: 0;
        height: 80px;
        width: 160px;
        scroll-snap-align: center;
    }

    @media (max-width: 990px) {
        gap: 10px;
        margin-top: 10px;
        padding: 0 10px;

        div {
            scroll-snap-align: start;
            width: 80px;
            height: 60px;
            min-width: 80px;
            max-width: 80px;
            min-height: 60px;
            max-height: 60px;
        }

        img {
            width: 80px;
            height: 60px;
            object-fit: cover;
        }
    }
`, op = ({
  images: e,
  isHovered: r,
  isBiggerSlider: t,
  toggleIsModalSlider: n,
  isDarkMode: a,
  modalOpen: o = !1,
  modalMode: l = !1
}) => {
  const [f, i] = Se(o), [s, c] = Se(0), [d, u] = Se(null), [m, v] = Se(null), [h, g] = Se(1), [p, x] = Se(null), [w, C] = Se(0), [y, b] = Se(0), [R, E] = Se(null), [M, I] = Se(null), $ = Je.useRef([]), G = 50, D = (O) => {
    O && (O.stopPropagation(), O.preventDefault(), "nativeEvent" in O && O.nativeEvent.stopImmediatePropagation());
    const V = s === 0 ? e.length - 1 : s - 1;
    c(V);
  }, k = (O) => {
    O && (O.stopPropagation(), O.preventDefault(), "nativeEvent" in O && O.nativeEvent.stopImmediatePropagation());
    const V = s === e.length - 1 ? 0 : s + 1;
    c(V);
  }, F = (O, N) => {
    O.stopPropagation(), O.preventDefault(), "nativeEvent" in O && O.nativeEvent.stopImmediatePropagation(), c(N);
  }, B = (O) => {
    l || t || H(O, !0);
  }, H = (O, N) => {
    O.stopPropagation(), O.preventDefault(), "nativeEvent" in O && O.nativeEvent.stopImmediatePropagation(), n ? n() : i(N);
  }, U = (O) => {
    const N = O.touches[0], V = O.touches[1], A = N.clientX - V.clientX, le = N.clientY - V.clientY;
    return Math.sqrt(A * A + le * le);
  }, ae = (O) => {
    if (O.touches.length === 2) {
      const N = U(O);
      x(N);
    } else if (O.touches.length === 1) {
      const N = O.targetTouches[0];
      u(N.clientX), v(null), E(N.clientX), I(N.clientY);
    }
  }, oe = (O) => {
    if (O.touches.length === 2 && p) {
      O.preventDefault();
      const V = U(O) / p;
      g(Math.min(Math.max(1, V), 3));
    } else if (O.touches.length === 1) {
      const N = O.targetTouches[0];
      if (h > 1) {
        if (O.preventDefault(), R !== null && M !== null) {
          const V = N.clientX - R, A = N.clientY - M;
          C((le) => le + V / h), b((le) => le + A / h);
        }
        E(N.clientX), I(N.clientY);
      } else
        v(N.clientX);
    }
  }, ce = () => {
    if (p)
      x(null), h <= 1 && (C(0), b(0));
    else if (h <= 1 && d && m) {
      const O = d - m, N = O > G, V = O < -50;
      N ? k() : V && D();
    }
    E(null), I(null);
  };
  Pr(() => {
    const O = (N) => {
      (f || t) && (N.key === "ArrowLeft" ? D() : N.key === "ArrowRight" && k());
    };
    return window.addEventListener("keydown", O), () => {
      window.removeEventListener("keydown", O);
    };
  }, [
    s,
    f,
    t,
    e.length
  ]), Pr(() => {
    var O;
    $.current[s] && ((O = $.current[s]) == null || O.scrollIntoView({
      behavior: "smooth",
      block: "nearest",
      inline: "center"
    }));
  }, [s]);
  const J = () => vt() || r || t || Kr;
  return /* @__PURE__ */ T.jsxs(T.Fragment, { children: [
    /* @__PURE__ */ T.jsxs(
      uw,
      {
        isBiggerSlider: t,
        onTouchStart: ae,
        onTouchMove: oe,
        onTouchEnd: ce,
        children: [
          J() ? /* @__PURE__ */ T.jsxs(T.Fragment, { children: [
            t ? null : /* @__PURE__ */ T.jsx(sw, { children: /* @__PURE__ */ T.jsx(
              Bi,
              {
                onClick: (O) => H(O, !0),
                ...Kr ? { onTouchEnd: (O) => H(O, !0) } : {},
                children: /* @__PURE__ */ T.jsx(Ve, { classNames: "icon-in-button", icon: Ye.CAMERA })
              }
            ) }),
            e.length > 1 ? /* @__PURE__ */ T.jsxs(cw, { isBiggerSlider: t, children: [
              /* @__PURE__ */ T.jsx(
                Bi,
                {
                  onClick: (O) => D(O),
                  ...Kr ? {
                    onTouchEnd: (O) => D(O)
                  } : {},
                  children: /* @__PURE__ */ T.jsx(Ve, { classNames: "icon-in-button", icon: Ye.ARROW_LEFT })
                }
              ),
              /* @__PURE__ */ T.jsx(
                Bi,
                {
                  onClick: (O) => k(O),
                  ...Kr ? {
                    onTouchEnd: (O) => k(O)
                  } : {},
                  children: /* @__PURE__ */ T.jsx(Ve, { classNames: "icon-in-button", icon: Ye.ARROW_RIGHT })
                }
              )
            ] }) : null
          ] }) : null,
          l ? null : /* @__PURE__ */ T.jsx(
            ow,
            {
              isBiggerSlider: t,
              onClick: B,
              "data-notclickable": !0,
              children: /* @__PURE__ */ T.jsx(
                iw,
                {
                  isBiggerSlider: t,
                  scale: h,
                  translateX: w,
                  translateY: y,
                  src: e[s].url.replace("PHOTO_SIZE", t ? _o.NORMAL_PHOTO : _o.FULL_SCREEN_PHOTO)
                }
              )
            }
          ),
          !l && e.length > 1 ? /* @__PURE__ */ T.jsx(dw, { isBiggerSlider: t, children: e.map((O, N) => /* @__PURE__ */ T.jsx(
            "div",
            {
              onClick: (V) => F(V, N),
              ...Kr ? {
                onTouchEnd: (V) => F(V, N)
              } : {},
              children: /* @__PURE__ */ T.jsx(nw, { slideIndex: N, currentIndex: s })
            },
            N
          )) }) : null,
          /* @__PURE__ */ T.jsx(
            Gx,
            {
              isDarkMode: a,
              isOpen: f,
              onClose: (O) => H(O, !1),
              centeredContent: !0,
              children: /* @__PURE__ */ T.jsx(fw, { children: /* @__PURE__ */ T.jsx("div", { children: /* @__PURE__ */ T.jsx(op, { images: e, isBiggerSlider: !0 }) }) })
            }
          )
        ]
      }
    ),
    t ? /* @__PURE__ */ T.jsx(pw, { children: e.map((O, N) => /* @__PURE__ */ T.jsx(
      "div",
      {
        ref: (V) => {
          V && ($.current[N] = V);
        },
        onClick: (V) => F(V, N),
        ...Kr ? { onTouchEnd: (V) => F(V, N) } : {},
        children: /* @__PURE__ */ T.jsx(lw, { active: s === N, src: e[N].url.replace("PHOTO_SIZE", _o.FULL_SCREEN_PHOTO) })
      },
      N
    )) }) : null
  ] });
}, mw = Q.div`
    display: flex;
    align-items: center;
    cursor: ${(e) => e.isPointer ? "pointer" : ""};

    @media (max-width: 786px) {
        justify-content: center;
        flex-direction: column;
    }

    span {
        margin-right: 10px;
    }
`, vw = Q.div`
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-auto-rows: auto;
    padding: 10px 15px;
    gap: 20px;

    @media (max-width: 1100px) {
        overflow: auto;
        scrollbar-width: thin;
        scrollbar-color: var(--color-alt-second-10) var(--color-background);
        scroll-behavior: smooth;
        white-space: nowrap;
        max-width: 100%;
        padding-bottom: 30px;

        ::-webkit-scrollbar-thumb {
            background-color: var(--color-primary);
            border: none;
        }

        ::-webkit-scrollbar {
            height: 4px;
        }
    }

`, hw = Q.p`
    font-weight: 500;
    color: var(--color-primary);
    margin-bottom: 0;
`, bw = Q.div`
    --font-weight: 400;

    color: var(--color-primary);

    @media (max-width: 786px) {
        text-align: center;
    }

    span {
        --font-weight: 300;
    }
`, Wd = Q.p`
    --font-weight: 400;

    display: flex;
    flex-direction: column;
    gap: 5px;
    padding: ${(e) => e.media ? "0 15px" : "10px 15px"};
    color: var(--color-primary);

    img {
        filter: invert(100%) sepia(100%) saturate(0%) hue-rotate(79deg) brightness(105%) contrast(102%);
    }

    p {
        margin: 0 0 10px 0;
        text-align: justify;
    }
`, yw = Q.p`
    padding: 10px 0;
    color: var(--color-primary);
`, gw = Q.button`
    background: var(--color-primary);
    color: var(--color-white);
    padding: 5px 10px;
    border-radius: 5px;
    border: none;
    cursor: pointer;
    transition: background 0.3s;

    &:hover {
        background: var(--color-primary-70);
    }
`, Rw = Q.div`
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
`, xw = Q.span`
    display: block;
    padding-left: 15px;
`, ww = Q.div``, Ew = Q.div`
    margin-left: 10px;
    display: flex;
    flex-direction: column;
    align-items: self-end;
    
    @media (min-width: 790px) {
        max-width: 125px;
        width: 100%;
    }
`, Cw = Q.h4`
    text-decoration-line: line-through;
    font-weight: 500;
    margin: 0;
    letter-spacing: 1.4px;
    line-height: 20px;
    color: var(--color-primary);
`, _w = Q.h1`
    font-weight: 600;
    font-size: 20px;
    line-height: inherit;
    color: var(--color-alt);
`, Pw = Q.div`
    display: block;
    gap: 5px;
    color: var(--color-primary);
    font-weight: 400;

    b {
        font-weight: 500;
    }
`, Tw = ({
  description: e,
  title: r,
  address: t,
  detailsElements: n,
  documents: a,
  handleDocumentClick: o,
  meta: l,
  priceSection: f
}) => {
  const i = _t(null), s = si(() => n, [n]), c = si(() => l && l.length > 0 ? /* @__PURE__ */ T.jsxs(ot, { children: [
    /* @__PURE__ */ T.jsx(ei, { children: "Słowa kluczowe:" }),
    l.map((d) => /* @__PURE__ */ T.jsxs(xw, { children: [
      /* @__PURE__ */ T.jsx("b", { children: d.key }),
      " - ",
      /* @__PURE__ */ T.jsx("p", { children: d.value })
    ] }, d.key))
  ] }) : null, [l]);
  return /* @__PURE__ */ T.jsxs(T.Fragment, { children: [
    /* @__PURE__ */ T.jsxs(ot, { isTwoColumns: !!f, children: [
      /* @__PURE__ */ T.jsxs(ww, { children: [
        /* @__PURE__ */ T.jsx(ei, { children: r ?? "-" }),
        /* @__PURE__ */ T.jsx(yw, { children: t ?? "-" })
      ] }),
      f && /* @__PURE__ */ T.jsxs(Ew, { children: [
        /* @__PURE__ */ T.jsx(Cw, { children: f.priceBeforeModification }),
        /* @__PURE__ */ T.jsx(_w, { children: `${fm(Number(f.price))} zł` }),
        /* @__PURE__ */ T.jsxs(Pw, { children: [
          /* @__PURE__ */ T.jsx("b", { children: sf(f.pricePerSquareMeter.toString(), 2) }),
          " zł / m",
          /* @__PURE__ */ T.jsx("sup", { children: "2" })
        ] })
      ] })
    ] }),
    /* @__PURE__ */ T.jsx(ot, { children: /* @__PURE__ */ T.jsx(vw, { ref: i, children: s.map((d, u) => /* @__PURE__ */ T.jsxs(mw, { children: [
      /* @__PURE__ */ T.jsx(Ve, { icon: d.icon }),
      /* @__PURE__ */ T.jsxs(bw, { children: [
        /* @__PURE__ */ T.jsx("span", { dangerouslySetInnerHTML: { __html: d.text } }),
        /* @__PURE__ */ T.jsx(hw, { dangerouslySetInnerHTML: { __html: d.value } })
      ] })
    ] }, u)) }) }),
    /* @__PURE__ */ T.jsxs(ot, { children: [
      /* @__PURE__ */ T.jsx(ei, { children: "Szczegóły ogłoszenia:" }),
      e && /* @__PURE__ */ T.jsx(Wd, { dangerouslySetInnerHTML: { __html: e.replace(/\n/g, "<br />") } })
    ] }),
    c,
    a && a.length > 0 ? /* @__PURE__ */ T.jsxs(ot, { children: [
      /* @__PURE__ */ T.jsx(ei, { children: "Dokumenty:" }),
      /* @__PURE__ */ T.jsx(Rw, { children: a.map((d, u) => /* @__PURE__ */ T.jsx(Wd, { children: /* @__PURE__ */ T.jsx(gw, { onClick: () => o == null ? void 0 : o(d), children: d }) }, u)) })
    ] }) : null
  ] });
}, Sw = Q.button`
  background: var(--color-alt-second);
  color: var(--color-primary);
  border: none;
  font: inherit;
  cursor: pointer;
  outline: inherit;
  transition: background-color .3s;
  padding: 15px 20px;
  border-radius: 30px;
  display: flex;
  position: relative;

  &.active {
    span {
      outline: var(--color-white) solid 2px;
    }
  }
  
  &.disabled {
    opacity: 0.2;
    pointer-events: none;
  }

  span {
    margin-right: 8px;
  }

  &.active,
  &:hover {
    transition: background-color .3s;
    background: var(--color-alt);
    color: ${(e) => e.darkMode ? "var(--color-primary)" : "var(--color-white)"};

    img {
      filter: invert(100%) sepia(100%) saturate(0%) hue-rotate(79deg) brightness(105%) contrast(102%);
    }
  }
`, zd = ({ disabled: e, label: r, icon: t, isActive: n, onClick: a, children: o, isDarkMode: l }) => /* @__PURE__ */ T.jsxs(Sw, { darkMode: l, onClick: a, className: dr({
  active: n,
  disabled: e
}), children: [
  o,
  t ? /* @__PURE__ */ T.jsx(Ve, { icon: t }) : null,
  r
] }), qw = ({ children: e, isActive: r }) => /* @__PURE__ */ T.jsx(T.Fragment, { children: r ? e : null }), Ow = Q.div`
    display: flex;
    flex-wrap: nowrap;
    white-space: nowrap;
    gap: 10px;
    overflow: auto;
    scrollbar-width: thin;
    scrollbar-color: var(--color-alt-second-10) var(--color-background);
    scroll-behavior: smooth;
    padding: 10px 0;
    margin: 0 20px;

    ::-webkit-scrollbar-thumb {
        background-color: var(--color-primary);
        border: none;
    }

    ::-webkit-scrollbar {
        height: 4px;
    }

    @media (min-width: 1100px) {
        justify-content: flex-start;
        overflow: hidden;
    }
       
    & > button:first-child {
        width: fit-content;
        @media (max-width: 1100px) {
            margin-right: unset;
            width: unset;
        }
    }

    & > button:last-child {
        margin-right: 10px;
    }
`;
var nt = /* @__PURE__ */ ((e) => (e[e.DETAILS = 1] = "DETAILS", e[e.DUPLICATES = 2] = "DUPLICATES", e[e.MODIFICATIONS = 3] = "MODIFICATIONS", e[e.NOTES = 4] = "NOTES", e[e.ADDITIONAL = 5] = "ADDITIONAL", e[e.MESSAGES = 6] = "MESSAGES", e[e.OPINIONS = 7] = "OPINIONS", e))(nt || {});
const Aw = ({
  toggleContainerDetails: e,
  tabIndex: r,
  isNotInteractive: t,
  notInteractiveElements: n,
  interactiveElements: a,
  userDetails: o,
  // numberOfDuplicates,
  // numberOfModifications,
  detailsTabContent: l,
  // duplicatesTabContent,
  // modificationTabContent,
  // notesTabContent,
  // additionalTabContent,
  // handleLoadDuplicates,
  // handleLoadNotes,
  // messagesTabContent,
  // numberOfNotes,
  // opinionTabContent,
  // handleLoadComments,
  isDarkMode: f,
  isOneTab: i
}) => {
  const [s, c] = Se(1), d = _t(null), u = uf(), m = ((a == null ? void 0 : a.length) || 0) + ((n == null ? void 0 : n.length) || 0);
  return Pr(() => {
    r && c(r);
  }, [r]), /* @__PURE__ */ T.jsxs(T.Fragment, { children: [
    u < 991 && m > 1 ? /* @__PURE__ */ T.jsx(ot, { children: /* @__PURE__ */ T.jsx(
      np,
      {
        className: "icons-modal",
        isModalOpen: !0,
        interactiveElements: a,
        notInteractiveElements: n,
        isNotInteractive: t,
        userDetails: o
      }
    ) }) : null,
    i ? null : /* @__PURE__ */ T.jsx(ot, { className: "swipeable", children: /* @__PURE__ */ T.jsxs(Ow, { ref: d, children: [
      u > 991 && e ? /* @__PURE__ */ T.jsx(zd, { isDarkMode: f, onClick: e, icon: Ye.LEAVE, label: "Wróć do wyszukiwania" }) : null,
      /* @__PURE__ */ T.jsx(zd, { isDarkMode: f, onClick: () => c(
        1
        /* DETAILS */
      ), isActive: s === 1, label: "Szczegóły" })
    ] }) }),
    /* @__PURE__ */ T.jsx(qw, { isActive: s === 1, children: /* @__PURE__ */ T.jsx(Tw, { ...l }) })
  ] });
}, Mw = Q.div`
    z-index: 21;
`, kw = Q.div`
    position: relative;
    color: var(--color-primary);
    max-width: 600px;
    width: 100%;
    text-align: center;
    height: auto;
    border-radius: 13px;
    filter: drop-shadow(0px 0px 20px rgba(0, 0, 0, 0.08));
    background: ${(e) => e.darkMode ? "var(--color-alt-hover)" : "var(--color-alt-second)"};
    padding: 5px 12px;
    font-size: 13px;
    line-height: 20px;
    border: 1px solid rgba(3, 13, 69, 0.05);
    ${(e) => e.bottomTooltip ? "margin-top: 12px" : "margin-bottom: 12px"};
`, Dw = Q.div`
    :after {
        content: '';
        position: absolute;
        ${(e) => e.bottomTooltip ? "bottom: 27px;" : "top: -18px;"}
        left: -5px;
        width: 10px;
        height: 10px;
        background: ${(e) => e.darkMode ? "var(--color-alt-hover)" : "var(--color-alt-second)"};
        transform: ${(e) => e.bottomTooltip ? "rotate(225deg)" : "rotate(45deg)"};
        border-bottom: 1px solid rgba(3, 13, 69, 0.05);
        border-right: 1px solid rgba(3, 13, 69, 0.05);
        border-bottom-right-radius: 2px;
        z-index: 1;
    }
`, ip = ({
  text: e,
  alertsTooltip: r,
  bottomTooltip: t,
  showTooltip: n,
  referenceElement: a,
  onClick: o,
  isDarkMode: l,
  ...f
}) => {
  const [i, s] = Se(null), [c, d] = Se(null), { styles: u, attributes: m } = gf(a, i, {
    placement: "top",
    modifiers: [{ name: "arrow", options: { element: c } }]
  });
  return n && e ? /* @__PURE__ */ T.jsxs(
    Mw,
    {
      role: "tooltip",
      ref: s,
      style: u.popper,
      ...m.popper,
      onClick: o,
      className: dr({ "alerts-tooltip": r, "bottom-tooltip": t }),
      ...f,
      children: [
        /* @__PURE__ */ T.jsx(kw, { darkMode: l, bottomTooltip: t, children: e }),
        /* @__PURE__ */ T.jsx(Dw, { darkMode: l, bottomTooltip: t, ref: d, ...m.arrow, style: u.arrow })
      ]
    }
  ) : null;
}, jw = Q.img`
    width: 30px;
    height: 30px;
    border-radius: var(--border-radius);
    object-fit: cover;
`, ql = ({ img: e }) => e ? /* @__PURE__ */ T.jsx(jw, { src: e, alt: "user-photo", className: "user-photo-icon-img" }) : /* @__PURE__ */ T.jsx(Ve, { icon: Ye.USER, "aria-label": "User icon" }), zw = ({ detailsCardData: e }) => /* @__PURE__ */ T.jsx(
  Rm,
  {
    ...e,
    preferredTab: 1
  }
);
export {
  ot as BoxContainer,
  Bw as Button,
  Rm as CardDetails,
  kv as ChatWindow,
  kw as Cloud,
  bw as DetailedInfo,
  mw as DetailedInfoContainer,
  Wd as DetailsDescription,
  Tw as DetailsTab,
  nw as Dot,
  Fw as Folder,
  vw as Grid,
  Ve as Icon,
  Ye as IconEnum,
  Rh as IconsWithText,
  _o as ImageSize,
  gs as InfoBadge,
  sm as InfoBoxContainer,
  Qo as InteractiveIcons,
  np as InteractiveIconsWrapper,
  Xi as MessageSenders,
  ys as Messages,
  Gx as Modal,
  tw as ModalWithTrash,
  zw as SingleOfferDetailsRenderer,
  op as Slider,
  zd as Tab,
  qw as TabPanel,
  nt as TabType,
  Aw as Tabs,
  bh as TextInput,
  ei as Title,
  ip as Tooltip,
  Dw as Triangle,
  ql as UserPhotoIcon,
  hw as Value,
  Uw as colorModeStyles,
  fm as convertPrice,
  Hw as errorFallback,
  vm as formatDate,
  sf as formatFilterPrice,
  vt as isTouchDevice,
  Ww as renderWithGlobalStyle,
  $w as stringToBoolean,
  uf as useWindowWidth
};
